(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("vue-demi"));
	else if(typeof define === 'function' && define.amd)
		define([, "vue-demi"], factory);
	else if(typeof exports === 'object')
		exports["op-flow-component"] = factory(require("vue"), require("vue-demi"));
	else
		root["op-flow-component"] = factory(root["Vue"], root["vue-demi"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_f281__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "024c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0481":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("b495");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "050d":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ "052a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "07ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_74ba8b86_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ead3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_74ba8b86_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_74ba8b86_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "07d9":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("a0d5");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "083f":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var isObject = __webpack_require__("7526");
var isSymbol = __webpack_require__("cfd1");
var getMethod = __webpack_require__("60de");
var ordinaryToPrimitive = __webpack_require__("eba0");
var wellKnownSymbol = __webpack_require__("7d53");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "0894":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var toObject = __webpack_require__("37d1");
var lengthOfArrayLike = __webpack_require__("0481");
var setArrayLength = __webpack_require__("5231");
var doesNotExceedSafeInteger = __webpack_require__("0dc7");
var fails = __webpack_require__("72df");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "0957":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLabelInOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelToSnake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRequestConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadFile; });
const getLabelInOptions = (val, options) => {
  let _val = val;
  for (const item of options) {
    if (item.value === val) {
      _val = item.label;
    }
  }
  return _val;
};
function camelToSnake(str) {
  if (!str) return str;
  return str.replace(/([A-Z])/g, function (match) {
    return '_' + match.toLowerCase();
  }).toUpperCase();
}
const getRequestConfig = function (url, gatewayPath = 'workflow', method = 'post') {
  if (gatewayPath) {
    const regex = /([^/]+)/;
    const _gateway = regex.exec(url);
    url = url.replace(_gateway[0], gatewayPath);
  }
  return this()[method](url);
};
const downloadFile = (blob, fileName) => {
  const eleLink = document.createElement('a');
  eleLink.download = fileName;
  eleLink.style.display = 'none';
  eleLink.href = URL.createObjectURL(blob);
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
};

/***/ }),

/***/ "09b2":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("2444");
var utils = __webpack_require__("c532");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0a3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
class BaseUrl {
  constructor() {
    this.env = 'pro';
    this.baseUrl = {
      sit: {
        apigateway: 'https://apigatewaysit.oppein.com',
        cdnPath: 'https://mtdsrestest.oppein.com',
        flowCenter: 'https://pumasit.oppein.com',
        assp: 'https://asspsit.oppein.com'
      },
      uat: {
        apigateway: 'https://apigatewayuat.oppein.com',
        cdnPath: 'https://mtdsrestest.oppein.com',
        flowCenter: 'https://pumauat.oppein.com',
        assp: 'https://asspuat.oppein.com'
      },
      ver: {
        apigateway: 'https://apigatewayver.oppein.com',
        cdnPath: 'http://mtdsrestest.oppein.com',
        flowCenter: 'https://pumaver.oppein.com',
        assp: 'https://asspver.oppein.com'
      },
      pro: {
        apigateway: 'https://apigateway.oppein.com',
        cdnPath: 'http://mtdsosscdn.oppein.com',
        flowCenter: 'https://puma.oppein.com',
        assp: 'https://assp.oppein.com'
      }
    };
  }
  init(env) {
    this.env = env;
  }
  getBaseUrl() {
    return this.baseUrl[this.env];
  }
}
const baseUrlInst = new BaseUrl();
/* harmony default export */ __webpack_exports__["a"] = (baseUrlInst);

/***/ }),

/***/ "0a87":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "0c41":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0c5c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isVNode = isVNode;

var _util = __webpack_require__("6d2c");

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

/***/ }),

/***/ "0dbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DetailTaskTransferDialog_vue_vue_type_style_index_0_id_27debcfc_prod_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df1a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DetailTaskTransferDialog_vue_vue_type_style_index_0_id_27debcfc_prod_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DetailTaskTransferDialog_vue_vue_type_style_index_0_id_27debcfc_prod_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0dc7":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "0e19":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("4b2c"),
    getRawTag = __webpack_require__("2822"),
    objectToString = __webpack_require__("907a");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "0e30":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "0e39":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("7a25");
var isCallable = __webpack_require__("3ce8");
var toObject = __webpack_require__("37d1");
var sharedKey = __webpack_require__("332c");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("802e");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "0e93":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "1001":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("986c");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "1139":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _api_flow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4bf8");
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a692");
/* harmony import */ var _api_processInstance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e46d");
/* harmony import */ var _oppein_op_web_form_lib_form_utils_umd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("dbf1");
/* harmony import */ var _oppein_op_web_form_lib_form_utils_umd__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_oppein_op_web_form_lib_form_utils_umd__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_MsgDialog_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("64b0");
/* harmony import */ var _helper_eventBus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6e6e");
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8daa");
/* harmony import */ var _request_baseURL__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0a3b");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/**
 * @WARNING 此组件单独使用仅能作为展示表单信息使用，如果需要编辑并操作表单需要结合：import { getOnlineFormData } from '@oppein/op-web-form/lib/form-utils.umd.js'
 * getOnlineFormData方法异步返回表单数据，作为更新表单的参数,具体使用参考示例
 * @description 动态表单渲染组件，基于流程modelKey/流程id/草稿id/实例id/客户端类型等标识获取表单对象进行渲染，数据回填
 * @property title <String> 自定义标题，为空情况下默认使用实例名称(processName)
 * @property flowKey <String> 流程modelKey用于获取表单对象信息，仅有流程key场景,具体逻辑在 getFormInfoVal()
 * @property flowId <String> 流程id用于获取表单对象信息，作用等价于【flowKey】
 * @property draftId <String> 流程草稿id用于获取【草稿状态下】的表单对象信息，作用等价于【flowKey】
 * @property taskId <String> 流程待处理任务id用于获取某个节点下的表单对象信息，作用等价于【flowKey】，用于任务处理场景
 * @property instId <String> 流程实例id用于获取某个节点下的表单对象信息，作用等价于【flowKey】，用于任务处理场景
 * @property formDetail <Object> 流程表单对象信息，用于表单节点渲染，外部传入，等价于【flowKey】查询获取
 * @property defaultFormData <Object> 流程表单组件字符串，用于表单节数据回填，外部传入，等价于【flowKey】查询获取
 * @property readOnly <Boolean> 是否为只读模式，不可编辑
 * @property toReader <Boolean> 右上角是否展示传阅入口功能，需要结合FlowAction使用，否则无效。
 * @example <form-content  instId="[instId]" :readOnly="false"/>
 * <template>
 *     <form-content :flowKey="flowKey" :readOnly="false" />
 *     <el-button @click="updateFormData">保存<el-button>
 * </template>
 * <script>
 * import { getOnlineFormData } from '@oppein/op-web-form/lib/form-utils.umd.js'
 * import { Base64 } from 'js-base64'
 * export default{
 * 	  data() {
 *      return {
 * 		    flowKey: 'xxx',
 * 		  }
 *    },
 *    methods: {
 *      updateFormData() {
 *        const formData = await getOnlineFormData()
 *        const _option = {
 *          processInstanceId: this.instId,
 *          formData: Base64.encode(formData), // 目前必须转为Base64
 *        }
 *         await Form.formInstanceUpdate(_option) // request api
 *      }
 *    }
 * }
 *
 * */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-content',
  components: {
    MsgDialog: _component_MsgDialog_vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]
  },
  props: {
    title: String,
    flowKey: String,
    flowId: String,
    type: String,
    draftId: String,
    taskId: String,
    instId: String,
    formDetail: Object,
    defaultFormData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    toReader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      html: null,
      businessKey$: null,
      permission: null,
      processName: null,
      taskName: null,
      nodeId: null,
      processDefConfig: {},
      customerParams: {},
      formEventHandler: null,
      formVal: {},
      clientWidth: '92%',
      hasTimeNotice: false
    };
  },
  computed: {
    clientType() {
      if (this.type) {
        return this.type.toLocaleUpperCase();
      } else {
        return 'PC';
      }
    }
  },
  async mounted() {
    this.hasTimeNotice = !!this.$slots.timeNotice;
    this.clientWidth = window.document.getElementById('flow-form-content').clientWidth + 'px';
    let formVal = await this.getFormInfoVal();
    // 传递给操作面板，复用数据，避免再次调用接口
    if (formVal) {
      this.$emit('onLoadDetail', formVal);
    }
    this.formVal = formVal;
    if (!formVal) return;
    if (formVal.getProcessDefinitionKey) {
      // 设置流程相关属性
      this.processDefConfig.processModelKey = formVal.getProcessDefinitionKey.split('_')[0];
      this.processDefConfig.processDefKey = formVal.getProcessDefinitionKey;
      this.processDefConfig.version = formVal.getProcessDefinitionKey.split('_')[1];
    }
    // 发起根据流程key获取表单
    let _me = this;
    const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](config);
    this.html = formVal.formHtml;
    this.businessKey$ = (formVal === null || formVal === void 0 ? void 0 : formVal.businessKey) || null;
    this.initFormData(formVal.data);
    this.processName = formVal.title || formVal.processDefinitionName || formVal.processInstanceName || '';
    this.taskName = formVal.taskName;
    this.permission = formVal.permission;
    if (!this.permission.table) {
      this.setTablePermission();
    }
    // 只读
    if (this.readOnly) {
      for (let table in this.permission.fields) {
        const bodef = this.permission.fields[table];
        if (bodef) {
          for (let fname in bodef) {
            if (bodef[fname] === 'w' || bodef[fname] === 'b') {
              bodef[fname] = 'r';
            }
          }
        }
        this.permission.fields[table] = bodef;
      }
      for (let tableName in this.permission.table) {
        this.permission.table[tableName] = {
          add: false,
          del: false,
          hidden: false,
          required: false
        };
      }
    }
    // 保存之后需要刷新表单数据
    _helper_eventBus__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].$on('postFormData', data => {
      this.initFormData(data);
    });
    eval(formVal.diyJs);

    // iframe 父级获取表单数据 监听
    const iframe = parent.document.querySelector('iframe');
    if (iframe) {
      window.addEventListener('message', this.getDataFromOnlineForm);
    }
  },
  destroyed() {
    // iframe 父级获取表单数据时间销毁
    window.removeEventListener('message', this.getDataFromOnlineForm);
  },
  methods: {
    // iframe 父级获取表单数据
    async getDataFromOnlineForm(e) {
      if (e.data === 'GET_ONLINE_FORM_DATA') {
        window.parent.postMessage({
          type: 'ONLINE_FORM_DATA',
          data: await Object(_oppein_op_web_form_lib_form_utils_umd__WEBPACK_IMPORTED_MODULE_3__["getOnlineFormData"])(false)
        }, '*');
      }
    },
    getDetail(flowId) {
      return _api_flow__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getFormHtml({
        id: flowId || this.flowId,
        type: this.clientType
      });
    },
    async getFormInfoVal() {
      let _formVal = null;
      /**
       * 表单渲染数据有3种方式获取
       * 1、外部传入formDetail
       * 2、通过draftId获取
       * 3、通过taskId获取
       * 4、通过instId获取
       * 5、通过flowId获取
       * 6、通过flowKey获取
       */
      const loading = this.$loading();
      if (this.formDetail) {
        // 1、外部传入formDetail
        _formVal = this.formDetail;
        if (this.flowKey) {
          // 外部获取详情的时候，解决部分配置不齐全，由 flow key 查询补全
          const flowId = await _api_flow__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getFlowId(this.flowKey);
          const _temp = (await this.getDetail(flowId)) || {};
          _temp.data = _formVal.data;
          _formVal = _temp;
        }
      } else if (this.draftId) {
        // 2、草稿ID获取详情
        _formVal = await _api_processInstance__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].getDraft({
          id: this.draftId,
          type: this.clientType
        });
      } else if (this.taskId) {
        // 3、通过taskId获取
        _formVal = await _api_flow__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getDetailByTaskId({
          id: this.taskId,
          type: this.clientType
        });
      } else if (this.instId) {
        // 4、通过instId获取
        _formVal = await _api_flow__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getDetailByInstId({
          id: this.instId,
          type: this.clientType
        });
      } else if (this.flowId) {
        // 5、通过flowId获取
        _formVal = await this.getDetail();
      } else if (this.flowKey) {
        // 6、通过flowKey获取
        const flowId = await _api_flow__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getFlowId(this.flowKey);
        _formVal = await this.getDetail(flowId);
      }
      if (_formVal && _formVal.activityId) this.nodeId = _formVal.activityId;
      loading.close();
      return _formVal;
    },
    showToReadDialog() {
      if (!this.$parent || !this.$parent.$children) return;
      this.$parent.$children.map($child => {
        if ($child.submitRevoke) {
          $child.submitRevoke('/task/toRead');
        }
      });
    },
    // 处理初始化data
    initFormData(formData) {
      /**
       * defaultFormData可能会带有id和form_instance_id
       * 需要删除id字段和把form_instance_id换成flowKey换来的form_instance_id
       */
      if (this.defaultFormData) {
        const _formInstacneId = formData[Object.keys(formData)[0]].form_instance_id;
        removeIdKey(this.defaultFormData, _formInstacneId);
        this.data = this.defaultFormData;
      } else {
        this.data = formData;
      }
      function removeIdKey(data, formInstacneId) {
        if (typeof data === 'object') {
          for (let key in data) {
            if (key === 'id') {
              delete data[key];
            } else if (key === 'form_instance_id') {
              data[key] = formInstacneId;
            } else if (key.indexOf('sub_dyfo_') > -1 && Array.isArray(data[key])) {
              for (let item of data[key]) {
                if (!item.form_instance_id) {
                  item.form_instance_id = formInstacneId;
                }
                removeIdKey(item, formInstacneId);
              }
            } else {
              removeIdKey(data[key], formInstacneId);
            }
          }
        }
      }
    },
    // FIXME: 后续要对接后端返回子表控制，现在暂时由formContent自行控制
    setTablePermission() {
      if (this.permission) {
        this.permission.table = {};
        for (let key in this.permission.fields) {
          const sub_b = Object.values(this.permission.fields[key]).some(x => x == 'b');
          const sub_w = Object.values(this.permission.fields[key]).some(x => x == 'w');
          if (sub_b || sub_w) {
            this.permission.table[key] = {
              add: true,
              del: true,
              hidden: false,
              required: sub_b
            };
          } else {
            this.permission.table[key] = {
              add: false,
              del: false,
              hidden: false,
              required: false
            };
          }
        }
      }
    },
    // FIXME: 特殊处理子表权限
    handleSubTablePermission(tableName, configList) {
      for (let config of configList) {
        const {
          nodeId,
          permission
        } = config;
        if (this.nodeId && this.nodeId === nodeId || !this.nodeId && nodeId === 'form' || !nodeId) {
          this.permission.table[tableName] = Object.assign(this.permission.table[tableName], permission);
        }
      }
    },
    /**
     * 设置子表数据操作权限
     * @param {*} subTableName 子表表名
     * @param {Function} cusmerHandle    自定义函数function(subList, nodeId, boData){}, 优先执行function, function中处理每一项子表数据，sub_row_readonly=true代表数据只读，sub_row_no_delete=true代表数据不可删除
     *                      subList: subTableName对应的子表数据
     *                      nodeId: 当前任务的nodeId,只有任务详情存在nodeId
     *                      boData: 整个表单的数据
     * @param {String} cusmerHandle form/task，task代表处理所有节点任务详情，form代表动态表单单独使用和流程实例详情
     */
    setRowControlPermission(subTableName, customHandle) {
      let path = [];
      for (let map of Object.entries(this.data)) {
        const [key, val] = map;
        if (Object.prototype.hasOwnProperty.call(val, `sub_${subTableName}`)) {
          path = [key, `sub_${subTableName}`];
        }
      }
      if (path.length === 0) return;
      const nodeId = this.nodeId;
      const boData = this.data;
      const isCustomFunc = customHandle && typeof customHandle === 'function';
      const isType = customHandle && typeof customHandle === 'string';
      if (isCustomFunc) {
        customHandle(this.data[path[0]][path[1]], nodeId, boData);
      } else if (isType) {
        if (custom === 'task' && nodeId || custom === 'form' && !nodeId) {
          for (let item of this.data[path[0]][path[1]]) {
            item.sub_row_readonly = true;
            item.sub_row_no_delete = true;
          }
        }
      }
    },
    showMsg() {
      return this.clientType === 'PC' && this.$route.path.indexOf('flowStart') == -1;
    },
    // 打开信息弹框
    showMsgDialog() {
      this.$refs.MsgDialog.show(this.formVal);
    },
    // 复制标题和链接
    copyTitle(title) {
      const flowUrl = _request_baseURL__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].getBaseUrl().flowCenter;
      const href = `${flowUrl}/work-flow/instance-flow?instId=${this.formVal.processInstanceId || this.formVal.id}`;
      const txt = `${title}      ${href}`;
      this.$copyText(txt).then(() => {
        this.$message.success('标题和链接已复制到剪贴板中');
      });
    }
  }
});

/***/ }),

/***/ "1386":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "157c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "1702":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("abdf").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "1721":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AddTaskTransferDialog_vue_vue_type_style_index_0_id_3b078bf8_prod_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9824");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AddTaskTransferDialog_vue_vue_type_style_index_0_id_3b078bf8_prod_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AddTaskTransferDialog_vue_vue_type_style_index_0_id_3b078bf8_prod_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "185a":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var call = __webpack_require__("b546");
var propertyIsEnumerableModule = __webpack_require__("e129");
var createPropertyDescriptor = __webpack_require__("9618");
var toIndexedObject = __webpack_require__("378c");
var toPropertyKey = __webpack_require__("feca");
var hasOwn = __webpack_require__("7a25");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "1861":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_mobile_vue_vue_type_style_index_0_id_36a29514_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9275");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_mobile_vue_vue_type_style_index_0_id_36a29514_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_mobile_vue_vue_type_style_index_0_id_36a29514_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "18de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_910339de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("024c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_910339de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_910339de_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1a45":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1ab6":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("201b");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("6984")(module)))

/***/ }),

/***/ "1b4e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollBarWidth = void 0;

;

/***/ }),

/***/ "1ba6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1d61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_23fcf0b5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e18");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_23fcf0b5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_23fcf0b5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d8a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "1e45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inBrowser */
/* unused harmony export ua */
/* unused harmony export iswxwork */
/* unused harmony export isWx */
/* unused harmony export isH5plus */
/* unused harmony export isMiniProgram */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPCWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientType; });
/* harmony import */ var _components_flow_FlowAction_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fa1");
// ssr support

const inBrowser = typeof window !== 'undefined';
const ua = inBrowser && navigator.userAgent.toLowerCase() || '';
const regWeiXin = ua.match(/micromessenger/i);
const regWxWork = ua.match(/wxwork/i);
const regH5plus = ua.match(/html5plus/i);
const regMiniprogram = ua.match(/miniprogram/i);
const iswxwork = () => {
  return regWeiXin && regWeiXin[0] == 'micromessenger' && regWxWork && regWxWork[0] == 'wxwork';
};
const isWx = () => {
  return regWxWork != null && regWeiXin[0] == 'micromessenger';
};
const isH5plus = () => {
  return regH5plus && regH5plus[0] == 'html5plus';
};
const isMiniProgram = () => {
  return regMiniprogram && regMiniprogram[0] == 'miniprogram';
};
const isPCWidth = () => {
  const clientWidth = document.body.clientWidth;
  return clientWidth > 500;
};
const getClientType = () => {
  return isPCWidth() ? _components_flow_FlowAction_constants__WEBPACK_IMPORTED_MODULE_0__[/* PC */ "u"] : _components_flow_FlowAction_constants__WEBPACK_IMPORTED_MODULE_0__[/* H5 */ "i"];
};

/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a"),
    stackClear = __webpack_require__("44d9"),
    stackDelete = __webpack_require__("1386"),
    stackGet = __webpack_require__("052a"),
    stackHas = __webpack_require__("2fab"),
    stackSet = __webpack_require__("e3f8");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "1f5e":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("378c");
var toAbsoluteIndex = __webpack_require__("9a0f");
var lengthOfArrayLike = __webpack_require__("0481");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "201b":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("7bdd");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2117":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("5712");
var aCallable = __webpack_require__("63d3");
var NATIVE_BIND = __webpack_require__("43f8");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "2402":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("07d9")))

/***/ }),

/***/ "24da":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("e942");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "272b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("aaf2");
var $findLast = __webpack_require__("77f6").findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "2811":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FlowInstanceDetailDialog_vue_vue_type_style_index_0_id_a61fcf3a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("75f9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FlowInstanceDetailDialog_vue_vue_type_style_index_0_id_a61fcf3a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FlowInstanceDetailDialog_vue_vue_type_style_index_0_id_a61fcf3a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2822":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("4b2c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "28eb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("6b1d");
var $reduce = __webpack_require__("98f3").left;
var arrayMethodIsStrict = __webpack_require__("7f8a");
var CHROME_VERSION = __webpack_require__("4fed");
var IS_NODE = __webpack_require__("f117");

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "292c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a692");
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8daa");


const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](config);
const USER_LIST_BY_CON_TO_POST = ajax().post('/ucenterapi/internal/account/selectAccountListByIdList');
const ORGANIZATIONAL_STRUCTURE_LIST = ajax().post('/ucenterapi/internal/org/getOrganizationalStructureList');
const PLATFORM_LIST_TO_USER = ajax().get('/ucenter/api/ucenter/dictConfigure/getDictPowerPlatformListToUser.json');
const GET_DIC_BY_TYPE = ajax().post('/ucenter/api/ucenter/dict/getDictMapByTypeList');
/* harmony default export */ __webpack_exports__["a"] = ({
  // 用户
  getUserPageListByConToPost(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(USER_LIST_BY_CON_TO_POST, params).then(res => {
        if (res.status) {
          resolve(res.data);
        } else {
          resolve(false);
        }
      }).catch(() => resolve(false));
    });
  },
  // 组织架构
  getOrganizationalStructureList(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(ORGANIZATIONAL_STRUCTURE_LIST, params).then(res => {
        if (res.status) {
          resolve(res.data);
        } else {
          resolve(false);
        }
      }).catch(() => resolve(false));
    });
  },
  getDitByDitTypes(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_DIC_BY_TYPE, params).then(res => {
        if (res.status) {
          resolve(res.data);
        } else {
          resolve(false);
        }
      }).catch(() => resolve(false));
    });
  },
  getDictPowerPlatformListToUser() {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PLATFORM_LIST_TO_USER);
  }
});

/***/ }),

/***/ "2a1b":
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(0);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ "2a3e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("da06");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "2a46":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    getPrototype = __webpack_require__("ff00"),
    isObjectLike = __webpack_require__("b4b4");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "2be6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2cbd":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "2ce5":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");
var hasOwn = __webpack_require__("7a25");
var DESCRIPTORS = __webpack_require__("d4cb");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("d331").CONFIGURABLE;
var inspectSource = __webpack_require__("df6f");
var InternalStateModule = __webpack_require__("cdcd");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2dd7":
/***/ (function(module, exports, __webpack_require__) {

var toPositiveInteger = __webpack_require__("e01a");

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ "2e65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_43c3c3f1_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b18");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_43c3c3f1_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_43c3c3f1_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "2ed5":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("73bd"),
    baseAssignValue = __webpack_require__("c02d");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "2f33":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "2fab":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "3144":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "31d7":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./DynamicDialog.vue": "b614",
	"./FlowInstanceDetailDialog.vue": "9d19",
	"./FlowTaskToReadDetail.vue": "4386",
	"./FlowTaskTodoDetail.vue": "a691",
	"./ReplaceUserDialog/add.vue": "fd13"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "31d7";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "332c":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("4cdd");
var uid = __webpack_require__("1d8a");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "3336":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("1ec9"),
    assignMergeValue = __webpack_require__("6a68"),
    baseFor = __webpack_require__("51db"),
    baseMergeDeep = __webpack_require__("71bd"),
    isObject = __webpack_require__("b506"),
    keysIn = __webpack_require__("cc7f"),
    safeGet = __webpack_require__("2cbd");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "35d9":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("f72d"),
    isObjectLike = __webpack_require__("b4b4");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "365c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _flow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4bf8");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _flow__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c7ea");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _form__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _processInstance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e46d");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _processInstance__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b199");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _task__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _uc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("292c");







/***/ }),

/***/ "36d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessingTaskPrevRecord_vue_vue_type_style_index_0_id_af5a6274_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7d8a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessingTaskPrevRecord_vue_vue_type_style_index_0_id_af5a6274_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessingTaskPrevRecord_vue_vue_type_style_index_0_id_af5a6274_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "36fa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "378c":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("83a6");
var requireObjectCoercible = __webpack_require__("730c");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "37d1":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("730c");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "3a83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__("57e0")();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("e4be");
var hasOwn = __webpack_require__("c124");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "3bf3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3ce8":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("be6c");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "3cec":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "3ee2":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("3336"),
    createAssigner = __webpack_require__("c294");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "3f1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormContent_vue_vue_type_style_index_0_id_1a6a9b4a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("80f0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormContent_vue_vue_type_style_index_0_id_1a6a9b4a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormContent_vue_vue_type_style_index_0_id_1a6a9b4a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3f3f":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "40cc":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "413d":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "416c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),

/***/ "416d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isCallable = __webpack_require__("3ce8");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "419e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_5a414eb8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_5a414eb8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommonInput_vue_vue_type_style_index_0_id_5a414eb8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "41dd":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("eff8"),
    baseUnary = __webpack_require__("494f"),
    nodeUtil = __webpack_require__("4fab");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "4386":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowTaskToReadDetail.vue?vue&type=template&id=14fccd6a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('div',[_c('form-content',{attrs:{"instId":_vm.detail.processInstanceId,"readOnly":""}}),_c('flow-record',{ref:"flowRecord",attrs:{"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment,"instId":_vm.detail.processInstanceId}}),_c('flow-diagram',{attrs:{"instId":_vm.detail.processInstanceId}}),_c('flow-action',{attrs:{"is-manage":"","toReadId":_vm.detail.id,"taskId":_vm.detail.taskId,"instId":_vm.detail.processInstanceId},on:{"handle-back":_vm.close}})],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/FlowTaskToReadDetail.vue?vue&type=template&id=14fccd6a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowTaskToReadDetail.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FlowTaskToReadDetailvue_type_script_lang_js_ = ({
  name: 'FlowTaskToReadDetail',
  data() {
    return {
      detail: null,
      hiddenComment: false,
      hiddenAssignee: false
    };
  },
  methods: {
    setValue({
      detail,
      hiddenComment,
      hiddenAssignee
    }) {
      this.detail = detail;
      this.hiddenComment = hiddenComment;
      this.hiddenAssignee = hiddenAssignee;
    },
    close() {
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/FlowTaskToReadDetail.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_FlowTaskToReadDetailvue_type_script_lang_js_ = (FlowTaskToReadDetailvue_type_script_lang_js_); 
// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/dialog/FlowTaskToReadDetail.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  dialog_FlowTaskToReadDetailvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "14fccd6a",
  null
  
)

/* harmony default export */ var FlowTaskToReadDetail = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "43f8":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "445c":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "4499":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "44d9":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "45ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TaskTransferUserDialog_vue_vue_type_style_index_0_id_4ca6328d_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e1cc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TaskTransferUserDialog_vue_vue_type_style_index_0_id_4ca6328d_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TaskTransferUserDialog_vue_vue_type_style_index_0_id_4ca6328d_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "4774":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("cd68"),
    overRest = __webpack_require__("500b"),
    setToString = __webpack_require__("ecf6");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "479b":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("a4fc"),
    isArrayLike = __webpack_require__("f72d"),
    isIndex = __webpack_require__("a67c"),
    isObject = __webpack_require__("b506");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "4912":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "494f":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "4957":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4983":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__("fb54");
var utils = __webpack_require__("57f2");
var formats = __webpack_require__("7186");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "4b2c":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "4b8b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("3a83");

var callBind = __webpack_require__("7f95");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "4bd9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4bf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a692");
/* harmony import */ var _request_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8daa");


const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](config);
const PROCESS_FORM_HTML = ajax().get('/workflow/process/formHtml');
const GET_TODO_LIST = ajax().post('/workflow/task/page/todo');
const GET_FLOW_VERID = ajax().get('/workflow/model/getMasterVersionProcessDefId/:modelKey');
const GET_DETAIL_BY_INSTID = ajax().get('/workflow/processInstance/detail');
const GET_DETAIL_BY_TASKID = ajax().get('/workflow/task');
const FIRST_ACTIVITY_BUTTON_LIST = ajax().get('/workflow/model/master/firstActivityButtonList/:modelKey');
const FORM_AND_PROCESS_INSTANCE_EXTEND_INFP = ajax().get('/workflow/task/formAndProcessInstanceExtendInfo');
const LIST_FORM_ATTACHMENT_FIELDS = ajax().get('/dynamicform/func/listFormAttachmentFields');
const ATTACHMENT_DOWNLOAD = ajax().post('/workflow/processInstance/attachmentDownload');
const HANDLE_TO_READ_MARK = ajax().get('/workflow/task/toReadTask/markHandle'); // 标记为已读
/* harmony default export */ __webpack_exports__["a"] = ({
  // 获取流程表单发起渲染页
  getFormHtml(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_FORM_HTML, params).then(res => {
        resolve(res.data);
      });
    });
  },
  getDetailByInstId(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_DETAIL_BY_INSTID, params).then(res => {
        resolve(res.data);
      });
    });
  },
  getDetailByTaskId(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_DETAIL_BY_TASKID, params).then(res => {
        resolve(res.data);
      });
    });
  },
  getFlowId(modelKey) {
    return new Promise((resolve, reject) => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_FLOW_VERID, {
        modelKey
      }).then(res => {
        if (res.status) {
          resolve(res.data);
        } else {
          reject(res);
        }
      });
    });
  },
  getTodoList(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_TODO_LIST, params).then(res => {
        resolve(res.data);
      });
    });
  },
  getFirstActivityButtonListByModelKey(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FIRST_ACTIVITY_BUTTON_LIST, params).then(res => {
        resolve(res.data);
      });
    });
  },
  getFormAndProcessInstanceExtendInfo(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FORM_AND_PROCESS_INSTANCE_EXTEND_INFP, params).then(res => {
        resolve(res.data);
      });
    });
  },
  listFormAttachmentFields(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(LIST_FORM_ATTACHMENT_FIELDS, params).then(res => {
        resolve(res.data);
      });
    });
  },
  attachmentDownload(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(ATTACHMENT_DOWNLOAD, params).then(res => {
        resolve(res);
      });
    });
  },
  handleToReadMark(params) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(HANDLE_TO_READ_MARK, params).then(res => {
        resolve(res);
      });
    });
  }
});

/***/ }),

/***/ "4c0b":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "4cdd":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("0e93");
var store = __webpack_require__("c607");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.27.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.27.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "4db4":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("cd51");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "4eac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__("84d2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasModal = false;
var hasInitZIndex = false;
var zIndex = void 0;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set: function set(value) {
    zIndex = value;
  }
});

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),

/***/ "4efd":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("d856"),
    hashDelete = __webpack_require__("54f6"),
    hashGet = __webpack_require__("f9f5"),
    hashHas = __webpack_require__("40cc"),
    hashSet = __webpack_require__("994b");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "4f98":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("3336"),
    isObject = __webpack_require__("b506");

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),

/***/ "4fa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NO_CONFIGURED_USER_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return NO_AVAILABLE_USER_THROW_MODE_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UNKNOWN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELEGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TO_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMMUNICATION_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMMUNICATION_TASK_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMMUNICATION_TASK_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TEMPSAVE; });
/* unused harmony export COUNTERSIGN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MULTI_INSTANCE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MULTI_INSTANCE_PASSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MULTI_INSTANCE_REJECT; });
/* unused harmony export DELETE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUTTON_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SCRIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HANDLE_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return HANDLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HANDLE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HANDLE_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HANDLE_ROUTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return H5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PC; });
const NO_CONFIGURED_USER_EXCEPTION = {
  code: '117034',
  message: '节点未配置审核人,请检查流程配置!'
};
const NO_AVAILABLE_USER_THROW_MODE_EXCEPTION = {
  code: '117037',
  message: '节点无可用审核人,请联系管理员！'
};
const NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION = {
  code: '117023',
  message: '下个节点【Activity_1kbmr0u】用户不存在或已离职！请手动选择流转审核人！'
};
const UNKNOWN_ERROR = {
  code: '',
  message: '未知错误，请联系管理员'
};
const APPLY = '/task/apply';
const REJECT = '/task/reject';
const DELEGATE = '/task/delegate';
const STOP = '/task/stop';
const AGENT = '/task/agent';
const TO_READ = '/task/toRead';
const COMMUNICATION_TASK = '/task/communicationTask'; // 创建沟通
const COMMUNICATION_TASK_REPLY = '/task/communicationTask/reply'; // 沟通回复
const COMMUNICATION_TASK_CANCEL = '/task/communicationTask/cancel'; // 沟通任务取消
const TEMPSAVE = '/task/tempSave'; // 保存
const COUNTERSIGN = '/task/page/manage'; // 会签
const MULTI_INSTANCE_ADD = '/multiInstance/multiAdd'; // 加签
const MULTI_INSTANCE_PASSED = '/multiInstance/multiPassed'; // 赞成会签
const MULTI_INSTANCE_REJECT = '/multiInstance/multiReject'; // 反对会签
const DELETE = '/processInstance/delete'; // 删除

const BUTTON_TYPE = {
  [APPLY]: 'APPLY',
  [REJECT]: 'REJECT',
  [STOP]: 'STOP',
  [AGENT]: 'AGENT',
  [TO_READ]: 'TO_READ',
  [DELEGATE]: 'DELEGATE',
  [COMMUNICATION_TASK]: 'COMMUNICATION_TASK',
  [COMMUNICATION_TASK_REPLY]: 'COMMUNICATION_TASK_REPLY',
  [COMMUNICATION_TASK_CANCEL]: 'COMMUNICATION_TASK_CANCEL',
  [TEMPSAVE]: 'TEMPSAVE',
  [COUNTERSIGN]: 'COUNTERSIGN',
  [MULTI_INSTANCE_ADD]: 'MULTI_INSTANCE_ADD',
  [MULTI_INSTANCE_PASSED]: 'MULTI_INSTANCE_PASSED',
  [MULTI_INSTANCE_REJECT]: 'MULTI_INSTANCE_REJECT',
  [DELETE]: 'DELETE'
};
const SCRIPT = 'SCRIPT';

// emit 事件
const HANDLE_DRAFT = 'handle-draft';
const HANDLE_SUCCESS = 'handle-success';
const HANDLE_ERROR = 'handle-error';
const HANDLE_BACK = 'handle-back';
const HANDLE_ROUTER = 'handle-router';
const ERROR = 'error';
const SUCCESS = 'success';

// 客户端
const H5 = 'H5';
const PC = 'PC';

/***/ }),

/***/ "4fab":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("7bdd");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("6984")(module)))

/***/ }),

/***/ "4fed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var userAgent = __webpack_require__("64e4");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "500b":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("cda3");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "5189":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "51db":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("445c");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "5231":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("d4cb");
var isArray = __webpack_require__("c6de");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");
var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "5428":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isCallable = __webpack_require__("3ce8");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "54f6":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "5681":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5712":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("6a61");
var uncurryThis = __webpack_require__("70b7");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "57c6":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("7526");
var createNonEnumerableProperty = __webpack_require__("5b12");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "57e0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("e3c8");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "57f2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__("7186");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "59d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_73a2e4bc_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("36fa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_73a2e4bc_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_73a2e4bc_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5b12":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var definePropertyModule = __webpack_require__("abdf");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "5ccf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5e18":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5f57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_tasks_vue_vue_type_style_index_0_id_50489b64_prod_lang_scss_scope_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ccf");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_tasks_vue_vue_type_style_index_0_id_50489b64_prod_lang_scss_scope_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_tasks_vue_vue_type_style_index_0_id_50489b64_prod_lang_scss_scope_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5ff7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DynamicDialog_vue_vue_type_style_index_0_id_2b35b0ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a430");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DynamicDialog_vue_vue_type_style_index_0_id_2b35b0ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DynamicDialog_vue_vue_type_style_index_0_id_2b35b0ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6074":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_285db914_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0c41");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_285db914_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UserDialog_vue_vue_type_style_index_0_id_285db914_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "60de":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("63d3");
var isNullOrUndefined = __webpack_require__("6566");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "63d3":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var tryToString = __webpack_require__("4912");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "64b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/component/MsgDialog.vue?vue&type=template&id=bdb8f83c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialog.visible,"width":"50%","title":_vm.dialog.title,"destroy-on-close":"","append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.dialog, "visible", $event)}}},[_c('el-descriptions',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"size":"medium","column":1,"border":""}},[_c('el-descriptions-item',{attrs:{"label":"当前表单"}},[_c('el-button',{staticClass:"el-icon-printer",attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.printForm}},[_vm._v(" 打印")])],1),_c('el-descriptions-item',{attrs:{"label":"标题"}},[_vm._v(_vm._s(_vm.detailData.processInstanceName))]),_c('el-descriptions-item',{attrs:{"label":"流程编号"}},[_vm._v(_vm._s(_vm.detailData.processInstanceId))]),_c('el-descriptions-item',{attrs:{"label":"流程定义ID"}},[_vm._v(_vm._s(_vm.detailData.processDefinitionId))]),_c('el-descriptions-item',{attrs:{"label":"流程定义版本"}},[_vm._v(_vm._s(_vm.detailData.processDefinitionVersionType == 'MASTER' ? '主版本' : '从版本'))]),_c('el-descriptions-item',{attrs:{"label":"表单formKey"}},[_vm._v(_vm._s(_vm.detailData.formKey))]),_c('el-descriptions-item',{attrs:{"label":"表单版本号"}},[_vm._v(_vm._s(_vm.detailData.formVersion))]),_c('el-descriptions-item',{attrs:{"label":"表单版本"}},[_vm._v(_vm._s(_vm.detailData.formVersionType == 'MASTER' ? '主版本' : '从版本'))]),_c('el-descriptions-item',{attrs:{"label":"当前表单附件"}},[_c('el-button',{attrs:{"type":"primary","size":"mini","round":""},on:{"click":_vm.downloadFile}},[_vm._v("下载")])],1)],1),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini","plain":""},on:{"click":_vm.closeDialog}},[_vm._v("关闭")])],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/component/MsgDialog.vue?vue&type=template&id=bdb8f83c&scoped=true&

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("365c");

// EXTERNAL MODULE: ./src/request/baseURL.js
var baseURL = __webpack_require__("0a3b");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/component/MsgDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MsgDialogvue_type_script_lang_js_ = ({
  name: 'MsgDialog',
  data() {
    return {
      dialog: {
        title: '相关信息',
        visible: false
      },
      data: {},
      detailData: {},
      loading: false,
      processInstanceId: ''
    };
  },
  created() {},
  methods: {
    show(data) {
      this.data = data;
      this.dialog = {
        title: '相关信息',
        visible: true
      };
      this.getDetail();
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    getDetail() {
      this.processInstanceId = this.data.processInstanceId || this.data.id;
      this.loading = true;
      api["a" /* Flow */].getFormAndProcessInstanceExtendInfo({
        processInstanceId: this.processInstanceId
      }).then(res => {
        this.detailData = res;
        this.loading = false;
      });
    },
    printForm() {
      let str = '',
        styles = document.querySelectorAll('style,link');
      for (let i = 0; i < styles.length; i++) {
        str += styles[i].outerHTML;
      }
      str += '<style>.inputs div:first-child{box-sizing: border-box;}.form-content__header{position:relative!important;width:100%!important;}.column-row .column-cell .cell {width: auto!important;}.commentColumn {width: 100px;}.form-content__header button {display: none;}</style>';
      let content = document.getElementById('flow-form-content').innerHTML;
      let record = document.getElementById('flow-record').innerHTML;
      let printData = content + record;
      //创建一个iframe在负像素位置
      let w,
        doc,
        iframe = document.createElement('iframe'),
        f = document.body.appendChild(iframe);
      iframe.id = 'myIframe';
      iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
      w = f.contentWindow || f.contentDocument;
      doc = f.contentDocument || f.contentWindow.document;
      doc.open();
      //把样式跟html字符串拼接输出给iframe
      doc.write(str + printData);
      doc.close();
      //iframe渲染完成后,开启打印,并销毁iframe
      iframe.onload = function () {
        w.print();
        setTimeout(function () {
          document.body.removeChild(iframe);
        }, 100);
      };
    },
    async downloadFile() {
      this.loading = true;
      let params = {
        formKey: this.detailData.formKey,
        version: this.detailData.formVersion
      };
      const form = await api["a" /* Flow */].listFormAttachmentFields(params);
      const downloadParams = {
        qry: {
          rolePlatformType: 'ASSP',
          tenantId: 'ASSP',
          processInstanceParam: {
            id: {
              value: [this.processInstanceId],
              queryType: 'LIKE'
            }
          }
        },
        fields: form.map(item => {
          delete item.modelDesc;
          return item;
        })
      };
      const data = await api["a" /* Flow */].attachmentDownload(downloadParams);
      this.loading = false;
      if (data.status) {
        this.$message.success('任务正在下载，请在【集团营销补贴 - 附件下载管理】查看');
        const asspUrl = baseURL["a" /* default */].getBaseUrl().assp;
        window.open(asspUrl + '/marketSubsidyFieldsList');
      }
      if (!data.status) this.$message.error(data.message);
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/component/MsgDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var component_MsgDialogvue_type_script_lang_js_ = (MsgDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/form/component/MsgDialog.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  component_MsgDialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "bdb8f83c",
  null
  
)

/* harmony default export */ var MsgDialog = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "64e4":
/***/ (function(module, exports) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "6566":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "65d0":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("c91c");
var enumBugKeys = __webpack_require__("b17e");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "6984":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "69f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_418dcb63_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5189");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_418dcb63_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_418dcb63_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6a61":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "6a68":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("c02d"),
    eq = __webpack_require__("a4fc");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "6a6e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6b1d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var getOwnPropertyDescriptor = __webpack_require__("185a").f;
var createNonEnumerableProperty = __webpack_require__("5b12");
var defineBuiltIn = __webpack_require__("ef30");
var defineGlobalProperty = __webpack_require__("4499");
var copyConstructorProperties = __webpack_require__("b634");
var isForced = __webpack_require__("ebac");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "6c91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_OpinionText_vue_vue_type_style_index_0_id_1ab3d07c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4bd9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_OpinionText_vue_vue_type_style_index_0_id_1ab3d07c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_OpinionText_vue_vue_type_style_index_0_id_1ab3d07c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6d2c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.rafThrottle = rafThrottle;
exports.objToArray = objToArray;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _types = __webpack_require__("e587");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var kebabCase = exports.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};

var capitalize = exports.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var looseEqual = exports.looseEqual = function looseEqual(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

var isEqual = exports.isEqual = function isEqual(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
      {
        return !val.size;
      }
    // Plain Object
    case '[object Object]':
      {
        return !Object.keys(val).length;
      }
  }

  return false;
};

function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

/***/ }),

/***/ "6dee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_cfc65ab0_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1a45");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_cfc65ab0_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_cfc65ab0_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6e6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

const eventbus = new vue__WEBPACK_IMPORTED_MODULE_0___default.a();
/* harmony default export */ __webpack_exports__["a"] = (eventbus);

/***/ }),

/***/ "6efc":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("ff7d"),
    isObjectLike = __webpack_require__("b4b4");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "70b7":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "7186":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "71bd":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("6a68"),
    cloneBuffer = __webpack_require__("1ab6"),
    cloneTypedArray = __webpack_require__("e91b"),
    copyArray = __webpack_require__("413d"),
    initCloneObject = __webpack_require__("b03d"),
    isArguments = __webpack_require__("6efc"),
    isArray = __webpack_require__("c316"),
    isArrayLikeObject = __webpack_require__("35d9"),
    isBuffer = __webpack_require__("dda8"),
    isFunction = __webpack_require__("daaf"),
    isObject = __webpack_require__("b506"),
    isPlainObject = __webpack_require__("2a46"),
    isTypedArray = __webpack_require__("41dd"),
    safeGet = __webpack_require__("2cbd"),
    toPlainObject = __webpack_require__("e127");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "71e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("050d");
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

// import Vue from 'vue'
const dataFilter = (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  if (dataStr) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(Number(dataStr)).format(pattern);
  } else {
    return '';
  }
};
// Vue.filter('dataFormat', dataFilter)
/* harmony default export */ __webpack_exports__["a"] = (dataFilter);

/***/ }),

/***/ "72df":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "730c":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("6566");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "735f":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "73bd":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("c02d"),
    eq = __webpack_require__("a4fc");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "7526":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var $documentAll = __webpack_require__("be6c");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "75f9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "773b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_2f62be9d_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e8dd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_2f62be9d_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_2f62be9d_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7745":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "77a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMENT_TYPE; });
/* unused harmony export DEFAULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROCESS_DRAFT_SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROCESS_DRAFT_MODIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODIFY_SYNC; });
const COMMENT_TYPE = [{
  label: '流程开始',
  value: 'START'
}, {
  label: '申请人提交',
  value: 'SUBMIT'
}, {
  label: '审核中',
  value: 'APPLYING'
}, {
  label: '审批通过',
  value: 'APPLY'
}, {
  label: '组任务签收',
  value: 'SIGNED'
}, {
  label: '组任务退回',
  value: 'UNSIGNED'
}, {
  label: '节点驳回',
  value: 'REJECT'
}, {
  label: '节点终止',
  value: 'STOP'
}, {
  label: '委派',
  value: 'DELEGATE'
}, {
  label: '转办',
  value: 'AGENT'
}, {
  label: '结束',
  value: 'END'
}, {
  label: '传阅',
  value: 'TOREAD'
}, {
  label: '传阅回复',
  value: 'TOREAD_REPLY'
}, {
  label: '发起沟通',
  value: 'COMMUNICATION_START'
}, {
  label: '沟通',
  value: 'COMMUNICATION'
}, {
  label: '沟通被取消',
  value: 'COMMUNICATION_CANCEL'
}, {
  label: '沟通回复',
  value: 'COMMUNICATION_REPLY'
}, {
  label: '沟通取消',
  value: 'COMMUNICATION_REJECT'
}, {
  label: '发起加签',
  value: 'ADD_MULTI_INSTANCE'
}, {
  label: '赞成会签',
  value: 'MULTI_INSTANCE_PASSED'
}, {
  label: '反对会签',
  value: 'MULTI_INSTANCE_REJECT'
}, {
  label: '删除',
  value: 'DELETE'
}];
const DEFAULT = 'DEFAULT';
const START = 'START';
const PROCESS_DRAFT_SAVE = 'PROCESS_DRAFT_SAVE';
const PROCESS_DRAFT_MODIFY = 'PROCESS_DRAFT_MODIFY';
const MODIFY_SYNC = 'MODIFY_SYNC';

/***/ }),

/***/ "77f6":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("2117");
var IndexedObject = __webpack_require__("83a6");
var toObject = __webpack_require__("37d1");
var lengthOfArrayLike = __webpack_require__("0481");

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE == 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),

/***/ "78dd":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "79ab":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "7a25":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var toObject = __webpack_require__("37d1");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "7bad":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "7bdd":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15")))

/***/ }),

/***/ "7c3f":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");
var createElement = __webpack_require__("f2bf");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "7d15":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "7d53":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var shared = __webpack_require__("4cdd");
var hasOwn = __webpack_require__("7a25");
var uid = __webpack_require__("1d8a");
var NATIVE_SYMBOL = __webpack_require__("cd51");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "7d8a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7d92":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7f8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("72df");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "7f95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("e4be");
var GetIntrinsic = __webpack_require__("3a83");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "802e":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "80f0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "815b":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "8251":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "83a6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var fails = __webpack_require__("72df");
var classof = __webpack_require__("6a61");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "846a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "84d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null && vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),

/***/ "8629":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_1_id_36a6bcde_prod_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("af97");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_1_id_36a6bcde_prod_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_1_id_36a6bcde_prod_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "86c4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_36a6bcde_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6a6e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_36a6bcde_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_36a6bcde_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "872c":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("9b9a"),
    mapCacheDelete = __webpack_require__("7745"),
    mapCacheGet = __webpack_require__("79ab"),
    mapCacheHas = __webpack_require__("f522"),
    mapCacheSet = __webpack_require__("7bad");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "88c7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UpdateNextUserDialog_vue_vue_type_style_index_0_id_4cb8044c_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5681");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UpdateNextUserDialog_vue_vue_type_style_index_0_id_4cb8044c_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UpdateNextUserDialog_vue_vue_type_style_index_0_id_4cb8044c_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "89df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAsspApiParams; });
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("28eb");
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0894");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);


/**
 * @param {string} str
 * @returns {Boolean}
 */
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}
const utils = {
  hasOwnPropertyCall: (obj, key) => {
    return Object.prototype.hasOwnProperty.call(obj, key);
  },
  isEmpty: value => {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  },
  // 获取随机的名称
  getName: () => {
    return Math.random().toString(36).substr(2, 10);
  },
  // 获取控件是否可编辑
  getWriteable: permission => {
    if (permission === 'n' || permission === 'r') {
      return false;
    }
    return true;
  },
  // 合并验证规则(如果rules和appendRules均为字符串格式，合并后仍为字符串格式；如果其中一个为Object格式，合并后为Object格式。)
  mergeValidate: (rules, appendRules) => {
    if (!appendRules || appendRules.constructor !== Object && appendRules.constructor !== String) {
      return rules;
    }
    let rulesTypeIsString = true,
      appendTypeIsString = appendRules.constructor === String,
      finalTypeIsString = true;
    if (rules === undefined || rules === null) {
      rulesTypeIsString = appendTypeIsString;
      rules = appendTypeIsString ? '' : {};
    } else if (rules.constructor === Object || rules.constructor === String) {
      rulesTypeIsString = rules.constructor === String;
    } else {
      throw `rules的类型为${typeof rules}，只能为Object类型或String类型。`;
    }
    finalTypeIsString = rulesTypeIsString && appendTypeIsString;
    // 仍然以String格式
    if (finalTypeIsString) {
      const ruleAry = utils.stringSplit(rules, '|');
      const appendAry = utils.stringSplit(appendRules, '|');
      let ruleObj = {},
        appendObj = {};
      ruleAry.forEach(r => {
        const k = utils.stringSplit(r, ':')[0];
        ruleObj[k] = r;
      });
      appendAry.forEach(a => {
        const k = utils.stringSplit(a, ':')[0];
        appendObj[k] = a;
      });
      // 如果旧规则中存在与追加规则中的同名规则，则使用追加规则覆盖旧规则。
      const mergeObj = Object.assign(ruleObj, appendObj);
      return Object.values(mergeObj).join('|');
    }
    // 转换为Object格式
    else {
      let ruleObj = {},
        appendObj = {};
      if (rulesTypeIsString) {
        ruleObj = utils.validateString2Object(rules);
      } else {
        ruleObj = {
          ...rules
        };
      }
      if (appendTypeIsString) {
        appendObj = utils.validateString2Object(appendRules);
      } else {
        appendObj = {
          ...appendRules
        };
      }
      return Object.assign(ruleObj, appendObj);
    }
  },
  // 减少校验规则
  reduceValidate: (rules, reduceRules) => {
    if (!rules || !reduceRules || reduceRules.constructor !== Object && reduceRules.constructor !== String) {
      return rules;
    }
    // 要减少的校验规则的名称集合
    let reduceRuleNames = [];
    if (reduceRules.constructor === String) {
      const reduceRuleObj = utils.validateString2Object(reduceRules);
      reduceRuleNames = Object.keys(reduceRuleObj);
    } else {
      reduceRuleNames = Object.keys(reduceRules);
    }
    if (rules.constructor === Object) {
      Object.keys(rules).forEach(k => {
        if (reduceRuleNames.some(n => n == k)) {
          delete rules[k];
        }
      });
      return rules;
    } else if (rules.constructor === String) {
      const ruleAry = utils.stringSplit(rules, '|');
      const nRuleAry = ruleAry.reduce((ary, r) => {
        const name = utils.stringSplit(r, ':')[0];
        if (reduceRuleNames.every(m => m != name)) {
          ary.push(r);
        }
        return ary;
      }, []);
      return nRuleAry.join('|');
    } else {
      throw `rules的类型为${typeof rules}，只能为Object类型或String类型。`;
    }
  },
  // 字符串格式的校验规则转为对象格式
  validateString2Object: rule => {
    if (!rule || rule.constructor !== String) {
      return rule;
    }
    let obj = {};
    const ary = utils.stringSplit(rule, '|');
    ary.forEach(m => {
      const regAndArgs = utils.stringSplit(m, ':');
      if (regAndArgs.length == 1) {
        obj[regAndArgs[0]] = true;
      } else if (regAndArgs.length > 1) {
        const args = utils.stringSplit(regAndArgs[1], ',');
        obj[regAndArgs[0]] = args;
      }
    });
    return obj;
  },
  // 字符串str按照sep分割为数组，并清理掉数组结果中的空白项。
  stringSplit: (str, sep) => {
    if (!str || str.constructor !== String || !sep || sep.constructor !== String) {
      return [];
    }
    let ary = str.split(sep);
    ary = ary.map(p => {
      return p.trim();
    });
    ary = ary.trim();
    return ary;
  },
  // 获取控件是否添加必填校验
  addRequiredOrNot: (permission, validate) => {
    if (permission !== 'b') {
      return validate;
    }
    if (validate === undefined || validate === null) {
      validate = '';
    }
    return utils.mergeValidate('required', validate);
  },
  // 格式化日期时间
  formatDate: value => {
    let date = null;
    if (!value) {
      return date;
    }
    if (value.constructor == Date && !isNaN(value.getTime())) {
      date = value;
    } else if (value.constructor == String || value.constructor == Number) {
      date = new Date(value);
    } else {
      throw '格式化日期时，传入的数据格式不正确。';
    }
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? '0' + MM : MM;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let m = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
  },
  // 格式化日期
  formatDateYear: value => {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? '0' + MM : MM;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + MM + '-' + d;
  },
  // 日期1是否早于日期2
  dateIsBefore: (dateOne, dateTwo, canEquals) => {
    if (!dateOne || !dateTwo) {
      return true;
    }
    //兼容苹果浏览器写法 "- 符号替换成/"
    dateOne = dateOne.replace(/-/g, '/');
    dateTwo = dateTwo.replace(/-/g, '/');
    var date1 = new Date(dateOne).getTime() || new Date(new Date().format('yyyy-MM-dd') + ' ' + dateOne).getTime();
    var date2 = new Date(dateTwo).getTime() || new Date(new Date().format('yyyy-MM-dd') + ' ' + dateTwo).getTime();
    if (!canEquals) {
      //大于。v2>v1 。
      if (date2 > date1) {
        return true;
      } else {
        return false;
      }
    } else {
      //大于等于。v2>=v1 。只要v1不大于v2即可
      if (date1 > date2) {
        return false;
      } else {
        return true;
      }
    }
  },
  // 日期计算，不传单位时，默认以'天'为单位计算
  dateCalc: (startDate, endDate, op) => {
    if (!startDate || !endDate || startDate.length == 0 || endDate.length == 0) {
      return 0;
    }
    if (!op || op.constructor != String) {
      op = 'day';
    }
    const opAry = ['year', 'month', 'day', 'hour', 'minute', 'second'];
    if (opAry.indexOf(op) == -1) {
      throw `计算日期的单位只能从${opAry}中选择`;
    }
    let date1 = new Date(Date.parse(startDate.replace(/-/g, '/'))).getTime();
    let date2 = new Date(Date.parse(endDate.replace(/-/g, '/'))).getTime();
    if (!Number.isInteger(date1) || !Number.isInteger(date2)) {
      const now = new Date();
      let nowStr = now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();
      if (!Number.isInteger(date1)) {
        date1 = new Date(`${nowStr} ${startDate}`).getTime();
      }
      if (!Number.isInteger(date1)) {
        date2 = new Date(`${nowStr} ${endDate}`).getTime();
      }
      if (!Number.isInteger(date1) || !Number.isInteger(date2)) {
        return 0;
      }
    }
    let res = 0;
    let days = date2 - date1;
    switch (op) {
      case 'year':
        res = parseInt(days / (1000 * 60 * 60 * 24 * 30 * 12));
        break;
      case 'month':
        res = parseInt(days / (1000 * 60 * 60 * 24 * 30));
        break;
      case 'day':
        res = parseInt(days / (1000 * 60 * 60 * 24));
        break;
      case 'hour':
        res = parseInt(days / (1000 * 60 * 60));
        break;
      case 'minute':
        res = parseInt(days / (1000 * 60));
        break;
      case 'second':
        res = parseInt(days / 1000);
    }
    return res;
  },
  nest2tile: (arr, childrenKey, obtainChildren) => {
    if (!childrenKey) {
      childrenKey = 'children';
    }
    return [].concat(...arr.map(item => {
      let _item = {
        ...item
      };
      if (obtainChildren == undefined || obtainChildren == false) {
        delete _item[childrenKey];
      }
      return [].concat(_item, ...utils.nest2tile(item[childrenKey]));
    }));
  },
  // 平铺结构转嵌套结构
  tile2nest: (array, key, pKey, childrenKey) => {
    if (!array || array.constructor !== Array) {
      return array;
    }
    // 复制一份，避免修改原始数组
    let ary = [...array];
    key = key || 'id';
    pKey = pKey || 'parentId';
    childrenKey = childrenKey || 'children';
    // 定义一个待移除数组
    let ary2remove = [];
    ary.map(item => {
      if (item[key] !== item[pKey]) {
        // 找父节点
        let p = ary.filter(c => c[key] === item[pKey]);
        if (p && p.length == 1) {
          p[0][childrenKey] = p[0][childrenKey] || [];
          // 将子节点放到父节点中
          p[0][childrenKey].push(item);
          ary2remove.push(item[key]);
        }
      }
    });
    // 遍历移除待删除对象
    ary2remove.map(item => {
      ary = ary.filter(c => c[key] !== item);
    });
    return ary;
  },
  // 获取控件所在表单对应的实例对象
  getOnlineFormInstance: instance => {
    if (instance == instance.$root) {
      return instance;
    }
    if (!instance) {
      throw 'VueComponent实例为空.';
    }
    // eslint-disable-next-line no-prototype-builtins
    if (instance.hasOwnProperty('watchMap')) {
      return instance;
    } else if (instance.$parent) {
      return utils.getOnlineFormInstance(instance.$parent);
    }
  },
  // 获取子表每一行所在的作用域元素及索引
  getSubScopeElAndIndex: el => {
    const subScopeEl = utils.getParentElementByAttribute(el, 'data-subname');
    if (!subScopeEl) {
      return {
        subScopeEl: null,
        index: null
      };
    }
    let index = subScopeEl.dataset['index'];
    if (index === undefined) {
      throw '要计算的子表行未获取到index属性.';
    }
    index = Number.parseInt(index);
    return {
      subScopeEl,
      index
    };
  },
  // 在子表指定行中通过v-model表达式获取input对应的vue实例
  getSubInputScopeByModelExpression: (subScopeEl, expression) => {
    const inputAry = subScopeEl.getElementsByClassName('inputs');
    let result = null;
    for (var i = 0, c; c = inputAry[i++];) {
      let expressionName = c.__vue__.$vnode.data.model.expression;
      // 兼容front端使用
      if (c.__vue__.$vnode && c.__vue__.$vnode.componentOptions && c.__vue__.$vnode.componentOptions.propsData && c.__vue__.$vnode.componentOptions.propsData.modelExpression) {
        expressionName = c.__vue__.$vnode.componentOptions.propsData.modelExpression;
      }
      if (c && c.__vue__ && c.__vue__.$vnode.data.model && expressionName === expression) {
        result = c.__vue__;
      }
    }
    return result;
  },
  // 获取在线表单的json格式字符串的表单数据(validate参数决定是否需要对表单进行验证)
  validateForm: (instance, scopeName) => {
    return new Promise((resolve, reject) => {
      instance.$root.$validator.validateAll(scopeName).then(result => {
        if (result) {
          resolve(result);
        } else {
          reject(instance.$root.$validator.errors.items);
        }
      });
    });
  },
  // 获取指定dom元素的父级中具有指定属性的dom元素
  getParentElementByAttribute: (el, attribute) => {
    if (el === null || el === undefined) {
      return null;
    }
    if (!el.hasAttribute || typeof el.hasAttribute != 'function') {
      throw '传入的元素el不能为空且必须为HTMLHtmlElement类型.';
    }
    if (!attribute || attribute.constructor !== String) {
      throw '传入的属性attribute不能为空且必须为String类型.';
    }
    if (el.hasAttribute(attribute)) {
      return el;
    } else if (el.tagName === 'HTML') {
      return null;
    } else {
      return utils.getParentElementByAttribute(el.parentElement, attribute);
    }
  },
  // 从父级dom元素中获取指定属性的值
  getSomeAttributeFromParentElement: (el, attribute) => {
    let pEl = utils.getParentElementByAttribute(el, attribute);
    if (pEl && pEl.getAttribute && pEl.getAttribute.constructor === Function) {
      return pEl.getAttribute(attribute);
    }
    return null;
  },
  // 将子表属性路径转换为完整的属性路径，例如：item.name => data.sub[0].name
  getWholePathOfSub: function getWholePathOfSub(subPath, mainPath, index) {
    if (!subPath || !mainPath || index === null || !Number.isInteger(index)) {
      return null;
    }
    var match = subPath.split('.');
    if (match && match.length > 1) {
      return ''.concat(mainPath, '[').concat(index, '].').concat(match[match.length - 1]);
    }
    return null;
  },
  // 通过路径取得对象中的属性
  getValueByPath: (obj, path, subIndex) => {
    if (!obj || !path || path.constructor != String) {
      return null;
    }
    if (!/^\w?.*[\w|\]]$/.test(path)) {
      return null;
    }
    let pathAry = path.split('.');
    if (pathAry.length == 1) {
      return obj[path];
    } else if (pathAry.length > 1) {
      let ret = obj;
      for (var i = 0; i < pathAry.length; i++) {
        if (ret === null || ret === undefined) {
          return null;
        }
        const key = pathAry[i];
        const match = /^(\w+)\[(\d+)\]$/.exec(key);
        if (match) {
          ret = ret[match[1]][match[2]];
        } else if (ret && ret.constructor === Array) {
          let index = 0;
          if (subIndex != null && subIndex != undefined) {
            let preIndex = Number.parseInt(subIndex);
            if (!isNaN(preIndex)) {
              index = preIndex;
            }
          }
          ret = ret[index][key];
        } else {
          ret = ret[key];
        }
      }
      return ret;
    }
    return null;
  },
  // 通过路径设置对象中的属性
  setValueByPath: (obj, path, value, subIndex) => {
    if (!obj || !path || path.constructor != String) {
      return;
    }
    if (!/^\w?.*[\w|\]]$/.test(path)) {
      return;
    }
    let pathAry = path.split('.');
    if (pathAry.length == 1) {
      obj[path] = value;
    } else if (pathAry.length > 1) {
      let ret = obj;
      for (var i = 0; i < pathAry.length; i++) {
        const key = pathAry[i];
        const match = /^(\w+)\[(\d+)\]$/.exec(key);
        if (i == pathAry.length - 1) {
          if (match) {
            ret[match[1]][match[2]] = value;
          } else if (ret && ret.constructor === Array) {
            let index = 0;
            if (subIndex != null && subIndex != undefined) {
              let preIndex = Number.parseInt(subIndex);
              if (!isNaN(preIndex)) {
                index = preIndex;
              }
            }
            ret[index][key] = value;
          } else {
            ret[key] = value;
          }
        } else {
          if (match) {
            ret = ret[match[1]][match[2]];
          } else {
            ret = ret[key];
          }
        }
      }
    }
  },
  /**
   * 将字符串转为json对象。
   * @param jsonStr
   * @param type  可不填写parseToJson
   * @returns
   */
  parseToJson: (jsonStr, type) => {
    type = type || 1;
    if (!jsonStr || jsonStr === '') return null;
    try {
      switch (type) {
        case 1:
          return JSON.parse(jsonStr);
        case 2:
          return eval(`(${jsonStr})`);
        default:
          throw '解析json对象错误';
      }
    } catch (e) {
      return utils.parseToJson(jsonStr, type + 1);
    }
  },
  /**
   * 将数字转换成人名币大写。
   *
   * @param currencyDigits
   * @returns
   */
  convertCurrency: currencyDigits => {
    var MAXIMUM_NUMBER = 99999999999.99;
    var CN_ZERO = '零';
    var CN_ONE = '壹';
    var CN_TWO = '贰';
    var CN_THREE = '叁';
    var CN_FOUR = '肆';
    var CN_FIVE = '伍';
    var CN_SIX = '陆';
    var CN_SEVEN = '柒';
    var CN_EIGHT = '捌';
    var CN_NINE = '玖';
    var CN_TEN = '拾';
    var CN_HUNDRED = '佰';
    var CN_THOUSAND = '仟';
    var CN_TEN_THOUSAND = '万';
    var CN_HUNDRED_MILLION = '亿';
    var CN_SYMBOL = '';
    var CN_DOLLAR = '元';
    var CN_TEN_CENT = '角';
    var CN_CENT = '分';
    var CN_INTEGER = '整';
    var integral;
    var decimal;
    var outputCharacters;
    var parts;
    var digits, radices, bigRadices, decimals;
    var zeroCount;
    var i, p, d;
    var quotient, modulus;
    currencyDigits = currencyDigits.toString();
    if (currencyDigits == '') {
      return '';
    }
    if (currencyDigits.match(/[^,.\d]/) != null) {
      return '';
    }
    if (currencyDigits.match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
      return '';
    }
    currencyDigits = currencyDigits.replace(/,/g, '');
    currencyDigits = currencyDigits.replace(/^0+/, '');
    if (Number(currencyDigits) > MAXIMUM_NUMBER) {
      return '';
    }
    parts = currencyDigits.split('.');
    if (parts.length > 1) {
      integral = parts[0];
      decimal = parts[1];
      decimal = decimal.substr(0, 2);
    } else {
      integral = parts[0];
      decimal = '';
    }
    digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
    radices = new Array('', CN_TEN, CN_HUNDRED, CN_THOUSAND);
    bigRadices = new Array('', CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
    decimals = new Array(CN_TEN_CENT, CN_CENT);
    outputCharacters = '';
    if (Number(integral) > 0) {
      zeroCount = 0;
      for (i = 0; i < integral.length; i++) {
        p = integral.length - i - 1;
        d = integral.substr(i, 1);
        quotient = p / 4;
        modulus = p % 4;
        if (d == '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            outputCharacters += digits[0];
          }
          zeroCount = 0;
          outputCharacters += digits[Number(d)] + radices[modulus];
        }
        if (modulus == 0 && zeroCount < 4) {
          outputCharacters += bigRadices[quotient];
        }
      }
      outputCharacters += CN_DOLLAR;
    }
    if (decimal != '') {
      for (i = 0; i < decimal.length; i++) {
        d = decimal.substr(i, 1);
        if (d != '0') {
          outputCharacters += digits[Number(d)] + decimals[i];
        }
      }
    }
    if (outputCharacters == '') {
      outputCharacters = CN_ZERO + CN_DOLLAR;
    }
    if (decimal == '') {
      outputCharacters += CN_INTEGER;
    }
    outputCharacters = CN_SYMBOL + outputCharacters;
    return outputCharacters;
  },
  /**
   * 通过name获取页面url地址参数
   * @param name
   * @returns
   *
   */
  getUrlKey: name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [undefined, ''])[1].replace(/\+/g, '%20')) || null;
  },
  // 返回调整顺序后的数组 part：数组中的一个或多个元素， direct：调整的方向  up：向上  down：向下
  arrayMove: (ary, part, direct) => {
    direct = direct || 'down';
    if (!part || part.constructor !== Object && part.constructor !== Array) {
      return ary;
    }
    if (part.constructor === Object) {
      part = [part];
    }
    if (direct == 'up') {
      part.forEach(m => {
        let index = ary.indexOf(m, 1);
        if (index > 0) {
          let newAry = [...ary];
          newAry[index - 1] = ary[index];
          newAry[index] = ary[index - 1];
          ary = newAry;
        }
      });
    } else if (direct == 'down') {
      for (var i = part.length - 1, m; m = part[i--];) {
        let index = ary.indexOf(m, 0);
        if (index > -1 && index < ary.length - 1) {
          let newAry = [...ary];
          newAry[index + 1] = ary[index];
          newAry[index] = ary[index + 1];
          ary = newAry;
        }
      }
    }
    return ary;
  },
  // 通过配置中指定的key所对应的属性路径在当前表单中获取对应的值，支持通过data.main.name 或者是 item.name来分别获取主表数据及子表数据的情况
  getValueByConfigKey: (inst, config, key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!config.hasOwnProperty(key)) {
      throw `config对象中未找到属性${key}`;
    }
    const keyPath = config[key];
    // 获取当前组件所在的表单
    const formInst = utils.getOnlineFormInstance(inst.$parent);
    // 获取当前组件是否在子表中的某一行
    const {
      subScopeEl,
      index
    } = utils.getSubScopeElAndIndex(inst.$el);
    if (subScopeEl) {
      //判断是否有孙表
      let paths = subScopeEl.dataset['subname'];
      if (paths.split('.').length == 4 && paths.indexOf('[') == -1) {
        //孙表回填路径
        paths = paths.split('.')[0] + '.' + paths.split('.')[1] + '.' + paths.split('.')[2] + '[' + parseInt(utils.getSomeAttributeFromParentElement(inst.$el, 'sub-index')) + ']' + '.' + paths.split('.')[3];
      }
      // 将item.name这样的路径替换为data.sub[0].name这样的全路径格式
      let wholeKeyPath = utils.getWholePathOfSub(keyPath, paths, index);
      return utils.getValueByPath(formInst, wholeKeyPath);
    } else {
      return utils.getValueByPath(formInst, keyPath);
    }
  },
  // 通过配置中指定的key来设置值到对应的属性路径上，支持设置主表数据data.main.name 或设置子表数据item.name
  setValueByConfigKey: (inst, config, key, value) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!config.hasOwnProperty(key)) {
      return;
    }
    const keyPath = config[key];
    // 获取当前组件所在的表单
    const formInst = utils.getOnlineFormInstance(inst.$parent);
    // 获取当前组件是否在子表中的某一行
    const {
      subScopeEl,
      index
    } = utils.getSubScopeElAndIndex(inst.$el);
    if (subScopeEl) {
      //判断是否有孙表
      let paths = subScopeEl.dataset['subname'];
      if (paths.split('.').length == 4 && paths.indexOf('[') == -1) {
        //孙表回填路径
        paths = paths.split('.')[0] + '.' + paths.split('.')[1] + '.' + paths.split('.')[2] + '[' + parseInt(utils.getSomeAttributeFromParentElement(inst.$el, 'sub-index')) + ']' + '.' + paths.split('.')[3];
      }
      // 将item.name这样的路径替换为data.sub[0].name这样的全路径格式
      let wholeKeyPath = utils.getWholePathOfSub(keyPath, paths, index);
      utils.setValueByPath(formInst, wholeKeyPath, value);
    } else {
      utils.setValueByPath(formInst, keyPath, value);
    }
  },
  // 判断两个对象是否相等（props为属性数组，有传入时，只比对传入的属性是否相等）
  objectEquals: (obj1, obj2, props) => {
    if (!props || props.constructor !== Array) {
      props = [];
    }
    if (!obj1 || !obj2) {
      return obj1 === obj2;
    }
    for (var propName in obj1) {
      if (props.length > 0 && props.indexOf(propName) === -1) {
        continue;
      }
      // eslint-disable-next-line no-prototype-builtins
      if (obj1.hasOwnProperty(propName) != obj2.hasOwnProperty(propName)) {
        return false;
      } else if (typeof obj1[propName] != typeof obj2[propName]) {
        return false;
      }
    }
    // eslint-disable-next-line no-redeclare
    for (var propName in obj2) {
      if (props.length > 0 && props.indexOf(propName) === -1) {
        continue;
      }
      // eslint-disable-next-line no-prototype-builtins
      if (obj1.hasOwnProperty(propName) != obj2.hasOwnProperty(propName)) {
        return false;
      } else if (typeof obj1[propName] != typeof obj2[propName]) {
        return false;
      }
      // eslint-disable-next-line no-prototype-builtins
      if (!obj1.hasOwnProperty(propName)) {
        continue;
      }
      if (obj1[propName] instanceof Array && obj2[propName] instanceof Array) {
        if (!utils.arrayEquals(obj1[propName], obj2[propName])) {
          return false;
        }
      } else if (obj1[propName] instanceof Object && obj2[propName] instanceof Object) {
        if (!utils.objectEquals(obj1[propName], obj2[propName])) {
          return false;
        }
      } else if (obj1[propName] != obj2[propName]) {
        return false;
      }
    }
    return true;
  },
  // 判断两个数组是否相等，支持数组中元素为对象时的深度对比
  arrayEquals: (ary1, ary2) => {
    if (!ary1 || !ary2) {
      return ary1 === ary2;
    }
    if (ary1.length != ary2.length) {
      return false;
    }
    for (var i = 0, l = ary1.length; i < l; i++) {
      if (ary1[i] instanceof Array && ary2[i] instanceof Array) {
        if (!utils.arrayEquals(ary1[i], ary2[i])) {
          return false;
        }
      } else if (ary1[i] instanceof Object && ary2[i] instanceof Object) {
        if (!utils.objectEquals(ary1[i], ary2[i])) {
          return false;
        }
      } else if (ary1[i] != ary2[i]) {
        return false;
      }
    }
    return true;
  },
  // 以第一行文本的缩进空格数为基准，后续的每一行都去掉这个基准所对应的空格。
  trimEachLine: text => {
    if (!text || text.constructor != String || text.indexOf('\n') == -1) {
      return text;
    }
    let ary = text.split('\n'),
      totem = 0;
    return ary.reduce((prev, cur, index) => {
      if (index == 1) {
        const match = /^(\s+).*$/.exec(cur);
        match && match.length == 2 && (totem = match[1].length);
      }
      return prev + '\n' + cur.slice(totem, cur.length);
    });
  },
  // 获取字符串的哈希编码
  hashCode: text => {
    var hash = 0,
      char;
    if (text.length == 0) return hash;
    for (var i = 0; i < text.length; i++) {
      char = text.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return hash;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (utils);

// 在数组上扩展一个删除指定项的方法
Array.prototype.remove = function (item) {
  let index = this.findIndex(v => v === item);
  if (index > -1) {
    this.splice(index, 1);
  }
};

// 在数组上扩展一个去重的方法
Array.prototype.unique = function (arg) {
  const res = new Map();
  return this.filter(m => {
    if (arg) {
      return !res.has(m[arg]) && res.set(m[arg], 1);
    } else {
      return !res.has(m) && res.set(m, 1);
    }
  });
};

// 去除数组中的空字符串选项
Array.prototype.trim = function () {
  return this.filter(m => m !== '');
};

// 按照数组中的指定key将数组进行分组
Array.prototype.groupByKey = function (key) {
  let res = {};
  this.forEach(m => {
    let group = res[m[key]];
    if (!group) {
      group = [];
      res[m[key]] = group;
    }
    group.push(m);
  });
  return res;
};

// 按照数组中的指定key将数组进行分组
Array.prototype.groupByKey = function (key) {
  let res = {};
  this.forEach(m => {
    let group = res[m[key]];
    if (!group) {
      group = [];
      res[m[key]] = group;
    }
    group.push(m);
  });
  return res;
};

// 将数组对象中的某一个属性值单独抽取出来成为一个新的数组  [{id:'1',name:'苹果'},{id:'2',name:'香蕉'}].extractByKey("id") ==> ['1','2']
Array.prototype.extractByKey = function (key) {
  let set = new Set();
  this.forEach(m => {
    if (key && m[key]) {
      set.add(m[key]);
    }
  });
  return Array.from(set);
};

/**
 * 日期格式化。
 * 日期格式：
 * yyyy，yy 年份
 * MM 大写表示月份
 * dd 表示日期
 * hh 表示小时
 * mm 表示分钟
 * ss 表示秒
 * q  表示季度
 * 实例如下：
 * var now = new Date();
 * var nowStr = now.format("yyyy-MM-dd hh:mm:ss");
 */
Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1,
    //month
    'd+': this.getDate(),
    //day
    'h+': this.getHours(),
    //hour
    'H+': this.getHours(),
    //hour
    'm+': this.getMinutes(),
    //minute
    's+': this.getSeconds(),
    //second
    'q+': Math.floor((this.getMonth() + 3) / 3),
    //quarter
    S: this.getMilliseconds() //millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
};
const downloadBlob = (blob, fileName) => {
  // 下载的文件名
  const filename = `${fileName}`;
  // 创建隐藏的可下载链接
  const eleLink = document.createElement('a');
  eleLink.download = filename;
  eleLink.style.display = 'none';
  // 下载内容转变成blob地址
  eleLink.href = window.URL.createObjectURL(blob);
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
};
function getAsspApiParams(key, value, group, operation, relation) {
  const signList = ['AND', 'OR', 'LIKE', 'IN'];
  if (!signList.includes(relation)) {
    console.error('只允许传入AND,OR,LIKE操作符');
    return null;
  }
  return {
    property: key,
    value: value,
    group: group || 'main',
    operation: operation || 'LIKE',
    relation: relation
  };
}

/***/ }),

/***/ "8ba6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("5428");
var hasOwn = __webpack_require__("7a25");
var createNonEnumerableProperty = __webpack_require__("5b12");
var isPrototypeOf = __webpack_require__("fb9b");
var setPrototypeOf = __webpack_require__("c1a2");
var copyConstructorProperties = __webpack_require__("b634");
var proxyAccessor = __webpack_require__("1702");
var inheritIfRequired = __webpack_require__("8fa9");
var normalizeStringArgument = __webpack_require__("aa4d");
var installErrorCause = __webpack_require__("57c6");
var installErrorStack = __webpack_require__("f241");
var DESCRIPTORS = __webpack_require__("d4cb");
var IS_PURE = __webpack_require__("0e93");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8daa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ request; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ reqWebApi; });

// UNUSED EXPORTS: asyncRequest, _ajax, __POST, __GET

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/element-ui/lib/message.js
var lib_message = __webpack_require__("e3ca");
var message_default = /*#__PURE__*/__webpack_require__.n(lib_message);

// CONCATENATED MODULE: ./src/request/interceptors/response-handle-newsso.js

/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2018/9/15
 * Time: 14:12
 * Desc: 返回码统一处理
 */

/* harmony default export */ var response_handle_newsso = ([response => {
  if (response && ['110001', '110013', '110016'].join(',').indexOf(response.data.code) !== -1) {
    window.location = response.data.data + encodeURIComponent(location.href) + `&AppCode=PUMA&SubAppCode=PUMAPC001`;
  } else if (response.data.code && !(response.data.code === '200' || response.data.code === '100000')) {
    let message = response.data.message || response.data.msg || response.data.exception || response.data.errMsg || '未知异常';
    // 导入模版提示使用其他提示框
    if (response.config.url.indexOf('templateImport') === -1) {
      // Message.error(message)
    }
  }
  return response;
}, error => {
  const response = error.response;
  if (response && ['110001', '110013', '110016'].join(',').indexOf(response.data.code) !== -1) {
    window.location = response.data.data + encodeURIComponent(location.href) + `&AppCode=PUMA&SubAppCode=PUMAPC001`;
  } else {
    let message = response.data.message || response.data.msg || response.data.exception || response.data.errMsg || '未知异常';
    message_default()({
      message: `服务器异常，请稍后再试！(${message})`,
      type: 'error',
      duration: 0,
      showClose: true
    });
  }
  Promise.reject(error);
}]);
// CONCATENATED MODULE: ./src/request/interceptors/set-app-code.js
/**
 * 设置appCode
 */
let cacheSubAppCode = '';
/* harmony default export */ var set_app_code = ([config => {
  let _subAppCode = '';
  if (cacheSubAppCode) {
    _subAppCode = cacheSubAppCode;
  } else {
    _subAppCode = cacheSubAppCode = sessionStorage.getItem('__PLUGIN_SUB_APPCODE__');
  }
  if (!config.headers) {
    config.headers = {};
  }
  config.headers['AppCode'] = _subAppCode.slice(0, 4);
  config.headers['SubAppCode'] = _subAppCode;
  return config;
}, error => Promise.reject(error)]);
// EXTERNAL MODULE: ./src/request/utils.js + 2 modules
var utils = __webpack_require__("f9c6");

// CONCATENATED MODULE: ./src/request/interceptors/request-with-token.js

/* harmony default export */ var request_with_token = ([config => {
  const token = Object(utils["b" /* getToken */])();
  if (token) {
    config.headers['Oauth2-AccessToken'] = token;
  }
  return config;
}, error => Promise.reject(error)]);
// CONCATENATED MODULE: ./src/request/interceptors/retry-when-timeout.js
/**
 * 请求超时，重新请求
 */

/* harmony default export */ var retry_when_timeout = ([response => response, error => {
  const config = error.config;
  if (!config || !config.retry) return Promise.reject(error);
  config.__retryCount = config.__retryCount || 0;
  if (config.__retryCount >= config.retry) {
    return Promise.reject(error);
  }
  config.__retryCount += 1;
  const delayRetry = new Promise(resolve => {
    setTimeout(() => resolve(), config.retryDelay || 0);
  });
  return delayRetry.then(() => Axios(config));
}]);
// CONCATENATED MODULE: ./src/request/axios.js





axios_default.a.defaults.timeout = 1000 * 60 * 2;
axios_default.a.defaults.retry = 3;
axios_default.a.defaults.retryDelay = 500;
const Axios = axios_default.a.create({
  withCredentials: true,
  'X-Requested-With': 'XMLHttpRequest'
});
// 请求拦截（配置发送请求的信息
Axios.interceptors.request.use(...set_app_code);
Axios.interceptors.request.use(...request_with_token);
// Axios.interceptors.request.use(...handleRequestCancel);
Axios.interceptors.request.use(config => config, error => {
  return Promise.reject(error);
});

// 响应拦截（配置请求回来的信息）
Axios.interceptors.response.use(...response_handle_newsso);
// Axios.interceptors.response.use(...handleResponseCancel);
Axios.interceptors.response.use(...retry_when_timeout);
axios_default.a.interceptors.response.use(response => response, error => {
  return Promise.reject(error);
});
const AxiosWebApi = axios_default.a.create();
AxiosWebApi.interceptors.request.use(...set_app_code);
AxiosWebApi.interceptors.request.use(...request_with_token);
AxiosWebApi.interceptors.request.use(config => config, error => {
  return Promise.reject(error);
});

// EXTERNAL MODULE: ./src/request/baseURL.js
var baseURL = __webpack_require__("0a3b");

// EXTERNAL MODULE: ./src/request/convertors/ajax-config.js + 2 modules
var ajax_config = __webpack_require__("a692");

// CONCATENATED MODULE: ./src/request/index.js
/**
 * 异步接口调用，与同步接口调用
 */




/**
 * 异步请求获取cms接口
 * @param api
 * @param data
 * @returns {Promise<any>}
 */
const request = (api, data) => new Promise((resolve, reject) => {
  const params = api.setData(data);
  params.baseURL = baseURL["a" /* default */].getBaseUrl().apigateway;
  Axios(params).then(result => {
    resolve(result.data);
  }).catch(error => {
    if (!error.response) {
      return;
    }
    reject(error);
  });
});

/**
 * 同步请求
 * @param api
 * @param data
 * @returns {Promise<*>}
 */
const asyncRequest = async (api, data) => {
  try {
    return await Axios(api.setData(data));
  } catch (error) {
    return Promise.reject(error);
  }
};
const reqWebApi = (url, method, data) => {
  new Promise((resolve, reject) => {
    const _methods = method.toLocaleLowerCase();
    const _params = {
      url: url,
      method: _methods,
      baseURL: BASE_URL.apigateway
    };
    if (_methods === 'get') {
      _params.params = data;
    } else if (_methods === 'post') {
      _params.data = data;
    }
    AxiosWebApi(_params).then(result => {
      resolve(result.data);
    }).catch(error => {
      if (!error.response) {
        return;
      }
      reject(error);
    });
  });
};

/**
 * @deprecated It will be deleted in future
 * @method _ajax
 * */
const _ajax = (path, data, type) => {
  const ajax = config => new ajax_config["a" /* default */](config);
  const url = typeof path === 'string' ? path : path.pathname;
  let api = 'get';
  if (type === 'post') {
    api = ajax().post(url);
  }
  if (type === 'get') {
    api = ajax().get(url);
  }
  const params = api.setData(data);
  if (typeof path !== 'string') {
    params.baseURL = path.origin;
  }
  return Axios(params).then(result => result.data).catch(error => error);
};
/**
 * @deprecated It will be deleted in future
 * @method __POST
 * */
const __POST = (path, data) => _ajax(path, data, 'post');
/**
 * @deprecated It will be deleted in future
 * @method __GET
 * */
const __GET = (path, data) => _ajax(path, data, 'get');

/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "8eda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessSummary_vue_vue_type_style_index_0_id_1a7e81fb_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3bf3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessSummary_vue_vue_type_style_index_0_id_1a7e81fb_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ProcessSummary_vue_vue_type_style_index_0_id_1a7e81fb_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8fa9":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");
var setPrototypeOf = __webpack_require__("c1a2");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "906d":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "907a":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "9275":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "930a":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "95fb":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "9616":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("815b");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "9618":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "9824":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "986c":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "98f3":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("63d3");
var toObject = __webpack_require__("37d1");
var IndexedObject = __webpack_require__("83a6");
var lengthOfArrayLike = __webpack_require__("0481");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "994b":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "9a0f":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("9616");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "9ad1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_1ea977ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c45c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_1ea977ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_1ea977ee_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9b18":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9b9a":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("4efd"),
    ListCache = __webpack_require__("fa8a"),
    Map = __webpack_require__("a9e0");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "9c67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__("416c");

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__("4eac");

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__("1b4e");

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__("84d2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idSeed = 1;

var scrollBarWidth = void 0;

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),

/***/ "9d19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowInstanceDetailDialog.vue?vue&type=template&id=a61fcf3a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instId)?_c('div',{staticClass:"flow-instances"},[_c('el-tabs',{staticClass:"flow-tab",on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"表单数据","name":"first"}}),_c('el-tab-pane',{attrs:{"label":"表单修改记录","name":"second"}}),_c('el-tab-pane',{attrs:{"label":"当前表单数据","name":"third"}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeName == 'first'),expression:"activeName == 'first'"}],staticClass:"content"},[_c('form-content',{attrs:{"instId":_vm.instId,"readOnly":_vm.readOnly,"toReader":_vm.toReader},on:{"onLoadDetail":_vm.onLoadDetail}}),_c('flow-record',{attrs:{"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment,"addDialogVisible":_vm.addDialogVisible,"inst-id":_vm.instId}}),_c('flow-diagram',{attrs:{"inst-id":_vm.instId}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeName == 'second'),expression:"activeName == 'second'"}]},[_c('diff-form-data',{ref:"diffForm",attrs:{"businessKey":_vm.businessKey}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeName == 'third'),expression:"activeName == 'third'"}]},[_c('el-row',{staticStyle:{"margin-bottom":"1em"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-button',{on:{"click":_vm.getCurrentFormData}},[_vm._v("获取当前表单数据")]),(!_vm.readOnly)?_c('el-button',{attrs:{"primary":""},on:{"click":_vm.saveCurrentFormData}},[_vm._v("更新数据")]):_vm._e()],1)],1),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 10, maxRows: 30 }},model:{value:(_vm.currentFormData),callback:function ($$v) {_vm.currentFormData=$$v},expression:"currentFormData"}})],1)],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/FlowInstanceDetailDialog.vue?vue&type=template&id=a61fcf3a&scoped=true&

// EXTERNAL MODULE: ../web-form/lib/form-utils.umd.js
var form_utils_umd = __webpack_require__("dbf1");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/js-base64/base64.mjs
var base64 = __webpack_require__("fb51");

// EXTERNAL MODULE: ./src/api/form.js
var api_form = __webpack_require__("c7ea");

// EXTERNAL MODULE: ./src/request/utils.js + 2 modules
var utils = __webpack_require__("f9c6");

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/DiffFormData/index.vue?vue&type=template&id=910339de&scoped=true&
var DiffFormDatavue_type_template_id_910339de_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff-form-data"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":16}},[_c('op-table',{attrs:{"data":_vm.tableData,"max-height":600,"loading":_vm.loading}},[_vm._l((_vm.tableHeaders),function(column){return _c('op-column',{key:column.key,attrs:{"label":column.name,"prop":column.key,"type":column.type}})}),_c('op-column',{attrs:{"label":"操作","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.handleClick(scope.row, scope.$index, 'diff')}}},[_vm._v("查看修改 ")]),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.handleClick(scope.row, scope.$index, 'code')}}},[_vm._v("数据 ")])]}}])})],2)],1),_c('el-col',{staticClass:"diff",attrs:{"span":8}},[_c('div',{staticClass:"diff-header"},[_c('span',{staticClass:"title"},[_vm._v("数据修改明细")])]),(_vm.showType)?_c('div',{staticClass:"diff-info"},[(_vm.filterDiffResult.length)?_c('span',{staticClass:"item"},[_vm._v("\n          "+_vm._s(("合计操作量：" + (_vm.filterDiffResult.length)))+"\n        ")]):_vm._e(),_c('span',{staticClass:"item"},[_vm._v("\n          "+_vm._s(("操作人：" + (_vm.currentActionInfo.user)))+"\n        ")]),_c('span',{staticClass:"item"},[_vm._v("\n          "+_vm._s(("操作时间：" + (_vm.currentActionInfo.date)))+"\n        ")])]):_vm._e(),_c('div',{staticClass:"diff-filter"},[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"placeholder":"请选择过滤字段","filterable":"","clearable":""},model:{value:(_vm.selectedKey),callback:function ($$v) {_vm.selectedKey=$$v},expression:"selectedKey"}},_vm._l((_vm.keyList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_c('div',{staticClass:"diff-container"},[(_vm.showType === 'code')?_c('code',[_vm._v(_vm._s(_vm.currentJSON))]):(_vm.showType === 'diff')?_c('div',[(_vm.filterDiffResult.length)?_vm._l((_vm.filterDiffResult),function(item){return _c('el-descriptions',{staticClass:"diff-item",attrs:{"labelStyle":{ width: '80px', flexShrink: 0 },"column":1}},[_c('el-descriptions-item',{attrs:{"label":"操作类型"}},[_vm._v(_vm._s(item.typeName))]),_c('el-descriptions-item',{attrs:{"label":"字段key"}},[_vm._v(_vm._s(item.key))]),_c('el-descriptions-item',{attrs:{"label":"表名"}},[_vm._v(_vm._s(item.tableName))]),_c('el-descriptions-item',{attrs:{"label":"字段名"}},[_vm._v(_vm._s(item.keyName))]),_c('el-descriptions-item',{attrs:{"label":"原值","span":1}},[_vm._v(_vm._s(item.pval))]),_c('el-descriptions-item',{attrs:{"label":"修改值","span":1}},[_vm._v(_vm._s(item.nval))]),(item.pIndex !== undefined)?_c('el-descriptions-item',{attrs:{"label":"原子表索引"}},[_vm._v(_vm._s(item.pIndex))]):_vm._e(),(item.nIndex !== undefined)?_c('el-descriptions-item',{attrs:{"label":"新子表索引"}},[_vm._v(_vm._s(item.nIndex))]):_vm._e()],1)}):[_c('div',[_vm._v(_vm._s(_vm.selectedKey ? '该字段没有修改记录' : '没有修改表单数据'))])]],2):_vm._e()])])],1)],1)}
var DiffFormDatavue_type_template_id_910339de_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/DiffFormData/index.vue?vue&type=template&id=910339de&scoped=true&

// EXTERNAL MODULE: external "vue-demi"
var external_vue_demi_ = __webpack_require__("f281");

// EXTERNAL MODULE: ./src/helper/date.js
var date = __webpack_require__("71e8");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("0894");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/lodash/lodash.js
var lodash = __webpack_require__("9ec3");

// CONCATENATED MODULE: ./src/components/form/DiffFormData/handler.js


const NEW_FIELD = 'newField';
const MODIFY_FIELD = 'modifyField';
const NEW_TABLE = 'newTable';
const NEW_SUBTABLE = 'newSubTable';
const NEW_SUBTABLE_ITEM = 'newSubTableItem';
const MODIFY_SUBTABLE_ITEM = 'modifySubTableItemField';
const DELETED_SUBTABLE_ITEM = 'deleteSubTableItem';
function translateType(type) {
  switch (type) {
    case NEW_FIELD:
      return '新增字段';
    case MODIFY_FIELD:
      return '字段值修改';
    case NEW_TABLE:
      return '新增主表';
    case NEW_SUBTABLE:
      return '新增子表';
    case NEW_SUBTABLE_ITEM:
      return '新增子表项';
    case MODIFY_SUBTABLE_ITEM:
      return '子表项字段修改';
    case DELETED_SUBTABLE_ITEM:
      return '子表项被删除';
  }
}

/**
 * 动态表单字段值是否相等
 * 1、动态表单会自动把number类型转成string类型，因此  1 == '1' 合法；
 * 2、动态表单会把null, undefine转成''，因此两个都是空置时，认为相等；
 * @param {*} a 对比值
 * @param {*} b 对比值
 * @returns {Boolean}
 */
function simpleEqual(a, b) {
  return String(a) === String(b) || !a && !b || Number(a) === Number(b);
}

/**
 * 比对动态表单历史记录数据
 * @param {*} prev 原始值
 * @param {*} next 修改后的值
 * @param {Array} result 对比后的结果
 * @param {String} wholeKey 当前递归的path
 * @param {Number} pIndex 子表项原始值的索引
 * @param {Number} nIndex 子表项修改后的索引
 * @returns
 */
function diffJsonData(prev, next, result = [], wholeKey, pIndex, nIndex) {
  if (wholeKey === 'deleteIds') {
    return;
  }
  if (Object(lodash["isObject"])(next) && !Array.isArray(next)) {
    // 处理table对象、子表项对象和initData
    Object.entries(next).forEach(([key, val]) => {
      const _wholeKey = wholeKey ? `${wholeKey}.${key}` : key;
      if (!Object.prototype.hasOwnProperty.call(prev, key)) {
        if (key === 'deleteIds') {
          return;
        }
        let type = '';
        if (Array.isArray(val)) {
          type = NEW_SUBTABLE;
        } else if (Object(lodash["isObject"])(val)) {
          type = NEW_TABLE;
        } else {
          type = NEW_FIELD;
        }
        result.push({
          type: type,
          key: _wholeKey,
          pval: null,
          nval: val,
          pIndex,
          nIndex
        });
      } else {
        diffJsonData(prev[key], val, result, _wholeKey, pIndex, nIndex);
      }
    });
  } else if (Array.isArray(next) && Array.isArray(prev)) {
    // 子表逻辑
    // 寻找prev有，next没有的对象, 这些对象代表被删除
    prev.forEach((p, _pIndex) => {
      if (!next.some(n => n.id === p.id)) {
        result.push({
          type: DELETED_SUBTABLE_ITEM,
          key: wholeKey,
          pval: p,
          nval: null,
          pIndex: _pIndex,
          nIndex: -1
        });
      }
    });
    next.forEach((n, _nIndex) => {
      // 没有id的代表新增项
      // 查找原始项的子表索引
      const _pIndex = prev.findIndex(p => p.id === n.id);
      if (!n.id || _pIndex === -1) {
        result.push({
          type: NEW_SUBTABLE_ITEM,
          key: wholeKey,
          pval: null,
          nval: n,
          nIndex: _nIndex,
          pIndex: -1
        });
      } else {
        diffJsonData(prev[_pIndex], n, result, wholeKey, _pIndex, _nIndex);
      }
    });
  } else {
    // 非对象属性
    if (!simpleEqual(prev, next)) {
      result.push({
        type: pIndex !== undefined && nIndex !== undefined ? MODIFY_SUBTABLE_ITEM : MODIFY_FIELD,
        key: wholeKey,
        pval: prev,
        nval: next,
        pIndex,
        nIndex
      });
    }
  }
}

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("28eb");

// CONCATENATED MODULE: ./src/components/form/DiffFormData/filterResult.js




function useFilterResult(data) {
  const keyList = Object(external_vue_demi_["ref"])([]);
  const selectedKey = Object(external_vue_demi_["ref"])('');
  const keyMap = Object(external_vue_demi_["ref"])({});
  const tableMap = Object(external_vue_demi_["ref"])({});
  const getKeyList = id => {
    api_form["a" /* default */].getPermissionList(id).then(res => {
      keyList.value = res.table.reduce((prev, next) => {
        const tableName = next.relation === 'MAIN' ? next.name : 'sub_' + next.name;
        tableMap.value[tableName] = next.description;
        const filedList = next.entityFieldList.map(item => {
          keyMap.value[`${tableName}.${item.name}`] = `${item.description || item.customFieldName}`;
          return {
            label: `${item.description || item.customFieldName}(${tableName}.${item.name})`,
            value: `${tableName}.${item.name}`
          };
        });
        prev.push(...filedList);
        return prev;
      }, []);
      console.log(tableMap.value);
    });
  };
  const filterDiffResult = Object(external_vue_demi_["computed"])(() => {
    if (!selectedKey.value) {
      return data.value;
    } else {
      const result = data.value.filter(x => x.key.indexOf(selectedKey.value) > -1);
      return result;
    }
  });
  const translateKeyName = key => {
    const keyPath = key.split('.');
    if (keyPath.length === 3) {
      // 子表字段
      console.log(`${keyPath[1]}.${keyPath[2]}`);
      return {
        keyName: keyMap.value[`${keyPath[1]}.${keyPath[2]}`] || '',
        tableName: `${tableMap.value[keyPath[0]]} - ${tableMap.value[keyPath[1]]}`
      };
    } else if (keyPath.length === 2) {
      // 主表字段
      return {
        keyName: keyMap.value[key] || '',
        tableName: tableMap.value[keyPath[0]] + (tableMap.value[keyPath[1]] ? ` - ${tableMap.value[keyPath[1]]}` : '')
      };
    }
    return {
      keyName: '',
      tableName: ''
    };
  };
  return {
    getKeyList,
    keyList,
    selectedKey,
    translateKeyName,
    filterDiffResult
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/DiffFormData/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var DiffFormDatavue_type_script_lang_js_ = (Object(external_vue_demi_["defineComponent"])({
  name: 'diff-form-data',
  props: {
    businessKey: {
      type: String
    },
    formDataGateway: {
      type: String
    }
  },
  setup(props) {
    const loading = Object(external_vue_demi_["ref"])(false);
    const tableData = Object(external_vue_demi_["ref"])([]);
    const tableHeaders = [{
      name: '操作人',
      key: 'changeUser'
    }, {
      name: '操作节点',
      key: 'changeNode'
    }, {
      name: '操作时间',
      key: 'changeDt',
      type: 'date'
    }];
    let prevCode = '';
    const currentJSON = Object(external_vue_demi_["ref"])('');
    const diffResult = Object(external_vue_demi_["ref"])([]);
    const showType = Object(external_vue_demi_["ref"])('');
    const currentActionInfo = Object(external_vue_demi_["ref"])({
      user: '',
      date: ''
    });
    const getDiffData = () => {
      loading.value = true;
      api_form["a" /* default */].getLogByBizId({
        bizId: props.businessKey
      }, props.formDataGateway || '').then(res => {
        tableData.value = res.map(item => {
          let changeNode;
          if (item.extendData) {
            const extendData = JSON.parse(item.extendData);
            changeNode = extendData.scenario == 'MODIFY_SYNC' ? '后台流程单修改' : extendData.taskName;
          }
          return {
            ...item,
            changeNode
          };
        });
        if (res.length > 0) {
          let formInstanceId = '';
          const formData = JSON.parse(res[0].afterChange);
          Object.values(formData).forEach(obj => {
            formInstanceId = obj.form_instance_id;
            if (formInstanceId) {
              return;
            }
          });
          getKeyList(formInstanceId);
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    function resetData(obj) {
      const initObj = {};
      Object.keys(obj).forEach(tableKey => {
        initObj[tableKey] = {};
        Object.keys(obj[tableKey]).forEach(key => {
          if (Array.isArray(obj[tableKey][key])) {
            initObj[tableKey][key] = [];
          } else if (key === 'initData') {
            initObj[tableKey].initData = obj[tableKey].initData;
          } else {
            initObj[tableKey][key] = '';
          }
        });
      });
      return initObj;
    }
    const handleClick = (row, index, type) => {
      currentActionInfo.value.date = Object(date["a" /* default */])(row.changeDt);
      currentActionInfo.value.user = row.changeUser;
      currentJSON.value = JSON.parse(row.afterChange);
      diffResult.value = [];
      if (index > 0) {
        prevCode = JSON.parse(tableData.value[index - 1].afterChange);
        diffJsonData(prevCode, currentJSON.value, diffResult.value);
      } else {
        prevCode = null;
        const _newValue = resetData(currentJSON.value);
        diffJsonData(_newValue, currentJSON.value, diffResult.value);
      }
      diffResult.value.forEach(item => {
        item.typeName = translateType(item.type);
        const {
          keyName,
          tableName
        } = translateKeyName(item.key);
        item.keyName = keyName;
        item.tableName = tableName;
      });
      showType.value = type;
    };
    const {
      keyList,
      getKeyList,
      selectedKey,
      filterDiffResult,
      translateKeyName
    } = useFilterResult(diffResult);
    return {
      loading,
      tableData,
      tableHeaders,
      currentJSON,
      showType,
      currentActionInfo,
      getDiffData,
      handleClick,
      keyList,
      selectedKey,
      filterDiffResult
    };
  }
}));
// CONCATENATED MODULE: ./src/components/form/DiffFormData/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var form_DiffFormDatavue_type_script_lang_js_ = (DiffFormDatavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/DiffFormData/index.vue?vue&type=style&index=0&id=910339de&prod&lang=scss&scoped=true&
var DiffFormDatavue_type_style_index_0_id_910339de_prod_lang_scss_scoped_true_ = __webpack_require__("18de");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/form/DiffFormData/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  form_DiffFormDatavue_type_script_lang_js_,
  DiffFormDatavue_type_template_id_910339de_scoped_true_render,
  DiffFormDatavue_type_template_id_910339de_scoped_true_staticRenderFns,
  false,
  null,
  "910339de",
  null
  
)

/* harmony default export */ var DiffFormData = (component.exports);
// EXTERNAL MODULE: ./src/components/flow/FlowAction/constants.js
var constants = __webpack_require__("4fa1");

// EXTERNAL MODULE: ./src/helper/eventBus.js
var eventBus = __webpack_require__("6e6e");

// EXTERNAL MODULE: ./src/components/flow/enum.js
var flow_enum = __webpack_require__("77a9");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("365c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowInstanceDetailDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var FlowInstanceDetailDialogvue_type_script_lang_js_ = ({
  name: 'FlowInstanceDetailDialog',
  components: {
    DiffFormData: DiffFormData
  },
  data() {
    return {
      hiddenComment: false,
      hiddenAssignee: false,
      addDialogVisible: false,
      toReader: false,
      readOnly: true,
      instId: '',
      businessKey: '',
      activeName: 'first',
      loading: false,
      tableData: [],
      tableHeaders: [{
        name: '操作人',
        key: 'changeUser'
      }, {
        name: '操作时间',
        key: 'changeDt',
        type: 'date'
      }],
      currentFormData: '',
      detail: null
    };
  },
  methods: {
    setValue({
      id,
      businessKey,
      readOnly,
      hiddenComment,
      hiddenAssignee,
      toReader
    }) {
      this.instId = id;
      this.hiddenAssignee = hiddenAssignee;
      this.hiddenComment = hiddenComment;
      this.businessKey = businessKey;
      this.readOnly = readOnly;
      this.toReader = toReader;
    },
    async submit(val) {
      if (!this.instId) {
        return utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], '缺少实例id， 请联系管理员！');
      }
      let formData = '';
      // 防止submit触发时，会有地方传入event对象
      if (val && typeof val === 'string') {
        formData = val;
      } else {
        formData = await Object(form_utils_umd["getOnlineFormData"])();
      }
      const _option = {
        // processInstanceId: this.instId,
        bizId: this.detail.businessKey,
        formData: base64["a" /* Base64 */].encode(formData),
        scenario: flow_enum["b" /* MODIFY_SYNC */]
      };
      const loading = this.$loading();
      // 保存表单
      const gatewayPath = this.detail && this.detail.formDataGateway || '';
      const {
        status,
        message,
        data
      } = await api["c" /* ProcessInstance */].defaultFormHandlerModify(_option, gatewayPath).finally(() => loading.close());
      // const { status, message, data } = await Form.formInstanceUpdate(_option).finally(() => loading.close())
      if (!status) {
        return utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], message || '保存失败！');
      }
      if (data.businessKey && !gatewayPath) {
        const {
          data: _formData
        } = await api_form["a" /* default */].getFormDataByBusinessKey(data.businessKey);
        eventBus["a" /* default */].$emit('postFormData', _formData);
      }
      return utils["a" /* doHandleToEmitOrToast */].call(this, constants["n" /* HANDLE_SUCCESS */], constants["y" /* SUCCESS */], '保存成功！');
    },
    handleClick() {
      if (this.activeName === 'second') {
        this.$refs.diffForm.getDiffData();
      }
    },
    async getCurrentFormData() {
      const formData = await Object(form_utils_umd["getOnlineFormData"])();
      this.currentFormData = JSON.stringify(JSON.parse(formData), null, 2);
    },
    saveCurrentFormData() {
      this.submit(this.currentFormData);
    },
    onLoadDetail(detail) {
      this.detail = detail;
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/FlowInstanceDetailDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_FlowInstanceDetailDialogvue_type_script_lang_js_ = (FlowInstanceDetailDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/dialog/FlowInstanceDetailDialog.vue?vue&type=style&index=0&id=a61fcf3a&prod&lang=scss&scoped=true&
var FlowInstanceDetailDialogvue_type_style_index_0_id_a61fcf3a_prod_lang_scss_scoped_true_ = __webpack_require__("2811");

// CONCATENATED MODULE: ./src/components/dialog/FlowInstanceDetailDialog.vue






/* normalize component */

var FlowInstanceDetailDialog_component = Object(componentNormalizer["a" /* default */])(
  dialog_FlowInstanceDetailDialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "a61fcf3a",
  null
  
)

/* harmony default export */ var FlowInstanceDetailDialog = __webpack_exports__["default"] = (FlowInstanceDetailDialog_component.exports);

/***/ }),

/***/ "9dc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_cf016638_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6a0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_cf016638_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_cf016638_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ec3":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15"), __webpack_require__("6984")(module)))

/***/ }),

/***/ "9fa6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "9fb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentContentItem_vue_vue_type_style_index_0_id_652513f4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3144");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentContentItem_vue_vue_type_style_index_0_id_652513f4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommentContentItem_vue_vue_type_style_index_0_id_652513f4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a03e":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");
var uncurryThis = __webpack_require__("70b7");
var getOwnPropertyNamesModule = __webpack_require__("65d0");
var getOwnPropertySymbolsModule = __webpack_require__("2402");
var anObject = __webpack_require__("157c");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "a0d5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("07d9")))

/***/ }),

/***/ "a430":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a4ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a4fc":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "a67c":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "a685":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_1bf3ec3b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfc1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_1bf3ec3b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CommunicationTask_vue_vue_type_style_index_0_id_1bf3ec3b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a691":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowTaskTodoDetail.vue?vue&type=template&id=326a8f4a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[(_vm.detail)?_c('form-content',{attrs:{"taskId":_vm.detail.taskId,"task-detail":_vm.taskDetail}}):_vm._e(),(_vm.detail)?_c('flow-record',{attrs:{"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment,"instId":_vm.detail.processInstanceId}}):_vm._e(),(_vm.detail)?_c('flow-diagram',{attrs:{"instId":_vm.detail.processInstanceId}}):_vm._e(),(_vm.detail)?_c('flow-action',{ref:"flowAction",attrs:{"is-manage":"","taskId":_vm.detail.taskId,"taskDetail":_vm.taskDetail,"instId":_vm.detail.processInstanceId,"activityId":_vm.detail.activityId,"buttonList":_vm.buttonList,"nextActivityNodeList":_vm.nextActivityNodeList},on:{"handle-success":_vm.back,"handle-error":_vm.onError,"handle-back":_vm.back}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/FlowTaskTodoDetail.vue?vue&type=template&id=326a8f4a&scoped=true&

// EXTERNAL MODULE: ./src/api/task.js
var task = __webpack_require__("b199");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/FlowTaskTodoDetail.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var FlowTaskTodoDetailvue_type_script_lang_js_ = ({
  name: 'FlowTaskTodoDetail',
  data() {
    return {
      detail: null,
      taskDetail: null,
      isLoading: false,
      hiddenComment: false,
      hiddenAssignee: false,
      buttonList: [],
      nextActivityNodeList: []
    };
  },
  methods: {
    setValue({
      detail,
      hiddenComment,
      hiddenAssignee
    }) {
      this.detail = detail;
      this.hiddenComment = hiddenComment;
      this.hiddenAssignee = hiddenAssignee;
      this.getTaskDetail(detail.taskId);
    },
    async getTaskDetail(id) {
      this.isLoading = true;
      this.taskDetail = await task["a" /* default */].taskDetail({
        id,
        type: 'PC'
      }).finally(() => this.isLoading = false);
      setTimeout(() => this.isLoading = false, 15000);
      if (this.taskDetail && this.taskDetail.buttonList) {
        this.buttonList = this.taskDetail.buttonList || [];
      }
      if (this.taskDetail && this.taskDetail.nextActivityNodeList) {
        this.nextActivityNodeList = this.taskDetail.nextActivityNodeList || [];
      }
    },
    back(type) {
      if (type === 'TO_READ') {
        this.$refs.flowAction.getCommentList();
        this.$forceUpdate();
        return;
      }
      this.$emit('close');
    },
    onError(message) {
      console.log(message);
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/FlowTaskTodoDetail.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_FlowTaskTodoDetailvue_type_script_lang_js_ = (FlowTaskTodoDetailvue_type_script_lang_js_); 
// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/dialog/FlowTaskTodoDetail.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  dialog_FlowTaskTodoDetailvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "326a8f4a",
  null
  
)

/* harmony default export */ var FlowTaskTodoDetail = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "a692":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./src/request/convertors/content-type.js
var content_type_namespaceObject = {};
__webpack_require__.r(content_type_namespaceObject);
__webpack_require__.d(content_type_namespaceObject, "json", function() { return json; });
__webpack_require__.d(content_type_namespaceObject, "url", function() { return content_type_url; });
__webpack_require__.d(content_type_namespaceObject, "form", function() { return content_type_form; });

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("0894");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/qs/lib/index.js
var lib = __webpack_require__("a6ed");

// CONCATENATED MODULE: ./src/request/convertors/content-type.js


/*
 * convert object to json
 */
const json = (data, headers) => {
  headers['Content-Type'] = 'application/json';
  return JSON.stringify(data);
};

/*
 * convert object to urlencoded
 */
const content_type_url = (data, headers) => {
  headers['Content-Type'] = 'application/x-www-form-urlencoded';
  return Object(lib["stringify"])(data);
};

/*
 * convert object to formdata
 */
const content_type_form = (data, headers) => {
  headers['Content-Type'] = 'multipart/form-data';
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/path-to-regexp/dist.es2015/index.js
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at ".concat(j));
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern)
                throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function () {
        var result = "";
        var value;
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while (execResult) {
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: "",
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    }
                    else {
                        route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                    }
                }
                else {
                    if (token.modifier === "+" || token.modifier === "*") {
                        route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                    }
                    else {
                        route += "(".concat(token.pattern, ")").concat(token.modifier);
                    }
                }
            }
            else {
                route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
            }
        }
    }
    if (end) {
        if (!strict)
            route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1
            : endToken === undefined;
        if (!strict) {
            route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        }
        if (!isEndDelimited) {
            route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./src/request/convertors/ajax-config.js




let isRESTfull = false;
const ajax_config_RESTfullParams = [];

// let isRESTfull = false;
// const RESTfullParams = [];

const checkRESTfullApi = (regexpArr, url) => {
  pathToRegexp(url, regexpArr);
  return regexpArr.length > 0;
};
const checkRESTfullParams = (params, data) => {
  const used = [];
  if (Object.keys(data).length === 0) {
    // vue.util.warn(`[services api]: missing parameter`);
    return used;
  }
  params.forEach(item => {
    if (data[item.name]) used.push([item.name]);
    // data[item.name]
    //   ? used.push([item.name])
    //   : vue.util.warn(`[services api]: missing parameter: ${item.name}`);
  });

  return used;
};
const handleRESTfullData = (urlParams, data) => {
  urlParams.forEach(item => {
    delete data[item];
  });
  return data;
};

/*
 *  react axios configs
 */
class ajax_config_AjaxConfig {
  // url = ''
  // method = ''
  // params = {}
  // data = {}
  // transformRequest = []

  constructor(config) {
    Object.assign(this, config);
  }
  set _url(value) {
    // if (!isRESTfull) {
    //   isRESTfull = checkRESTfullApi(RESTfullParams, value);
    // }
    this.baseUrl = value;
    this.url = value;
  }
  setResponseType(type) {
    this.responseType = type;
    return this;
  }
  get(url) {
    this._url = url;
    this.method = 'get';
    return this;
  }
  delete(url) {
    this._url = url;
    this.method = 'delete';
    return this;
  }
  head(url) {
    this._url = url;
    this.method = 'head';
    return this;
  }
  options(url) {
    this._url = url;
    this.method = 'options';
    return this;
  }
  post(url) {
    this._url = url;
    this.method = 'post';
    return this;
  }
  put(url) {
    this._url = url;
    this.method = 'put';
    return this;
  }
  patch(url) {
    this._url = url;
    this.method = 'patch';
    return this;
  }
  format(type) {
    if (!content_type_namespaceObject[type]) {
      external_commonjs_vue_commonjs2_vue_root_Vue_default.a.util.warn(`[services format: contentType]: ${type} is undefined`);
    }
    this.transformRequest = [content_type_namespaceObject[type]];
    return this;
  }
  setData(data) {
    let newData = data;
    // handle RESTfull api
    const RESTfullParams = [];
    if (checkRESTfullApi(RESTfullParams, this.baseUrl)) {
      const arr = checkRESTfullParams(RESTfullParams, data);
      if (arr.length > 0) {
        const toPath = compile(this.baseUrl);
        const RESTfulUrl = toPath(data);
        const newValue = handleRESTfullData(arr, data);
        this.url = RESTfulUrl;
        newData = newValue;
      }
    }
    if (this.method === 'get') {
      this.params = newData;
    } else {
      this.data = newData;
    }
    return this;
  }
}
/* harmony default export */ var ajax_config = __webpack_exports__["a"] = (ajax_config_AjaxConfig);

/***/ }),

/***/ "a6ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("4983");
var parse = __webpack_require__("c3b9");
var formats = __webpack_require__("7186");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "a769":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("b506"),
    isPrototype = __webpack_require__("09b2"),
    nativeKeysIn = __webpack_require__("fd44");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "a9e0":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10"),
    root = __webpack_require__("201b");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "aa4d":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("2a3e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "aaf2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__("df09");
var DESCRIPTORS = __webpack_require__("d4cb");
var global = __webpack_require__("f498");
var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");
var hasOwn = __webpack_require__("7a25");
var classof = __webpack_require__("da06");
var tryToString = __webpack_require__("4912");
var createNonEnumerableProperty = __webpack_require__("5b12");
var defineBuiltIn = __webpack_require__("ef30");
var defineProperty = __webpack_require__("abdf").f;
var isPrototypeOf = __webpack_require__("fb9b");
var getPrototypeOf = __webpack_require__("0e39");
var setPrototypeOf = __webpack_require__("c1a2");
var wellKnownSymbol = __webpack_require__("7d53");
var uid = __webpack_require__("1d8a");
var InternalStateModule = __webpack_require__("cdcd");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ "ab6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_c02fc530_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dc5c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_c02fc530_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_index_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pc_vue_vue_type_style_index_0_id_c02fc530_prod_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "abdf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var IE8_DOM_DEFINE = __webpack_require__("7c3f");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("ff3b");
var anObject = __webpack_require__("157c");
var toPropertyKey = __webpack_require__("feca");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "ae68":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("d99b"),
    isArguments = __webpack_require__("6efc"),
    isArray = __webpack_require__("c316"),
    isBuffer = __webpack_require__("dda8"),
    isIndex = __webpack_require__("a67c"),
    isTypedArray = __webpack_require__("41dd");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "af54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("aaf2");
var $findLastIndex = __webpack_require__("77f6").findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "af97":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b03d":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("bc61"),
    getPrototype = __webpack_require__("ff00"),
    isPrototype = __webpack_require__("09b2");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "b17e":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "b199":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a692");
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8daa");


const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](config);
const PROCESS_START = ajax().post('/workflow/process/start');
const TASK_DETAIL = ajax().get('/workflow/task');
const AGREE_ACTION = ajax().post('/workflow/task/apply');
const STOP_ACTION = ajax().post('/workflow/task/stop');
const REJECT_ACTION = ajax().post('/workflow/task/reject');
const DELEGATE_ACTION = ajax().post('/workflow/task/delegate');
const REJECT_ABLE_NODES = ajax().get('/workflow/task/rejectable/node/:taskId');
const AGENT_ACTION = ajax().post('/workflow/task/agent');
const TO_READ_TASK = ajax().post('/workflow/task/toReadTask');
const TO_READ_TASK_HANDLE = ajax().post('/workflow/task/toReadTask/handle');
const TASK_PAGE_MANEGE = ajax().post('/workflow/task/page/manage');
const CHANGE_ASSIGNEE = ajax().post('/workflow/task/changeAssignee');
const COMMUNICATION_TASK = ajax().post('/workflow/task/communicationTask');
const COMMUNICATION_TASK_REPLY = ajax().post('/workflow/task/communicationTask/reply');
const COMMUNICATION_TASK_CANCEL = ajax().post('/workflow/task/communicationTask/cancel');
const TEMP_TASK_SAVE = ajax().post('/workflow/task/tempSave');
const MULTI_INSTANCE_ADD = ajax().post('/workflow/multiInstance/add');
const MULTI_INSTANCE_COMPLETE = ajax().post('/workflow/multiInstance/complete');
const TASK_PAGE_TOREAD_MANEGE = ajax().post('/workflow/task/page/toRead/manage');
const TASK_TRANSFER_PAGE = ajax().post('/workflow/task/page/transfer');
const TASK_TRANSFER = ajax().post('/workflow/task/transfer');
const EXPORT_TASK_TRANSFER_PAGE = ajax().post('/workflow/task/export/pageTransfer').setResponseType('blob');
const TASK_TRANSFER_DETAIL = ajax().post('/workflow/task/transfer/detail');
const PROCESS_INSTANCE_TIME_NOTICE = ajax().get('/workflow/processInstance/timeNotice/:processInstanceId');
const TASK_TIME_NOTICE = ajax().get('/workflow/task/timeNotice/:taskId');
const TASK_EXPORT_MANAGER = ajax().post('/workflow/task/export/manage').setResponseType('blob');
/* harmony default export */ __webpack_exports__["a"] = ({
  // 发起主版本流程
  startProcess(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_START, params);
  },
  // 任务详情
  taskDetail(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_DETAIL, params).then(res => {
        resolve(res.data);
      });
    });
  },
  // 同意
  agreeAction(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(AGREE_ACTION, params);
  },
  // 转办
  agentAction(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(AGENT_ACTION, params);
  },
  // 驳回
  rejectAction(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(REJECT_ACTION, params);
  },
  // 获取可驳回节点
  rejectableNodes(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(REJECT_ABLE_NODES, params).then(res => {
        resolve(res.data);
      });
    });
  },
  // 转办
  async delegateAction(params) {
    const {
      status
    } = await Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(DELEGATE_ACTION, params);
    return status;
  },
  // 终止
  stopAction(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(STOP_ACTION, params);
  },
  // 传阅任务创建
  toReadTask(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TO_READ_TASK, params);
  },
  // 将待阅任务标记为已完成/回复
  toReadTaskHandle(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TO_READ_TASK_HANDLE, params);
  },
  // 获取任务管理列表（ASSP用 包含流程数据权限逻辑）
  taskPageManage(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_PAGE_MANEGE, params);
  },
  // 获取待阅任务管理列表（ASSP用 包含流程数据权限逻辑）
  taskPageToReadManage(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_PAGE_TOREAD_MANEGE, params);
  },
  // 更改执行人
  changeAssignee(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(CHANGE_ASSIGNEE, params);
  },
  // 沟通任务创建
  createCommunicationTask(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(COMMUNICATION_TASK, params);
  },
  // 沟通回复
  replyCommunicationTask(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(COMMUNICATION_TASK_REPLY, params);
  },
  // 沟通任务取消
  cancelCommunicationTask(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(COMMUNICATION_TASK_CANCEL, params);
  },
  // 任务表单暂存
  tempTaskSave(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TEMP_TASK_SAVE, params);
  },
  // 加签
  multiInstanceAdd(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(MULTI_INSTANCE_ADD, params);
  },
  // 会签同意/反对
  multiInstanceComplete(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(MULTI_INSTANCE_COMPLETE, params);
  },
  // 分页查询任务移交记录
  taskTransferPage(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_TRANSFER_PAGE, params);
  },
  // 任务移交
  taskTransfer(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_TRANSFER, params);
  },
  // 导出任务移交记录
  exportTaskTransferPage(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(EXPORT_TASK_TRANSFER_PAGE, params);
  },
  // 查询任务移交明细
  taskTransferDetail(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_TRANSFER_DETAIL, params);
  },
  // 获取流程用时提醒
  processInstanceTimeNotice(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_TIME_NOTICE, params);
  },
  // 获取任务用时提醒
  taskTimeNotice(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_TIME_NOTICE, params);
  },
  exportTaskCommitInfo(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TASK_EXPORT_MANAGER, params);
  }
});

/***/ }),

/***/ "b3f2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b495":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("9616");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "b4b4":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "b4fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_23f55c87_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("846a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_23f55c87_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ToReadDialog_vue_vue_type_style_index_0_id_23f55c87_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b506":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var buildURL = __webpack_require__("30b5");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("9fa6");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ( true &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("7aac");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "b53e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_instance_detail_vue_vue_type_style_index_0_id_5fbc17c8_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6ce");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_instance_detail_vue_vue_type_style_index_0_id_5fbc17c8_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_flow_instance_detail_vue_vue_type_style_index_0_id_5fbc17c8_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b546":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "b614":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/DynamicDialog.vue?vue&type=template&id=2b35b0ee&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dynamic-dialog",attrs:{"visible":_vm.dialog.visible,"width":_vm.dialog.width,"title":_vm.title || _vm.dialog.title,"fullscreen":"","destroy-on-close":"","append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.dialog, "visible", $event)},"opened":_vm.init}},[_c('div',{style:({ paddingBottom: _vm.footer ? '60px' : '0' }),attrs:{"slot":"default"},slot:"default"},[_c(_vm.dialog.name,{ref:"dialog",tag:"component",on:{"close":_vm.closeDialog}})],1),(_vm.footer)?_c('div',{staticClass:"dynamic-dialog__footer"},[_c('el-button',{attrs:{"size":"mini","plain":""},on:{"click":_vm.closeDialog}},[_vm._v("关闭")]),(_vm.canSave)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":_vm.submit}},[_vm._v("保存")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/DynamicDialog.vue?vue&type=template&id=2b35b0ee&scoped=true&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("f38f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/DynamicDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DynamicDialogvue_type_script_lang_js_ = ({
  name: 'DynamicDialog',
  props: {
    title: String,
    componentId: String,
    footer: {
      type: Boolean,
      default: false
    },
    canSave: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: {
        title: '',
        visible: false,
        name: ''
      },
      instId: '',
      data: ''
    };
  },
  async created() {
    // 注册当前组件
    const _vm = await Promise.resolve(/* import() */).then(__webpack_require__.t.bind(null, "8bbf", 7));
    const _C = await __webpack_require__("31d7")(`./${this.componentId}.vue`);
    _vm.default.component(this.componentId, _C.default);
  },
  methods: {
    show(data, title = '') {
      this.data = data;
      this.dialog = {
        visible: true,
        title,
        name: this.componentId
      };
    },
    init() {
      if (!this.$refs.dialog.setValue) {
        throw new Error('必须在子组件内实现setValue方法！');
      }
      this.$refs.dialog.setValue(this.data);
    },
    submit() {
      if (!this.$refs.dialog.submit) {
        throw new Error('必须在子组件内实现submit方法！');
      }
      this.$refs.dialog.submit(this.data);
    },
    closeDialog() {
      this.dialog.visible = false;
    }
  }
});
// CONCATENATED MODULE: ./src/components/dialog/DynamicDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_DynamicDialogvue_type_script_lang_js_ = (DynamicDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/dialog/DynamicDialog.vue?vue&type=style&index=0&id=2b35b0ee&prod&lang=scss&scoped=true&
var DynamicDialogvue_type_style_index_0_id_2b35b0ee_prod_lang_scss_scoped_true_ = __webpack_require__("5ff7");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/dialog/DynamicDialog.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  dialog_DynamicDialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2b35b0ee",
  null
  
)

/* harmony default export */ var DynamicDialog = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "b634":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("7a25");
var ownKeys = __webpack_require__("a03e");
var getOwnPropertyDescriptorModule = __webpack_require__("185a");
var definePropertyModule = __webpack_require__("abdf");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "b742":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "bc61":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("b506");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "be6c":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "bf10":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("e672"),
    getValue = __webpack_require__("e29f");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "c02d":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("3f3f");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "c124":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("e4be");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "c1a2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("70b7");
var anObject = __webpack_require__("157c");
var aPossiblePrototype = __webpack_require__("f3e4");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "c294":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("4774"),
    isIterateeCall = __webpack_require__("479b");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "c316":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c3b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("57f2");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "c45c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");
var isBuffer = __webpack_require__("95fb");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var defineGlobalProperty = __webpack_require__("4499");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6a0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c6ce":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c6de":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("6a61");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "c7ea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a692");
/* harmony import */ var _request_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8daa");
/* harmony import */ var _helper_tool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0957");



const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](config);
const FORM_INSTANCE_UPDATE = ajax().post('/workflow/form/formInstance/update');
// const GET_LOG_BY_BIZ_ID = ajax().get('/workflow/dyfoLog/:bizId/listLogByBizId')
const GET_LOG_BY_BIZ_ID = gatewayPath => _helper_tool__WEBPACK_IMPORTED_MODULE_2__[/* getRequestConfig */ "d"].call(ajax, '/workflow/dyfoLog/:bizId/listLogByBizId', gatewayPath, 'get'); // 创建表单
const GET_PERMISSION_BY_INSTANCEID = ajax().get('dynamicform/formInstance/getPermissionStructureByFmIdAndClType');
const GET_FORM_DATA_BY_BUSINESSKEY = ajax().get('workflow/defaultFormHandler/getFormData');
/* harmony default export */ __webpack_exports__["a"] = ({
  formInstanceUpdate: params => {
    return Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FORM_INSTANCE_UPDATE, params);
  },
  // 获取日志记录
  getLogByBizId(params, gatewayPath = '') {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_LOG_BY_BIZ_ID(gatewayPath), params).then(res => {
        resolve(res.data);
      });
    });
  },
  getPermissionList(id) {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_PERMISSION_BY_INSTANCEID, {
        id: id,
        clientType: 'PC'
      }).then(res => {
        resolve(res.data);
      });
    });
  },
  getFormDataByBusinessKey(businesskey, type = 'PC') {
    return new Promise(resolve => {
      Object(_request_index__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_FORM_DATA_BY_BUSINESSKEY, {
        bizId: businesskey,
        type
      }).then(res => {
        resolve(res.data);
      });
    });
  }
});

/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c91c":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var hasOwn = __webpack_require__("7a25");
var toIndexedObject = __webpack_require__("378c");
var indexOf = __webpack_require__("1f5e").indexOf;
var hiddenKeys = __webpack_require__("d687");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "c926":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("cda3"),
    baseRest = __webpack_require__("4774"),
    customDefaultsMerge = __webpack_require__("4f98"),
    mergeWith = __webpack_require__("3ee2");

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),

/***/ "cb7b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cc7f":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("ae68"),
    baseKeysIn = __webpack_require__("a769"),
    isArrayLike = __webpack_require__("f72d");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "cd51":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("4fed");
var fails = __webpack_require__("72df");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "cd68":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "cda3":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "cdcd":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("416d");
var global = __webpack_require__("f498");
var isObject = __webpack_require__("7526");
var createNonEnumerableProperty = __webpack_require__("5b12");
var hasOwn = __webpack_require__("7a25");
var shared = __webpack_require__("c607");
var sharedKey = __webpack_require__("332c");
var hiddenKeys = __webpack_require__("d687");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "cfd1":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("5428");
var isCallable = __webpack_require__("3ce8");
var isPrototypeOf = __webpack_require__("fb9b");
var USE_SYMBOL_AS_UID = __webpack_require__("4db4");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d331":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var hasOwn = __webpack_require__("7a25");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "d4cb":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "d54f":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("43f8");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "d687":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d856":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "d99b":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "da06":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("3cec");
var isCallable = __webpack_require__("3ce8");
var classofRaw = __webpack_require__("6a61");
var wellKnownSymbol = __webpack_require__("7d53");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "daaf":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isObject = __webpack_require__("b506");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "dbf1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0894");
__webpack_require__("f38f");
__webpack_require__("dc28");
__webpack_require__("272b");
__webpack_require__("af54");
__webpack_require__("e890");
(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory(__webpack_require__("8bbf"));else {}
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE__8bbf__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/
      __webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/
      __webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/
        if (mode & 8) return value;
        /******/
        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/
        var ns = Object.create(null);
        /******/
        __webpack_require__.r(ns);
        /******/
        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/
        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
        /******/
        return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __webpack_require__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(__webpack_require__.s = "fae3");
      /******/
    }
    /************************************************************************/
    /******/({
      /***/"0c5c": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.isVNode = isVNode;
        var _util = __webpack_require__("6d2c");
        function isVNode(node) {
          return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
        }
        ;

        /***/
      },

      /***/"1b4e": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.default = function () {
          if (_vue2.default.prototype.$isServer) return 0;
          if (scrollBarWidth !== undefined) return scrollBarWidth;
          var outer = document.createElement('div');
          outer.className = 'el-scrollbar__wrap';
          outer.style.visibility = 'hidden';
          outer.style.width = '100px';
          outer.style.position = 'absolute';
          outer.style.top = '-9999px';
          document.body.appendChild(outer);
          var widthNoScroll = outer.offsetWidth;
          outer.style.overflow = 'scroll';
          var inner = document.createElement('div');
          inner.style.width = '100%';
          outer.appendChild(inner);
          var widthWithScroll = inner.offsetWidth;
          outer.parentNode.removeChild(outer);
          scrollBarWidth = widthNoScroll - widthWithScroll;
          return scrollBarWidth;
        };
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var scrollBarWidth = void 0;
        ;

        /***/
      },

      /***/"416c": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.default = function (target) {
          for (var i = 1, j = arguments.length; i < j; i++) {
            var source = arguments[i] || {};
            for (var prop in source) {
              if (source.hasOwnProperty(prop)) {
                var value = source[prop];
                if (value !== undefined) {
                  target[prop] = value;
                }
              }
            }
          }
          return target;
        };
        ;

        /***/
      },

      /***/"4eac": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        var _dom = __webpack_require__("84d2");
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var hasModal = false;
        var hasInitZIndex = false;
        var zIndex = void 0;
        var getModal = function getModal() {
          if (_vue2.default.prototype.$isServer) return;
          var modalDom = PopupManager.modalDom;
          if (modalDom) {
            hasModal = true;
          } else {
            hasModal = false;
            modalDom = document.createElement('div');
            PopupManager.modalDom = modalDom;
            modalDom.addEventListener('touchmove', function (event) {
              event.preventDefault();
              event.stopPropagation();
            });
            modalDom.addEventListener('click', function () {
              PopupManager.doOnModalClick && PopupManager.doOnModalClick();
            });
          }
          return modalDom;
        };
        var instances = {};
        var PopupManager = {
          modalFade: true,
          getInstance: function getInstance(id) {
            return instances[id];
          },
          register: function register(id, instance) {
            if (id && instance) {
              instances[id] = instance;
            }
          },
          deregister: function deregister(id) {
            if (id) {
              instances[id] = null;
              delete instances[id];
            }
          },
          nextZIndex: function nextZIndex() {
            return PopupManager.zIndex++;
          },
          modalStack: [],
          doOnModalClick: function doOnModalClick() {
            var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
            if (!topItem) return;
            var instance = PopupManager.getInstance(topItem.id);
            if (instance && instance.closeOnClickModal) {
              instance.close();
            }
          },
          openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
            if (_vue2.default.prototype.$isServer) return;
            if (!id || zIndex === undefined) return;
            this.modalFade = modalFade;
            var modalStack = this.modalStack;
            for (var i = 0, j = modalStack.length; i < j; i++) {
              var item = modalStack[i];
              if (item.id === id) {
                return;
              }
            }
            var modalDom = getModal();
            (0, _dom.addClass)(modalDom, 'v-modal');
            if (this.modalFade && !hasModal) {
              (0, _dom.addClass)(modalDom, 'v-modal-enter');
            }
            if (modalClass) {
              var classArr = modalClass.trim().split(/\s+/);
              classArr.forEach(function (item) {
                return (0, _dom.addClass)(modalDom, item);
              });
            }
            setTimeout(function () {
              (0, _dom.removeClass)(modalDom, 'v-modal-enter');
            }, 200);
            if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
              dom.parentNode.appendChild(modalDom);
            } else {
              document.body.appendChild(modalDom);
            }
            if (zIndex) {
              modalDom.style.zIndex = zIndex;
            }
            modalDom.tabIndex = 0;
            modalDom.style.display = '';
            this.modalStack.push({
              id: id,
              zIndex: zIndex,
              modalClass: modalClass
            });
          },
          closeModal: function closeModal(id) {
            var modalStack = this.modalStack;
            var modalDom = getModal();
            if (modalStack.length > 0) {
              var topItem = modalStack[modalStack.length - 1];
              if (topItem.id === id) {
                if (topItem.modalClass) {
                  var classArr = topItem.modalClass.trim().split(/\s+/);
                  classArr.forEach(function (item) {
                    return (0, _dom.removeClass)(modalDom, item);
                  });
                }
                modalStack.pop();
                if (modalStack.length > 0) {
                  modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
                }
              } else {
                for (var i = modalStack.length - 1; i >= 0; i--) {
                  if (modalStack[i].id === id) {
                    modalStack.splice(i, 1);
                    break;
                  }
                }
              }
            }
            if (modalStack.length === 0) {
              if (this.modalFade) {
                (0, _dom.addClass)(modalDom, 'v-modal-leave');
              }
              setTimeout(function () {
                if (modalStack.length === 0) {
                  if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
                  modalDom.style.display = 'none';
                  PopupManager.modalDom = undefined;
                }
                (0, _dom.removeClass)(modalDom, 'v-modal-leave');
              }, 200);
            }
          }
        };
        Object.defineProperty(PopupManager, 'zIndex', {
          configurable: true,
          get: function get() {
            if (!hasInitZIndex) {
              zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
              hasInitZIndex = true;
            }
            return zIndex;
          },
          set: function set(value) {
            zIndex = value;
          }
        });
        var getTopPopup = function getTopPopup() {
          if (_vue2.default.prototype.$isServer) return;
          if (PopupManager.modalStack.length > 0) {
            var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
            if (!topPopup) return;
            var instance = PopupManager.getInstance(topPopup.id);
            return instance;
          }
        };
        if (!_vue2.default.prototype.$isServer) {
          // handle `esc` key when the popup is shown
          window.addEventListener('keydown', function (event) {
            if (event.keyCode === 27) {
              var topPopup = getTopPopup();
              if (topPopup && topPopup.closeOnPressEscape) {
                topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
              }
            }
          });
        }
        exports.default = PopupManager;

        /***/
      },

      /***/"6d2c": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.noop = noop;
        exports.hasOwn = hasOwn;
        exports.toObject = toObject;
        exports.getPropByPath = getPropByPath;
        exports.rafThrottle = rafThrottle;
        exports.objToArray = objToArray;
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        var _types = __webpack_require__("e587");
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        function noop() {}
        ;
        function hasOwn(obj, key) {
          return hasOwnProperty.call(obj, key);
        }
        ;
        function extend(to, _from) {
          for (var key in _from) {
            to[key] = _from[key];
          }
          return to;
        }
        ;
        function toObject(arr) {
          var res = {};
          for (var i = 0; i < arr.length; i++) {
            if (arr[i]) {
              extend(res, arr[i]);
            }
          }
          return res;
        }
        ;
        var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
          prop = prop || '';
          var paths = prop.split('.');
          var current = object;
          var result = null;
          for (var i = 0, j = paths.length; i < j; i++) {
            var path = paths[i];
            if (!current) break;
            if (i === j - 1) {
              result = current[path];
              break;
            }
            current = current[path];
          }
          return result;
        };
        function getPropByPath(obj, path, strict) {
          var tempObj = obj;
          path = path.replace(/\[(\w+)\]/g, '.$1');
          path = path.replace(/^\./, '');
          var keyArr = path.split('.');
          var i = 0;
          for (var len = keyArr.length; i < len - 1; ++i) {
            if (!tempObj && !strict) break;
            var key = keyArr[i];
            if (key in tempObj) {
              tempObj = tempObj[key];
            } else {
              if (strict) {
                throw new Error('please transfer a valid prop path to form item!');
              }
              break;
            }
          }
          return {
            o: tempObj,
            k: keyArr[i],
            v: tempObj ? tempObj[keyArr[i]] : null
          };
        }
        ;
        var generateId = exports.generateId = function generateId() {
          return Math.floor(Math.random() * 10000);
        };
        var valueEquals = exports.valueEquals = function valueEquals(a, b) {
          // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
          if (a === b) return true;
          if (!(a instanceof Array)) return false;
          if (!(b instanceof Array)) return false;
          if (a.length !== b.length) return false;
          for (var i = 0; i !== a.length; ++i) {
            if (a[i] !== b[i]) return false;
          }
          return true;
        };
        var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
        };

        // TODO: use native Array.find, Array.findIndex when IE support is dropped
        var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
          for (var i = 0; i !== arr.length; ++i) {
            if (pred(arr[i])) {
              return i;
            }
          }
          return -1;
        };
        var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
          var idx = arrayFindIndex(arr, pred);
          return idx !== -1 ? arr[idx] : undefined;
        };

        // coerce truthy value to array
        var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
          if (Array.isArray(val)) {
            return val;
          } else if (val) {
            return [val];
          } else {
            return [];
          }
        };
        var isIE = exports.isIE = function isIE() {
          return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
        };
        var isEdge = exports.isEdge = function isEdge() {
          return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
        };
        var isFirefox = exports.isFirefox = function isFirefox() {
          return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
        };
        var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
          if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
          var rules = ['transform', 'transition', 'animation'];
          var prefixes = ['ms-', 'webkit-'];
          rules.forEach(function (rule) {
            var value = style[rule];
            if (rule && value) {
              prefixes.forEach(function (prefix) {
                style[prefix + rule] = value;
              });
            }
          });
          return style;
        };
        var kebabCase = exports.kebabCase = function kebabCase(str) {
          var hyphenateRE = /([^-])([A-Z])/g;
          return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
        };
        var capitalize = exports.capitalize = function capitalize(str) {
          if (!(0, _types.isString)(str)) return str;
          return str.charAt(0).toUpperCase() + str.slice(1);
        };
        var looseEqual = exports.looseEqual = function looseEqual(a, b) {
          var isObjectA = (0, _types.isObject)(a);
          var isObjectB = (0, _types.isObject)(b);
          if (isObjectA && isObjectB) {
            return JSON.stringify(a) === JSON.stringify(b);
          } else if (!isObjectA && !isObjectB) {
            return String(a) === String(b);
          } else {
            return false;
          }
        };
        var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
          arrayA = arrayA || [];
          arrayB = arrayB || [];
          if (arrayA.length !== arrayB.length) {
            return false;
          }
          for (var i = 0; i < arrayA.length; i++) {
            if (!looseEqual(arrayA[i], arrayB[i])) {
              return false;
            }
          }
          return true;
        };
        var isEqual = exports.isEqual = function isEqual(value1, value2) {
          if (Array.isArray(value1) && Array.isArray(value2)) {
            return arrayEquals(value1, value2);
          }
          return looseEqual(value1, value2);
        };
        var isEmpty = exports.isEmpty = function isEmpty(val) {
          // null or undefined
          if (val == null) return true;
          if (typeof val === 'boolean') return false;
          if (typeof val === 'number') return !val;
          if (val instanceof Error) return val.message === '';
          switch (Object.prototype.toString.call(val)) {
            // String or Array
            case '[object String]':
            case '[object Array]':
              return !val.length;

            // Map or Set or File
            case '[object File]':
            case '[object Map]':
            case '[object Set]':
              {
                return !val.size;
              }
            // Plain Object
            case '[object Object]':
              {
                return !Object.keys(val).length;
              }
          }
          return false;
        };
        function rafThrottle(fn) {
          var locked = false;
          return function () {
            var _this = this;
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (locked) return;
            locked = true;
            window.requestAnimationFrame(function (_) {
              fn.apply(_this, args);
              locked = false;
            });
          };
        }
        function objToArray(obj) {
          if (Array.isArray(obj)) {
            return obj;
          }
          return isEmpty(obj) ? [] : [obj];
        }

        /***/
      },

      /***/"84d2": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }; /* istanbul ignore next */

        exports.hasClass = hasClass;
        exports.addClass = addClass;
        exports.removeClass = removeClass;
        exports.setStyle = setStyle;
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var isServer = _vue2.default.prototype.$isServer;
        var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
        var MOZ_HACK_REGEXP = /^moz([A-Z])/;
        var ieVersion = isServer ? 0 : Number(document.documentMode);

        /* istanbul ignore next */
        var trim = function trim(string) {
          return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
        };
        /* istanbul ignore next */
        var camelCase = function camelCase(name) {
          return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
            return offset ? letter.toUpperCase() : letter;
          }).replace(MOZ_HACK_REGEXP, 'Moz$1');
        };

        /* istanbul ignore next */
        var on = exports.on = function () {
          if (!isServer && document.addEventListener) {
            return function (element, event, handler) {
              if (element && event && handler) {
                element.addEventListener(event, handler, false);
              }
            };
          } else {
            return function (element, event, handler) {
              if (element && event && handler) {
                element.attachEvent('on' + event, handler);
              }
            };
          }
        }();

        /* istanbul ignore next */
        var off = exports.off = function () {
          if (!isServer && document.removeEventListener) {
            return function (element, event, handler) {
              if (element && event) {
                element.removeEventListener(event, handler, false);
              }
            };
          } else {
            return function (element, event, handler) {
              if (element && event) {
                element.detachEvent('on' + event, handler);
              }
            };
          }
        }();

        /* istanbul ignore next */
        var once = exports.once = function once(el, event, fn) {
          var listener = function listener() {
            if (fn) {
              fn.apply(this, arguments);
            }
            off(el, event, listener);
          };
          on(el, event, listener);
        };

        /* istanbul ignore next */
        function hasClass(el, cls) {
          if (!el || !cls) return false;
          if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
          if (el.classList) {
            return el.classList.contains(cls);
          } else {
            return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
          }
        }
        ;

        /* istanbul ignore next */
        function addClass(el, cls) {
          if (!el) return;
          var curClass = el.className;
          var classes = (cls || '').split(' ');
          for (var i = 0, j = classes.length; i < j; i++) {
            var clsName = classes[i];
            if (!clsName) continue;
            if (el.classList) {
              el.classList.add(clsName);
            } else if (!hasClass(el, clsName)) {
              curClass += ' ' + clsName;
            }
          }
          if (!el.classList) {
            el.setAttribute('class', curClass);
          }
        }
        ;

        /* istanbul ignore next */
        function removeClass(el, cls) {
          if (!el || !cls) return;
          var classes = cls.split(' ');
          var curClass = ' ' + el.className + ' ';
          for (var i = 0, j = classes.length; i < j; i++) {
            var clsName = classes[i];
            if (!clsName) continue;
            if (el.classList) {
              el.classList.remove(clsName);
            } else if (hasClass(el, clsName)) {
              curClass = curClass.replace(' ' + clsName + ' ', ' ');
            }
          }
          if (!el.classList) {
            el.setAttribute('class', trim(curClass));
          }
        }
        ;

        /* istanbul ignore next */
        var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
          if (isServer) return;
          if (!element || !styleName) return null;
          styleName = camelCase(styleName);
          if (styleName === 'float') {
            styleName = 'styleFloat';
          }
          try {
            switch (styleName) {
              case 'opacity':
                try {
                  return element.filters.item('alpha').opacity / 100;
                } catch (e) {
                  return 1.0;
                }
              default:
                return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
            }
          } catch (e) {
            return element.style[styleName];
          }
        } : function (element, styleName) {
          if (isServer) return;
          if (!element || !styleName) return null;
          styleName = camelCase(styleName);
          if (styleName === 'float') {
            styleName = 'cssFloat';
          }
          try {
            var computed = document.defaultView.getComputedStyle(element, '');
            return element.style[styleName] || computed ? computed[styleName] : null;
          } catch (e) {
            return element.style[styleName];
          }
        };

        /* istanbul ignore next */
        function setStyle(element, styleName, value) {
          if (!element || !styleName) return;
          if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
            for (var prop in styleName) {
              if (styleName.hasOwnProperty(prop)) {
                setStyle(element, prop, styleName[prop]);
              }
            }
          } else {
            styleName = camelCase(styleName);
            if (styleName === 'opacity' && ieVersion < 9) {
              element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
            } else {
              element.style[styleName] = value;
            }
          }
        }
        ;
        var isScroll = exports.isScroll = function isScroll(el, vertical) {
          if (isServer) return;
          var determinedDirection = vertical !== null && vertical !== undefined;
          var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');
          return overflow.match(/(scroll|auto|overlay)/);
        };
        var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
          if (isServer) return;
          var parent = el;
          while (parent) {
            if ([window, document, document.documentElement].includes(parent)) {
              return window;
            }
            if (isScroll(parent, vertical)) {
              return parent;
            }
            parent = parent.parentNode;
          }
          return parent;
        };
        var isInContainer = exports.isInContainer = function isInContainer(el, container) {
          if (isServer || !el || !container) return false;
          var elRect = el.getBoundingClientRect();
          var containerRect = void 0;
          if ([window, document, document.documentElement, null, undefined].includes(container)) {
            containerRect = {
              top: 0,
              right: window.innerWidth,
              bottom: window.innerHeight,
              left: 0
            };
          } else {
            containerRect = container.getBoundingClientRect();
          }
          return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
        };

        /***/
      },

      /***/"8bbf": /***/function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

        /***/
      },

      /***/"9b75": /***/function (module, exports, __webpack_require__) {
        module.exports = /******/function (modules) {
          // webpackBootstrap
          /******/ // The module cache
          /******/
          var installedModules = {};
          /******/
          /******/ // The require function
          /******/
          function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/if (installedModules[moduleId]) {
              /******/return installedModules[moduleId].exports;
              /******/
            }
            /******/ // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
              /******/i: moduleId,
              /******/l: false,
              /******/exports: {}
              /******/
            };
            /******/
            /******/ // Execute the module function
            /******/
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Flag the module as loaded
            /******/
            module.l = true;
            /******/
            /******/ // Return the exports of the module
            /******/
            return module.exports;
            /******/
          }
          /******/
          /******/
          /******/ // expose the modules object (__webpack_modules__)
          /******/
          __webpack_require__.m = modules;
          /******/
          /******/ // expose the module cache
          /******/
          __webpack_require__.c = installedModules;
          /******/
          /******/ // define getter function for harmony exports
          /******/
          __webpack_require__.d = function (exports, name, getter) {
            /******/if (!__webpack_require__.o(exports, name)) {
              /******/Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
              });
              /******/
            }
            /******/
          };
          /******/
          /******/ // define __esModule on exports
          /******/
          __webpack_require__.r = function (exports) {
            /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
              /******/Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
              });
              /******/
            }
            /******/
            Object.defineProperty(exports, '__esModule', {
              value: true
            });
            /******/
          };
          /******/
          /******/ // create a fake namespace object
          /******/ // mode & 1: value is a module id, require it
          /******/ // mode & 2: merge all properties of value into the ns
          /******/ // mode & 4: return value when already ns object
          /******/ // mode & 8|1: behave like require
          /******/
          __webpack_require__.t = function (value, mode) {
            /******/if (mode & 1) value = __webpack_require__(value);
            /******/
            if (mode & 8) return value;
            /******/
            if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/
            var ns = Object.create(null);
            /******/
            __webpack_require__.r(ns);
            /******/
            Object.defineProperty(ns, 'default', {
              enumerable: true,
              value: value
            });
            /******/
            if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
              return value[key];
            }.bind(null, key));
            /******/
            return ns;
            /******/
          };
          /******/
          /******/ // getDefaultExport function for compatibility with non-harmony modules
          /******/
          __webpack_require__.n = function (module) {
            /******/var getter = module && module.__esModule ? /******/function getDefault() {
              return module['default'];
            } : /******/function getModuleExports() {
              return module;
            };
            /******/
            __webpack_require__.d(getter, 'a', getter);
            /******/
            return getter;
            /******/
          };
          /******/
          /******/ // Object.prototype.hasOwnProperty.call
          /******/
          __webpack_require__.o = function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
          };
          /******/
          /******/ // __webpack_public_path__
          /******/
          __webpack_require__.p = "/dist/";
          /******/
          /******/
          /******/ // Load entry module and return exports
          /******/
          return __webpack_require__(__webpack_require__.s = 80);
          /******/
        }
        /************************************************************************/
        /******/({
          /***/0: /***/function (module, __webpack_exports__, __webpack_require__) {
            "use strict";

            /* harmony export (binding) */
            __webpack_require__.d(__webpack_exports__, "a", function () {
              return normalizeComponent;
            });
            /* globals __VUE_SSR_CONTEXT__ */

            // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
            // This module is a runtime utility for cleaner component module output and will
            // be included in the final webpack user bundle.

            function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
            shadowMode /* vue-cli only */) {
              // Vue.extend constructor export interop
              var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

              // render functions
              if (render) {
                options.render = render;
                options.staticRenderFns = staticRenderFns;
                options._compiled = true;
              }

              // functional template
              if (functionalTemplate) {
                options.functional = true;
              }

              // scopedId
              if (scopeId) {
                options._scopeId = 'data-v-' + scopeId;
              }
              var hook;
              if (moduleIdentifier) {
                // server build
                hook = function (context) {
                  // 2.3 injection
                  context = context ||
                  // cached call
                  this.$vnode && this.$vnode.ssrContext ||
                  // stateful
                  this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
                  // 2.2 with runInNewContext: true
                  if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                    context = __VUE_SSR_CONTEXT__;
                  }
                  // inject component styles
                  if (injectStyles) {
                    injectStyles.call(this, context);
                  }
                  // register component module identifier for async chunk inferrence
                  if (context && context._registeredComponents) {
                    context._registeredComponents.add(moduleIdentifier);
                  }
                };
                // used by ssr in case component is cached and beforeCreate
                // never gets called
                options._ssrRegister = hook;
              } else if (injectStyles) {
                hook = shadowMode ? function () {
                  injectStyles.call(this, this.$root.$options.shadowRoot);
                } : injectStyles;
              }
              if (hook) {
                if (options.functional) {
                  // for template-only hot-reload because in that case the render fn doesn't
                  // go through the normalizer
                  options._injectStyles = hook;
                  // register for functioal component in vue file
                  var originalRender = options.render;
                  options.render = function renderWithStyleInjection(h, context) {
                    hook.call(context);
                    return originalRender(h, context);
                  };
                } else {
                  // inject component registration as beforeCreate hook
                  var existing = options.beforeCreate;
                  options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
                }
              }
              return {
                exports: scriptExports,
                options: options
              };
            }

            /***/
          },

          /***/13: /***/function (module, exports) {
            module.exports = __webpack_require__("9c67");

            /***/
          },

          /***/23: /***/function (module, exports) {
            module.exports = __webpack_require__("0c5c");

            /***/
          },

          /***/7: /***/function (module, exports) {
            module.exports = __webpack_require__("8bbf");

            /***/
          },

          /***/80: /***/function (module, __webpack_exports__, __webpack_require__) {
            "use strict";

            __webpack_require__.r(__webpack_exports__);

            // EXTERNAL MODULE: external "vue"
            var external_vue_ = __webpack_require__(7);
            var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

            // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
            var render = function () {
              var _vm = this;
              var _h = _vm.$createElement;
              var _c = _vm._self._c || _h;
              return _c("transition", {
                attrs: {
                  name: "el-notification-fade"
                }
              }, [_c("div", {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible"
                }],
                class: ["el-notification", _vm.customClass, _vm.horizontalClass],
                style: _vm.positionStyle,
                attrs: {
                  role: "alert"
                },
                on: {
                  mouseenter: function ($event) {
                    _vm.clearTimer();
                  },
                  mouseleave: function ($event) {
                    _vm.startTimer();
                  },
                  click: _vm.click
                }
              }, [_vm.type || _vm.iconClass ? _c("i", {
                staticClass: "el-notification__icon",
                class: [_vm.typeClass, _vm.iconClass]
              }) : _vm._e(), _c("div", {
                staticClass: "el-notification__group",
                class: {
                  "is-with-icon": _vm.typeClass || _vm.iconClass
                }
              }, [_c("h2", {
                staticClass: "el-notification__title",
                domProps: {
                  textContent: _vm._s(_vm.title)
                }
              }), _c("div", {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.message,
                  expression: "message"
                }],
                staticClass: "el-notification__content"
              }, [_vm._t("default", [!_vm.dangerouslyUseHTMLString ? _c("p", [_vm._v(_vm._s(_vm.message))]) : _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.message)
                }
              })])], 2), _vm.showClose ? _c("div", {
                staticClass: "el-notification__closeBtn el-icon-close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation();
                    return _vm.close($event);
                  }
                }
              }) : _vm._e()])])]);
            };
            var staticRenderFns = [];
            render._withStripped = true;

            // CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&

            // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //
            //

            var typeMap = {
              success: 'success',
              info: 'info',
              warning: 'warning',
              error: 'error'
            };

            /* harmony default export */
            var mainvue_type_script_lang_js_ = {
              data: function data() {
                return {
                  visible: false,
                  title: '',
                  message: '',
                  duration: 4500,
                  type: '',
                  showClose: true,
                  customClass: '',
                  iconClass: '',
                  onClose: null,
                  onClick: null,
                  closed: false,
                  verticalOffset: 0,
                  timer: null,
                  dangerouslyUseHTMLString: false,
                  position: 'top-right'
                };
              },
              computed: {
                typeClass: function typeClass() {
                  return this.type && typeMap[this.type] ? 'el-icon-' + typeMap[this.type] : '';
                },
                horizontalClass: function horizontalClass() {
                  return this.position.indexOf('right') > -1 ? 'right' : 'left';
                },
                verticalProperty: function verticalProperty() {
                  return /^top-/.test(this.position) ? 'top' : 'bottom';
                },
                positionStyle: function positionStyle() {
                  var _ref;
                  return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
                }
              },
              watch: {
                closed: function closed(newVal) {
                  if (newVal) {
                    this.visible = false;
                    this.$el.addEventListener('transitionend', this.destroyElement);
                  }
                }
              },
              methods: {
                destroyElement: function destroyElement() {
                  this.$el.removeEventListener('transitionend', this.destroyElement);
                  this.$destroy(true);
                  this.$el.parentNode.removeChild(this.$el);
                },
                click: function click() {
                  if (typeof this.onClick === 'function') {
                    this.onClick();
                  }
                },
                close: function close() {
                  this.closed = true;
                  if (typeof this.onClose === 'function') {
                    this.onClose();
                  }
                },
                clearTimer: function clearTimer() {
                  clearTimeout(this.timer);
                },
                startTimer: function startTimer() {
                  var _this = this;
                  if (this.duration > 0) {
                    this.timer = setTimeout(function () {
                      if (!_this.closed) {
                        _this.close();
                      }
                    }, this.duration);
                  }
                },
                keydown: function keydown(e) {
                  if (e.keyCode === 46 || e.keyCode === 8) {
                    this.clearTimer(); // detele 取消倒计时
                  } else if (e.keyCode === 27) {
                    // esc关闭消息
                    if (!this.closed) {
                      this.close();
                    }
                  } else {
                    this.startTimer(); // 恢复倒计时
                  }
                }
              },

              mounted: function mounted() {
                var _this2 = this;
                if (this.duration > 0) {
                  this.timer = setTimeout(function () {
                    if (!_this2.closed) {
                      _this2.close();
                    }
                  }, this.duration);
                }
                document.addEventListener('keydown', this.keydown);
              },
              beforeDestroy: function beforeDestroy() {
                document.removeEventListener('keydown', this.keydown);
              }
            };
            // CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
            /* harmony default export */
            var src_mainvue_type_script_lang_js_ = mainvue_type_script_lang_js_;
            // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
            var componentNormalizer = __webpack_require__(0);

            // CONCATENATED MODULE: ./packages/notification/src/main.vue

            /* normalize component */

            var component = Object(componentNormalizer["a" /* default */])(src_mainvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

            /* hot reload */
            if (false) { var api; }
            component.options.__file = "packages/notification/src/main.vue";
            /* harmony default export */
            var main = component.exports;
            // EXTERNAL MODULE: external "element-ui/lib/utils/merge"
            var merge_ = __webpack_require__(9);
            var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

            // EXTERNAL MODULE: external "element-ui/lib/utils/popup"
            var popup_ = __webpack_require__(13);

            // EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
            var vdom_ = __webpack_require__(23);

            // CONCATENATED MODULE: ./packages/notification/src/main.js

            var NotificationConstructor = external_vue_default.a.extend(main);
            var instance = void 0;
            var instances = [];
            var seed = 1;
            var main_Notification = function Notification(options) {
              if (external_vue_default.a.prototype.$isServer) return;
              options = merge_default()({}, options);
              var userOnClose = options.onClose;
              var id = 'notification_' + seed++;
              var position = options.position || 'top-right';
              options.onClose = function () {
                Notification.close(id, userOnClose);
              };
              instance = new NotificationConstructor({
                data: options
              });
              if (Object(vdom_["isVNode"])(options.message)) {
                instance.$slots.default = [options.message];
                options.message = 'REPLACED_BY_VNODE';
              }
              instance.id = id;
              instance.$mount();
              document.body.appendChild(instance.$el);
              instance.visible = true;
              instance.dom = instance.$el;
              instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();
              var verticalOffset = options.offset || 0;
              instances.filter(function (item) {
                return item.position === position;
              }).forEach(function (item) {
                verticalOffset += item.$el.offsetHeight + 16;
              });
              verticalOffset += 16;
              instance.verticalOffset = verticalOffset;
              instances.push(instance);
              return instance;
            };
            ['success', 'warning', 'info', 'error'].forEach(function (type) {
              main_Notification[type] = function (options) {
                if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
                  options = {
                    message: options
                  };
                }
                options.type = type;
                return main_Notification(options);
              };
            });
            main_Notification.close = function (id, userOnClose) {
              var index = -1;
              var len = instances.length;
              var instance = instances.filter(function (instance, i) {
                if (instance.id === id) {
                  index = i;
                  return true;
                }
                return false;
              })[0];
              if (!instance) return;
              if (typeof userOnClose === 'function') {
                userOnClose(instance);
              }
              instances.splice(index, 1);
              if (len <= 1) return;
              var position = instance.position;
              var removedHeight = instance.dom.offsetHeight;
              for (var i = index; i < len - 1; i++) {
                if (instances[i].position === position) {
                  instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
                }
              }
            };
            main_Notification.closeAll = function () {
              for (var i = instances.length - 1; i >= 0; i--) {
                instances[i].close();
              }
            };

            /* harmony default export */
            var src_main = main_Notification;
            // CONCATENATED MODULE: ./packages/notification/index.js

            /* harmony default export */
            var notification = __webpack_exports__["default"] = src_main;

            /***/
          },

          /***/9: /***/function (module, exports) {
            module.exports = __webpack_require__("416c");

            /***/
          }

          /******/
        });

        /***/
      },

      /***/"9c67": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.PopupManager = undefined;
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        var _merge = __webpack_require__("416c");
        var _merge2 = _interopRequireDefault(_merge);
        var _popupManager = __webpack_require__("4eac");
        var _popupManager2 = _interopRequireDefault(_popupManager);
        var _scrollbarWidth = __webpack_require__("1b4e");
        var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
        var _dom = __webpack_require__("84d2");
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var idSeed = 1;
        var scrollBarWidth = void 0;
        exports.default = {
          props: {
            visible: {
              type: Boolean,
              default: false
            },
            openDelay: {},
            closeDelay: {},
            zIndex: {},
            modal: {
              type: Boolean,
              default: false
            },
            modalFade: {
              type: Boolean,
              default: true
            },
            modalClass: {},
            modalAppendToBody: {
              type: Boolean,
              default: false
            },
            lockScroll: {
              type: Boolean,
              default: true
            },
            closeOnPressEscape: {
              type: Boolean,
              default: false
            },
            closeOnClickModal: {
              type: Boolean,
              default: false
            }
          },
          beforeMount: function beforeMount() {
            this._popupId = 'popup-' + idSeed++;
            _popupManager2.default.register(this._popupId, this);
          },
          beforeDestroy: function beforeDestroy() {
            _popupManager2.default.deregister(this._popupId);
            _popupManager2.default.closeModal(this._popupId);
            this.restoreBodyStyle();
          },
          data: function data() {
            return {
              opened: false,
              bodyPaddingRight: null,
              computedBodyPaddingRight: 0,
              withoutHiddenClass: true,
              rendered: false
            };
          },
          watch: {
            visible: function visible(val) {
              var _this = this;
              if (val) {
                if (this._opening) return;
                if (!this.rendered) {
                  this.rendered = true;
                  _vue2.default.nextTick(function () {
                    _this.open();
                  });
                } else {
                  this.open();
                }
              } else {
                this.close();
              }
            }
          },
          methods: {
            open: function open(options) {
              var _this2 = this;
              if (!this.rendered) {
                this.rendered = true;
              }
              var props = (0, _merge2.default)({}, this.$props || this, options);
              if (this._closeTimer) {
                clearTimeout(this._closeTimer);
                this._closeTimer = null;
              }
              clearTimeout(this._openTimer);
              var openDelay = Number(props.openDelay);
              if (openDelay > 0) {
                this._openTimer = setTimeout(function () {
                  _this2._openTimer = null;
                  _this2.doOpen(props);
                }, openDelay);
              } else {
                this.doOpen(props);
              }
            },
            doOpen: function doOpen(props) {
              if (this.$isServer) return;
              if (this.willOpen && !this.willOpen()) return;
              if (this.opened) return;
              this._opening = true;
              var dom = this.$el;
              var modal = props.modal;
              var zIndex = props.zIndex;
              if (zIndex) {
                _popupManager2.default.zIndex = zIndex;
              }
              if (modal) {
                if (this._closing) {
                  _popupManager2.default.closeModal(this._popupId);
                  this._closing = false;
                }
                _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
                if (props.lockScroll) {
                  this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
                  if (this.withoutHiddenClass) {
                    this.bodyPaddingRight = document.body.style.paddingRight;
                    this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
                  }
                  scrollBarWidth = (0, _scrollbarWidth2.default)();
                  var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
                  var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
                  if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
                    document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
                  }
                  (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
                }
              }
              if (getComputedStyle(dom).position === 'static') {
                dom.style.position = 'absolute';
              }
              dom.style.zIndex = _popupManager2.default.nextZIndex();
              this.opened = true;
              this.onOpen && this.onOpen();
              this.doAfterOpen();
            },
            doAfterOpen: function doAfterOpen() {
              this._opening = false;
            },
            close: function close() {
              var _this3 = this;
              if (this.willClose && !this.willClose()) return;
              if (this._openTimer !== null) {
                clearTimeout(this._openTimer);
                this._openTimer = null;
              }
              clearTimeout(this._closeTimer);
              var closeDelay = Number(this.closeDelay);
              if (closeDelay > 0) {
                this._closeTimer = setTimeout(function () {
                  _this3._closeTimer = null;
                  _this3.doClose();
                }, closeDelay);
              } else {
                this.doClose();
              }
            },
            doClose: function doClose() {
              this._closing = true;
              this.onClose && this.onClose();
              if (this.lockScroll) {
                setTimeout(this.restoreBodyStyle, 200);
              }
              this.opened = false;
              this.doAfterClose();
            },
            doAfterClose: function doAfterClose() {
              _popupManager2.default.closeModal(this._popupId);
              this._closing = false;
            },
            restoreBodyStyle: function restoreBodyStyle() {
              if (this.modal && this.withoutHiddenClass) {
                document.body.style.paddingRight = this.bodyPaddingRight;
                (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
              }
              this.withoutHiddenClass = true;
            }
          }
        };
        exports.PopupManager = _popupManager2.default;

        /***/
      },

      /***/"e587": /***/function (module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;
        exports.isDefined = exports.isUndefined = exports.isFunction = undefined;
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.isString = isString;
        exports.isObject = isObject;
        exports.isHtmlElement = isHtmlElement;
        var _vue = __webpack_require__("8bbf");
        var _vue2 = _interopRequireDefault(_vue);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function isString(obj) {
          return Object.prototype.toString.call(obj) === '[object String]';
        }
        function isObject(obj) {
          return Object.prototype.toString.call(obj) === '[object Object]';
        }
        function isHtmlElement(node) {
          return node && node.nodeType === Node.ELEMENT_NODE;
        }

        /**
         *  - Inspired:
         *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
         */
        var isFunction = function isFunction(functionToCheck) {
          var getType = {};
          return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        };
        if ( true && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
          exports.isFunction = isFunction = function isFunction(obj) {
            return typeof obj === 'function' || false;
          };
        }
        exports.isFunction = isFunction;
        var isUndefined = exports.isUndefined = function isUndefined(val) {
          return val === void 0;
        };
        var isDefined = exports.isDefined = function isDefined(val) {
          return val !== undefined && val !== null;
        };

        /***/
      },

      /***/"fae3": /***/function (module, __webpack_exports__, __webpack_require__) {
        "use strict";

        // ESM COMPAT FLAG
        __webpack_require__.r(__webpack_exports__);

        // EXPORTS
        __webpack_require__.d(__webpack_exports__, "getOnlineFormData", function () {
          return (/* reexport */getOnlineFormData
          );
        });
        __webpack_require__.d(__webpack_exports__, "validateForm", function () {
          return (/* reexport */validateForm
          );
        });
        __webpack_require__.d(__webpack_exports__, "updateOnlineFormData", function () {
          return (/* reexport */updateOnlineFormData
          );
        });
        __webpack_require__.d(__webpack_exports__, "getOnlineFormInstance", function () {
          return (/* reexport */getOnlineFormInstance
          );
        });
        __webpack_require__.d(__webpack_exports__, "getDiyJsContext", function () {
          return (/* reexport */getDiyJsContext
          );
        });
        __webpack_require__.d(__webpack_exports__, "getActiveFormControlInst", function () {
          return (/* reexport */getActiveFormControlInst
          );
        });
        __webpack_require__.d(__webpack_exports__, "checkFormDataDiffrence", function () {
          return (/* reexport */checkFormDataDiffrence
          );
        });
        __webpack_require__.d(__webpack_exports__, "compareObjects", function () {
          return (/* reexport */compareObjects
          );
        });
        __webpack_require__.d(__webpack_exports__, "highlightEle", function () {
          return (/* reexport */highlightEle
          );
        });
        __webpack_require__.d(__webpack_exports__, "removeHighlightEle", function () {
          return (/* reexport */removeHighlightEle
          );
        });
        __webpack_require__.d(__webpack_exports__, "removeAllHighlightEle", function () {
          return (/* reexport */removeAllHighlightEle
          );
        });
        __webpack_require__.d(__webpack_exports__, "getModelFormItem", function () {
          return (/* reexport */getModelFormItem
          );
        });

        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
        // This file is imported into lib/wc client bundles.

        if (typeof window !== 'undefined') {
          var i;
          if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
            __webpack_require__.p = i[1]; // eslint-disable-line
          }
        }

        // Indicate to webpack that this file can be concatenated
        /* harmony default export */
        var setPublicPath = null;

        // EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/element-ui/lib/notification.js
        var notification = __webpack_require__("9b75");
        var notification_default = /*#__PURE__*/__webpack_require__.n(notification);

        // CONCATENATED MODULE: ./src/core/formUtils.js

        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
          if (!it) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return {
                    done: true
                  };
                  return {
                    done: false,
                    value: o[i++]
                  };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F
              };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it.return != null) it.return();
              } finally {
                if (didErr) throw err;
              }
            }
          };
        }
        function _typeof(obj) {
          "@babel/helpers - typeof";

          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
            return typeof obj;
          } : function (obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          }, _typeof(obj);
        }
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        var notifications = {}; //用来获取弹窗的实例，以对对应弹窗进行操作
        function handleFormValidateError(errors, showNotify) {
          var errorMsg = [];
          errors && errors.forEach(function (e) {
            var fieldLabel = '';
            if (e.field) {
              if (e.field.indexOf('-') != -1) {
                fieldLabel = e.field.substr(e.field.indexOf('-') + 1);
              } else {
                fieldLabel = e.field;
              }
            }
            errorMsg.push("".concat(fieldLabel, " ").concat(e.msg));
          });
          if (errorMsg.length > 0) {
            if (document.getElementsByName('online-form')[0]) {
              var frmInst = document.getElementsByName('online-form')[0].__vue__;
              var jsonObj = frmInst.$refs.onlineForm.$refs;
              for (var key in jsonObj) {
                if (jsonObj[key]) {
                  var textContent = jsonObj[key].$el.textContent;
                  for (var i = 0; i < errorMsg.length; i++) {
                    if (textContent.indexOf(errorMsg[i]) != -1) {
                      if (document.getElementsByClassName(key)[0]) {
                        document.getElementsByClassName(key)[0].style.color = 'red';
                      }
                      break;
                    }
                  }
                }
              }
            }
            if (showNotify) {
              handleErrorNotify(errorMsg);
            }
            return errorMsg;
          }
        }
        function closeAllNotification() {
          for (var key in notifications) {
            notifications[key].close();
            delete notifications[key];
          }
        }

        // 错误弹窗提示
        function handleErrorNotify(errorMsg) {
          closeAllNotification();
          var notifi = notification_default.a.error({
            title: '系统提示',
            dangerouslyUseHTMLString: true,
            message: "\u8BF7\u6B63\u786E\u7684\u586B\u5199\u4EE5\u4E0B\u8868\u5355\u5185\u5BB9\uFF1A<br/>".concat(errorMsg.join('<br/>')),
            duration: 0
          });
          notifications[notifi.id] = notifi;
        }

        /**
         * 获取动态表单数据
         * @param {*} validate 是否自动校验
         * @param {*} refId 多个onlineform时，可指定获取对应refId的表单
         * @param {*} showNotify 是否展示系统提示框
         * @returns
         */
        var getOnlineFormData = function getOnlineFormData(validate) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _options$refId = options.refId,
            refId = _options$refId === void 0 ? null : _options$refId,
            _options$showNotify = options.showNotify,
            showNotify = _options$showNotify === void 0 ? true : _options$showNotify;
          return new Promise(function (resolve, reject) {
            var formElementAry = document.getElementsByName('online-form');
            var frmFrame = document.getElementById('frmFrame');
            if ((!formElementAry || formElementAry.length != 1) && frmFrame) {
              if (frmFrame && frmFrame.length > 0) {
                var frm = frmFrame[0];
                var isCallBack = false;
                var cancelTimeout = false;
                var isTimeOut = false;
                // 子页面是否收到了消息
                var isRoger = false;
                frm.contentWindow.postMessage('saveData', '*');
                window.addEventListener('message', function (e) {
                  if (e.data && e.data.constructor == Object) {
                    if (e.data.type == 'saveData' && !isCallBack) {
                      isCallBack = true;
                      if (e.data.state && !isTimeOut) {
                        var iframeData = {
                          businessKey: e.data.businessKey,
                          sysCode: e.data.sysCode
                        };
                        if (e.data.vars) {
                          iframeData.vars = e.data.vars;
                        }
                        resolve(iframeData);
                      }
                    } else if (e.data.type == 'cancelTimeout') {
                      cancelTimeout = true;
                    } else if (e.data.type == 'roger' && !isRoger) {
                      isRoger = true;
                    }
                  }
                });

                // 只要子页面引入了hotent.helper.js，父页面发送了消息后，子页面会马上回复`roger`。
                // 这里设置0.5秒后未收到`roger`消息则认为子页面未引入hotent.helper.js，此时直接reject。
                setTimeout(function () {
                  if (!isRoger) {
                    reject(6);
                  }
                }, 500);

                // 设置10秒超时机制，如果超时则不再往下执行
                setTimeout(function () {
                  if (!isCallBack && !cancelTimeout) {
                    isTimeOut = true;
                    reject('URL表单处理业务数据超时.');
                  }
                }, 10000);
              } else {
                reject('未获取到在线表单或者URL表单.');
              }
            } else {
              var frmInst = null;
              if (formElementAry.length === 1) {
                frmInst = formElementAry[0].__vue__;
              } else if (formElementAry.length > 1 && refId) {
                for (var i = 0; i <= formElementAry.length - 1; i++) {
                  if (formElementAry[i].__vue__.$attrs.refId === refId) {
                    frmInst = formElementAry[i].__vue__;
                  }
                }
              }
              if (!frmInst || !frmInst._isVue) {
                console.error('使用了在线表单，但是表单为空或者加载失败.');
                resolve(null);
              }
              //处理handsontable子表数据
              var refs = frmInst.$refs['onlineForm'].$refs;
              var hotData = true;
              if (refs) {
                for (var ref in refs) {
                  if (refs.hasOwnProperty(ref) && ref.indexOf('hottable.') == 0) {
                    var refEle = refs[ref];
                    hotData = refEle.getHotTableData(true);
                    if (hotData && Array.isArray(hotData)) {
                      var names = ref.split('.');
                      if (hotData && Array.isArray(hotData)) {
                        frmInst.data[names[1]][names[2]] = _toConsumableArray(hotData);
                      } else {
                        frmInst.data[names[1]][names[2]] = [];
                      }
                    }
                  }
                }
              }
              if (!validate) {
                resolve(JSON.stringify(frmInst.data));
                return;
              }
              frmInst.$root.$validator.validateAll('custom-form').then(function (result) {
                if (hotData === false) {
                  //hottable子表数据校验失败
                  reject('hottable子表数据校验失败');
                  return;
                }
                if (result) {
                  resolve(JSON.stringify(frmInst.data));
                } else {
                  var message = handleFormValidateError(frmInst.$root.$validator.errors.items, showNotify);
                  reject(message);
                }
              });
            }
          });
        };

        /**
         *  校验表单
         * @param {*} options
         * @returns
         */
        var validateForm = function validateForm(options) {
          var _options$refId2 = options.refId,
            refId = _options$refId2 === void 0 ? null : _options$refId2,
            _options$showNotify2 = options.showNotify,
            showNotify = _options$showNotify2 === void 0 ? true : _options$showNotify2;
          return new Promise(function (resolve, reject) {
            var formElementAry = document.getElementsByName('online-form');
            var frmInst = null;
            if (formElementAry.length === 1) {
              frmInst = formElementAry[0].__vue__;
            } else if (formElementAry.length > 1 && refId) {
              for (var i = 0; i <= formElementAry.length - 1; i++) {
                if (formElementAry[i].__vue__.$attrs.refId === refId) {
                  frmInst = formElementAry[i].__vue__;
                }
              }
            }
            if (!frmInst || !frmInst._isVue) {
              reject('使用了在线表单，但是表单为空或者加载失败.');
            }
            //处理handsontable子表数据
            frmInst.$root.$validator.validateAll('custom-form').then(function (result) {
              if (result) {
                resolve(true);
              } else {
                handleFormValidateError(frmInst.$root.$validator.errors.items, showNotify);
                reject(false);
              }
            });
          });
        };
        var getOnlineFormInst = function getOnlineFormInst() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _options$refId3 = options.refId,
            refId = _options$refId3 === void 0 ? null : _options$refId3,
            _options$showNotify3 = options.showNotify,
            showNotify = _options$showNotify3 === void 0 ? true : _options$showNotify3;
          var formElementAry = document.getElementsByName('online-form');
          var frmInst = null;
          if (formElementAry.length === 1) {
            frmInst = formElementAry[0].__vue__;
          } else if (formElementAry.length > 1 && refId) {
            for (var i = 0; i <= formElementAry.length - 1; i++) {
              if (formElementAry[i].__vue__.$attrs.refId === refId) {
                frmInst = formElementAry[i].__vue__;
              }
            }
          }
          if (!frmInst || !frmInst._isVue) {
            console.error('使用了在线表单，但是表单为空或者加载失败.');
          } else {
            return frmInst;
          }
        };
        var updateOnlineFormData = function updateOnlineFormData(data) {
          var inst = getOnlineFormInst();
          if (data && _typeof(data) === 'object') {
            inst.data = Object.assign(inst.data, data);
          }
        };

        // 获取控件所在表单对应的实例对象
        var getOnlineFormInstance = function getOnlineFormInstance(instance) {
          if (!instance) {
            throw 'VueComponent实例为空.';
          }
          if (instance.$el.getAttribute && instance.$el.getAttribute('name') === 'online-form') {
            return instance;
          } else if (instance.$root && instance.$root._uid == instance._uid) {
            throw "\u67E5\u627EVueComponent\u5B9E\u4F8B\u6811\u65F6\u627E\u5230\u6839\u8282\u70B9\u90FD\u672A\u627E\u5230name\u4E3Aonline-form\u7684\u5B9E\u4F8B.";
          } else if (instance.$parent) {
            return utils.getOnlineFormInstance(instance.$parent);
          }
        };

        // 获取diyJs所在的上下文实例
        var getDiyJsContext = function getDiyJsContext(instance) {
          return getOnlineFormInstance(instance).$parent;
        };

        /**
         *
         * @param {*} key 表单绑定的modelName： data.tableName.fieldName
         * @returns 控件实例
         */
        var getActiveFormControlInst = function getActiveFormControlInst(key) {
          return new Promise(function (resolve) {
            setTimeout(function () {
              var selector = "[model-name='".concat(key, "']");
              var dom = document.querySelector(selector);
              var inst = null;
              if (dom && dom.__vue__) {
                inst = dom.__vue__;
              }
              resolve(inst);
            }, 30);
          });
        };

        /**
         * 对比两个FormData是否相等, 如果不相等，高亮差异字段
         * @param {*} formData
         * @param {*} oldFormData
         * @param {boolean} highlight 是否高亮差异字段
         * @returns {{status: boolean, diff: string[]}} 是否相等
         */
        var checkFormDataDiffrence = function checkFormDataDiffrence(formData, oldFormData) {
          var highlight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
          // 对比数据
          // 获取数据不一致的key, 目前只考虑主表
          var oldData = JSON.parse(oldFormData);
          var newData = JSON.parse(formData);

          // 比较差异
          var diff = {};
          compareObjects(newData, oldData, diff, '');

          // 输出差异
          console.log('差异的属性和值：', diff);
          var keys = Object.keys(diff);
          // 高亮
          if (highlight) {
            var eleKeys = keys.map(function (key) {
              return 'data.' + key;
            });
            removeHighlightEle('.op-check-diff__error-mask');
            highlightEle(eleKeys, 'op-check-diff__error-mask');
          }
          return {
            status: keys.length === 0,
            diff: keys
          };
        };

        /**
         *  对比两个formData的差异
         * @param {*} newObj
         * @param {*} oldObj
         * @param {*} diff
         * @param {*} path
         */
        function compareObjects(newObj, oldObj, diff, path) {
          for (var key in newObj) {
            if (newObj.hasOwnProperty(key) && oldObj.hasOwnProperty(key)) {
              var currentPath = path ? "".concat(path, ".").concat(key) : key;
              if (_typeof(newObj[key]) === 'object' && _typeof(oldObj[key]) === 'object') {
                if (Array.isArray(newObj[key]) && Array.isArray(oldObj[key])) {
                  // TODO: 数组比对容易出问题，暂时不处理
                  // if (JSON.stringify(newObj[key]) !== JSON.stringify(oldObj[key])) {
                  //   diff[currentPath] = {
                  //     oldValue: oldObj[key],
                  //     newValue: newObj[key],
                  //   }
                  // }
                } else {
                  compareObjects(newObj[key], oldObj[key], diff, currentPath);
                }
              } else if ((!emptyVal(newObj[key]) || !emptyVal(oldObj[key])) && !valEquals(newObj[key], oldObj[key])) {
                // 这里使用 != ，是因为动态表单存在将数字自动转成字符串的情况
                // TODO: 这里还要判断，如果是时间格式的数据，要转成时间戳再比较
                diff[currentPath] = {
                  oldValue: oldObj[key],
                  newValue: newObj[key]
                };
              }
            }
          }
        }
        function emptyVal(val) {
          // 判断 0、null、undefine、NaN 为动态表单空值
          return val == 0 || Number.isNaN(val) || val === undefined || val === null;
        }
        function valEquals(val1, val2) {
          if (val1 == val2) {
            return true;
          } else {
            // 如果可以转成数字，则先转成数字
            if (typeof val1 === 'string' && !isNaN(Number(val1))) {
              val1 = Number(val1);
            }
            if (typeof val2 === 'string' && !isNaN(Number(val2))) {
              val2 = Number(val2);
            }
            // 如果能转成时间戳，再比较
            if (typeof val1 === 'string' && !isNaN(Date.parse(val1))) {
              val1 = Date.parse(val1);
            }
            if (typeof val2 === 'string' && !isNaN(Date.parse(val2))) {
              val2 = Date.parse(val2);
            }
            return val1 == val2;
          }
        }

        /**
         *  高亮元素
         * @param {*} keys 字段路径组，eg: [data.dyfo_ad_subsidy_assp_ba.org_code]
         * @param {*} className 高亮类名
         */
        function highlightEle() {
          var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var className = arguments.length > 1 ? arguments[1] : undefined;
          var fieldKeys = keys.filter(function (key) {
            return key.indexOf('.sub_') === -1;
          });
          var subFieldKeys = keys.filter(function (key) {
            return key.indexOf('.sub_') !== -1;
          });

          // 高亮字段
          var fieldEles = [];
          var fieldEleList = document.querySelectorAll('[model-name]');
          var _iterator = _createForOfIteratorHelper(fieldEleList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var ele = _step.value;
              if (fieldKeys.includes(ele.getAttribute('model-name'))) {
                fieldEles.push(ele);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var formItemList = fieldEles.map(function (item) {
            return getModelFormItem(item);
          });
          formItemList.forEach(function (ele) {
            var maskDiv = document.createElement('div');
            maskDiv.className = className;
            ele.style.position = 'relative';
            ele.style.zIndex = '1';
            ele.insertBefore(maskDiv, ele.firstChild);
          });

          // 高亮子表
          var _iterator2 = _createForOfIteratorHelper(subFieldKeys),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var key = _step2.value;
              var tableKey = key.replace('data.', '');
              var subTableId = 'xh_tablegd_' + tableKey;
              var tableEle = document.getElementById(subTableId);
              var maskDiv = document.createElement('div');
              maskDiv.className = className;
              maskDiv.style.left = 0;
              var containerEle = tableEle.parentElement.parentElement.parentElement;
              containerEle.style.position = 'relative';
              containerEle.style.zIndex = '1';
              containerEle.insertBefore(maskDiv, containerEle.firstChild);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        /**
         * 移除高亮元素
         * @param {string} querySelector 高亮元素的选择器
         */
        function removeHighlightEle(querySelector) {
          var maskDoms = document.querySelectorAll(querySelector);
          var _iterator3 = _createForOfIteratorHelper(maskDoms),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var dom = _step3.value;
              dom.remove();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        /**
         *  移除所有高亮元素
         */
        function removeAllHighlightEle() {
          var classNames = ['.op-check-rule__error-mask', '.op-check-diff__error-mask', '.op-check-rule__condition'];
          classNames.forEach(function (className) {
            removeHighlightEle(className);
          });
        }

        /**
         * 获取动态表单项el-form-item元素
         * @param {*} ele
         * @returns
         */
        function getModelFormItem(ele) {
          if (!ele.parentElement) {
            return null;
          }
          if (ele.parentElement.classList.value.split(' ').includes('el-form-item')) {
            return ele.parentElement;
          } else {
            return getModelFormItem(ele.parentElement);
          }
        }
        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js

        /***/
      }

      /******/
    })
  );
});

/***/ }),

/***/ "dbfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popup_vue_vue_type_style_index_0_id_3f2ecf2a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4957");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popup_vue_vue_type_style_index_0_id_3f2ecf2a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popup_vue_vue_type_style_index_0_id_3f2ecf2a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "dc28":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("aaf2");
var lengthOfArrayLike = __webpack_require__("0481");
var toIntegerOrInfinity = __webpack_require__("9616");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),

/***/ "dc5c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dca0":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("201b");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "dda8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("201b"),
    stubFalse = __webpack_require__("0e30");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("6984")(module)))

/***/ }),

/***/ "df09":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ "df1a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df6f":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");
var isCallable = __webpack_require__("3ce8");
var store = __webpack_require__("c607");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "dfc1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("9616");

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ "e127":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("2ed5"),
    keysIn = __webpack_require__("cc7f");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "e129":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "e1cc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e29f":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "e3c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "e3ca":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 81);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__("9c67");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__("e587");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = __webpack_require__("0c5c");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__("8bbf");

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-message-fade" },
      on: { "after-leave": _vm.handleAfterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: [
            "el-message",
            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
            _vm.center ? "is-center" : "",
            _vm.showClose ? "is-closable" : "",
            _vm.customClass
          ],
          style: _vm.positionStyle,
          attrs: { role: "alert" },
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
        },
        [
          _vm.iconClass
            ? _c("i", { class: _vm.iconClass })
            : _c("i", { class: _vm.typeClass }),
          _vm._t("default", [
            !_vm.dangerouslyUseHTMLString
              ? _c("p", { staticClass: "el-message__content" }, [
                  _vm._v(_vm._s(_vm.message))
                ])
              : _c("p", {
                  staticClass: "el-message__content",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
          ]),
          _vm.showClose
            ? _c("i", {
                staticClass: "el-message__closeBtn el-icon-close",
                on: { click: _vm.close }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false
    };
  },


  computed: {
    typeClass: function typeClass() {
      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + typeMap[this.type] : '';
    },
    positionStyle: function positionStyle() {
      return {
        'top': this.verticalOffset + 'px'
      };
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    }
  },

  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
});
// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/message/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/message/src/main.vue"
/* harmony default export */ var main = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_ = __webpack_require__(13);

// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_ = __webpack_require__(23);

// EXTERNAL MODULE: external "element-ui/lib/utils/types"
var types_ = __webpack_require__(17);

// CONCATENATED MODULE: ./packages/message/src/main.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var MessageConstructor = external_vue_default.a.extend(main);

var instance = void 0;
var instances = [];
var seed = 1;

var main_Message = function Message(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  var userOnClose = options.onClose;
  var id = 'message_' + seed++;

  options.onClose = function () {
    Message.close(id, userOnClose);
  };
  instance = new MessageConstructor({
    data: options
  });
  instance.id = id;
  if (Object(vdom_["isVNode"])(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  }
  instance.$mount();
  document.body.appendChild(instance.$el);
  var verticalOffset = options.offset || 20;
  instances.forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  instance.verticalOffset = verticalOffset;
  instance.visible = true;
  instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
  instances.push(instance);
  return instance;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  main_Message[type] = function (options) {
    if (Object(types_["isObject"])(options) && !Object(vdom_["isVNode"])(options)) {
      return main_Message(_extends({}, options, {
        type: type
      }));
    }
    return main_Message({
      type: type,
      message: options
    });
  };
});

main_Message.close = function (id, userOnClose) {
  var len = instances.length;
  var index = -1;
  var removedHeight = void 0;
  for (var i = 0; i < len; i++) {
    if (id === instances[i].id) {
      removedHeight = instances[i].$el.offsetHeight;
      index = i;
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
  if (len <= 1 || index === -1 || index > instances.length - 1) return;
  for (var _i = index; _i < len - 1; _i++) {
    var dom = instances[_i].$el;
    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
  }
};

main_Message.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

/* harmony default export */ var src_main = (main_Message);
// CONCATENATED MODULE: ./packages/message/index.js

/* harmony default export */ var message = __webpack_exports__["default"] = (src_main);

/***/ })

/******/ });

/***/ }),

/***/ "e3f8":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("fa8a"),
    Map = __webpack_require__("a9e0"),
    MapCache = __webpack_require__("872c");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "e46d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a692");
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8daa");
/* harmony import */ var _helper_tool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0957");



const ajax = config => new _request_convertors_ajax_config__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](config);
const DEFAULT_FORM_HANDLER_CREATE = gatewayPath => _helper_tool__WEBPACK_IMPORTED_MODULE_2__[/* getRequestConfig */ "d"].call(ajax, '/workflow/defaultFormHandler/create', gatewayPath); // 创建表单
const DEFAULT_FORM_HANDLER_MODIFY = gatewayPath => _helper_tool__WEBPACK_IMPORTED_MODULE_2__[/* getRequestConfig */ "d"].call(ajax, '/workflow/defaultFormHandler/modify', gatewayPath); // 更新表单
const TRACE = ajax().get('/workflow/processInstance/trace/:processInstanceId');
const LIST_COMMENT = ajax().get('/workflow/processInstance/listComment/:processInstanceId');
const LAST_COMMENT = ajax().get('/workflow/processInstance/lastComment/:processInstanceId');
const PAGE_FIND_ACTIVE_CRITERIA = ajax().post('/workflow/process/processDefinition/pageFindByCriteria');
/**
 * @deprecated 这个接口将来废弃，统一启用DEFAULT_FORM_HANDLER_CREATE
 */
const SAVE_PROCESS_DRAFT = ajax().post('/workflow/process/saveProcessDraft');
/**
 * @deprecated 这个接口将来废弃，统一启用DEFAULT_FORM_HANDLER_MODIFY
 */
const UPDATE_PROCESS_DRAFT = ajax().post('/workflow/process/updateProcessDraft');
const DELETE_PROCESS_DRAFT = ajax().delete('/workflow/process/deleteProcessDraft/:id');
const DELETE_PROCESS_DRAFT_WHEN_START_PROCESS = ajax().delete('/workflow/process/deleteProcessDraftWhenStartProcess/:id');
const GET_PROCESS_DRAFT_DETAIL = ajax().get('/workflow/process/getProcessDraftDetail');
const PAGE_FIND_BY_CRITERIA = ajax().post('/workflow/process/processDraft/pageFindByCriteria');
const GET_EXTEND_GRAPH_INFO = ajax().get('/workflow/processInstance/getExtendGraphInfo/:processInstanceId');
const PAGE_FIND_MANAGEMENT_INSTANCE_BY_CRITERIA = ajax().post('/workflow/processInstance/pageFindManagementInstanceByCriteria');
const PROCESS_INSTANCE_DETAIL = ajax().post('/workflow/processInstance/detail');
const PROCESS_INSTANCE_DELETE = ajax().delete('/workflow/processInstance/delete/:processInstanceId');
const PROCESS_INSTANCE_SUSPEND = ajax().post('/workflow/processInstance/suspend/:processInstanceId');
const PROCESS_INSTANCE_ACTIVATE = ajax().post('/workflow/processInstance/activate/:processInstanceId');
const PROCESS_INSTANCE_STOP = ajax().post('/workflow/processInstance/stop/:processInstanceId');
const START_PROCESS_BY_DEFINITION = ajax().post('/workflow/process/definition/start'); // 按流程定义发起流程'

const FIRST_ACTIVITY_BUTTON_LIST = ajax().get('/workflow/process/definition/firstActivityButtonList/:processDefinitionId'); // 获取流程中第一个节点的按钮列表

const FLOW_INST_LIST_BY_ES = ajax().post('/workflow/processInstance/v2/pageFindActive'); // 根据表单数据分页查询流程实例数据

const PROCESS_INSTANCE_SOFT_DELETE = ajax().delete('/workflow/processInstance/softDelete/:processInstanceId');
const PROCESS_INSTANCE_EXPORT = ajax().post('/workflow/processInstance/v2/export').setResponseType('blob'); // 批量导出查询流程实例数据

const SHOP_FLOW_SELECT = ajax().post('/assp-portal-eureka/assp/shopFlowSelect/v1/listJson'); //获取营销补贴关系（分页）

const FLOW_INST_DELETE_BY_ID = ajax().delete('/workflow//processInstance/delete/:processInstanceId'); // 流程实例删除

const GET_ACTIVITY_DETAIL = ajax().get('/assp-portal-eureka/assp/subsidiesActivity/v1/getJson'); // 获取活动信息
/* harmony default export */ __webpack_exports__["a"] = ({
  // 表单创建
  defaultFormHandlerCreate(params, gatewayPath = '') {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(DEFAULT_FORM_HANDLER_CREATE(gatewayPath), params);
  },
  // 表单更新
  defaultFormHandlerModify(params, gatewayPath = '') {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(DEFAULT_FORM_HANDLER_MODIFY(gatewayPath), params);
  },
  // 流程实例流程图追踪
  trace(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(TRACE, params);
  },
  // 获取流程审核意见列表
  listComment(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(LIST_COMMENT, params);
  },
  // 获取流程上一步操作审核意见
  lastComment(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(LAST_COMMENT, params);
  },
  /**
   * @deprecated 请使用 defaultFormHandlerCreate 代替
   * @description 暂存草稿
   * */
  saveDraft(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(SAVE_PROCESS_DRAFT, params);
  },
  /**
   * @deprecated 请使用 defaultFormHandlerModify 代替
   * @description 更新流程草稿
   * */
  updateDraft(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(UPDATE_PROCESS_DRAFT, params);
  },
  // 删除流程草稿
  deleteDraft(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(DELETE_PROCESS_DRAFT, params);
  },
  // 删除草稿（流程发起时）
  deleteProcessDraftWhenStartProcess(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(DELETE_PROCESS_DRAFT_WHEN_START_PROCESS, params);
  },
  // 获取流程草稿列表
  getDraftList(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PAGE_FIND_BY_CRITERIA, params).then(resp => resp.data);
  },
  // 获取流程草稿详情
  getDraft(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_PROCESS_DRAFT_DETAIL, params).then(resp => resp.data);
  },
  // 流程实例流程图扩展信息获取
  getExtendGraphInfoByProcessInstanceId(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_EXTEND_GRAPH_INFO, params);
  },
  // 流程审核实例列表
  pageFindActiveByCriteria(params) {
    return new Promise(resolve => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PAGE_FIND_ACTIVE_CRITERIA, params).then(res => {
        resolve(res.data);
      });
    });
  },
  // 流程实例流程图扩展信息获取
  pageFindManagementInstanceByCriteria(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PAGE_FIND_MANAGEMENT_INSTANCE_BY_CRITERIA, params);
  },
  // 激活
  activate: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_ACTIVATE, params);
  },
  // 挂起
  suspend: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_SUSPEND, params);
  },
  // 挂起
  stop: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_STOP, params);
  },
  // 挂起
  delete: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_DELETE, params);
  },
  // 发起流程
  startProcessByDefinition: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(START_PROCESS_BY_DEFINITION, params);
  },
  // 获取流程中第一个节点的按钮列表
  getFirstActivityButtonListByProcessDefinitionId(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FIRST_ACTIVITY_BUTTON_LIST, params).then(res => res.data).catch(_ => {});
  },
  // 流程es实例
  getFlowInstListByEs: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FLOW_INST_LIST_BY_ES, params);
  },
  // 软删除流程实例
  softDelete: function (params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_SOFT_DELETE, params);
  },
  exportProcessInstance(params) {
    return new Promise((resolve, reject) => {
      Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(PROCESS_INSTANCE_EXPORT, {
        ...params
      }).then(res => {
        resolve(res);
      });
    });
  },
  // 获取营销补贴关系（分页）
  shopFlowSelectList(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(SHOP_FLOW_SELECT, params);
  },
  // 流程实例删除
  flowInstDeleteById(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(FLOW_INST_DELETE_BY_ID, params);
  },
  // 获取活动信息
  getActivityDetail(params) {
    return Object(_request__WEBPACK_IMPORTED_MODULE_1__[/* request */ "b"])(GET_ACTIVITY_DETAIL, params).then(res => res.data);
  }
});

/***/ }),

/***/ "e4be":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("f220");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "e556":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("e902");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "e587":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDefined = exports.isUndefined = exports.isFunction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isString = isString;
exports.isObject = isObject;
exports.isHtmlElement = isHtmlElement;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

/**
 *  - Inspired:
 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
 */
var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

if ( true && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
  exports.isFunction = isFunction = function isFunction(obj) {
    return typeof obj === 'function' || false;
  };
}

exports.isFunction = isFunction;
var isUndefined = exports.isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = exports.isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};

/***/ }),

/***/ "e672":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("daaf"),
    isMasked = __webpack_require__("f6f6"),
    isObject = __webpack_require__("b506"),
    toSource = __webpack_require__("735f");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e697":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bf10");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "e890":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("f498");
var call = __webpack_require__("b546");
var ArrayBufferViewCore = __webpack_require__("aaf2");
var lengthOfArrayLike = __webpack_require__("0481");
var toOffset = __webpack_require__("2dd7");
var toIndexedObject = __webpack_require__("37d1");
var fails = __webpack_require__("72df");

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ "e8dd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e902":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("a4fc");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "e91b":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("1001");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "e942":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "ea26":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var createPropertyDescriptor = __webpack_require__("9618");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "ead3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eba0":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("b546");
var isCallable = __webpack_require__("3ce8");
var isObject = __webpack_require__("7526");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ebac":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("72df");
var isCallable = __webpack_require__("3ce8");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "ecf6":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("fbba"),
    shortOut = __webpack_require__("906d");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "ef30":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");
var definePropertyModule = __webpack_require__("abdf");
var makeBuiltIn = __webpack_require__("2ce5");
var defineGlobalProperty = __webpack_require__("4499");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "eff8":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isLength = __webpack_require__("b742"),
    isObjectLike = __webpack_require__("b4b4");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "f117":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var classof = __webpack_require__("6a61");

module.exports = typeof process != 'undefined' && classof(process) == 'process';

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("07d9")))

/***/ }),

/***/ "f19a":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "f220":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "f241":
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__("5b12");
var clearErrorStack = __webpack_require__("8251");
var ERROR_STACK_INSTALLABLE = __webpack_require__("ea26");

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ "f281":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_f281__;

/***/ }),

/***/ "f2bf":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("f498");
var isObject = __webpack_require__("7526");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "f38f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("6b1d");
var global = __webpack_require__("f498");
var apply = __webpack_require__("d54f");
var wrapErrorConstructorWithCause = __webpack_require__("8ba6");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "f3e4":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("3ce8");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "f498":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("7d15")))

/***/ }),

/***/ "f522":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("24da");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "f591":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_b7da835a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1ba6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_b7da835a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_id_b7da835a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f600":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_69a003e7_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b3f2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_69a003e7_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RejectableNodesDialog_vue_vue_type_style_index_0_id_69a003e7_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "f6f6":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("dca0");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "f72d":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("daaf"),
    isLength = __webpack_require__("b742");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "f7f3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_23fcf0b5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cb7b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_23fcf0b5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_1_id_23fcf0b5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f9c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getToken; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ hasHandleToEmit; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ doHandleToEmitOrToast; });

// UNUSED EXPORTS: cacheToken, removeCacheToken

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("f38f");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("28eb");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("0894");

// CONCATENATED MODULE: ./src/helper/url.js


const obj2query = obj => {
  if (!obj || typeof obj !== 'object' || obj instanceof Array) {
    return void 0;
  }
  const value = Object.entries(obj).reduce((a, b) => {
    a.push(`${encodeURIComponent(b[0])}=${encodeURIComponent(b[1])}`);
    return a;
  }, []).join('&');
  return value ? `?${value}` : '';
};
const query2Obj = (url, keyStrFuc) => {
  const queryObj = {};
  if (url.split('?').length > 1) {
    const queryStr = url.split('?')[1];
    if (!queryStr) return queryObj;
    queryStr.split('&').forEach(item => {
      if (item && item.split('=').length > 0) {
        let [key, val] = item.split('=');
        key = keyStrFuc ? keyStrFuc(key) : key;
        if (key) queryObj[key] = val || '';
      }
    });
  }
  return queryObj;
};
const getQueryVariable = (str, variable) => {
  const query = str.split('?')[1];
  if (!query) return false;
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};
/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
// CONCATENATED MODULE: ./src/helper/cookieExpand.js
/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2019/3/13
 * Time: 11:39
 * Desc:
 */

/**
 * @desc 获取cookie
 * @param name cookie的key
 * @returns {string}
 */
const getCookie = name => {
  var arr = document.cookie.split('; ');
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split('=');
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return '';
};

/**
 * 设置cookie
 * @param name cookie的key
 * @param value cookie的value
 * @param expiredays 设置过期时间
 */
const setCookie = (name, value, expiredays) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = name + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
};

/**
 * @desc 删除cookie
 * @param name cooie的key
 */
const delCookie = name => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  }
};
// EXTERNAL MODULE: ./src/helper/env.js
var env = __webpack_require__("1e45");

// CONCATENATED MODULE: ./src/request/utils.js




const storege = window.sessionStorage;
function cacheToken(token) {
  if (token) {
    storege.setItem('Oauth2-AccessToken', token);
  }
  const _token = token || getQueryObject().token || getCookie('Oauth2-AccessToken');
  if (!storege.getItem('Oauth2-AccessToken') && _token) {
    storege.setItem('Oauth2-AccessToken', _token);
  }
}
function getToken() {
  return getQueryObject().token || storege.getItem('Oauth2-AccessToken') || getCookie('Oauth2-AccessToken');
}
function removeCacheToken() {
  storege.removeItem('Oauth2-AccessToken');
}
/**
 * @description 区分有无事件监听来判断：立即处理还是发射事件
 * arguments[0] 事件名
 * arguments[1...] 任意参数
 * */
function hasHandleToEmit() {
  if (typeof arguments[0] !== 'string') throw Error('事件名称必须为字符串！');
  if (this.$listeners[arguments[0]]) {
    this.$emit(...arguments);
    return true;
  }
  return false;
}

/**
 * @description 区分有无事件监听来判断消息提示弹出还是发射事件，消息提示忽略3后的参数
 * arguments[0] 事件名
 * arguments[1] 消息类型
 * arguments[2] 消息
 * arguments[3...] 任意参数
 * */
function doHandleToEmitOrToast() {
  if (typeof arguments[0] !== 'string') throw Error('事件名称必须为字符串！');
  if (this.$listeners[arguments[0]]) {
    // 去除消息类型标识，默认第二个参数为消息类型
    let args = Array.prototype.filter.call(arguments, (_, index) => index !== 1);
    this.$emit(...args);
  } else {
    this.$message[arguments[1]](arguments[2]);
  }
}

/***/ }),

/***/ "f9f5":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("e697");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "fa8a":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("f19a"),
    listCacheDelete = __webpack_require__("930a"),
    listCacheGet = __webpack_require__("e556"),
    listCacheHas = __webpack_require__("0a87"),
    listCacheSet = __webpack_require__("2f33");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "FlowInstanceDetailDialog", function() { return /* reexport */ FlowInstanceDetailDialog["default"]; });
__webpack_require__.d(__webpack_exports__, "FlowTaskTodoDetail", function() { return /* reexport */ FlowTaskTodoDetail["default"]; });
__webpack_require__.d(__webpack_exports__, "FlowTaskToReadDetail", function() { return /* reexport */ FlowTaskToReadDetail["default"]; });
__webpack_require__.d(__webpack_exports__, "FlowInstanceDetail", function() { return /* reexport */ flow_instance_detail; });
__webpack_require__.d(__webpack_exports__, "FlowActionNoSubmit", function() { return /* reexport */ FlowActionNoSubmit; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/index.vue?vue&type=template&id=b7da835a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-action",attrs:{"id":"flow-action"}},[_c('div',{staticClass:"flow-action__title"},[_c('span',[_vm._v("流程处理")]),_c('span',{staticClass:"open",on:{"click":_vm.showAction}},[_c('i',{class:[_vm.open ? 'el-icon-caret-bottom' : 'el-icon-caret-top'],staticStyle:{"font-size":"16px"}})]),_c('div',{staticClass:"action-btn-list"},_vm._l((_vm.topButtonList),function(btn){return _c('el-button',{key:btn.id,attrs:{"size":"mini","type":"primary","plain":"","round":""},on:{"click":function($event){return _vm.submitRevoke(btn.requestUri)}}},[_vm._v(_vm._s(btn.alias || btn.name))])}),1)]),_c('div',{staticClass:"action-container",style:(Object.assign({}, _vm.containerHeight))},[(!_vm.noCommit)?_c('div',{staticClass:"flow-action__message"},[_c('OpinionText',{model:{value:(_vm.approveMessage),callback:function ($$v) {_vm.approveMessage=$$v},expression:"approveMessage"}})],1):_vm._e(),_c('div',{staticClass:"flow-action__btnArea"},[_c('div',{staticClass:"normal-task"},[(!_vm.toReadId)?_vm._l((_vm.btnList),function(btn,index){return _c('el-button',{key:btn.type + index,attrs:{"type":"primary","disabled":!btn.active},on:{"click":function($event){return _vm.submitRevoke(btn.type, btn.beforeScript)}}},[_vm._v("\n            "+_vm._s(btn.alias || btn.name)+"\n          ")])}):[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleToReadTask}},[_vm._v(" 提交 ")])]],2),_c('div',[_c('el-button',{staticClass:"flow-action__btnArea-close",attrs:{"type":"default"},on:{"click":_vm.handleBack}},[_vm._v("返回")])],1)])]),_c('rejectable-nodes-dialog',{ref:"rejectableNodesDialog",on:{"on-reject":_vm.handleCallback}}),_c('to-read-dialog',{ref:"toReadDialog",on:{"on-to-read":_vm.handleCallback}}),_c('agent-dialog',{ref:"agentDialog",on:{"on-agent":_vm.handleCallback}}),_c('user-dialog',{ref:"userDialog",on:{"onConfirm":_vm.onUserConfirm}}),_c('communication-task',{ref:"communicationTask",on:{"onConfirm":_vm.handleCallback}}),_c('multi-instance-add-dialog',{ref:"multiInstanceAddDialog",on:{"onConfirm":_vm.handleCallback}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/index.vue?vue&type=template&id=b7da835a&scoped=true&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/OpinionText.vue?vue&type=template&id=1ab3d07c&scoped=true&
var OpinionTextvue_type_template_id_1ab3d07c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opinion-text"},[_c('div',{staticClass:"title"},[_vm._v("审批意见：")]),_c('div',{staticClass:"container"},[_c('el-input',{attrs:{"placeholder":"请输入审批意见","type":"textarea","rows":"3"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('div',{staticClass:"common-words"},[_c('div',[_c('span',[_vm._v("常用语：")]),_vm._l((_vm.tagsList),function(item){return _c('el-tag',{key:item,staticClass:"tag",attrs:{"type":"info"},on:{"click":function($event){return _vm.clickWords(item)}}},[_vm._v(_vm._s(item))])})],2),_c('span',{staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm.textNum)+"/500")])])],1)])}
var OpinionTextvue_type_template_id_1ab3d07c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/OpinionText.vue?vue&type=template&id=1ab3d07c&scoped=true&

// EXTERNAL MODULE: ./src/helper/utils.js
var utils = __webpack_require__("89df");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/OpinionText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var OpinionTextvue_type_script_lang_js_ = ({
  props: ['value'],
  data() {
    return {
      tagsList: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  computed: {
    text: {
      set(val) {
        if (Object(utils["d" /* isString */])(val) && val.length <= 500) {
          this.$emit('input', val);
        }
      },
      get() {
        return this.value;
      }
    },
    textNum() {
      return this.text ? this.text.length : 0;
    }
  },
  methods: {
    clickWords(word) {
      this.text += word;
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/OpinionText.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_OpinionTextvue_type_script_lang_js_ = (OpinionTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/OpinionText.vue?vue&type=style&index=0&id=1ab3d07c&prod&lang=scss&scoped=true&
var OpinionTextvue_type_style_index_0_id_1ab3d07c_prod_lang_scss_scoped_true_ = __webpack_require__("6c91");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/task/OpinionText.vue






/* normalize component */

var OpinionText_component = Object(componentNormalizer["a" /* default */])(
  task_OpinionTextvue_type_script_lang_js_,
  OpinionTextvue_type_template_id_1ab3d07c_scoped_true_render,
  OpinionTextvue_type_template_id_1ab3d07c_scoped_true_staticRenderFns,
  false,
  null,
  "1ab3d07c",
  null
  
)

/* harmony default export */ var OpinionText = (OpinionText_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/RejectableNodesDialog.vue?vue&type=template&id=cfc65ab0&scoped=true&
var RejectableNodesDialogvue_type_template_id_cfc65ab0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"可驳回节点","visible":_vm.dialogVisible,"append-to-body":"","close-on-click-modal":false,"width":"40%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("确定")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}]},[_c('el-form-item',{attrs:{"label-width":"100px","label":"驳回指定节点:"}},[(_vm.nodeList && _vm.nodeList.length)?_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.node),callback:function ($$v) {_vm.node=$$v},expression:"node"}},_vm._l((_vm.nodeList),function(node){return _c('el-option',{key:node.id,attrs:{"label":node.name,"value":node.id}})}),1):_c('span',[_vm._v("上一个节点")])],1),_c('el-form-item',{staticStyle:{"margin":"30px 0"},attrs:{"label-width":"100px","label":"驳回重提模式:"}},[_c('div',{staticClass:"rejeck rejeck-first"},[_c('el-radio',{staticClass:"rejeck-radio",attrs:{"label":false,"disabled":_vm.disableRejectMode},model:{value:(_vm.config.skipHistoryNode),callback:function ($$v) {_vm.$set(_vm.config, "skipHistoryNode", $$v)},expression:"config.skipHistoryNode"}},[_vm._v("重新审批")]),_c('span',{staticClass:"rejeck-tips"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("重新提交时，已审批的需要重新审")])],1),_c('div',{staticClass:"rejeck"},[_c('el-radio',{staticClass:"rejeck-radio",attrs:{"label":true,"disabled":_vm.disableRejectMode},model:{value:(_vm.config.skipHistoryNode),callback:function ($$v) {_vm.$set(_vm.config, "skipHistoryNode", $$v)},expression:"config.skipHistoryNode"}},[_vm._v("回到本节点")]),_c('span',{staticClass:"rejeck-tips"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("重新提交时，已审批的无需再审")])],1)]),(_vm.userDeprecated)?_c('el-form-item',{staticClass:"user-select",attrs:{"label-width":"100px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":"","config":{
          id: 'nextUsers.userId',
          name: 'nextUsers.name',
        }},model:{value:(_vm.nextUsers.name),callback:function ($$v) {_vm.$set(_vm.nextUsers, "name", $$v)},expression:"nextUsers.name"}})],1):_vm._e()],1)],1)}
var RejectableNodesDialogvue_type_template_id_cfc65ab0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/RejectableNodesDialog.vue?vue&type=template&id=cfc65ab0&scoped=true&

// EXTERNAL MODULE: ./src/api/task.js
var task = __webpack_require__("b199");

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/CommonInput.vue?vue&type=template&id=5a414eb8&scoped=true&
var CommonInputvue_type_template_id_5a414eb8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label-width":"120px","label":_vm.labelName,"prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","clearable":""},on:{"input":_vm.onInput},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_c('div',{staticClass:"convenient-action"},[_vm._v("\n    常用语：\n    "),_vm._l((_vm.commonWords),function(word){return _c('el-tag',{key:word,on:{"click":function($event){_vm.comment += word}}},[_vm._v(_vm._s(word))])}),_c('span',{staticClass:"max"},[_vm._v(_vm._s(_vm.comment.length)+"/500")])],2)],1)}
var CommonInputvue_type_template_id_5a414eb8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommonInput.vue?vue&type=template&id=5a414eb8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/CommonInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CommonInputvue_type_script_lang_js_ = ({
  name: 'CommonInput',
  props: {
    value: String,
    labelName: {
      type: String,
      default: '处理意见:'
    }
  },
  data() {
    return {
      commonWords: ['请后面的同事审批', '我不同意', '确认通过'],
      comment: ''
    };
  },
  watch: {
    comment: {
      deep: true,
      handler: function (val) {
        this.$emit('input', val);
      }
    },
    value: {
      deep: true,
      handler: function (val) {
        this.comment = val;
      }
    }
  },
  methods: {
    onInput(e) {
      console.log(e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommonInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_CommonInputvue_type_script_lang_js_ = (CommonInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/CommonInput.vue?vue&type=style&index=0&id=5a414eb8&prod&lang=scss&scoped=true&
var CommonInputvue_type_style_index_0_id_5a414eb8_prod_lang_scss_scoped_true_ = __webpack_require__("419e");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommonInput.vue






/* normalize component */

var CommonInput_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_CommonInputvue_type_script_lang_js_,
  CommonInputvue_type_template_id_5a414eb8_scoped_true_render,
  CommonInputvue_type_template_id_5a414eb8_scoped_true_staticRenderFns,
  false,
  null,
  "5a414eb8",
  null
  
)

/* harmony default export */ var CommonInput = (CommonInput_component.exports);
// EXTERNAL MODULE: ./src/components/flow/FlowAction/constants.js
var constants = __webpack_require__("4fa1");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/RejectableNodesDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var RejectableNodesDialogvue_type_script_lang_js_ = ({
  name: 'RejectableNodesDialog',
  components: {
    CommonInput: CommonInput
  },
  data() {
    return {
      // 可支持脚本修改的配置
      config: {
        disableRejectMode: false,
        exceptNodes: [],
        skipHistoryNode: false
      },
      dialogVisible: false,
      userDeprecated: false,
      node: null,
      nodeList: null,
      params: {
        rejectActivityId: null,
        taskId: null,
        processInstanceId: null
      },
      nextUsers: {
        userId: null,
        name: null
      }
    };
  },
  computed: {
    disableRejectMode() {
      return this.config.disableRejectMode || !this.nodeList || !this.nodeList.length;
    }
  },
  methods: {
    showDialog(taskId, processInstanceId, params, config = {}) {
      const {
        exceptNodes,
        disableRejectMode,
        skipHistoryNode
      } = config;
      this.config.disableRejectMode = disableRejectMode;
      this.config.exceptNodes = exceptNodes;
      this.config.skipHistoryNode = skipHistoryNode;
      this.params = Object.assign(this.params, params || {});
      this.node = null;
      this.dialogVisible = true;
      this.params.taskId = taskId;
      this.params.processInstanceId = processInstanceId;
      this.getRejectableNodes(taskId);
    },
    async getRejectableNodes(taskId) {
      const _nodeList = (await task["a" /* default */].rejectableNodes({
        taskId
      })) || null;
      if (_nodeList) {
        // 过滤exceptNode的节点id
        this.nodeList = _nodeList.filter(node => {
          return !this.config.exceptNodes.includes(node.id);
        });
        // 仅有一个元素的时候，默认选中
        if (this.nodeList && Array.isArray(this.nodeList) && this.nodeList.length === 1) {
          this.node = this.nodeList[0].id;
        }
      }
    },
    onUserConfirm(users) {
      if (!users || !users.length) return;
      this.params.nextUsers = {
        userId: users[0].id,
        name: users[0].name
      };
      this.doRejectAction();
    },
    onConfirm() {
      // 如果驳回节点处理人异常，需手动选择处理人
      if (this.userDeprecated && !this.nextUsers.userId) {
        return this.$message.warning('请选择处理人！');
      } else {
        const nextUsersObj = this.nextUsers.userId ? {
          nextUsers: this.nextUsers
        } : {};
        this.params = Object.assign(this.params, nextUsersObj);
      }
      // 没有配置默认驳回上一个节点
      if (!this.nodeList || !Array.isArray(this.nodeList)) {
        delete this.params.rejectActivityId;
        this.doRejectAction();
        return;
      }
      // 如有驳回节点选项，必须选择一个
      if (!this.node && Array.isArray(this.nodeList) && this.nodeList.length) {
        return this.$message.info('至少选择一个节点！');
      }
      this.params.rejectActivityId = this.node;
      this.doRejectAction();
    },
    async doRejectAction(params = {}) {
      this.params.skipHistoryNode = this.config.skipHistoryNode;
      let option = Object.assign(this.params, params);
      const _loading = this.$loading({
        background: 'rgba(0,0,0, 0.35)',
        text: '正在驳回...'
      });
      const resp = await task["a" /* default */].rejectAction(option).finally(() => _loading.close());
      if (resp && !resp.status && resp.code === '117024') {
        this.dialogVisible = false;
        await this.$confirm('外部安装工发起的，不可驳回。', {
          title: '温馨提示',
          confirmButtonText: '我知道了！',
          showCancelButton: false
        });
      } else {
        this.$emit('on-reject', {
          ...resp,
          type: constants["v" /* REJECT */]
        });
        if (resp.status) {
          this.dialogVisible = false;
        }
      }
    },
    close() {
      this.dialogVisible = false;
      this.nextUsers = {
        userId: null,
        name: null
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/RejectableNodesDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_RejectableNodesDialogvue_type_script_lang_js_ = (RejectableNodesDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/RejectableNodesDialog.vue?vue&type=style&index=0&id=cfc65ab0&prod&lang=scss&scoped=true&
var RejectableNodesDialogvue_type_style_index_0_id_cfc65ab0_prod_lang_scss_scoped_true_ = __webpack_require__("6dee");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/RejectableNodesDialog.vue






/* normalize component */

var RejectableNodesDialog_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_RejectableNodesDialogvue_type_script_lang_js_,
  RejectableNodesDialogvue_type_template_id_cfc65ab0_scoped_true_render,
  RejectableNodesDialogvue_type_template_id_cfc65ab0_scoped_true_staticRenderFns,
  false,
  null,
  "cfc65ab0",
  null
  
)

/* harmony default export */ var RejectableNodesDialog = (RejectableNodesDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/ToReadDialog.vue?vue&type=template&id=1ea977ee&scoped=true&
var ToReadDialogvue_type_template_id_1ea977ee_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"流程传阅","visible":_vm.dialogVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.user}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"传阅人员:","prop":"user"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'user.id',
          account: 'user.account',
          name: 'user.name',
        }},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1),_c('common-input',{attrs:{"label-name":"传阅说明:"},model:{value:(_vm.user.comment),callback:function ($$v) {_vm.$set(_vm.user, "comment", $$v)},expression:"user.comment"}})],1)],1)}
var ToReadDialogvue_type_template_id_1ea977ee_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/ToReadDialog.vue?vue&type=template&id=1ea977ee&scoped=true&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("0894");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/ToReadDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ToReadDialogvue_type_script_lang_js_ = ({
  name: 'ToReadDialog',
  components: {
    CommonInput: CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      user: {
        id: null,
        name: null,
        account: null,
        comment: ''
      },
      params: null,
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    show(params) {
      this.params = params;
      this.dialogVisible = true;
      this.user = {
        name: null,
        id: null,
        account: null,
        comment: ''
      };
    },
    async onConfirm() {
      if (!this.user.id) return this.$message.warning('请先选择传阅人员！');
      const ids = this.user.id.split(',');
      const names = this.user.name.split(',');
      const toReadUsers = [];
      ids.map((id, index) => {
        toReadUsers.push({
          userId: id,
          name: names[index]
        });
      });
      if (!this.params) return this.$message.error('数据异常！');
      const option = {
        toReadUsers,
        commentType: 'TOREAD',
        ...this.params,
        comment: this.user.comment
      };
      if (!option.comment) {
        return this.$message.warning('请先填传阅说明！');
      }
      let loading = this.$loading();
      const resp = await task["a" /* default */].toReadTask(option).finally(() => {
        loading.close();
      });
      this.$emit('on-to-read', {
        ...resp,
        type: constants["A" /* TO_READ */]
      });
      if (resp.status) {
        this.dialogVisible = false;
      }
    },
    close() {
      this.dialogVisible = false;
      this.user = {
        id: null,
        name: null,
        account: null,
        comment: ''
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/ToReadDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_ToReadDialogvue_type_script_lang_js_ = (ToReadDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/ToReadDialog.vue?vue&type=style&index=0&id=1ea977ee&prod&lang=scss&scoped=true&
var ToReadDialogvue_type_style_index_0_id_1ea977ee_prod_lang_scss_scoped_true_ = __webpack_require__("9ad1");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/ToReadDialog.vue






/* normalize component */

var ToReadDialog_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_ToReadDialogvue_type_script_lang_js_,
  ToReadDialogvue_type_template_id_1ea977ee_scoped_true_render,
  ToReadDialogvue_type_template_id_1ea977ee_scoped_true_staticRenderFns,
  false,
  null,
  "1ea977ee",
  null
  
)

/* harmony default export */ var ToReadDialog = (ToReadDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/AgentDialog.vue?vue&type=template&id=cacad09c&scoped=true&
var AgentDialogvue_type_template_id_cacad09c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"转办","visible":_vm.dialogVisible,"width":"30%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":"","config":{
          id: 'form.agentUserId',
          account: 'form.account',
          name: 'form.userName',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('CommonInput',{model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)}
var AgentDialogvue_type_template_id_cacad09c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/AgentDialog.vue?vue&type=template&id=cacad09c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/AgentDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AgentDialogvue_type_script_lang_js_ = ({
  name: 'AgentDialog',
  components: {
    CommonInput: CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        agentUserId: null,
        account: null,
        userName: null,
        comment: ''
      },
      comment: '',
      option: {},
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    showDialog(option) {
      this.dialogVisible = true;
      this.option = option;
    },
    // 提交转办
    onConfirm() {
      if (!this.form.agentUserId) return this.$message.warning('必须选择接受人！');
      if (!this.form.account) return this.$message.warning('必须选择接受人！');
      const option = Object.assign(this.option || {}, this.form);
      if (!option.comment) {
        return this.$message.warning('请先填处理意见！');
      }
      this.doAgentAction(option);
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        agentUserId: null,
        account: null,
        userName: null,
        name: null,
        comment: ''
      };
    },
    // 操作转办
    async doAgentAction(option) {
      option.nextUsers && delete option.nextUsers;
      const loading = this.$loading();
      const {
        status,
        message,
        code
      } = await task["a" /* default */].agentAction(option).finally(() => {
        loading.close();
      });
      if (status) {
        this.dialogVisible = false;
      }
      this.$emit('on-agent', {
        status,
        message,
        code,
        type: constants["a" /* AGENT */]
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/AgentDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_AgentDialogvue_type_script_lang_js_ = (AgentDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/flow/FlowAction/AgentDialog.vue





/* normalize component */

var AgentDialog_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_AgentDialogvue_type_script_lang_js_,
  AgentDialogvue_type_template_id_cacad09c_scoped_true_render,
  AgentDialogvue_type_template_id_cacad09c_scoped_true_staticRenderFns,
  false,
  null,
  "cacad09c",
  null
  
)

/* harmony default export */ var AgentDialog = (AgentDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/UserDialog.vue?vue&type=template&id=285db914&scoped=true&
var UserDialogvue_type_template_id_285db914_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"选择处理人","visible":_vm.dialogVisible,"width":"40%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form,"label-position":"left"}},[(_vm.desc)?_c('el-alert',{staticClass:"tips",attrs:{"type":"warning","closable":false}},[_vm._v("\n      "+_vm._s(_vm.desc)+"\n    ")]):_vm._e(),(_vm.extraDesc)?_c('el-alert',{staticClass:"tips",attrs:{"closable":false}},[_vm._v("\n      "+_vm._s(_vm.extraDesc)+"\n    ")]):_vm._e(),(_vm.nextActivityNodeList && _vm.nextActivityNodeList.length && _vm.form.list.length > 0)?_vm._l((_vm.nextActivityNodeList),function(activity,idx){return _c('el-form-item',{key:idx,attrs:{"label-width":"200px","label":activity.name + '：'}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":false,"config":{
            id: ("form.list[" + idx + "].userId"),
            name: ("form.list[" + idx + "].name"),
            orgNo: ("form.list[" + idx + "].orgNo"),
          }},model:{value:(_vm.form.list[idx].name),callback:function ($$v) {_vm.$set(_vm.form.list[idx], "name", $$v)},expression:"form.list[idx].name"}})],1)}):_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":false,"config":{
          id: 'form.userId',
          name: 'form.name',
          orgNo: 'form.orgNo',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],2)],1)}
var UserDialogvue_type_template_id_285db914_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/UserDialog.vue?vue&type=template&id=285db914&scoped=true&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("28eb");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/UserDialog.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 人员弹窗目前有2个场景
 * 1、通过script动态触发默认弹窗选人， actionType = 'SCRIPT'
 * 2、当出现下一个节点审核人失效时（找不到人或者人已经离职了），自动弹出选人窗口
 */
/* harmony default export */ var UserDialogvue_type_script_lang_js_ = ({
  name: 'UserDialog',
  data() {
    return {
      dialogVisible: false,
      form: {
        userId: null,
        name: null,
        orgNo: null,
        list: []
      },
      type: null,
      desc: null,
      extraDesc: null,
      data: null,
      actionType: null,
      nextActivityNodeList: []
    };
  },
  computed: {
    isNodeSelectPerson() {
      return this.actionType && this.nextActivityNodeList.length;
    }
  },
  methods: {
    initForm() {
      this.form = {
        userId: null,
        name: null,
        orgNo: null,
        actionType: null,
        list: []
      };
      this.actionType = null;
      this.nextActivityNodeList = [];
    },
    showDialog(type, options = null, actionType = null, config = {
      nextActivityNodeList: null,
      exceptNodes: []
    }) {
      const {
        nextActivityNodeList,
        exceptNodes
      } = config;
      this.dialogVisible = true;
      this.type = type;
      this.actionType = actionType;
      if (nextActivityNodeList) {
        this.nextActivityNodeList = nextActivityNodeList.filter(item => !(exceptNodes || []).includes(item.id));
        nextActivityNodeList.map(_a => {
          this.form.list.push({
            activityId: _a.id,
            userId: null,
            name: null,
            orgNo: null,
            isMultiInstance: !!_a.isMultiInstance
          });
        });
      }
      if (options && options.data && options.data.activity) {
        var _options$data;
        const {
          id,
          name
        } = (options === null || options === void 0 ? void 0 : (_options$data = options.data) === null || _options$data === void 0 ? void 0 : _options$data.activity) || {
          id: '',
          name: null
        };
        id && name && (this.desc = options.message.replace(id, name));
      }
      if (options.extraMessage) {
        this.extraDesc = options.extraMessage;
      }
    },
    // 提交转办
    onConfirm() {
      // 人员失效场景，必须选择处理人
      if (!this.form.userId && !this.actionType) {
        return this.$message.warning('必须选择接处理人！');
      }
      if (this.form.list && this.form.list.length > 1 && this.form.list.filter(item => !!item.userId).length !== this.nextActivityNodeList.length) {
        return this.$message.warning('全部项必须选择接处理人！');
      }
      let nextUsers = [];
      if (this.actionType && this.nextActivityNodeList.length) {
        let list = JSON.parse(JSON.stringify(this.form.list));
        // script触发的选人弹窗可以不选人，不选的话后端会默认拿流程配置的人
        const existUserList = list.reduce((prev, next) => {
          if (next.userId) {
            const activityId = next.activityId;
            let len = next.userId.split(',').length;
            let ids = [];
            let isMultiInstances = [];
            while (len) {
              ids.push(activityId);
              isMultiInstances.push(next.isMultiInstance);
              len--;
            }
            next.activityId = ids.join(',');
            next.isMultiInstance = isMultiInstances;
            prev.push(next);
          }
          return prev;
        }, []);
        nextUsers = existUserList.map(item => this.splitToObject(item)).flat();
      } else {
        let form = JSON.parse(JSON.stringify(this.form));
        delete form.list;
        nextUsers = this.splitToObject(form);
      }
      this.$emit('onConfirm', this.type, nextUsers, this.actionType);
      this.dialogVisible = false;
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        userId: null,
        name: null,
        orgNo: null,
        list: []
      };
    },
    splitToObject(obj) {
      let keys = Object.keys(obj);
      let list = [];
      let form = Object.assign({}, obj);
      for (let formKey in form) {
        if (typeof form[formKey] === 'string') {
          form[formKey] = form[formKey].split(',');
        }
      }
      if (obj && keys && keys.length && obj[keys[0]]) {
        const count = form[keys[0]].length;
        for (let i = 0; i < count; i++) {
          let item = {};
          keys.map(key => {
            item[key] = form[key][i];
          });
          list.push(item);
        }
      }
      return list;
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/UserDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_UserDialogvue_type_script_lang_js_ = (UserDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/UserDialog.vue?vue&type=style&index=0&id=285db914&prod&lang=scss&scoped=true&
var UserDialogvue_type_style_index_0_id_285db914_prod_lang_scss_scoped_true_ = __webpack_require__("6074");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/UserDialog.vue






/* normalize component */

var UserDialog_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_UserDialogvue_type_script_lang_js_,
  UserDialogvue_type_template_id_285db914_scoped_true_render,
  UserDialogvue_type_template_id_285db914_scoped_true_staticRenderFns,
  false,
  null,
  "285db914",
  null
  
)

/* harmony default export */ var UserDialog = (UserDialog_component.exports);
// EXTERNAL MODULE: ./src/components/dialog/ReplaceUserDialog/add.vue + 4 modules
var add = __webpack_require__("fd13");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./src/components/dialog/CreateFunc/index.js
/**
 * import AddCompany from './add.vue'
 * import CreateVueFunc from '@/components/form/CreateFunc'
 * export default CreateVueFunc(AddCompany)
 */


function CreateVueFunc(component) {
  const Construtor = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend(component);
  const CreateFunc = options => {
    let instance = null;
    const _params = {
      propsData: options
    };
    instance = new Construtor(_params);
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.$on('close', () => {
      document.body.removeChild(instance.vm.$el);
      instance.vm.$destroy();
    });
    return new Promise(resolve => {
      instance.vm.$on('returnValue', val => {
        resolve(val);
      });
    });
  };
  return CreateFunc;
}
// CONCATENATED MODULE: ./src/components/dialog/ReplaceUserDialog/index.js


/* harmony default export */ var ReplaceUserDialog = (CreateVueFunc(add["default"]));
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/CommunicationTask.vue?vue&type=template&id=73a2e4bc&scoped=true&
var CommunicationTaskvue_type_template_id_73a2e4bc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.user}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:","prop":"user"}},[(_vm.actionType == _vm.COMMUNICATION_TASK_REPLY)?_vm._l((_vm.communicateUsers),function(user,idx){return _c('el-tag',{key:idx,attrs:{"type":"info"}},[_vm._v(_vm._s(user.name))])}):_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'user.id',
          account: 'user.account',
          name: 'user.name',
        }},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],2),_c('common-input',{attrs:{"label-name":"处理意见:"},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)],1)}
var CommunicationTaskvue_type_template_id_73a2e4bc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommunicationTask.vue?vue&type=template&id=73a2e4bc&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/CommunicationTask.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const commentType = {
  [constants["d" /* COMMUNICATION_TASK */]]: 'COMMUNICATION_START',
  [constants["f" /* COMMUNICATION_TASK_REPLY */]]: 'COMMUNICATION_REPLY'
};
/* harmony default export */ var CommunicationTaskvue_type_script_lang_js_ = ({
  name: 'CommunicationTask',
  components: {
    CommonInput: CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      user: {
        id: null,
        name: null,
        account: null
      },
      title: null,
      comment: '',
      params: null,
      commonWords: ['请后面的同事审批', '我不同意', '确认通过'],
      actionType: null,
      COMMUNICATION_TASK_REPLY: constants["f" /* COMMUNICATION_TASK_REPLY */],
      communicateUsers: []
    };
  },
  methods: {
    showDialog(params, actionType) {
      this.params = params;
      this.user = {
        name: null,
        id: null,
        account: null
      };
      this.comment = params.comment || '';
      this.title = actionType == constants["d" /* COMMUNICATION_TASK */] ? '沟通' : '回复沟通';
      this.actionType = actionType;
      if (params.communicateUsers && actionType == constants["f" /* COMMUNICATION_TASK_REPLY */]) {
        this.communicateUsers = params.communicateUsers;
        delete params.communicateUsers;
        this.communicateUsers.map(user => {
          for (let userKey in user) {
            if (!this.user[userKey]) {
              this.user[userKey] = [];
            }
            this.user[userKey].push(user[userKey]);
          }
        });
        for (const paramsKey in this.user) {
          if (this.user[paramsKey] && Array.isArray(this.user[paramsKey])) {
            this.user[paramsKey] = this.user[paramsKey].join(',');
          }
        }
      }
      this.$forceUpdate();
      this.dialogVisible = true;
    },
    async onConfirm() {
      if (this.actionType == constants["d" /* COMMUNICATION_TASK */]) {
        var _this$user, _this$user$id, _this$user2, _this$user2$name;
        if (!this.user.id) return this.$message.error('请先选择沟通接受人员！');
        const ids = (_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$id = _this$user.id) === null || _this$user$id === void 0 ? void 0 : _this$user$id.split(',');
        const names = (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : (_this$user2$name = _this$user2.name) === null || _this$user2$name === void 0 ? void 0 : _this$user2$name.split(',');
        this.communicateUsers = [];
        ids.map((id, index) => {
          this.communicateUsers.push({
            userId: id,
            name: names[index]
          });
        });
      }
      if (!this.comment) return this.$message.error('请输入处理意见！');
      if (!this.params || !this.communicateUsers.length) return this.$message.error('数据异常！');
      let resp,
        loading = this.$loading(),
        users = this.actionType === constants["d" /* COMMUNICATION_TASK */] ? {
          toCommunicateUsers: this.communicateUsers
        } : {
          communicateUsers: this.communicateUsers
        },
        option = {
          ...users,
          communicateUsers: this.communicateUsers,
          commentType: commentType[constants["f" /* COMMUNICATION_TASK_REPLY */]],
          ...this.params,
          comment: this.comment
        };
      if (!option.communicateUsers.length) return this.$message.error('请先选择沟通接受人员！');
      switch (this.actionType) {
        case constants["d" /* COMMUNICATION_TASK */]:
          resp = await task["a" /* default */].createCommunicationTask(option).finally(() => {
            loading.close();
          });
          break;
        case constants["f" /* COMMUNICATION_TASK_REPLY */]:
          resp = await task["a" /* default */].replyCommunicationTask(option).finally(() => {
            loading.close();
          });
          break;
        default:
          break;
      }
      this.$emit('onConfirm', {
        ...resp,
        type: this.actionType
      });
      if (resp.status) {
        this.$message.success('操作成功！');
        this.dialogVisible = false;
      }
    },
    close() {
      this.dialogVisible = false;
      this.user = {
        id: null,
        name: null,
        account: null
      };
      this.comment = '';
      this.$forceUpdate();
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommunicationTask.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_CommunicationTaskvue_type_script_lang_js_ = (CommunicationTaskvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/CommunicationTask.vue?vue&type=style&index=0&id=73a2e4bc&prod&lang=scss&scoped=true&
var CommunicationTaskvue_type_style_index_0_id_73a2e4bc_prod_lang_scss_scoped_true_ = __webpack_require__("59d2");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/CommunicationTask.vue






/* normalize component */

var CommunicationTask_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_CommunicationTaskvue_type_script_lang_js_,
  CommunicationTaskvue_type_template_id_73a2e4bc_scoped_true_render,
  CommunicationTaskvue_type_template_id_73a2e4bc_scoped_true_staticRenderFns,
  false,
  null,
  "73a2e4bc",
  null
  
)

/* harmony default export */ var CommunicationTask = (CommunicationTask_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/MultiInstanceAddDialog.vue?vue&type=template&id=633aff0f&scoped=true&
var MultiInstanceAddDialogvue_type_template_id_633aff0f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"加签","visible":_vm.dialogVisible,"width":"30%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'form.userId',
          account: 'form.orgNo',
          name: 'form.name',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('CommonInput',{model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)}
var MultiInstanceAddDialogvue_type_template_id_633aff0f_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowAction/MultiInstanceAddDialog.vue?vue&type=template&id=633aff0f&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/MultiInstanceAddDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MultiInstanceAddDialogvue_type_script_lang_js_ = ({
  name: 'MultiInstanceAddDialog',
  components: {
    CommonInput: CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        userId: null,
        orgNo: null,
        name: null,
        comment: ''
      },
      comment: '',
      option: {},
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    showDialog(option) {
      this.dialogVisible = true;
      this.option = option;
    },
    // 提交加签
    onConfirm() {
      if (!this.form.userId) return this.$message.warning('必须选择接收人！');
      if (!this.form.orgNo) return this.$message.warning('必须选择接收人！');
      const option = Object.assign(this.option || {}, this.form);
      if (!option.comment) {
        return this.$message.warning('请先填处理意见！');
      }
      this.doAction(option);
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        userId: null,
        orgNo: null,
        name: null,
        comment: ''
      };
    },
    // 操作加签
    async doAction(option) {
      var _this$form, _this$form$userId, _this$form2, _this$form2$name, _this$form3, _this$form3$orgNo;
      const userIds = (_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$userId = _this$form.userId) === null || _this$form$userId === void 0 ? void 0 : _this$form$userId.split(',');
      const names = (_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : (_this$form2$name = _this$form2.name) === null || _this$form2$name === void 0 ? void 0 : _this$form2$name.split(',');
      const orgNos = (_this$form3 = this.form) === null || _this$form3 === void 0 ? void 0 : (_this$form3$orgNo = _this$form3.orgNo) === null || _this$form3$orgNo === void 0 ? void 0 : _this$form3$orgNo.split(',');
      let params = {
        activityId: option.activityId,
        processInstanceId: option.processInstanceId,
        taskId: option.taskId,
        comment: option.comment,
        assigneeList: []
      };
      userIds.map((id, index) => {
        params.assigneeList.push({
          userId: id,
          name: names[index],
          orgNo: orgNos[index]
        });
      });
      const loading = this.$loading();
      const {
        status,
        message,
        code
      } = await task["a" /* default */].multiInstanceAdd(params).finally(() => {
        loading.close();
      });
      if (status) {
        this.$message.success('流程加签成功！');
        this.dialogVisible = false;
      }
      this.$emit('onConfirm', {
        status,
        message,
        code,
        type: constants["o" /* MULTI_INSTANCE_ADD */]
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/MultiInstanceAddDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowAction_MultiInstanceAddDialogvue_type_script_lang_js_ = (MultiInstanceAddDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/flow/FlowAction/MultiInstanceAddDialog.vue





/* normalize component */

var MultiInstanceAddDialog_component = Object(componentNormalizer["a" /* default */])(
  FlowAction_MultiInstanceAddDialogvue_type_script_lang_js_,
  MultiInstanceAddDialogvue_type_template_id_633aff0f_scoped_true_render,
  MultiInstanceAddDialogvue_type_template_id_633aff0f_scoped_true_staticRenderFns,
  false,
  null,
  "633aff0f",
  null
  
)

/* harmony default export */ var MultiInstanceAddDialog = (MultiInstanceAddDialog_component.exports);
// EXTERNAL MODULE: ../web-form/lib/form-utils.umd.js
var form_utils_umd = __webpack_require__("dbf1");

// EXTERNAL MODULE: ./src/api/processInstance.js
var processInstance = __webpack_require__("e46d");

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/js-base64/base64.mjs
var base64 = __webpack_require__("fb51");

// EXTERNAL MODULE: ./src/request/utils.js + 2 modules
var request_utils = __webpack_require__("f9c6");

// EXTERNAL MODULE: ./src/helper/env.js
var helper_env = __webpack_require__("1e45");

// EXTERNAL MODULE: ./src/helper/eventBus.js
var eventBus = __webpack_require__("6e6e");

// EXTERNAL MODULE: ./src/api/flow.js
var flow = __webpack_require__("4bf8");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("365c");

// EXTERNAL MODULE: ./src/helper/tool.js
var tool = __webpack_require__("0957");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowAction/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// 操作类型







/**
 * @description FlowAction
 * @param taskId <String> required, 待办任务ID
 * @param taskDetail <Object> 任务详情，非必须，如果是在强制节点选择审核人员场景，建议传递
 * @param instId <String> required, 流程实例ID
 * @param toReadId <String>, 传阅记录ID，回复传阅操作的时候必须
 * @param buttonList <String> required, 底部操作按钮列表，通过流程任务详情接口获取（接口信息：http://10.10.1.244:3000/project/11/interface/api/25074）
 * @event handel-success 自定义失败回调事件，如果不处理内部默认提示toast
 * @event handel-error 自定义成功回调事件，如果不处理内部默认提示toast，回调参数：
 *                        @param <String> type（APPLY/同意, REJECT/驳回, STOP/终止, AGENT/转办, TO_READ/传阅, DELEGATE/委派）
 *                        @param <Object> data：
 *                                            NO_CONFIGURED_USER_EXCEPTION(117034): // 未配置用户
 *                                            NO_AVAILABLE_USER_THROW_MODE_EXCEPTION(117037): // 配置，但无可用
 *                                            NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION(117023): // 用户不存在或已离职
 *                                            以及其他任何错误信息，返回结构一致
 *                                            接口返回的全量错误信息，详细查看：https://www.tapd.cn/23181131/prong/tasks/view/1123181131001114730
 *                                            如为监听此事件默认$message.error()弹出消息提示框
 * @event handel-user-error 自定义选人事件，需要自行实现选人逻辑，完成选人和后续操作。
 * @event handel-back 返回按钮点击事件，如引用组件处为监听此事件，默认启用vue-router，$router.back()。
 * */
/* harmony default export */ var FlowActionvue_type_script_lang_js_ = ({
  props: {
    taskId: String,
    instId: String,
    toReadId: String,
    activityId: String,
    taskDetail: Object,
    noCommit: {
      type: Boolean,
      default: false
    },
    buttonList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isManage: {
      type: Boolean,
      default: false
    },
    onBeforeSubmit: {
      type: Function,
      default: () => {}
    },
    onAfterSetParams: {
      type: Function,
      default: () => {}
    },
    onBeforeAction: {
      type: Function,
      default: () => {}
    },
    gatewayPath: {
      type: String,
      default: ''
    }
  },
  name: 'flow-action',
  components: {
    OpinionText: OpinionText,
    RejectableNodesDialog: RejectableNodesDialog,
    ToReadDialog: ToReadDialog,
    AgentDialog: AgentDialog,
    UserDialog: UserDialog,
    CommunicationTask: CommunicationTask,
    MultiInstanceAddDialog: MultiInstanceAddDialog
  },
  data() {
    return {
      open: true,
      taskInfo: {
        status: ''
      },
      approveMessage: '',
      nextUsers: [],
      TO_READ: constants["A" /* TO_READ */],
      exceptNodes: [],
      // 过滤节点id，可用于驳回节点过滤和选人节点过滤
      // 同意按钮相关参数
      customNextUser: false,
      // 控制同意按钮是否强制弹出选人对话框
      customNextUserDialogMessage: '',
      // 选人对话框的额外提示信息
      activity: null,
      activities: [],
      // 驳回专用的脚本设置属性
      rejectConfig: {
        disableRejectMode: false,
        skipHistoryNode: false
      }
    };
  },
  computed: {
    containerHeight() {
      if (this.open) {
        return {
          height: 'auto'
        };
      } else {
        return {
          height: '0px'
        };
      }
    },
    btnList() {
      const _list = this.buttonList.map(item => ({
        name: item.name,
        type: item.requestUri,
        active: item.active,
        order: item.order,
        alias: item.alias,
        ajax: {
          method: item.method,
          uri: item.requestUri
        },
        beforeScript: item.beforeScript || ''
      }));
      return _list.filter(item => item.type.indexOf('toRead') === -1);
    },
    topButtonList() {
      const buttonList = [{
        id: '1459077296364270963',
        order: 5,
        name: '传阅',
        method: 'POST',
        requestUri: constants["A" /* TO_READ */],
        isPeopleSelection: true,
        beforeScript: null,
        groovyScript: null
      }];
      if (this.toReadId || !Array.isArray(this.buttonList)) return buttonList;
      return this.buttonList.filter(item => item.requestUri.indexOf('toRead') !== -1);
    },
    isCanToRead() {
      if (!Array.isArray(this.buttonList)) return false;
      return this.buttonList.filter(item => item.requestUri.indexOf('toRead') !== -1).length;
    }
  },
  mounted() {
    this.$on('showToReadDialog', async () => {
      let params = await this.getParams(false);
      if (this.$refs.toReadDialog) {
        this.$refs.toReadDialog.show(params);
      }
    });

    // 如果有readId, 说明是传阅任务，访问时需要调用接口改成已阅
    // 这里要添加管理端的判断，如果是管理端进入的管理页面，不需要调用接口
    if (this.toReadId && !this.isManage) {
      flow["a" /* default */].handleToReadMark({
        id: this.toReadId
      }).then(res => {
        console.log('已阅');
      });
    }
    // 发起任务详情请求
    this.fetchTaskDetail();
  },
  methods: {
    //执行前置脚本
    async tempScript(script, params) {
      if (script == undefined || script == '') {
        return true;
      }
      let _this = this;
      let _req = this.$req;
      let dialogVm = {
        replaceUser: ReplaceUserDialog,
        getOnlineFormData: form_utils_umd["getOnlineFormData"],
        validateForm: form_utils_umd["validateForm"]
      };
      const formDom = document.getElementById('flow-form-content');
      let formContext = formDom ? document.getElementById('flow-form-content').__vue__ : null;
      let boData = await Object(form_utils_umd["getOnlineFormData"])(false);
      async function evil() {
        let Fn = Function('_req', 'boData', '_this', 'context', 'dialogVm', 'params', script); //一个变量指向Function，防止有些前端编译工具报错
        let result = Fn(_req, JSON.parse(boData), _this, formContext, dialogVm, params);
        return result;
      }
      let resultValue = await evil();
      // 如果是undefine，认为脚本执行成功，只有明确return false才阻止提交
      let flag = resultValue !== false;
      return flag;
    },
    async getFormData(isCheck = true) {
      if (document.getElementsByName('online-form')[0]) {
        const form = await Object(form_utils_umd["getOnlineFormData"])(isCheck);
        return base64["a" /* Base64 */].encode(form);
      }
      return '';
    },
    // 获取表单数据
    async getParams(isCheck) {
      const formData = await this.getFormData(isCheck);
      return {
        formData,
        taskId: this.taskId,
        processInstanceId: this.instId,
        comment: this.approveMessage,
        nextUsers: this.nextUsers
      };
    },
    resetConfig() {
      this.customNextUser = false;
      this.customNextUserDialogMessage = '';
    },
    setValueByKeyForTaskDetail(obj = {}) {
      for (const objKey in obj) {
        this.taskDetail[objKey] = obj[objKey];
      }
    },
    // 保存表单数据
    async handleModifyFormData(formData, type, scenario) {
      // 开始更新表单数据
      if (!this.taskDetail || !this.taskDetail.businessKey) {
        this.handleCallback({
          type,
          status: false,
          data: null,
          message: '缺少businessKey参数'
        });
        return false;
      }
      // scenario是场景参数，交给后端判断当前操作是否真的要修改表单数据
      //
      const gatewayPath = this.gatewayPath || this.taskDetail && this.taskDetail.formDataGateway || ''; // 默认prop取，无则detail取
      const _scenario = scenario || Object(tool["a" /* camelToSnake */])(type.split('/').pop());
      const data = await api["c" /* ProcessInstance */].defaultFormHandlerModify({
        formData: formData,
        scenario: _scenario,
        // 业务场景标识
        bizId: this.taskDetail.businessKey,
        extendParams: {}
      }, gatewayPath // 默认prop取，无则detail取
      );

      if (!data.status) {
        this.handleCallback({
          type,
          ...data
        });
        return false;
      }
      if (data.data && data.data.businessKey && !gatewayPath) {
        const {
          data: _formData
        } = await api["b" /* Form */].getFormDataByBusinessKey(data.data.businessKey);
        eventBus["a" /* default */].$emit('postFormData', _formData);
      }
      return true;
    },
    // 提交按钮操作
    async submitRevoke(type, script, nextUsers = '', actionType = '') {
      let params = {};
      // 提交前置钩子, 这个钩子不能修改表单数据，只能拿到taskDetail进行业务判断，用于业务前置校验
      if (this.onBeforeSubmit) {
        const result = await this.onBeforeSubmit(type, this.taskDetail);
        if (result === false) return;
      }

      // 每次触发按钮的时候，都先重置内置的属性
      this.resetConfig();
      try {
        // 处理前的二次确认
        const isConfirm = await this.handleBeforeActionConfirm(type);
        if (!isConfirm) return;

        // 处理按钮脚本, 可以修改表单数据，修改当前实例的内置变量，返回false阻止提交
        if (script) {
          const flag = await this.tempScript(script, params);
          if (!flag) {
            return;
          }
        }

        // 1、同意按钮[APPLY]校验表单
        const _isCheck = type === constants["b" /* APPLY */];
        let _params = await this.getParams(_isCheck);
        // 整合params
        params = {
          ..._params,
          ...params
        };

        // 前端脚本设置，是否主动选择下一节点接收人,不包含传阅、转办
        if (this.customNextUser && !actionType && ![constants["A" /* TO_READ */], constants["a" /* AGENT */]].includes(type)) {
          if (!this.taskDetail) {
            const taskDetailValue = await task["a" /* default */].taskDetail({
              id: this.taskId,
              type: Object(helper_env["a" /* getClientType */])()
            });
            this.setValueByKeyForTaskDetail(taskDetailValue);
            // TODO 判断是否存在下一节点ＩＤ
            if (!this.taskDetail) return this.handleCallback({
              status: false,
              type,
              message: '下一个节点信息缺失，请联系管理员《人员选择必须场景》！'
            });
          }
          // TODO 对接选择节点
          params.extraMessage = this.customNextUserDialogMessage;
          return this.$refs.userDialog.showDialog(type, params, constants["w" /* SCRIPT */], {
            nextActivityNodeList: this.taskDetail.nextActivityNodeList,
            exceptNodes: this.exceptNodes
          });
        }
        // 处理指定用户
        if (nextUsers) {
          // 强制选人操作
          if (actionType === constants["w" /* SCRIPT */]) {
            this.nextUsers = nextUsers;
            // 人员异常选人
          } else {
            if (this.activity && Array.isArray(nextUsers)) {
              nextUsers = nextUsers.map(user => {
                user.activityId = this.activity.id;
                return user;
              });
              let sampleUsers = this.nextUsers.filter(user => user.activityId === this.activity.id);
              if (sampleUsers && sampleUsers.length) {
                let otherUsers = nextUsers.filter(user => user.activityId !== this.activity.id);
                this.nextUsers = [...otherUsers, ...nextUsers];
              } else {
                this.nextUsers = [...this.nextUsers, ...nextUsers];
              }
            }
          }
          // 下个节点添加会签标志
          this.nextUsers.forEach(item => {
            let isMultiInstance = false;
            if (
            // 会签标志通过按钮脚本配置nextActivityNodeList传入
            this.taskDetail.nextActivityNodeList.some(node => {
              if (node.id === item.activityId) {
                isMultiInstance = node.isMultiInstance;
                return true;
              }
              return false;
            })) {
              item.isMultiInstance = isMultiInstance;
            }
          });
          params = Object.assign(params, {
            nextUsers: this.nextUsers
          });
        }

        // 执行onBeforeAction钩子, 用于执行工作流动作前的所有业务动作，和修改params
        if (this.onBeforeAction) {
          if (params.formData) {
            params.formData = JSON.parse(base64["a" /* Base64 */].decode(params.formData));
          }
          const result = await this.onBeforeAction(type, params);
          if (params.formData) {
            params.formData = base64["a" /* Base64 */].encode(JSON.stringify(params.formData));
          }
          if (result === false) return;
        }
        if (!params.formData) {
          return this.handleCallback({
            status: false,
            type,
            message: '获取表单信息失败，请联系管理员！'
          });
        }

        // 所有操作先保存一次表单数据接口
        const isModifyFormData = await this.handleModifyFormData(params.formData, type, params.scenario);
        if (!isModifyFormData) {
          return;
        }

        // 开始流程处理
        if (type === constants["b" /* APPLY */]) {
          if (!params.comment) params.comment = '同意';
          await this.handleAgree(params);
        } else if (type === constants["v" /* REJECT */]) {
          await this.handleReject(params);
        } else if (type === constants["g" /* DELEGATE */] || type === constants["d" /* COMMUNICATION_TASK */] || type === constants["f" /* COMMUNICATION_TASK_REPLY */]) {
          if (this.$refs.communicationTask) {
            if (this.taskDetail && this.taskDetail.communicateUser) {
              params.communicateUsers = [this.taskDetail.communicateUser];
            }
            this.$refs.communicationTask.showDialog(params, type);
          }
        } else if (type === constants["e" /* COMMUNICATION_TASK_CANCEL */]) {
          const resp = await task["a" /* default */].cancelCommunicationTask({
            id: this.taskId
          });
          if (resp.status) {
            this.$message.success('取消成功！');
            // this.refreshCommList()
            // 重新加载当前路由
            this.$router.go(this.$router.currentRoute);
          } else {
            this.$message.error(resp.message || '取消失败！');
          }
        } else if (type === constants["x" /* STOP */]) {
          await this.handleEndProcess(params);
        } else if (type === constants["a" /* AGENT */]) {
          if (this.$refs.agentDialog) {
            this.$refs.agentDialog.showDialog(params);
          }
        } else if (type === constants["A" /* TO_READ */]) {
          if (this.$refs.toReadDialog) {
            this.$refs.toReadDialog.show(params);
          }
        } else if (type === constants["z" /* TEMPSAVE */]) {
          await this.handlTempSave(params);
        } else if (type === constants["o" /* MULTI_INSTANCE_ADD */]) {
          if (this.$refs.multiInstanceAddDialog) {
            this.$refs.multiInstanceAddDialog.showDialog({
              ...params,
              activityId: this.activityId
            });
          }
        } else if (type === constants["p" /* MULTI_INSTANCE_PASSED */]) {
          if (!params.comment) params.comment = '同意';
          this.handleComplete(params, 'PASSED');
        } else if (type === constants["q" /* MULTI_INSTANCE_REJECT */]) {
          this.handleComplete(params, 'REJECT');
        }
      } catch (error) {
        // this.handleCallback({ type, data: error })
        console.log({
          type,
          data: error
        });
      }
    },
    // 选择指定人弹窗回调
    onUserConfirm(type, nextUsers, actionType) {
      // FIXME: userDialog就已经卡住nextUsers必填的场景了，这里不需要再判断了
      // if (!Array.isArray(nextUsers) || !nextUsers.length || !type) {
      //   return this.handleCallback({
      //     type,
      //     message: '用户数据异常，联系管理员！',
      //   })
      // }
      this.submitRevoke(type, '', nextUsers, actionType);
    },
    /**
     * @description 请求结果统一处理
     * @param options {}
     *        --| status, 状态
     *        --| data, 请求返回结果数据
     *        --| message, 消息提示文本
     * @return $emit: e(事件handle-success/handle-error)、 argument [message, type, data]
     *                                                          --| message, 消息提示文本
     *                                                          --| type, 按钮操作类型
     *                                                          --| data, 请求返回结果数据(包含成功数据/异常详情)
     * */
    // 请求操作异常处理
    handleCallback(options = {}) {
      // init option
      options = Object.assign({
        status: false,
        data: null,
        ...constants["B" /* UNKNOWN_ERROR */]
      }, options);
      // success
      if (options.status) {
        request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["n" /* HANDLE_SUCCESS */], 'success', options.message || '操作成功!', constants["c" /* BUTTON_TYPE */][options.type] || '', options);
        // 清空选中用户
        this.initUserDialog();
        // 刷新列表页
        eventBus["a" /* default */].$emit('refresh');
        return;
      }
      // 接口异常
      if (!options.status) {
        if (options.data && options.data.activity) {
          this.activity = options.data.activity;
          if (this.nextUsers.length) {
            // 清空选中用户
            this.initUserDialog();
          }
        }
        switch (options.code) {
          case constants["t" /* NO_CONFIGURED_USER_EXCEPTION */].code: // 未配置用户
          case constants["s" /* NO_AVAILABLE_USER_THROW_MODE_EXCEPTION */].code:
            // 配置，但无可用
            request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], 'error', options.message || constants["t" /* NO_CONFIGURED_USER_EXCEPTION */].message, constants["c" /* BUTTON_TYPE */][options.type] || '', options);
            break;
          case constants["r" /* NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION */].code:
            // 用户不存在或已离职
            if (request_utils["c" /* hasHandleToEmit */].call(this, 'handle-user-error', options)) break;
            this.$refs.userDialog.showDialog(options.type, options);
            break;
          default:
            request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], 'error', options.message || constants["B" /* UNKNOWN_ERROR */].message, constants["c" /* BUTTON_TYPE */][options.type] || '', options);
            break;
        }
      }
    },
    async handleBeforeActionConfirm(type) {
      const MESSAGE = {
        [constants["b" /* APPLY */]]: '确定同意此任务吗？',
        [constants["x" /* STOP */]]: '确定终止此任务吗？',
        [constants["e" /* COMMUNICATION_TASK_CANCEL */]]: '确定取消由你发起的所有沟通？',
        [constants["p" /* MULTI_INSTANCE_PASSED */]]: '确定赞成此会签内容吗？',
        [constants["q" /* MULTI_INSTANCE_REJECT */]]: '确定反对此会签内容吗？'
      };
      if (!MESSAGE[type]) return true;
      const confirm = await this.$confirm(MESSAGE[type], '提示', {
        type: 'warning'
      }).catch(() => {});
      if (confirm !== 'confirm') {
        this.$message.info('取消操作！');
        this.initUserDialog();
      }
      return confirm === 'confirm';
    },
    // 同意
    async handleAgree(params) {
      const loading = this.$loading();
      const {
        status,
        message,
        code,
        data
      } = await task["a" /* default */].agreeAction(params).finally(() => {
        loading.close();
      });
      this.handleCallback({
        status,
        data,
        message,
        code,
        type: constants["b" /* APPLY */]
      });
    },
    // 删除
    async handleDelete(params) {
      const confirm = await this.$confirm('删除数据后不可恢复，确定删除？', '提示', {
        type: 'warning'
      }).catch(() => {});
      if (confirm === 'confirm') {
        const loading = this.$loading();
        const {
          status,
          message,
          code,
          data
        } = await processInstance["a" /* default */].flowInstDeleteById({
          processInstanceId: params.processInstanceId
        }).finally(() => {
          loading.close();
        });
        this.handleCallback({
          status,
          data,
          message,
          code,
          type: DELETE
        });
      } else {
        this.$message.info('取消操作！');
      }
    },
    // 暂存
    async handlTempSave(params) {
      const loading = this.$loading();
      const {
        status,
        message,
        data
      } = await task["a" /* default */].tempTaskSave({
        formData: params.formData,
        taskId: params.taskId
      }).finally(() => {
        loading.close();
      });
      if (status) {
        eventBus["a" /* default */].$emit('postFormData', data);
        this.$message.success('暂存成功！');
      } else {
        this.$message.error(message);
      }
    },
    // 驳回
    async handleReject(params) {
      if (!this.taskId || !this.instId) {
        this.handleCallback({
          message: '数据异常，请联系管理！',
          type: constants["v" /* REJECT */]
        });
      }
      if (!params.comment) {
        return this.$message.warning('请先填写驳回意见！');
      }
      // 选中用户直接更新
      const isSpecifiedNextUsers = params.nextUsers && params.nextUsers.length && !this.customNextUser;
      if (isSpecifiedNextUsers) {
        // 非强制选人场景
        await this.$refs.rejectableNodesDialog.doRejectAction(params);
      } else {
        params.comment = this.approveMessage;
        this.$refs.rejectableNodesDialog.showDialog(this.taskId, this.instId, params, {
          exceptNodes: this.exceptNodes,
          disableRejectMode: this.rejectConfig.disableRejectMode,
          skipHistoryNode: this.rejectConfig.skipHistoryNode
        });
      }
    },
    // 终止
    async handleEndProcess(params) {
      const loading = this.$loading();
      let resp = await task["a" /* default */].stopAction(params).finally(() => {
        loading.close();
      });
      const response = Object.assign(resp || {}, {
        status: (resp === null || resp === void 0 ? void 0 : resp.status) || false,
        type: constants["x" /* STOP */],
        message: resp !== null && resp !== void 0 && resp.status ? '终止成功' : resp.message
      });
      this.handleCallback(response);
    },
    // 回复传阅
    async handleToReadTask() {
      const params = {
        id: this.toReadId,
        comment: this.approveMessage
      };
      const loading = this.$loading();
      const resp = await task["a" /* default */].toReadTaskHandle(params).finally(() => {
        loading.close();
      });
      if (resp && resp.status) {
        this.handleCallback({
          status: resp.status,
          message: '回复成功',
          type: constants["A" /* TO_READ */]
        });
        this.refreshCommList();
      }
    },
    // 刷新处理记录
    refreshCommList() {
      if (this.$parent && this.$parent.$children && Array.isArray(this.$parent.$children)) {
        this.$parent.$children.map(child => {
          if (child && child.getCommentList) {
            child.getCommentList();
          }
        });
      }
    },
    // 返回
    handleBack() {
      if (!request_utils["c" /* hasHandleToEmit */].call(this, constants["j" /* HANDLE_BACK */])) {
        this.$router.back();
      }
    },
    // 初始化人员选择器选中状态
    initUserDialog() {
      if (this.$refs.userDialog && this.$refs.userDialog.initForm) {
        this.$refs.userDialog.initForm();
      }
    },
    showAction() {
      this.open = !this.open;
      this.$emit('show-action', this.open);
    },
    // 会签同意/反对
    async handleComplete(params, mieCompleteType) {
      if (!params.comment) {
        return this.$message.warning('请先填写审批意见！');
      }
      const loading = this.$loading();
      const {
        status,
        message,
        code,
        data
      } = await task["a" /* default */].multiInstanceComplete({
        taskId: params.taskId,
        comment: params.comment,
        mieCompleteType
      }).finally(() => {
        loading.close();
      });
      this.handleCallback({
        status,
        data,
        message,
        code,
        type: constants["b" /* APPLY */]
      });
    },
    // 查询任务详情, taskId的时候触发
    async fetchTaskDetail() {
      if (!this.taskDetail && !this.taskId) {
        this.handleCallback({
          type: 'INIT',
          status: false,
          data: null,
          message: '组件属性，至少设置taskDetail或者taskId任意一项'
        });
        return;
      }
      if (!this.taskDetail && this.taskId) {
        const taskDetailValue = (await task["a" /* default */].taskDetail({
          id: this.taskId,
          type: Object(helper_env["a" /* getClientType */])()
        })) || null;
        this.setValueByKeyForTaskDetail(taskDetailValue);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowAction/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionvue_type_script_lang_js_ = (FlowActionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowAction/index.vue?vue&type=style&index=0&id=b7da835a&prod&lang=scss&scoped=true&
var FlowActionvue_type_style_index_0_id_b7da835a_prod_lang_scss_scoped_true_ = __webpack_require__("f591");

// CONCATENATED MODULE: ./src/components/flow/FlowAction/index.vue






/* normalize component */

var FlowAction_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "b7da835a",
  null
  
)

/* harmony default export */ var FlowAction = (FlowAction_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/index.vue?vue&type=template&id=418dcb63&scoped=true&
var FlowActionNoSubmitvue_type_template_id_418dcb63_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-action",attrs:{"id":"flow-action"}},[_c('div',{staticClass:"flow-action__title"},[_c('span',[_vm._v("流程处理")]),_c('span',{staticClass:"open",on:{"click":_vm.showAction}},[_c('i',{class:[_vm.open ? 'el-icon-caret-bottom' : 'el-icon-caret-top'],staticStyle:{"font-size":"16px"}})]),_c('div',{staticClass:"action-btn-list"},_vm._l((_vm.topButtonList),function(btn){return _c('el-button',{key:btn.id,attrs:{"size":"mini","type":"primary","plain":"","round":""},on:{"click":function($event){return _vm.submitRevoke(btn.requestUri)}}},[_vm._v(_vm._s(btn.alias || btn.name))])}),1)]),_c('div',{staticClass:"action-container",style:(Object.assign({}, _vm.containerHeight))},[(!_vm.noCommit)?_c('div',{staticClass:"flow-action__message"},[_c('OpinionText',{model:{value:(_vm.approveMessage),callback:function ($$v) {_vm.approveMessage=$$v},expression:"approveMessage"}})],1):_vm._e(),_c('div',{staticClass:"flow-action__btnArea"},[_c('div',{staticClass:"normal-task"},[(!_vm.toReadId)?_vm._l((_vm.btnList),function(btn,index){return _c('el-button',{key:btn.type + index,attrs:{"type":"primary","disabled":!btn.active},on:{"click":function($event){return _vm.submitRevoke(btn.type, btn.beforeScript)}}},[_vm._v("\n            "+_vm._s(btn.alias || btn.name)+"\n          ")])}):[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleToReadTask}},[_vm._v(" 提交 ")])]],2),_c('div',[_c('el-button',{staticClass:"flow-action__btnArea-close",attrs:{"type":"default"},on:{"click":_vm.handleBack}},[_vm._v("返回")])],1)])]),_c('rejectable-nodes-dialog',{ref:"rejectableNodesDialog",on:{"on-reject":_vm.handleCallback}}),_c('to-read-dialog',{ref:"toReadDialog",on:{"on-to-read":_vm.handleCallback}}),_c('agent-dialog',{ref:"agentDialog",on:{"on-agent":_vm.handleCallback}}),_c('user-dialog',{ref:"userDialog",on:{"onConfirm":_vm.onUserConfirm}}),_c('communication-task',{ref:"communicationTask",on:{"onConfirm":_vm.handleCallback}}),_c('multi-instance-add-dialog',{ref:"multiInstanceAddDialog",on:{"onConfirm":_vm.handleCallback}})],1)}
var FlowActionNoSubmitvue_type_template_id_418dcb63_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/index.vue?vue&type=template&id=418dcb63&scoped=true&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue?vue&type=template&id=69a003e7&scoped=true&
var RejectableNodesDialogvue_type_template_id_69a003e7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"可驳回节点","visible":_vm.dialogVisible,"append-to-body":"","close-on-click-modal":false,"width":"40%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("确定")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}]},[_c('el-form-item',{attrs:{"label-width":"100px","label":"驳回指定节点:"}},[(_vm.nodeList && _vm.nodeList.length)?_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.node),callback:function ($$v) {_vm.node=$$v},expression:"node"}},_vm._l((_vm.nodeList),function(node){return _c('el-option',{key:node.id,attrs:{"label":node.name,"value":node.id}})}),1):_c('span',[_vm._v("上一个节点")])],1),_c('el-form-item',{staticStyle:{"margin":"30px 0"},attrs:{"label-width":"100px","label":"驳回重提模式:"}},[_c('div',{staticClass:"rejeck rejeck-first"},[_c('el-radio',{staticClass:"rejeck-radio",attrs:{"label":false},model:{value:(_vm.config.skipHistoryNode),callback:function ($$v) {_vm.$set(_vm.config, "skipHistoryNode", $$v)},expression:"config.skipHistoryNode"}},[_vm._v("重新审批")]),_c('span',{staticClass:"rejeck-tips"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("重新提交时，已审批的需要重新审")])],1),_c('div',{staticClass:"rejeck"},[_c('el-radio',{staticClass:"rejeck-radio",attrs:{"label":true,"disabled":_vm.disableRejectMode},model:{value:(_vm.config.skipHistoryNode),callback:function ($$v) {_vm.$set(_vm.config, "skipHistoryNode", $$v)},expression:"config.skipHistoryNode"}},[_vm._v("回到本节点")]),_c('span',{staticClass:"rejeck-tips"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("重新提交时，已审批的无需再审")])],1)]),(_vm.userDeprecated)?_c('el-form-item',{staticClass:"user-select",attrs:{"label-width":"100px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":"","config":{
          id: 'nextUsers.userId',
          name: 'nextUsers.name',
        }},model:{value:(_vm.nextUsers.name),callback:function ($$v) {_vm.$set(_vm.nextUsers, "name", $$v)},expression:"nextUsers.name"}})],1):_vm._e()],1)],1)}
var RejectableNodesDialogvue_type_template_id_69a003e7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue?vue&type=template&id=69a003e7&scoped=true&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/CommonInput.vue?vue&type=template&id=74ba8b86&scoped=true&
var CommonInputvue_type_template_id_74ba8b86_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label-width":"120px","label":_vm.labelName,"prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","clearable":""},on:{"input":_vm.onInput},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_c('div',{staticClass:"convenient-action"},[_vm._v("\n    常用语：\n    "),_vm._l((_vm.commonWords),function(word){return _c('el-tag',{key:word,on:{"click":function($event){_vm.comment += word}}},[_vm._v(_vm._s(word))])}),_c('span',{staticClass:"max"},[_vm._v(_vm._s(_vm.comment.length)+"/500")])],2)],1)}
var CommonInputvue_type_template_id_74ba8b86_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommonInput.vue?vue&type=template&id=74ba8b86&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/CommonInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FlowActionNoSubmit_CommonInputvue_type_script_lang_js_ = ({
  name: 'CommonInput',
  props: {
    value: String,
    labelName: {
      type: String,
      default: '处理意见:'
    }
  },
  data() {
    return {
      commonWords: ['请后面的同事审批', '我不同意', '确认通过'],
      comment: ''
    };
  },
  watch: {
    comment: {
      deep: true,
      handler: function (val) {
        this.$emit('input', val);
      }
    },
    value: {
      deep: true,
      handler: function (val) {
        this.comment = val;
      }
    }
  },
  methods: {
    onInput(e) {
      console.log(e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommonInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_CommonInputvue_type_script_lang_js_ = (FlowActionNoSubmit_CommonInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/CommonInput.vue?vue&type=style&index=0&id=74ba8b86&prod&lang=scss&scoped=true&
var CommonInputvue_type_style_index_0_id_74ba8b86_prod_lang_scss_scoped_true_ = __webpack_require__("07ca");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommonInput.vue






/* normalize component */

var FlowActionNoSubmit_CommonInput_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_CommonInputvue_type_script_lang_js_,
  CommonInputvue_type_template_id_74ba8b86_scoped_true_render,
  CommonInputvue_type_template_id_74ba8b86_scoped_true_staticRenderFns,
  false,
  null,
  "74ba8b86",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_CommonInput = (FlowActionNoSubmit_CommonInput_component.exports);
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/constants.js
const NO_CONFIGURED_USER_EXCEPTION = {
  code: '117034',
  message: '节点未配置审核人,请检查流程配置!'
};
const NO_AVAILABLE_USER_THROW_MODE_EXCEPTION = {
  code: '117037',
  message: '节点无可用审核人,请联系管理员！'
};
const NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION = {
  code: '117023',
  message: '下个节点【Activity_1kbmr0u】用户不存在或已离职！请手动选择流转审核人！'
};
const UNKNOWN_ERROR = {
  code: '',
  message: '未知错误，请联系管理员'
};
const APPLY = '/task/apply';
const REJECT = '/task/reject';
const DELEGATE = '/task/delegate';
const STOP = '/task/stop';
const AGENT = '/task/agent';
const TO_READ = '/task/toRead';
const COMMUNICATION_TASK = '/task/communicationTask'; // 创建沟通
const COMMUNICATION_TASK_REPLY = '/task/communicationTask/reply'; // 沟通回复
const COMMUNICATION_TASK_CANCEL = '/task/communicationTask/cancel'; // 沟通任务取消
const TEMPSAVE = '/task/tempSave'; // 保存
const COUNTERSIGN = '/task/page/manage'; // 会签
const MULTI_INSTANCE_ADD = '/multiInstance/add'; // 加签
const MULTI_INSTANCE_PASSED = '/multiInstance/passed'; // 赞成会签
const MULTI_INSTANCE_REJECT = '/multiInstance/reject'; // 反对会签
const constants_DELETE = '/processInstance/delete'; // 删除

const BUTTON_TYPE = {
  [APPLY]: 'APPLY',
  [REJECT]: 'REJECT',
  [STOP]: 'STOP',
  [AGENT]: 'AGENT',
  [TO_READ]: 'TO_READ',
  [DELEGATE]: 'DELEGATE',
  [COMMUNICATION_TASK]: 'COMMUNICATION_TASK',
  [COMMUNICATION_TASK_REPLY]: 'COMMUNICATION_TASK_REPLY',
  [COMMUNICATION_TASK_CANCEL]: 'COMMUNICATION_TASK_CANCEL',
  [TEMPSAVE]: 'TEMPSAVE',
  [COUNTERSIGN]: 'COUNTERSIGN',
  [MULTI_INSTANCE_ADD]: 'MULTI_INSTANCE_ADD',
  [MULTI_INSTANCE_PASSED]: 'MULTI_INSTANCE_PASSED',
  [MULTI_INSTANCE_REJECT]: 'MULTI_INSTANCE_REJECT',
  [constants_DELETE]: 'DELETE'
};
const SCRIPT = 'SCRIPT';

// emit 事件
const HANDLE_DRAFT = 'handle-draft';
const HANDLE_SUCCESS = 'handle-success';
const HANDLE_ERROR = 'handle-error';
const HANDLE_BACK = 'handle-back';
const HANDLE_ROUTER = 'handle-router';
const ERROR = 'error';
const SUCCESS = 'success';

// 客户端
const H5 = 'H5';
const PC = 'PC';
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FlowActionNoSubmit_RejectableNodesDialogvue_type_script_lang_js_ = ({
  name: 'RejectableNodesDialog',
  components: {
    CommonInput: FlowActionNoSubmit_CommonInput
  },
  data() {
    return {
      // 可支持脚本修改的配置
      config: {
        disableRejectMode: false,
        exceptNodes: [],
        skipHistoryNode: false
      },
      dialogVisible: false,
      userDeprecated: false,
      node: null,
      nodeList: null,
      params: {
        rejectActivityId: null,
        taskId: null,
        processInstanceId: null
      },
      nextUsers: {
        userId: null,
        name: null
      }
    };
  },
  computed: {
    disableRejectMode() {
      return this.config.disableRejectMode || !this.nodeList || !this.nodeList.length;
    }
  },
  methods: {
    showDialog(taskId, processInstanceId, params, config = {}) {
      const {
        exceptNodes,
        disableRejectMode,
        skipHistoryNode
      } = config;
      this.config.disableRejectMode = disableRejectMode;
      this.config.exceptNodes = exceptNodes;
      this.config.skipHistoryNode = skipHistoryNode;
      this.params = Object.assign(this.params, params || {});
      this.node = null;
      this.dialogVisible = true;
      this.params.taskId = taskId;
      this.params.processInstanceId = processInstanceId;
      this.getRejectableNodes(taskId);
    },
    async getRejectableNodes(taskId) {
      const _nodeList = (await task["a" /* default */].rejectableNodes({
        taskId
      })) || null;
      if (_nodeList) {
        // 过滤exceptNode的节点id
        this.nodeList = _nodeList.filter(node => {
          return !this.config.exceptNodes.includes(node.id);
        });
      }
    },
    onUserConfirm(users) {
      if (!users || !users.length) return;
      this.params.nextUsers = {
        userId: users[0].id,
        name: users[0].name
      };
      this.doRejectAction();
    },
    onConfirm() {
      // 如果驳回节点处理人异常，需手动选择处理人
      if (this.userDeprecated && !this.nextUsers.userId) {
        return this.$message.warning('请选择处理人！');
      } else {
        const nextUsersObj = this.nextUsers.userId ? {
          nextUsers: this.nextUsers
        } : {};
        this.params = Object.assign(this.params, nextUsersObj);
      }
      // 没有配置默认驳回上一个节点
      if (!this.nodeList || !Array.isArray(this.nodeList)) {
        delete this.params.rejectActivityId;
        this.doRejectAction();
        return;
      }
      // 如有驳回节点选项，必须选择一个
      if (!this.node && Array.isArray(this.nodeList) && this.nodeList.length) {
        return this.$message.info('至少选择一个节点！');
      }
      this.params.rejectActivityId = this.node;
      this.doRejectAction();
    },
    async doRejectAction(params = {}) {
      this.params.skipHistoryNode = this.config.skipHistoryNode;
      let option = Object.assign(this.params, params);
      const resp = await task["a" /* default */].rejectAction(option);
      this.$emit('on-reject', {
        ...resp,
        type: REJECT
      });
      if (resp.status) {
        this.dialogVisible = false;
      }
    },
    close() {
      this.dialogVisible = false;
      this.nextUsers = {
        userId: null,
        name: null
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_RejectableNodesDialogvue_type_script_lang_js_ = (FlowActionNoSubmit_RejectableNodesDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue?vue&type=style&index=0&id=69a003e7&prod&lang=scss&scoped=true&
var RejectableNodesDialogvue_type_style_index_0_id_69a003e7_prod_lang_scss_scoped_true_ = __webpack_require__("f600");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/RejectableNodesDialog.vue






/* normalize component */

var FlowActionNoSubmit_RejectableNodesDialog_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_RejectableNodesDialogvue_type_script_lang_js_,
  RejectableNodesDialogvue_type_template_id_69a003e7_scoped_true_render,
  RejectableNodesDialogvue_type_template_id_69a003e7_scoped_true_staticRenderFns,
  false,
  null,
  "69a003e7",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_RejectableNodesDialog = (FlowActionNoSubmit_RejectableNodesDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue?vue&type=template&id=23f55c87&scoped=true&
var ToReadDialogvue_type_template_id_23f55c87_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"流程传阅","visible":_vm.dialogVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.user}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"传阅人员:","prop":"user"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'user.id',
          account: 'user.account',
          name: 'user.name',
        }},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1),_c('common-input',{attrs:{"label-name":"传阅说明:"},model:{value:(_vm.user.comment),callback:function ($$v) {_vm.$set(_vm.user, "comment", $$v)},expression:"user.comment"}})],1)],1)}
var ToReadDialogvue_type_template_id_23f55c87_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue?vue&type=template&id=23f55c87&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FlowActionNoSubmit_ToReadDialogvue_type_script_lang_js_ = ({
  name: 'ToReadDialog',
  components: {
    CommonInput: FlowActionNoSubmit_CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      user: {
        id: null,
        name: null,
        account: null,
        comment: ''
      },
      params: null,
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    show(params) {
      this.params = params;
      this.dialogVisible = true;
      this.user = {
        name: null,
        id: null,
        account: null,
        comment: ''
      };
    },
    async onConfirm() {
      if (!this.user.id) return this.$message.warning('请先选择传阅人员！');
      const ids = this.user.id.split(',');
      const names = this.user.name.split(',');
      const toReadUsers = [];
      ids.map((id, index) => {
        toReadUsers.push({
          userId: id,
          name: names[index]
        });
      });
      if (!this.params) return this.$message.error('数据异常！');
      const option = {
        toReadUsers,
        commentType: 'TOREAD',
        ...this.params,
        comment: this.user.comment
      };
      if (!option.comment) {
        return this.$message.warning('请先填传阅说明！');
      }
      let loading = this.$loading();
      const resp = await task["a" /* default */].toReadTask(option).finally(() => {
        loading.close();
      });
      this.$emit('on-to-read', {
        ...resp,
        type: TO_READ
      });
      if (resp.status) {
        this.dialogVisible = false;
      }
    },
    close() {
      this.dialogVisible = false;
      this.user = {
        id: null,
        name: null,
        account: null,
        comment: ''
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_ToReadDialogvue_type_script_lang_js_ = (FlowActionNoSubmit_ToReadDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue?vue&type=style&index=0&id=23f55c87&prod&lang=scss&scoped=true&
var ToReadDialogvue_type_style_index_0_id_23f55c87_prod_lang_scss_scoped_true_ = __webpack_require__("b4fe");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/ToReadDialog.vue






/* normalize component */

var FlowActionNoSubmit_ToReadDialog_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_ToReadDialogvue_type_script_lang_js_,
  ToReadDialogvue_type_template_id_23f55c87_scoped_true_render,
  ToReadDialogvue_type_template_id_23f55c87_scoped_true_staticRenderFns,
  false,
  null,
  "23f55c87",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_ToReadDialog = (FlowActionNoSubmit_ToReadDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/AgentDialog.vue?vue&type=template&id=7019fb39&scoped=true&
var AgentDialogvue_type_template_id_7019fb39_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"转办","visible":_vm.dialogVisible,"width":"30%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":"","config":{
          id: 'form.agentUserId',
          account: 'form.account',
          name: 'form.userName',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('CommonInput',{model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)}
var AgentDialogvue_type_template_id_7019fb39_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/AgentDialog.vue?vue&type=template&id=7019fb39&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/AgentDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FlowActionNoSubmit_AgentDialogvue_type_script_lang_js_ = ({
  name: 'AgentDialog',
  components: {
    CommonInput: FlowActionNoSubmit_CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        agentUserId: null,
        account: null,
        userName: null,
        comment: ''
      },
      comment: '',
      option: {},
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    showDialog(option) {
      this.dialogVisible = true;
      this.option = option;
    },
    // 提交转办
    onConfirm() {
      if (!this.form.agentUserId) return this.$message.warning('必须选择接受人！');
      if (!this.form.account) return this.$message.warning('必须选择接受人！');
      const option = Object.assign(this.option || {}, this.form);
      if (!option.comment) {
        return this.$message.warning('请先填处理意见！');
      }
      this.doAgentAction(option);
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        agentUserId: null,
        account: null,
        userName: null,
        name: null,
        comment: ''
      };
    },
    // 操作转办
    async doAgentAction(option) {
      option.nextUsers && delete option.nextUsers;
      const loading = this.$loading();
      const {
        status,
        message,
        code
      } = await task["a" /* default */].agentAction(option).finally(() => {
        loading.close();
      });
      if (status) {
        this.dialogVisible = false;
      }
      this.$emit('on-agent', {
        status,
        message,
        code,
        type: AGENT
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/AgentDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_AgentDialogvue_type_script_lang_js_ = (FlowActionNoSubmit_AgentDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/AgentDialog.vue





/* normalize component */

var FlowActionNoSubmit_AgentDialog_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_AgentDialogvue_type_script_lang_js_,
  AgentDialogvue_type_template_id_7019fb39_scoped_true_render,
  AgentDialogvue_type_template_id_7019fb39_scoped_true_staticRenderFns,
  false,
  null,
  "7019fb39",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_AgentDialog = (FlowActionNoSubmit_AgentDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/UserDialog.vue?vue&type=template&id=43c3c3f1&scoped=true&
var UserDialogvue_type_template_id_43c3c3f1_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"选择处理人","visible":_vm.dialogVisible,"width":"40%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form,"label-position":"left"}},[(_vm.desc)?_c('el-alert',{staticClass:"tips",attrs:{"type":"warning","closable":false}},[_vm._v("\n      "+_vm._s(_vm.desc)+"\n    ")]):_vm._e(),(_vm.extraDesc)?_c('el-alert',{staticClass:"tips",attrs:{"closable":false}},[_vm._v("\n      "+_vm._s(_vm.extraDesc)+"\n    ")]):_vm._e(),(
        _vm.nextActivityNodeList &&
          _vm.nextActivityNodeList.length &&
          _vm.form.list.length > 0
      )?_vm._l((_vm.nextActivityNodeList),function(activity,idx){return _c('el-form-item',{key:idx,attrs:{"label-width":"200px","label":activity.name + '：'}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":false,"config":{
            id: ("form.list[" + idx + "].userId"),
            name: ("form.list[" + idx + "].name"),
            orgNo: ("form.list[" + idx + "].orgNo"),
          }},model:{value:(_vm.form.list[idx].name),callback:function ($$v) {_vm.$set(_vm.form.list[idx], "name", $$v)},expression:"form.list[idx].name"}})],1)}):_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"single":false,"config":{
          id: 'form.userId',
          name: 'form.name',
          orgNo: 'form.orgNo',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],2)],1)}
var UserDialogvue_type_template_id_43c3c3f1_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/UserDialog.vue?vue&type=template&id=43c3c3f1&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/UserDialog.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 人员弹窗目前有2个场景
 * 1、通过script动态触发默认弹窗选人， actionType = 'SCRIPT'
 * 2、当出现下一个节点审核人失效时（找不到人或者人已经离职了），自动弹出选人窗口
 */
/* harmony default export */ var FlowActionNoSubmit_UserDialogvue_type_script_lang_js_ = ({
  name: 'UserDialog',
  data() {
    return {
      dialogVisible: false,
      form: {
        userId: null,
        name: null,
        orgNo: null,
        list: []
      },
      type: null,
      desc: null,
      extraDesc: null,
      data: null,
      actionType: null,
      nextActivityNodeList: []
    };
  },
  computed: {
    isNodeSelectPerson() {
      return this.actionType && this.nextActivityNodeList.length;
    }
  },
  methods: {
    initForm() {
      this.form = {
        userId: null,
        name: null,
        orgNo: null,
        actionType: null,
        list: []
      };
      this.actionType = null;
      this.nextActivityNodeList = [];
    },
    showDialog(type, options = null, actionType = null, nextActivityNodeList = null) {
      this.dialogVisible = true;
      this.type = type;
      this.actionType = actionType;
      if (nextActivityNodeList) {
        this.nextActivityNodeList = nextActivityNodeList;
        nextActivityNodeList.map(_a => {
          this.form.list.push({
            activityId: _a.id,
            userId: null,
            name: null,
            orgNo: null
          });
        });
      }
      if (options && options.data && options.data.activity) {
        var _options$data;
        const {
          id,
          name
        } = (options === null || options === void 0 ? void 0 : (_options$data = options.data) === null || _options$data === void 0 ? void 0 : _options$data.activity) || {
          id: '',
          name: null
        };
        id && name && (this.desc = options.message.replace(id, name));
      }
      if (options.extraMessage) {
        this.extraDesc = options.extraMessage;
      }
    },
    // 提交转办
    onConfirm() {
      // 人员失效场景，必须选择处理人
      if (!this.form.userId && !this.actionType) {
        return this.$message.warning('必须选择接处理人！');
      }
      if (this.form.list && this.form.list.length > 1 && this.form.list.filter(item => !!item.userId).length !== this.nextActivityNodeList.length) {
        return this.$message.warning('全部项必须选择接处理人！');
      }
      let nextUsers = [];
      if (this.actionType && this.nextActivityNodeList.length) {
        let list = JSON.parse(JSON.stringify(this.form.list));
        // script触发的选人弹窗可以不选人，不选的话后端会默认拿流程配置的人
        const existUserList = list.reduce((prev, next) => {
          if (next.userId) {
            const activityId = next.activityId;
            let len = next.userId.split(',').length;
            let ids = [];
            while (len) {
              ids.push(activityId);
              len--;
            }
            next.activityId = ids.join(',');
            prev.push(next);
          }
          return prev;
        }, []);
        nextUsers = existUserList.map(item => this.splitToObject(item)).flat();
      } else {
        let form = JSON.parse(JSON.stringify(this.form));
        delete form.list;
        nextUsers = this.splitToObject(form);
      }
      this.$emit('onConfirm', this.type, nextUsers, this.actionType);
      this.dialogVisible = false;
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        userId: null,
        name: null,
        orgNo: null,
        list: []
      };
    },
    splitToObject(obj) {
      let keys = Object.keys(obj);
      let list = [];
      let form = Object.assign({}, obj);
      for (let formKey in form) {
        form[formKey] = form[formKey].split(',');
      }
      if (obj && keys && keys.length && obj[keys[0]]) {
        const count = form[keys[0]].length;
        for (let i = 0; i < count; i++) {
          let item = {};
          keys.map(key => {
            item[key] = form[key][i];
          });
          list.push(item);
        }
      }
      return list;
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/UserDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_UserDialogvue_type_script_lang_js_ = (FlowActionNoSubmit_UserDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/UserDialog.vue?vue&type=style&index=0&id=43c3c3f1&prod&lang=scss&scoped=true&
var UserDialogvue_type_style_index_0_id_43c3c3f1_prod_lang_scss_scoped_true_ = __webpack_require__("2e65");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/UserDialog.vue






/* normalize component */

var FlowActionNoSubmit_UserDialog_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_UserDialogvue_type_script_lang_js_,
  UserDialogvue_type_template_id_43c3c3f1_scoped_true_render,
  UserDialogvue_type_template_id_43c3c3f1_scoped_true_staticRenderFns,
  false,
  null,
  "43c3c3f1",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_UserDialog = (FlowActionNoSubmit_UserDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue?vue&type=template&id=1bf3ec3b&scoped=true&
var CommunicationTaskvue_type_template_id_1bf3ec3b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.user}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:","prop":"user"}},[(_vm.actionType == _vm.COMMUNICATION_TASK_REPLY)?_vm._l((_vm.communicateUsers),function(user,idx){return _c('el-tag',{key:idx,attrs:{"type":"info"}},[_vm._v(_vm._s(user.name))])}):_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'user.id',
          account: 'user.account',
          name: 'user.name',
        }},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],2),_c('common-input',{attrs:{"label-name":"处理意见:"},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)],1)}
var CommunicationTaskvue_type_template_id_1bf3ec3b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue?vue&type=template&id=1bf3ec3b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const CommunicationTaskvue_type_script_lang_js_commentType = {
  [COMMUNICATION_TASK]: 'COMMUNICATION_START',
  [COMMUNICATION_TASK_REPLY]: 'COMMUNICATION_REPLY'
};
/* harmony default export */ var FlowActionNoSubmit_CommunicationTaskvue_type_script_lang_js_ = ({
  name: 'CommunicationTask',
  components: {
    CommonInput: FlowActionNoSubmit_CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      user: {
        id: null,
        name: null,
        account: null
      },
      title: null,
      comment: '',
      params: null,
      commonWords: ['请后面的同事审批', '我不同意', '确认通过'],
      actionType: null,
      COMMUNICATION_TASK_REPLY: COMMUNICATION_TASK_REPLY,
      communicateUsers: []
    };
  },
  methods: {
    showDialog(params, actionType) {
      this.params = params;
      this.user = {
        name: null,
        id: null,
        account: null
      };
      this.comment = params.comment || '';
      this.title = actionType == COMMUNICATION_TASK ? '沟通' : '回复沟通';
      this.actionType = actionType;
      if (params.communicateUsers && actionType == COMMUNICATION_TASK_REPLY) {
        this.communicateUsers = params.communicateUsers;
        delete params.communicateUsers;
        this.communicateUsers.map(user => {
          for (let userKey in user) {
            if (!this.user[userKey]) {
              this.user[userKey] = [];
            }
            this.user[userKey].push(user[userKey]);
          }
        });
        for (const paramsKey in this.user) {
          if (this.user[paramsKey] && Array.isArray(this.user[paramsKey])) {
            this.user[paramsKey] = this.user[paramsKey].join(',');
          }
        }
      }
      this.$forceUpdate();
      this.dialogVisible = true;
    },
    async onConfirm() {
      if (this.actionType == COMMUNICATION_TASK) {
        var _this$user, _this$user$id, _this$user2, _this$user2$name;
        if (!this.user.id) return this.$message.error('请先选择沟通接受人员！');
        const ids = (_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$id = _this$user.id) === null || _this$user$id === void 0 ? void 0 : _this$user$id.split(',');
        const names = (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : (_this$user2$name = _this$user2.name) === null || _this$user2$name === void 0 ? void 0 : _this$user2$name.split(',');
        this.communicateUsers = [];
        ids.map((id, index) => {
          this.communicateUsers.push({
            userId: id,
            name: names[index]
          });
        });
      }
      if (!this.comment) return this.$message.error('请输入处理意见！');
      if (!this.params || !this.communicateUsers.length) return this.$message.error('数据异常！');
      let resp,
        loading = this.$loading(),
        users = this.actionType === COMMUNICATION_TASK ? {
          toCommunicateUsers: this.communicateUsers
        } : {
          communicateUsers: this.communicateUsers
        },
        option = {
          ...users,
          communicateUsers: this.communicateUsers,
          commentType: CommunicationTaskvue_type_script_lang_js_commentType[COMMUNICATION_TASK_REPLY],
          ...this.params,
          comment: this.comment
        };
      if (!option.communicateUsers.length) return this.$message.error('请先选择沟通接受人员！');
      switch (this.actionType) {
        case COMMUNICATION_TASK:
          resp = await task["a" /* default */].createCommunicationTask(option).finally(() => {
            loading.close();
          });
          break;
        case COMMUNICATION_TASK_REPLY:
          resp = await task["a" /* default */].replyCommunicationTask(option).finally(() => {
            loading.close();
          });
          break;
        default:
          break;
      }
      this.$emit('onConfirm', {
        ...resp,
        type: this.actionType
      });
      if (resp.status) {
        this.$message.success('操作成功！');
        this.dialogVisible = false;
      }
    },
    close() {
      this.dialogVisible = false;
      this.user = {
        id: null,
        name: null,
        account: null
      };
      this.comment = '';
      this.$forceUpdate();
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_CommunicationTaskvue_type_script_lang_js_ = (FlowActionNoSubmit_CommunicationTaskvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue?vue&type=style&index=0&id=1bf3ec3b&prod&lang=scss&scoped=true&
var CommunicationTaskvue_type_style_index_0_id_1bf3ec3b_prod_lang_scss_scoped_true_ = __webpack_require__("a685");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/CommunicationTask.vue






/* normalize component */

var FlowActionNoSubmit_CommunicationTask_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_CommunicationTaskvue_type_script_lang_js_,
  CommunicationTaskvue_type_template_id_1bf3ec3b_scoped_true_render,
  CommunicationTaskvue_type_template_id_1bf3ec3b_scoped_true_staticRenderFns,
  false,
  null,
  "1bf3ec3b",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_CommunicationTask = (FlowActionNoSubmit_CommunicationTask_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/MultiInstanceAddDialog.vue?vue&type=template&id=5a5f4656&scoped=true&
var MultiInstanceAddDialogvue_type_template_id_5a5f4656_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"加签","visible":_vm.dialogVisible,"width":"30%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label-width":"120px","label":"接收人:"}},[_c('op-user-selector',{attrs:{"appendToBody":true,"config":{
          id: 'form.userId',
          account: 'form.orgNo',
          name: 'form.name',
        }},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('CommonInput',{model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)}
var MultiInstanceAddDialogvue_type_template_id_5a5f4656_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/MultiInstanceAddDialog.vue?vue&type=template&id=5a5f4656&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/MultiInstanceAddDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FlowActionNoSubmit_MultiInstanceAddDialogvue_type_script_lang_js_ = ({
  name: 'MultiInstanceAddDialog',
  components: {
    CommonInput: FlowActionNoSubmit_CommonInput
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        userId: null,
        orgNo: null,
        name: null,
        comment: ''
      },
      comment: '',
      option: {},
      commonWords: ['请后面的同事审批', '我不同意', '确认通过']
    };
  },
  methods: {
    showDialog(option) {
      this.dialogVisible = true;
      this.option = option;
    },
    // 提交加签
    onConfirm() {
      if (!this.form.userId) return this.$message.warning('必须选择接收人！');
      if (!this.form.orgNo) return this.$message.warning('必须选择接收人！');
      const option = Object.assign(this.option || {}, this.form);
      if (!option.comment) {
        return this.$message.warning('请先填处理意见！');
      }
      this.doAction(option);
    },
    close() {
      this.dialogVisible = false;
      this.form = {
        userId: null,
        orgNo: null,
        name: null,
        comment: ''
      };
    },
    // 操作加签
    async doAction(option) {
      var _this$form, _this$form$userId, _this$form2, _this$form2$name, _this$form3, _this$form3$orgNo;
      const userIds = (_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$userId = _this$form.userId) === null || _this$form$userId === void 0 ? void 0 : _this$form$userId.split(',');
      const names = (_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : (_this$form2$name = _this$form2.name) === null || _this$form2$name === void 0 ? void 0 : _this$form2$name.split(',');
      const orgNos = (_this$form3 = this.form) === null || _this$form3 === void 0 ? void 0 : (_this$form3$orgNo = _this$form3.orgNo) === null || _this$form3$orgNo === void 0 ? void 0 : _this$form3$orgNo.split(',');
      let params = {
        activityId: option.activityId,
        processInstanceId: option.processInstanceId,
        taskId: option.taskId,
        comment: option.comment,
        assigneeList: []
      };
      userIds.map((id, index) => {
        params.assigneeList.push({
          userId: id,
          name: names[index],
          orgNo: orgNos[index]
        });
      });
      const loading = this.$loading();
      const {
        status,
        message,
        code
      } = await task["a" /* default */].multiInstanceAdd(params).finally(() => {
        loading.close();
      });
      if (status) {
        this.$message.success('流程加签成功！');
        this.dialogVisible = false;
      }
      this.$emit('onConfirm', {
        status,
        message,
        code,
        type: MULTI_INSTANCE_ADD
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/MultiInstanceAddDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmit_MultiInstanceAddDialogvue_type_script_lang_js_ = (FlowActionNoSubmit_MultiInstanceAddDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/MultiInstanceAddDialog.vue





/* normalize component */

var FlowActionNoSubmit_MultiInstanceAddDialog_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmit_MultiInstanceAddDialogvue_type_script_lang_js_,
  MultiInstanceAddDialogvue_type_template_id_5a5f4656_scoped_true_render,
  MultiInstanceAddDialogvue_type_template_id_5a5f4656_scoped_true_staticRenderFns,
  false,
  null,
  "5a5f4656",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit_MultiInstanceAddDialog = (FlowActionNoSubmit_MultiInstanceAddDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowActionNoSubmit/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// 操作类型





/**
 * @description FlowAction
 * @param taskId <String> required, 待办任务ID
 * @param taskDetail <Object> 任务详情，非必须，如果是在强制节点选择审核人员场景，建议传递
 * @param instId <String> required, 流程实例ID
 * @param isSubmit <Boolean> 是否提交表单数据到到工作流，默认提交 TRUE
 * @param toReadId <String>, 传阅记录ID，回复传阅操作的时候必须
 * @param buttonList <String> required, 底部操作按钮列表，通过流程任务详情接口获取（接口信息：http://10.10.1.244:3000/project/11/interface/api/25074）
 * @event handel-success 自定义失败回调事件，如果不处理内部默认提示toast
 * @event handel-error 自定义成功回调事件，如果不处理内部默认提示toast，回调参数：
 *                        @param <String> type（APPLY/同意, REJECT/驳回, STOP/终止, AGENT/转办, TO_READ/传阅, DELEGATE/委派）
 *                        @param <Object> data：
 *                                            NO_CONFIGURED_USER_EXCEPTION(117034): // 未配置用户
 *                                            NO_AVAILABLE_USER_THROW_MODE_EXCEPTION(117037): // 配置，但无可用
 *                                            NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION(117023): // 用户不存在或已离职
 *                                            以及其他任何错误信息，返回结构一致
 *                                            接口返回的全量错误信息，详细查看：https://www.tapd.cn/23181131/prong/tasks/view/1123181131001114730
 *                                            如为监听此事件默认$message.error()弹出消息提示框
 * @event handel-user-error 自定义选人事件，需要自行实现选人逻辑，完成选人和后续操作。
 * @event handel-back 返回按钮点击事件，如引用组件处为监听此事件，默认启用vue-router，$router.back()。
 * */
/* harmony default export */ var FlowActionNoSubmitvue_type_script_lang_js_ = ({
  props: {
    taskId: String,
    isSubmit: {
      // 是否提交表单数据到到工作流，默认提交
      type: Boolean,
      default: true
    },
    instId: String,
    toReadId: String,
    activityId: String,
    taskDetail: Object,
    noCommit: {
      type: Boolean,
      default: false
    },
    buttonList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    nextActivityNodeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    onBeforeSubmit: {
      type: Function,
      default: () => {}
    },
    onAfterSetParams: {
      type: Function,
      default: () => {}
    }
  },
  name: 'FlowActionNoSubmit',
  components: {
    OpinionText: OpinionText,
    RejectableNodesDialog: FlowActionNoSubmit_RejectableNodesDialog,
    ToReadDialog: FlowActionNoSubmit_ToReadDialog,
    AgentDialog: FlowActionNoSubmit_AgentDialog,
    UserDialog: FlowActionNoSubmit_UserDialog,
    CommunicationTask: FlowActionNoSubmit_CommunicationTask,
    MultiInstanceAddDialog: FlowActionNoSubmit_MultiInstanceAddDialog
  },
  data() {
    return {
      open: true,
      taskInfo: {
        status: ''
      },
      approveMessage: '',
      nextUsers: [],
      TO_READ: TO_READ,
      customNextUser: false,
      // 控制同意按钮是否强制弹出选人对话框
      customNextUserDialogMessage: '',
      // 选人对话框的额外提示信息
      activity: null,
      activities: [],
      exceptNodes: [],
      // 过滤节点id，可用于驳回节点过滤和选人节点过滤
      // 驳回专用的脚本设置属性
      rejectConfig: {
        disableRejectMode: false,
        skipHistoryNode: false
      }
    };
  },
  computed: {
    containerHeight() {
      if (this.open) {
        return {
          height: 'auto'
        };
      } else {
        return {
          height: '0px'
        };
      }
    },
    btnList() {
      const _list = this.buttonList.map(item => ({
        name: item.name,
        type: item.requestUri,
        active: item.active,
        order: item.order,
        alias: item.alias,
        ajax: {
          method: item.method,
          uri: item.requestUri
        },
        beforeScript: item.beforeScript || ''
      }));
      return _list.filter(item => item.type.indexOf('toRead') === -1);
    },
    topButtonList() {
      const buttonList = [{
        id: '1459077296364270963',
        order: 5,
        name: '传阅',
        method: 'POST',
        requestUri: TO_READ,
        isPeopleSelection: true,
        beforeScript: null,
        groovyScript: null
      }];
      if (this.toReadId || !Array.isArray(this.buttonList)) return buttonList;
      return this.buttonList.filter(item => item.requestUri.indexOf('toRead') !== -1);
    },
    isCanToRead() {
      if (!Array.isArray(this.buttonList)) return false;
      return this.buttonList.filter(item => item.requestUri.indexOf('toRead') !== -1).length;
    }
  },
  mounted() {
    this.$on('showToReadDialog', async () => {
      let params = await this.getParams(false);
      if (this.$refs.toReadDialog) {
        this.$refs.toReadDialog.show(params);
      }
    });
  },
  methods: {
    //执行前置脚本
    async tempScript(script, params, isReject = false) {
      if (script == undefined || script == '') {
        return true;
      }
      let _this = this;
      let _req = this.$req;
      let dialogVm = {
        replaceUser: ReplaceUserDialog
      };
      let formContext = document.getElementById('flow-form-content').__vue__;
      let boData = await Object(form_utils_umd["getOnlineFormData"])(!isReject);
      async function evil() {
        let Fn = Function('_req', 'boData', '_this', 'context', 'dialogVm', 'params', script); //一个变量指向Function，防止有些前端编译工具报错
        let result = Fn(_req, JSON.parse(boData), _this, formContext, dialogVm, params);
        return result;
      }
      let resultValue = await evil();
      // 如果是undefine，认为脚本执行成功，只有明确return false才阻止提交
      let flag = resultValue !== false;
      return flag;
    },
    async getFormData(isCheck = true) {
      if (document.getElementsByName('online-form')[0]) {
        const form = await Object(form_utils_umd["getOnlineFormData"])(isCheck);
        return base64["a" /* Base64 */].encode(form);
      }
      return '';
    },
    // 获取表单数据
    async getParams(isCheck) {
      const formData = await this.getFormData(isCheck);
      const option = {
        formData: '',
        // isSubmit FALSE 不提交表单数据到工作流
        taskId: this.taskId,
        processInstanceId: this.instId,
        comment: this.approveMessage,
        nextUsers: this.nextUsers
      };
      if (formData) {
        option.formData = this.isSubmit ? formData : ''; // isSubmit FALSE 不提交表单数据到工作流
      }

      return option;
    },
    resetConfig() {
      this.customNextUser = false;
      this.customNextUserDialogMessage = '';
    },
    // 提交按钮操作
    async submitRevoke(type, script, nextUsers = '', actionType = '') {
      let params = {};
      // 提交前置钩子
      if (this.onBeforeSubmit) {
        const result = await this.onBeforeSubmit(type, nextUsers, actionType);
        if (result === false) return;
      }

      // 每次触发按钮的时候，都先重置内置的属性
      this.resetConfig();
      if (script) {
        const flag = await this.tempScript(script, params, type === REJECT);
        if (!flag) {
          return;
        }
      }
      try {
        // 1、同意按钮[APPLY]校验表单
        // 2、如果已经有脚本，在脚本执行过程中已经校验过一次表单了，所以就不需要二次校验了，防止脚本修改值引起的表单联动后
        let _params = this.isSubmit ? await this.getParams(script ? false : type === APPLY) : await this.getParams(false);
        // 整合params
        params = {
          ..._params,
          ...params
        };
        await this.onAfterSetParams(type, params, base64["a" /* Base64 */]);
        if (!params) {
          return this.handleCallback({
            status: false,
            type,
            message: '获取表单信息失败，请联系管理员！'
          });
        }
        // 前端脚本设置，是否主动选择下一节点接收人,不包含传阅、转办
        if (this.customNextUser && !actionType && ![TO_READ, AGENT].includes(type)) {
          if (!this.taskDetail) {
            this.taskDetail = await task["a" /* default */].taskDetail({
              id: this.taskId,
              type: Object(helper_env["a" /* getClientType */])()
            });
            // TODO 判断是否存在下一节点ＩＤ
            if (!this.taskDetail) return this.handleCallback({
              status: false,
              type,
              message: '下一个节点信息缺失，请联系管理员《人员选择必须场景》！'
            });
          }
          // TODO 对接选择节点
          params.extraMessage = this.customNextUserDialogMessage;
          return this.$refs.userDialog.showDialog(type, params, SCRIPT, {
            nextActivityNodeList: this.taskDetail.nextActivityNodeList,
            exceptNodes: this.exceptNodes
          });
        }
        // 处理指定用户
        if (nextUsers) {
          // 强制选人操作
          if (actionType === SCRIPT) {
            this.nextUsers = nextUsers;
            // 人员异常选人
          } else {
            if (this.activity && Array.isArray(nextUsers)) {
              nextUsers = nextUsers.map(user => {
                user.activityId = this.activity.id;
                return user;
              });
              let sampleUsers = this.nextUsers.filter(user => user.activityId === this.activity.id);
              if (sampleUsers && sampleUsers.length) {
                let otherUsers = nextUsers.filter(user => user.activityId !== this.activity.id);
                this.nextUsers = [...otherUsers, ...nextUsers];
              } else {
                this.nextUsers = [...this.nextUsers, ...nextUsers];
              }
            }
          }
          // 下个节点添加会签标志
          this.nextUsers.forEach(item => {
            let isMultiInstance = false;
            if (this.nextActivityNodeList.some(node => {
              if (node.id == item.activityId) {
                isMultiInstance = node.isMultiInstance;
                return true;
              }
              return false;
            })) {
              item.isMultiInstance = isMultiInstance;
            }
          });
          params = Object.assign(params, {
            nextUsers: this.nextUsers
          });
        }
        switch (type) {
          case APPLY:
            if (!params.comment) params.comment = '同意';
            await this.handleAgree(params);
            break;
          case REJECT:
            await this.handleReject(params);
            break;
          case DELEGATE:
          case COMMUNICATION_TASK: // 创建沟通
          case COMMUNICATION_TASK_REPLY:
            // 回复沟通
            if (this.$refs.communicationTask) {
              if (this.taskDetail && this.taskDetail.communicateUser) {
                params.communicateUsers = [this.taskDetail.communicateUser];
              }
              this.$refs.communicationTask.showDialog(params, type);
            }
            break;
          case COMMUNICATION_TASK_CANCEL:
            // 取消沟通
            this.$confirm('确定取消由你发起的所有沟通？').then(async confirm => {
              const resp = await task["a" /* default */].cancelCommunicationTask({
                id: this.taskId
              });
              if (resp.status) {
                this.$message.success('取消成功！');
                // this.refreshCommList()
                // 重新加载当前路由
                this.$router.go(this.$router.currentRoute);
              } else {
                this.$message.error(resp.message || '取消失败！');
              }
            }).catch(cancel => {
              this.$message.info('你已取消操作！');
            });
            break;
          case STOP:
            await this.handleEndProcess(params);
            break;
          case AGENT:
            if (this.$refs.agentDialog) {
              this.$refs.agentDialog.showDialog(params);
            }
            break;
          case TO_READ:
            if (this.$refs.toReadDialog) {
              this.$refs.toReadDialog.show(params);
            }
            break;
          case TEMPSAVE:
            await this.handlTempSave(params);
            break;
          case MULTI_INSTANCE_ADD:
            if (this.$refs.multiInstanceAddDialog) {
              this.$refs.multiInstanceAddDialog.showDialog({
                ...params,
                activityId: this.activityId
              });
            }
            break;
          case MULTI_INSTANCE_PASSED:
            if (!params.comment) params.comment = '同意';
            this.handleComplete(params, 'PASSED');
            break;
          case MULTI_INSTANCE_REJECT:
            this.handleComplete(params, 'REJECT');
            break;
          case constants_DELETE:
            this.handleDelete(params);
            break;
          default:
            break;
        }
      } catch (error) {
        // this.handleCallback({ type, data: error })
        console.log({
          type,
          data: error
        });
      }
    },
    // 选择指定人弹窗回调
    onUserConfirm(type, nextUsers, actionType) {
      // FIXME: userDialog就已经卡住nextUsers必填的场景了，这里不需要再判断了
      // if (!Array.isArray(nextUsers) || !nextUsers.length || !type) {
      //   return this.handleCallback({
      //     type,
      //     message: '用户数据异常，联系管理员！',
      //   })
      // }
      this.submitRevoke(type, '', nextUsers, actionType);
    },
    /**
     * @description 请求结果统一处理
     * @param options {}
     *        --| status, 状态
     *        --| data, 请求返回结果数据
     *        --| message, 消息提示文本
     * @return $emit: e(事件handle-success/handle-error)、 argument [message, type, data]
     *                                                          --| message, 消息提示文本
     *                                                          --| type, 按钮操作类型
     *                                                          --| data, 请求返回结果数据(包含成功数据/异常详情)
     * */
    // 请求操作异常处理
    handleCallback(options = {}) {
      // init option
      options = Object.assign({
        status: false,
        data: null,
        ...UNKNOWN_ERROR
      }, options);
      // success
      if (options.status) {
        request_utils["a" /* doHandleToEmitOrToast */].call(this, HANDLE_SUCCESS, 'success', options.message || '操作成功!', BUTTON_TYPE[options.type] || '', options);
        // 清空选中用户
        this.initUserDialog();
        // 刷新列表页
        eventBus["a" /* default */].$emit('refresh');
        return;
      }
      // 接口异常
      if (!options.status) {
        if (options.data && options.data.activity) {
          this.activity = options.data.activity;
          if (this.nextUsers.length) {
            // 清空选中用户
            this.initUserDialog();
          }
        }
        switch (options.code) {
          case NO_CONFIGURED_USER_EXCEPTION.code: // 未配置用户
          case NO_AVAILABLE_USER_THROW_MODE_EXCEPTION.code:
            // 配置，但无可用
            request_utils["a" /* doHandleToEmitOrToast */].call(this, HANDLE_ERROR, 'error', options.message || NO_CONFIGURED_USER_EXCEPTION.message, BUTTON_TYPE[options.type] || '', options);
            break;
          case NO_AVAILABLE_USER_SELECT_MODE_EXCEPTION.code:
            // 用户不存在或已离职
            if (request_utils["c" /* hasHandleToEmit */].call(this, 'handle-user-error', options)) break;
            this.$refs.userDialog.showDialog(options.type, options);
            break;
          default:
            request_utils["a" /* doHandleToEmitOrToast */].call(this, HANDLE_ERROR, 'error', options.message || UNKNOWN_ERROR.message, BUTTON_TYPE[options.type] || '', options);
            break;
        }
      }
    },
    // 同意
    async handleAgree(params) {
      const confirm = await this.$confirm('确定同意此任务吗？', '提示', {
        type: 'warning'
      }).catch(() => {});
      if (confirm === 'confirm') {
        const loading = this.$loading();
        const {
          status,
          message,
          code,
          data
        } = await task["a" /* default */].agreeAction(params).finally(() => {
          loading.close();
        });
        this.handleCallback({
          status,
          data,
          message,
          code,
          type: APPLY
        });
      } else {
        this.$message.info('取消操作！');
        this.initUserDialog();
      }
    },
    // 删除
    async handleDelete(params) {
      const confirm = await this.$confirm('删除数据后不可恢复，确定删除？', '提示', {
        type: 'warning'
      }).catch(() => {});
      if (confirm === 'confirm') {
        const loading = this.$loading();
        const {
          status,
          message,
          code,
          data
        } = await processInstance["a" /* default */].flowInstDeleteById({
          processInstanceId: params.processInstanceId
        }).finally(() => {
          loading.close();
        });
        this.handleCallback({
          status,
          data,
          message,
          code,
          type: constants_DELETE
        });
      } else {
        this.$message.info('取消操作！');
      }
    },
    // 暂存
    async handlTempSave(params) {
      const loading = this.$loading();
      const {
        status,
        message,
        data
      } = await task["a" /* default */].tempTaskSave({
        formData: params.formData,
        taskId: params.taskId
      }).finally(() => {
        loading.close();
      });
      if (status) {
        eventBus["a" /* default */].$emit('postFormData', data);
        this.$message.success('暂存成功！');
      } else {
        this.$message.error(message);
      }
    },
    // 驳回
    async handleReject(params) {
      if (!this.taskId || !this.instId) {
        this.handleCallback({
          message: '数据异常，请联系管理！',
          type: REJECT
        });
      }
      if (!params.comment) {
        return this.$message.warning('请先填写驳回意见！');
      }
      // 选中用户直接更新
      const isSpecifiedNextUsers = params.nextUsers && params.nextUsers.length && !this.customNextUser;
      if (isSpecifiedNextUsers) {
        // 非强制选人场景
        await this.$refs.rejectableNodesDialog.doRejectAction(params);
      } else {
        params.comment = this.approveMessage;
        this.$refs.rejectableNodesDialog.showDialog(this.taskId, this.instId, params, {
          exceptNodes: this.exceptNodes,
          disableRejectMode: this.rejectConfig.disableRejectMode,
          skipHistoryNode: this.rejectConfig.skipHistoryNode
        });
      }
    },
    // 终止
    async handleEndProcess(params) {
      const confirm = await this.$confirm('确定终止此任务吗？', '提示', {
        type: 'warning'
      }).catch(() => this.$message.info('取消操作！'));
      if (confirm === 'confirm') {
        const loading = this.$loading();
        let resp = await task["a" /* default */].stopAction(params).finally(() => {
          loading.close();
        });
        const response = Object.assign(resp || {}, {
          status: (resp === null || resp === void 0 ? void 0 : resp.status) || false,
          type: STOP,
          message: resp !== null && resp !== void 0 && resp.status ? '终止成功' : resp.message
        });
        this.handleCallback(response);
      } else {
        this.$message.info('取消操作！');
        this.initUserDialog();
      }
    },
    // 回复传阅
    async handleToReadTask() {
      const params = {
        id: this.toReadId,
        comment: this.approveMessage
      };
      const loading = this.$loading();
      const resp = await task["a" /* default */].toReadTaskHandle(params).finally(() => {
        loading.close();
      });
      if (resp && resp.status) {
        this.handleCallback({
          status: resp.status,
          message: '回复成功',
          type: TO_READ
        });
        this.refreshCommList();
      }
    },
    // 刷新处理记录
    refreshCommList() {
      if (this.$parent && this.$parent.$children && Array.isArray(this.$parent.$children)) {
        this.$parent.$children.map(child => {
          if (child && child.getCommentList) {
            child.getCommentList();
          }
        });
      }
    },
    // 返回
    handleBack() {
      if (!request_utils["c" /* hasHandleToEmit */].call(this, HANDLE_BACK)) {
        this.$router.back();
      }
    },
    // 初始化人员选择器选中状态
    initUserDialog() {
      if (this.$refs.userDialog && this.$refs.userDialog.initForm) {
        this.$refs.userDialog.initForm();
      }
    },
    showAction() {
      this.open = !this.open;
      this.$emit('show-action', this.open);
    },
    // 会签同意/反对
    async handleComplete(params, mieCompleteType) {
      if (!params.comment) {
        return this.$message.warning('请先填写审批意见！');
      }
      const confirm = await this.$confirm(`确定${mieCompleteType == 'PASSED' ? '赞成' : '反对'}此会签内容吗？`, '提示', {
        type: 'warning'
      }).catch(() => {});
      if (confirm === 'confirm') {
        const loading = this.$loading();
        const {
          status,
          message,
          code,
          data
        } = await task["a" /* default */].multiInstanceComplete({
          taskId: params.taskId,
          comment: params.comment,
          mieCompleteType
        }).finally(() => {
          loading.close();
        });
        this.handleCallback({
          status,
          data,
          message,
          code,
          type: APPLY
        });
      } else {
        this.$message.info('取消操作！');
        this.initUserDialog();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowActionNoSubmitvue_type_script_lang_js_ = (FlowActionNoSubmitvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowActionNoSubmit/index.vue?vue&type=style&index=0&id=418dcb63&prod&lang=scss&scoped=true&
var FlowActionNoSubmitvue_type_style_index_0_id_418dcb63_prod_lang_scss_scoped_true_ = __webpack_require__("69f4");

// CONCATENATED MODULE: ./src/components/flow/FlowActionNoSubmit/index.vue






/* normalize component */

var FlowActionNoSubmit_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowActionNoSubmitvue_type_script_lang_js_,
  FlowActionNoSubmitvue_type_template_id_418dcb63_scoped_true_render,
  FlowActionNoSubmitvue_type_template_id_418dcb63_scoped_true_staticRenderFns,
  false,
  null,
  "418dcb63",
  null
  
)

/* harmony default export */ var FlowActionNoSubmit = (FlowActionNoSubmit_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowRecord/pc.vue?vue&type=template&id=36a6bcde&scoped=true&
var pcvue_type_template_id_36a6bcde_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-record",attrs:{"id":"flow-record"}},[(!_vm.hiddenTitle)?_c('div',{staticClass:"flow-record__title"},[_vm._v("处理记录")]):_vm._e(),_c('div',{staticClass:"flow-record__container"},[_c('op-table',{attrs:{"data":_vm.listComment,"maxHeight":500}},[_c('op-column',{attrs:{"type":"index","width":"50","align":"center","label":"序号","index":_vm.descIndex}}),_vm._l((_vm.tableHeaders),function(column){return _c('op-column',{key:column.key,attrs:{"type":column.type,"width":column.width,"min-width":column.minWidth,"label":column.name,"template":column.template,"tooltipTemplate":column.tooltipTemplate,"prop":column.key,"showTooltip":column.showTooltip}})})],2)],1)])}
var pcvue_type_template_id_36a6bcde_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowRecord/pc.vue?vue&type=template&id=36a6bcde&scoped=true&

// EXTERNAL MODULE: ./src/components/flow/enum.js
var flow_enum = __webpack_require__("77a9");

// CONCATENATED MODULE: ./src/components/flow/FlowRecord/mixins/props.js
/* harmony default export */ var props = ({
  props: {
    list: Array,
    instId: String,
    // 实例id
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    },
    hiddenTitle: {
      // 隐藏标题
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowRecord/pc.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pcvue_type_script_lang_js_ = ({
  mixins: [props],
  name: 'flow-record',
  data() {
    return {
      listComment: [],
      tableHeader: [
      // { name: '审批候选人', key: 'sysPlatform' },
      {
        name: '审批人',
        minWidth: 150,
        key: 'candidate'
      }, {
        name: '处理人',
        minWidth: 150,
        key: 'assignee'
      }, {
        name: '处理意见',
        key: 'comment',
        minWidth: 750,
        showTooltip: true,
        template: (h, {
          row
        }) => {
          return h('div', {
            class: {
              commentColumn: true
            }
          }, row.comment ? row.comment : '');
        },
        tooltipTemplate: (h, {
          row
        }) => {
          return h('div', row.comment ? row.comment : '');
        }
      }, {
        name: '处理情况',
        minWidth: 150,
        key: 'type',
        template: (h, {
          row
        }) => {
          let value = Object(tool["c" /* getLabelInOptions */])(row.type, flow_enum["a" /* COMMENT_TYPE */]);
          return h('span', value);
        }
      },
      // { name: '创建时间', width: 160, key: 'gasd', type: 'date' },
      {
        name: '操作时间',
        width: 160,
        key: 'time',
        type: 'date'
      }, {
        name: '处理步骤',
        minWidth: 150,
        key: 'activityName'
      }]
    };
  },
  computed: {
    tableHeaders() {
      let headers = this.tableHeader;
      console.log(this.hiddenAssignee);
      console.log(this.hiddenComment);
      if (this.hiddenAssignee) {
        headers = headers.filter(header => header.key !== 'assignee');
      }
      if (this.hiddenComment) {
        headers = headers.filter(header => header.key !== 'comment');
      }
      return headers;
    }
  },
  methods: {
    descIndex(index = 0) {
      if (!this.listComment) return 0;
      return this.listComment.length - index;
    },
    async getCommentList() {
      if (this.list && this.list.length) return;
      const {
        status,
        data
      } = await processInstance["a" /* default */].listComment({
        processInstanceId: this.instId
      });
      if (status) {
        this.listComment = data;
      }
    }
  },
  created() {
    this.listComment = this.list || [];
  },
  mounted() {
    this.getCommentList();
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowRecord/pc.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowRecord_pcvue_type_script_lang_js_ = (pcvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowRecord/pc.vue?vue&type=style&index=0&id=36a6bcde&prod&lang=scss&scoped=true&
var pcvue_type_style_index_0_id_36a6bcde_prod_lang_scss_scoped_true_ = __webpack_require__("86c4");

// EXTERNAL MODULE: ./src/components/flow/FlowRecord/pc.vue?vue&type=style&index=1&id=36a6bcde&prod&lang=css&
var pcvue_type_style_index_1_id_36a6bcde_prod_lang_css_ = __webpack_require__("8629");

// CONCATENATED MODULE: ./src/components/flow/FlowRecord/pc.vue







/* normalize component */

var pc_component = Object(componentNormalizer["a" /* default */])(
  FlowRecord_pcvue_type_script_lang_js_,
  pcvue_type_template_id_36a6bcde_scoped_true_render,
  pcvue_type_template_id_36a6bcde_scoped_true_staticRenderFns,
  false,
  null,
  "36a6bcde",
  null
  
)

/* harmony default export */ var pc = (pc_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowRecord/mobile.vue?vue&type=template&id=36a29514&scoped=true&
var mobilevue_type_template_id_36a29514_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-record"},[(!_vm.hiddenTitle)?_c('div',{staticClass:"flow-record__title"},[_vm._v("处理记录")]):_vm._e(),_c('div',{staticClass:"flow-record__container"},_vm._l((_vm.listComment),function(item,index){return _c('div',{key:item.id,staticClass:"flow-record__item"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.listLength - index))]),_c('span',{staticClass:"text",class:{ active: index === 0 }},[_vm._v(_vm._s(item.activityName))])]),_c('div',{staticClass:"user"},[_c('span',[_vm._v("审核人："+_vm._s(item.assignee))])]),(!_vm.hiddenAssignee)?_c('div',{staticClass:"user"},[_c('span',[_vm._v("处理人："+_vm._s(item.candidate))])]):_vm._e(),(!_vm.hiddenComment)?_c('div',{staticClass:"comment"},[_c('span',[_vm._v(_vm._s(item.comment))])]):_vm._e(),_c('div',{staticClass:"action-info"},[_c('span',{staticClass:"time"},[_vm._v("操作时间："+_vm._s(_vm.dataFilter(item.time)))])])])}),0)])}
var mobilevue_type_template_id_36a29514_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowRecord/mobile.vue?vue&type=template&id=36a29514&scoped=true&

// EXTERNAL MODULE: ./src/helper/date.js
var helper_date = __webpack_require__("71e8");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowRecord/mobile.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mobilevue_type_script_lang_js_ = ({
  mixins: [props],
  name: 'flow-record',
  data() {
    return {
      listComment: []
    };
  },
  methods: {
    async getCommentList() {
      if (this.list && this.list.length) return;
      const {
        status,
        data
      } = await processInstance["a" /* default */].listComment({
        processInstanceId: this.instId
      });
      if (status) {
        this.listComment = data;
      }
    },
    dataFilter: helper_date["a" /* default */]
  },
  computed: {
    listLength() {
      return this.listComment.length;
    }
  },
  created() {
    this.listComment = this.list || [];
  },
  mounted() {
    this.getCommentList();
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowRecord/mobile.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowRecord_mobilevue_type_script_lang_js_ = (mobilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowRecord/mobile.vue?vue&type=style&index=0&id=36a29514&prod&lang=scss&scoped=true&
var mobilevue_type_style_index_0_id_36a29514_prod_lang_scss_scoped_true_ = __webpack_require__("1861");

// CONCATENATED MODULE: ./src/components/flow/FlowRecord/mobile.vue






/* normalize component */

var mobile_component = Object(componentNormalizer["a" /* default */])(
  FlowRecord_mobilevue_type_script_lang_js_,
  mobilevue_type_template_id_36a29514_scoped_true_render,
  mobilevue_type_template_id_36a29514_scoped_true_staticRenderFns,
  false,
  null,
  "36a29514",
  null
  
)

/* harmony default export */ var mobile = (mobile_component.exports);
// CONCATENATED MODULE: ./src/components/flow/FlowRecord/index.js



const FlowRecord = {};
FlowRecord.install = Vue => {
  if (Object(helper_env["b" /* isPCWidth */])()) {
    Vue.component(pc.name, pc);
  } else {
    Vue.component(mobile.name, mobile);
  }
};
/* harmony default export */ var flow_FlowRecord = (FlowRecord);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowDiagram/index.vue?vue&type=template&id=23fcf0b5&scoped=true&
var FlowDiagramvue_type_template_id_23fcf0b5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.diagram)?_c('div',{ref:"root",staticClass:"flow-diagram"},[_c('div',{staticClass:"flow-diagram__title",on:{"click":_vm.openPreview}},[_vm._v("\n    流程图\n    "),_c('span',{class:{ 'loading-text': _vm.loading }},[_vm._v("（"+_vm._s(_vm.loading ? '流程图加载中，请稍后点击放大预览' : '点击放大预览')+"）")])]),_c('div',{staticClass:"preview-img"},[_c('img',{attrs:{"src":_vm.diagram,"alt":"流程图"},on:{"click":_vm.openPreview}})]),_c('el-dialog',{staticClass:"preview-dialog",attrs:{"visible":_vm.dialogVisible,"top":"0","append-to-body":"","fullscreen":"","title":"预览流程图"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{ref:"diagram",staticClass:"preview-dialog-diagram",style:({
        height: _vm.diagramHeight,
        width: _vm.diagramWidth,
        position: 'relative',
      })},[_c('img',{staticStyle:{"position":"relative"},attrs:{"src":_vm.diagram,"alt":"流程图","usemap":"#diagramImg"}}),_vm._l((_vm.extendGraphInfo),function(item,idx){return _c('div',{key:idx,ref:("extendGraphInfoItem_" + idx),refInFor:true,style:({
          width: item.width + 'px',
          height: item.height + 'px',
          position: 'absolute',
          top: item.y + 'px',
          left: item.x - 25 + 'px',
          borderRadius: '3px',
          cursor: 'pointer',
        }),on:{"mouseenter":function($event){return _vm.mouseenter($event, idx)}}},[(item.activityId === _vm.activityId)?_c('Popup',{staticClass:"popup-item",attrs:{"position-horizontal":_vm.positionHorizontal,"position-vertical":_vm.positionVertical,"current-area":item},on:{"popup-out":function($event){return _vm.handlePopupMouseOut()}}}):_vm._e()],1)})],2)])],1):_vm._e()}
var FlowDiagramvue_type_template_id_23fcf0b5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/index.vue?vue&type=template&id=23fcf0b5&scoped=true&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowDiagram/Popup.vue?vue&type=template&id=3f2ecf2a&scoped=true&
var Popupvue_type_template_id_3f2ecf2a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup",style:(Object.assign({}, _vm.positionHorizontal,
    _vm.positionVertical,
    {zIndex: 99999})),on:{"mouseleave":_vm.handleMouseOut}},[_c('div',{staticClass:"title"},[_c('div',[_vm._v("节点："+_vm._s(_vm.currentArea && _vm.currentArea.taskName))]),_c('div',[_vm._v(_vm._s(_vm._f("statusText")(_vm.currentArea && _vm.currentArea.type)))])]),(_vm.currentArea && _vm.currentArea.assigneeInfoList)?[_c('div',{staticClass:"popup-list"},_vm._l((_vm.currentArea.assigneeInfoList),function(item,index){return _c('el-descriptions',{key:index,ref:("popupList_" + index),refInFor:true,staticClass:"popup-list",attrs:{"title":"","direction":"vertical","column":4,"border":""}},[_c('el-descriptions-item',{attrs:{"label":item.assignee ? '处理人' : '候选人'}},[_vm._v(_vm._s(item.assignee || item.candidate))]),_c('el-descriptions-item',{attrs:{"label":"操作类型"}},[_vm._v(_vm._s(_vm._f("statusText")(item.type)))]),_c('el-descriptions-item',{attrs:{"label":"时间","span":3}},[_c('span',{staticClass:"value"},[_vm._v("开始："+_vm._s(_vm._f("dataFilter")(item.startTime)))]),_c('br'),_c('span',{staticClass:"value"},[_vm._v("结束："+_vm._s(_vm._f("dataFilter")(item.endTime)))])]),_c('el-descriptions-item',{attrs:{"label":"处理意见"}},[_vm._v(_vm._s(item.comment || '暂无'))])],1)}),1)]:_c('div',{staticClass:"popup-list"},[_vm._v("暂无处理信息")])],2)}
var Popupvue_type_template_id_3f2ecf2a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/Popup.vue?vue&type=template&id=3f2ecf2a&scoped=true&

// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/constant.js
/* harmony default export */ var constant = ({
  START: '流程开始',
  SUBMIT: '申请人提交',
  APPLYING: '审批中',
  APPLY: '审批通过',
  SIGNED: '组任务签收',
  UNSIGNED: '组任务退回',
  REJECT: '节点驳回',
  STOP: '节点终止',
  DELEGATE: '委派',
  //是工作流提供的一套标准流程 如果A委派任务给B,其流程流转将会是: ' A->B->A',
  AGENT: '转办',
  // 当前任务处理人无法处理该任务 需他人代理的时候的类型 与委派不同 代办完成后的任务 将不会流转回发起代办的人
  TOREAD: '传阅',
  TOREAD_REPLY: '传阅回复',
  NOT_CREATE_YET: '未产生过任务',
  END: '结束',
  COMMUNICATION_START: '发起沟通',
  COMMUNICATION: '沟通',
  COMMUNICATION_CANCEL: '沟通被取消',
  COMMUNICATION_REPLY: '沟通回复',
  COMMUNICATING: '沟通中',
  COMMUNICATION_REJECT: '沟通取消',
  COUNTERSIGN: '会签',
  ADD_MULTI_INSTANCE: '发起加签',
  MULTI_INSTANCE_PASSED: '赞成会签',
  MULTI_INSTANCE_REJECT: '反对会签',
  DELETE: '删除'
});
const BPM_STATUS = ['-', '未同步', '成功', '失败'];
const FLOW_CENTER_STATUS = {
  APPLYING: '审批中',
  REJECT: '驳回',
  ERROR: '异常',
  END: '办结',
  STOP: '终止'
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowDiagram/Popup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Popupvue_type_script_lang_js_ = ({
  name: 'Popup',
  props: {
    positionHorizontal: [Object, Number],
    positionVertical: [Object, Number],
    currentArea: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  filters: {
    dataFilter: helper_date["a" /* default */],
    statusText: function (status) {
      return constant[status];
    }
  },
  methods: {
    handleMouseOut() {
      this.$emit('popup-out');
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/Popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var FlowDiagram_Popupvue_type_script_lang_js_ = (Popupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowDiagram/Popup.vue?vue&type=style&index=0&id=3f2ecf2a&prod&lang=scss&scoped=true&
var Popupvue_type_style_index_0_id_3f2ecf2a_prod_lang_scss_scoped_true_ = __webpack_require__("dbfe");

// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/Popup.vue






/* normalize component */

var Popup_component = Object(componentNormalizer["a" /* default */])(
  FlowDiagram_Popupvue_type_script_lang_js_,
  Popupvue_type_template_id_3f2ecf2a_scoped_true_render,
  Popupvue_type_template_id_3f2ecf2a_scoped_true_staticRenderFns,
  false,
  null,
  "3f2ecf2a",
  null
  
)

/* harmony default export */ var Popup = (Popup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/FlowDiagram/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FlowDiagramvue_type_script_lang_js_ = ({
  props: ['instId'],
  name: 'flow-diagram',
  components: {
    Popup: Popup
  },
  data() {
    return {
      diagram: '',
      dialogVisible: false,
      extendGraphInfo: [],
      activityId: '',
      currentAreaIndex: -1,
      diagramHeight: 0,
      diagramWidth: 0,
      loading: false
    };
  },
  computed: {
    // positionHorizontal() {
    //   // 没有元素 不计算
    //   if (!this.currentArea && this.currentAreaIndex < 0) return 0
    //   // 右边距小于popup元素宽的是时候，展示在左侧
    //   let width = this.$refs.root.getBoundingClientRect().width
    //   let domRight = width - this.getElementPositionByRef('left')
    //   if (domRight < 160) {
    //     return {
    //       right: domRight + 20 + 'px',
    //     }
    //   }
    //   // 当前组件左边距离
    //   let rootLeft = this.$refs.root.getBoundingClientRect().left
    //   // 当前元素左边距离
    //   let domLeft = this.getElementPositionByRef('left')
    //   // 如果当前元素左边距离小于popup窗口宽，popup显示在当前元素右侧 TODO 右边距离暂时忽略
    //   if (domLeft - rootLeft < 160 || this.currentAreaIndex <= 1) {
    //     return {
    //       left: this.currentArea.x + this.currentArea.width - 20 + 'px',
    //     }
    //   }
    //   // 默认展示当前元素左边
    //   return {
    //     left:
    //       this.currentArea &&
    //       this.currentArea.x - this.currentArea.width - 250 + 'px',
    //   }
    // },
    // positionVertical() {
    //   if (!this.currentArea) return {}
    //   let diagramHeight = this.$refs.root.getBoundingClientRect().height
    //   const assigneeInfoListCount =
    //     this.currentArea?.assigneeInfoList?.length || 0
    //   const popupHeight = assigneeInfoListCount * 60 + 28 + 20
    //   let style = {}
    //   if (popupHeight > diagramHeight - 30) {
    //     style = {
    //       bottom: diagramHeight - this.getElementPositionByRef('height') + 'px',
    //     }
    //   } else {
    //     style = {
    //       top: this.currentArea && this.currentArea.y - 50 + 'px',
    //     }
    //   }
    //   return style
    // },
  },
  methods: {
    getElementPositionByRef(position = 'left') {
      let dom = this.$refs['extendGraphInfoItem_' + this.currentAreaIndex];
      if (!position) return dom && dom[0] && dom[0].getBoundingClientRect();
      let domLeft = dom && dom[0] && dom[0].getBoundingClientRect()[position] || -1;
      return domLeft;
    },
    handlePopupMouseOut() {
      this.activityId = '';
      this.currentAreaIndex = -1;
    },
    positionVertical() {
      return {};
    },
    positionHorizontal() {
      return {};
    },
    mouseenter(e, index) {
      if (e.type === 'mouseenter') {
        this.currentAreaIndex = index;
        this.activityId = index === -1 ? '' : this.extendGraphInfo[index].activityId;
      }
    },
    async getDiagram() {
      const {
        status,
        data
      } = await processInstance["a" /* default */].trace({
        processInstanceId: this.instId
      });
      if (status && data) {
        this.diagram = data;
      }
    },
    // 流程实例流程图扩展信息获取
    async getExtendGraphInfoByProcessInstanceId() {
      this.loading = true;
      const {
        status,
        data
      } = await processInstance["a" /* default */].getExtendGraphInfoByProcessInstanceId({
        processInstanceId: this.instId
      }).finally(() => {
        this.loading = false;
      });
      if (status && data) {
        this.extendGraphInfo = data.info || [];
        this.diagramHeight = data.height + 'px';
        this.diagramWidth = data.width + 'px';
      }
    },
    openPreview() {
      if (!this.loading) {
        this.dialogVisible = true;
      }
    }
  },
  mounted() {
    this.getDiagram();
    this.getExtendGraphInfoByProcessInstanceId();
  }
});
// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_FlowDiagramvue_type_script_lang_js_ = (FlowDiagramvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/FlowDiagram/index.vue?vue&type=style&index=0&id=23fcf0b5&prod&lang=scss&
var FlowDiagramvue_type_style_index_0_id_23fcf0b5_prod_lang_scss_ = __webpack_require__("1d61");

// EXTERNAL MODULE: ./src/components/flow/FlowDiagram/index.vue?vue&type=style&index=1&id=23fcf0b5&prod&lang=scss&scoped=true&
var FlowDiagramvue_type_style_index_1_id_23fcf0b5_prod_lang_scss_scoped_true_ = __webpack_require__("f7f3");

// CONCATENATED MODULE: ./src/components/flow/FlowDiagram/index.vue







/* normalize component */

var FlowDiagram_component = Object(componentNormalizer["a" /* default */])(
  flow_FlowDiagramvue_type_script_lang_js_,
  FlowDiagramvue_type_template_id_23fcf0b5_scoped_true_render,
  FlowDiagramvue_type_template_id_23fcf0b5_scoped_true_staticRenderFns,
  false,
  null,
  "23fcf0b5",
  null
  
)

/* harmony default export */ var FlowDiagram = (FlowDiagram_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessStart/pc.vue?vue&type=template&id=cf016638&
var pcvue_type_template_id_cf016638_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-start"},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{staticClass:"btnArea",attrs:{"span":24}},[_vm._t("button",null,{"controller":{ start: _vm.handleStart, formData: _vm.formHtmlVal ? _vm.formHtmlVal.data : null }}),_c('el-button',{attrs:{"type":"primary","disabled":_vm.startDisabled},on:{"click":function($event){return _vm.handleStart()}}},[_vm._v("提交")]),(_vm.isBack)?_c('el-button',{on:{"click":_vm.back}},[_vm._v("返回")]):_vm._e(),(_vm.isDraft)?_c('el-button',{attrs:{"type":"success","disabled":_vm.draftDisabled},on:{"click":function($event){return _vm.saveProcessDraft(false)}}},[_vm._v("保存草稿")]):_vm._e()],2)],1),_c('user-dialog',{ref:"userDialog",on:{"onConfirm":_vm.onUserConfirm}})],1)}
var pcvue_type_template_id_cf016638_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/ProcessStart/pc.vue?vue&type=template&id=cf016638&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("f38f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessStart/pc.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/**
 * @description 发起流程底部按钮组件
 * @prop flowKey <String> 流程modelKey，流程唯一标识
 * @prop draftId <String> 流程草稿id，存在草稿id的情况下可保存当前修改状态为草稿
 * @prop flowId <String> 流程定义id
 * @prop isDraft <Boolean>是否隐藏保存草稿操作按钮
 * @prop isBack <Boolean>是否隐藏返回草稿操作按钮
 * @prop beforeAction <Function>按钮前置操作
 * @deprecated isUpdateFormData {Boolean} 是否在流程处理过程种更新表单数据，默认为需要：true
 * @event @handle-success 发起流程成功后的回调事件，callback参数：[message]
 * @event @handle-error 发起流程/保存草稿成功后的回调事件，callback参数：[message, ...{...response}]
 * @event @handle-draft 保存草稿成功后的回调事件，callback参数：[message]
 * @event @handle-back 返回操作按钮，callback参数：无
 * @example <process-start flow-key="TEST_MODEL_KEY" flowId-id="xxx"  draft-id="xxx" :isDraft="false"/>
 * */
/* harmony default export */ var ProcessStart_pcvue_type_script_lang_js_ = ({
  name: 'process-start',
  props: {
    flowKey: String,
    draftId: String,
    flowId: String,
    beforeAction: Function,
    isDraft: {
      type: Boolean,
      default: true
    },
    isBack: {
      type: Boolean,
      default: true
    },
    formHtml: {
      type: Object,
      default: () => {}
    },
    gatewayPath: {
      type: String,
      default: null
    },
    /**
     * @deprecated will be deleted
     * */
    isUpdateFormData: {
      type: Boolean,
      default: true
    }
  },
  components: {
    UserDialog: UserDialog
  },
  data() {
    return {
      instanceDraftId: null,
      nextActivityNodeList: [],
      // 发起流程时，需要从script中获取需要手动选人的节点
      customNextUser: false,
      businessKey: null,
      scripts: null,
      startDisabled: false,
      startLoading: false,
      draftDisabled: false
    };
  },
  created() {
    // 优先props 、其次 query param
    this.instanceDraftId = this.draftId || this.$route.query.draftId || null;
    this.businessKey = this.businessKey || this.$route.query.businessKey || null;
  },
  mounted() {
    this.getFirstActivityButtonList();
  },
  computed: {
    formHtmlVal() {
      return this.formHtml;
    }
  },
  methods: {
    async tempScript(script, params) {
      if (script == undefined || script == '') {
        return true;
      }
      let _this = this;
      let _req = this.$req;
      let formContext = document.getElementById('flow-form-content').__vue__;
      let dialogVm = {
        replaceUser: ReplaceUserDialog
      };
      let boData = await Object(form_utils_umd["getOnlineFormData"])(true);
      async function evil() {
        let Fn = Function('_req', 'boData', '_this', 'context', 'dialogVm', 'params', script); //一个变量指向Function，防止有些前端编译工具报错
        let result = Fn(_req, JSON.parse(boData), _this, formContext, dialogVm, params);
        return result;
      }
      let resultValue = await evil();
      // 如果是undefine，认为脚本执行成功，只有明确return false才阻止提交
      let flag = resultValue !== false;
      return flag;
    },
    back() {
      if (!request_utils["c" /* hasHandleToEmit */].call(this, constants["j" /* HANDLE_BACK */])) {
        this.$router.back();
      }
    },
    // 选择指定人弹窗回调
    onUserConfirm(type, nextUsers) {
      this.handleStart(nextUsers, true);
    },
    async processStart(data) {
      // 从定义列表发起
      if (this.flowId) {
        data.processDefinitionId = this.flowId;
      } else {
        // 通过流程主版本发起
        data.modelKey = this.flowKey;
      }
      const request = data.processDefinitionId ? api["c" /* ProcessInstance */].startProcessByDefinition : api["d" /* Task */].startProcess;
      const resp = await request(data, this.gatewayPath).finally(() => this.startLoading.close());
      this.startLoading.close();
      if (resp && resp.status) {
        // 发起成功后删除草稿
        this.instanceDraftId && (await api["c" /* ProcessInstance */].deleteProcessDraftWhenStartProcess({
          id: this.instanceDraftId
        }));
        return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["n" /* HANDLE_SUCCESS */], constants["y" /* SUCCESS */], resp.data);
      }
      this.startDisabled = false;
      return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], (resp === null || resp === void 0 ? void 0 : resp.message) || constants["B" /* UNKNOWN_ERROR */].message, resp || '');
    },
    async getFormData(isVerification = true) {
      let el = document.getElementsByName('online-form')[0] || false;
      // 专门用于URL query 对象传递扩展参数 key extendParams 表名同级字段上送报文
      let extendParams = {};
      if (this.$route.query.extendParams && typeof this.$route.query.extendParams === 'string') {
        try {
          extendParams = JSON.parse(this.$route.query.extendParams) || {};
        } catch (_) {
          console.error('query extendParams 获取出错了！必须为JSON对象字符串', _);
        }
      }
      if (el) {
        try {
          const onlineFormData = await Object(form_utils_umd["getOnlineFormData"])(isVerification);
          return {
            extendParams: typeof extendParams === 'string' ? JSON.parse(extendParams) : extendParams,
            formData: onlineFormData
          };
        } catch (e) {
          console.error('getOnlineFormData function 获取表单出错了！', e);
          return false;
        }
      }
      return false;
    },
    async handleStart(users, skip = false) {
      let _continue = true;
      let params = {};
      this.startLoading = this.$loading();
      this.startDisabled = true;
      if (this.scripts && this.scripts.beforeScript && !skip) {
        try {
          _continue = await this.tempScript(this.scripts.beforeScript, params);
        } catch (_) {
          if (false) {}
        }
        if (!_continue) {
          this.startDisabled = false;
          this.startLoading.close();
          return;
        }
      }
      // 开启自定义选择
      if (this.customNextUser && !users) {
        this.startDisabled = false;
        return this.$refs.userDialog.showDialog('START', params, constants["w" /* SCRIPT */], {
          nextActivityNodeList: this.nextActivityNodeList
        });
      }
      this.startLoading = this.$loading();
      if (users) {
        params.nextUsers = users;
      }
      if (this.beforeAction && typeof this.beforeAction == 'function') {
        _continue = await this.beforeAction();
        if (!_continue) {
          this.startDisabled = false;
          this.startLoading.close();
          return;
        }
      }
      const form = await this.getFormData();
      if (!form) {
        this.startDisabled = false;
        this.startLoading.close();
        return;
      }
      if (form.formData) {
        let formData = JSON.parse(form.formData);
        if (formData.dyfo_ad_subsidy_assp_ba && formData.dyfo_ad_subsidy_assp_ba.activity_id) {
          const detail = await api["c" /* ProcessInstance */].getActivityDetail({
            id: formData.dyfo_ad_subsidy_assp_ba.activity_id
          });
          const currentTime = new Date().getTime();
          const startDt = new Date(detail.mainProject.startDt).getTime();
          const endDt = new Date(detail.mainProject.endDt).getTime();
          const activityStartDt = new Date(detail.startDt).getTime();
          const activityEndDt = new Date(detail.endDt).getTime();
          if (currentTime < startDt || currentTime > endDt || currentTime < activityStartDt || currentTime > activityEndDt) {
            let userInfo = JSON.parse(sessionStorage.getItem('currentUser'));
            let msg = userInfo.attributes.departmentType === 'oppein' ? '不可发起，当前时间已超过制度的版本时效或活动的有效时间！' : '不可发起，当前时间已超过制度的版本时效或活动有效时间！请联系商场管理员。';
            this.startLoading.close();
            return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], msg, 'message');
          }
        }

        // 整理表单保存参数
        if (!this.businessKey) {
          const option = this.handleData(form, this.businessKey || '', params);
          // 创建记录保存表单数据
          const {
            status,
            data,
            message
          } = await api["c" /* ProcessInstance */].defaultFormHandlerCreate(option, this.gatewayPath);
          if (!status) {
            this.startDisabled = false;
            this.startLoading.close();
            return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], message || '业务系统保存数据异常！');
          }
          this.businessKey = data.businessKey;
        }
        // 开始发起动作
        if (this.businessKey) {
          await this.processStart(this.handleData(form, this.businessKey || '', params));
        }
      } else {
        // 没有动态表单
        await this.processStart(this.handleData(null, '', params));
      }
    },
    handleData(form = null, businessKey = '', p = {}) {
      const params = {
        formData: null,
        scenario: flow_enum["e" /* START */],
        // 代表发起场景
        ...p
      };
      if (form && form.hasOwnProperty('updateFormData')) {
        params.updateFormData = form.updateFormData;
      }
      if (form && form.formData) {
        params.formData = base64["a" /* Base64 */].encode(form.formData);
      }
      if (form && form.extendParams) {
        params.extendParams = form.extendParams;
      }
      // 从兄弟节点获取流程的businessKey
      businessKey = businessKey ? businessKey : this.getBusinessKey$();
      if (businessKey) {
        params.businessKey = businessKey;
      }
      return params;
    },
    getBusinessKey$() {
      let businessKeys = [];
      const getKey = $children => {
        $children.map(_vm => {
          if (_vm.$vnode.tag && _vm.$vnode.tag.indexOf('form-content') !== -1 && _vm.$data.businessKey$) {
            businessKeys.push(_vm.$data.businessKey$);
          } else if (_vm.$children && _vm.$children.length) {
            getKey(_vm.$children);
          }
        });
      };
      getKey(this.$root.$children);
      return businessKeys[businessKeys.length - 1];
    },
    async createOrUpdateDraft(init, businessKey = '') {
      const params = {};
      const form = await this.getFormData(false);
      if (form && !init) {
        params.formData = base64["a" /* Base64 */].encode(form.formData);
        params.extendParams = form.extendParams || {};
      }
      if (businessKey) {
        params.bizId = businessKey; // 关联表单数据的业务主键，即businessKey
      }

      // 更新操作
      if (this.businessKey) {
        if (!this.instanceDraftId) {
          return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], '草稿id缺失!');
        }
        params.extendParams['draftId'] = this.instanceDraftId;
        params.scenario = flow_enum["c" /* PROCESS_DRAFT_MODIFY */];
        const resp = await api["c" /* ProcessInstance */].defaultFormHandlerModify(params, this.gatewayPath);
        if (resp.data.businessKey && !this.gatewayPath) {
          // TODO: 如果有gateway就替换getFormDataByBusinessKey的gateway
          const {
            data: _formData
          } = await api["b" /* Form */].getFormDataByBusinessKey(this.businessKey);
          eventBus["a" /* default */].$emit('postFormData', _formData);
        }
        return resp;
      } else {
        // 新建操作
        // 获取流程定义 ID
        params.extendParams['processDefinitionId'] = !this.flowId ? await api["a" /* Flow */].getFlowId(this.flowKey, this.gatewayPath) : this.flowId;
        // 新建草稿场景
        params.scenario = flow_enum["d" /* PROCESS_DRAFT_SAVE */];
        return api["c" /* ProcessInstance */].defaultFormHandlerCreate(params, this.gatewayPath).then(res => {
          if (res && res.status) {
            // 临时缓存作为标识，第二次点击暂存按钮为更新操作
            if (res.data.businessKey) {
              this.businessKey = res.data.businessKey;
            }
            // 草稿模式，更新表单渲染回填新建属性
            if (res.data.formData) {
              eventBus["a" /* default */].$emit('postFormData', res.data.formData);
            }

            // 临时缓存作为草ID， 后续作为闪击
            if (res.data.draftId) {
              this.instanceDraftId = res.data.draftId;
            }
          }
          return res;
        });
      }
    },
    async saveProcessDraft(init = false) {
      // 创建或者更新流程草稿
      const loading = this.$loading();
      this.draftDisabled = true;
      const resp = await this.createOrUpdateDraft(init, this.businessKey).finally(() => loading.close());
      if (!resp || !resp.status) {
        this.draftDisabled = false;
        return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], resp.message || '草稿保存错误!');
      }
      this.draftDisabled = false;
      return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["k" /* HANDLE_DRAFT */], constants["y" /* SUCCESS */], '提交成功');
    },
    async getFirstActivityButtonList() {
      let data;
      if (this.flowId) {
        data = await api["c" /* ProcessInstance */].getFirstActivityButtonListByProcessDefinitionId({
          processDefinitionId: this.flowId
        });
      } else {
        if (!this.flowKey) {
          return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], '缺少模型key，请检查参数！');
        }
        data = await api["a" /* Flow */].getFirstActivityButtonListByModelKey({
          modelKey: this.flowKey
        });
      }
      this.scripts = data[0] || null;
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/ProcessStart/pc.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_ProcessStart_pcvue_type_script_lang_js_ = (ProcessStart_pcvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/ProcessStart/pc.vue?vue&type=style&index=0&id=cf016638&prod&lang=scss&
var pcvue_type_style_index_0_id_cf016638_prod_lang_scss_ = __webpack_require__("9dc5");

// CONCATENATED MODULE: ./src/components/flow/ProcessStart/pc.vue






/* normalize component */

var ProcessStart_pc_component = Object(componentNormalizer["a" /* default */])(
  flow_ProcessStart_pcvue_type_script_lang_js_,
  pcvue_type_template_id_cf016638_render,
  pcvue_type_template_id_cf016638_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProcessStart_pc = (ProcessStart_pc_component.exports);
// CONCATENATED MODULE: ./src/components/flow/ProcessStart/index.js

// import Mobile from './mobile.vue'

const ProcessStart = {};
ProcessStart.install = Vue => {
  // const clientWidth = document.body.clientWidth
  // if (clientWidth > 500) {
  // Vue.component(PC.name, PC)
  // } else {
  //   Vue.component(Mobile.name, Mobile)
  // }
  Vue.component(ProcessStart_pc.name, ProcessStart_pc);
};
/* harmony default export */ var flow_ProcessStart = (ProcessStart);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue?vue&type=template&id=af5a6274&scoped=true&
var ProcessingTaskPrevRecordvue_type_template_id_af5a6274_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading && _vm.lastComment)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"processing-task-prev-record"},[_c('div',{staticClass:"processing-task-prev-record__title"},[_vm._v("处理记录")]),_c('div',{staticClass:"processing-task-prev-record__content"},[_c('comment-content-item',{attrs:{"label":"处理情况","value":_vm._f("getTypeLabel")(_vm.lastComment.type)}}),_c('comment-content-item',{attrs:{"label":"审批意见","value":_vm.lastComment.comment}})],1)]):_vm._e()}
var ProcessingTaskPrevRecordvue_type_template_id_af5a6274_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue?vue&type=template&id=af5a6274&scoped=true&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue?vue&type=template&id=652513f4&scoped=true&
var CommentContentItemvue_type_template_id_652513f4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"comment-content-item"},[_c('div',{staticClass:"comment-content-item__label"},[_vm._v(_vm._s(_vm.label)+"：")]),_c('div',{staticClass:"comment-content-item__value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])]):_vm._e()}
var CommentContentItemvue_type_template_id_652513f4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue?vue&type=template&id=652513f4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CommentContentItemvue_type_script_lang_js_ = ({
  name: 'CommentContent',
  props: {
    label: String,
    value: String
  }
});
// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var ProcessingTaskPrevRecord_CommentContentItemvue_type_script_lang_js_ = (CommentContentItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue?vue&type=style&index=0&id=652513f4&prod&lang=scss&scoped=true&
var CommentContentItemvue_type_style_index_0_id_652513f4_prod_lang_scss_scoped_true_ = __webpack_require__("9fb3");

// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/CommentContentItem.vue






/* normalize component */

var CommentContentItem_component = Object(componentNormalizer["a" /* default */])(
  ProcessingTaskPrevRecord_CommentContentItemvue_type_script_lang_js_,
  CommentContentItemvue_type_template_id_652513f4_scoped_true_render,
  CommentContentItemvue_type_template_id_652513f4_scoped_true_staticRenderFns,
  false,
  null,
  "652513f4",
  null
  
)

/* harmony default export */ var CommentContentItem = (CommentContentItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description 处理待办任务显示上一步审核信息组件，
 * @props instId<String> 流程实例id
 * @example <processing-task-prev-record instId="xxx" />
 * */




/* harmony default export */ var ProcessingTaskPrevRecordvue_type_script_lang_js_ = ({
  name: 'processing-task-prev-record',
  components: {
    CommentContentItem: CommentContentItem
  },
  props: {
    instId: String
  },
  filters: {
    getTypeLabel: type => {
      return Object(tool["c" /* getLabelInOptions */])(type, flow_enum["a" /* COMMENT_TYPE */]);
    }
  },
  data() {
    return {
      lastComment: '',
      isLoading: false
    };
  },
  mounted() {
    this.getLastComment();
  },
  methods: {
    async getLastComment() {
      if (!this.instId) return;
      this.isLoading = true;
      if (this.list && this.list.length) return;
      const {
        status,
        data
      } = await processInstance["a" /* default */].lastComment({
        processInstanceId: this.instId
      }).finally(() => this.isLoading = false);
      if (status) {
        this.lastComment = data;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue?vue&type=script&lang=js&
 /* harmony default export */ var ProcessingTaskPrevRecord_ProcessingTaskPrevRecordvue_type_script_lang_js_ = (ProcessingTaskPrevRecordvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue?vue&type=style&index=0&id=af5a6274&prod&lang=scss&scoped=true&
var ProcessingTaskPrevRecordvue_type_style_index_0_id_af5a6274_prod_lang_scss_scoped_true_ = __webpack_require__("36d4");

// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/ProcessingTaskPrevRecord.vue






/* normalize component */

var ProcessingTaskPrevRecord_component = Object(componentNormalizer["a" /* default */])(
  ProcessingTaskPrevRecord_ProcessingTaskPrevRecordvue_type_script_lang_js_,
  ProcessingTaskPrevRecordvue_type_template_id_af5a6274_scoped_true_render,
  ProcessingTaskPrevRecordvue_type_template_id_af5a6274_scoped_true_staticRenderFns,
  false,
  null,
  "af5a6274",
  null
  
)

/* harmony default export */ var ProcessingTaskPrevRecord = (ProcessingTaskPrevRecord_component.exports);
// CONCATENATED MODULE: ./src/components/flow/ProcessingTaskPrevRecord/index.js

/* harmony default export */ var flow_ProcessingTaskPrevRecord = (ProcessingTaskPrevRecord);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/TimeNotice/pc.vue?vue&type=template&id=2f62be9d&scoped=true&
var pcvue_type_template_id_2f62be9d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"time-notice"},[_c('div',{staticClass:"des"},[(_vm.taskId)?_c('div',[_vm._v("\n      已用时："),_c('span',{style:({ color: _vm.filterColor() })},[_vm._v(_vm._s(_vm.taskTime.inFactUsingDay))]),_vm._v(" 天 ，应在"+_vm._s(_vm.taskTime.standardFinishDay)+"天内处理 ； 流程完结标准周期："+_vm._s(_vm.taskTime.processInstanceTimeNotice.standardFinishDay)+"天 ， 已用时："),_c('span',[_vm._v(_vm._s(_vm.taskTime.processInstanceTimeNotice.inFactUsingDay))]),_vm._v(" 天\n    ")]):_vm._e(),(_vm.instId)?_c('div',[_vm._v("\n      流程完结标准周期："+_vm._s(_vm.taskTime.standardFinishDay)+" 天 ，\n      "+_vm._s(_vm.taskDetail.processStatus == 'APPLYING' ? '已用时' : '实际用时')+":\n      "),_c('span',[_vm._v(" "+_vm._s(_vm.taskTime.inFactUsingDay))]),_vm._v(" 天\n    ")]):_vm._e()])]):_vm._e()}
var pcvue_type_template_id_2f62be9d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/flow/TimeNotice/pc.vue?vue&type=template&id=2f62be9d&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/flow/TimeNotice/pc.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TimeNotice_pcvue_type_script_lang_js_ = ({
  name: 'time-notice',
  props: {
    taskId: String,
    instId: String,
    taskDetail: Object
  },
  data() {
    return {
      isShow: false,
      taskTime: {
        standardFinishDay: 0,
        inFactUsingDay: 0,
        processInstanceTimeNotice: {
          standardFinishDay: 0,
          inFactUsingDay: 0
        },
        statusList: ['APPLYING', 'END', 'STOP']
      }
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    filterColor() {
      return Number(this.taskTime.inFactUsingDay) > Number(this.taskTime.standardFinishDay) ? 'red' : '';
    },
    async getDetail() {
      // 获取任务用时提醒
      if (this.taskId) {
        this.isShow = false;
        let res = await task["a" /* default */].taskTimeNotice({
          taskId: this.taskId
        }).finally(() => this.isShow = true);
        if (res.status) this.taskTime = res.data;
      }
      if (this.instId) {
        this.isShow = false;
        let res = await task["a" /* default */].processInstanceTimeNotice({
          processInstanceId: this.instId
        }).finally(() => this.isShow = true);
        if (res.status) this.taskTime = res.data;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/flow/TimeNotice/pc.vue?vue&type=script&lang=js&
 /* harmony default export */ var flow_TimeNotice_pcvue_type_script_lang_js_ = (TimeNotice_pcvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/flow/TimeNotice/pc.vue?vue&type=style&index=0&id=2f62be9d&prod&lang=scss&scoped=true&
var pcvue_type_style_index_0_id_2f62be9d_prod_lang_scss_scoped_true_ = __webpack_require__("773b");

// CONCATENATED MODULE: ./src/components/flow/TimeNotice/pc.vue






/* normalize component */

var TimeNotice_pc_component = Object(componentNormalizer["a" /* default */])(
  flow_TimeNotice_pcvue_type_script_lang_js_,
  pcvue_type_template_id_2f62be9d_scoped_true_render,
  pcvue_type_template_id_2f62be9d_scoped_true_staticRenderFns,
  false,
  null,
  "2f62be9d",
  null
  
)

/* harmony default export */ var TimeNotice_pc = (TimeNotice_pc_component.exports);
// CONCATENATED MODULE: ./src/components/flow/TimeNotice/index.js

// import Mobile from './mobile.vue'

const TimeNotice = {};
TimeNotice.install = Vue => {
  // const clientWidth = document.body.clientWidth
  // if (clientWidth > 500) {
  // Vue.component(PC.name, PC)
  // } else {
  //   Vue.component(Mobile.name, Mobile)
  // }
  Vue.component(TimeNotice_pc.name, TimeNotice_pc);
};
/* harmony default export */ var flow_TimeNotice = (TimeNotice);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FormContent.vue?vue&type=template&id=1a6a9b4a&scoped=true&
var FormContentvue_type_template_id_1a6a9b4a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-content",attrs:{"id":"flow-form-content"}},[_c('div',{staticClass:"form-content__header",style:({ width: _vm.clientWidth })},[_vm._t("headLeft"),(_vm.taskName && _vm.clientType === 'PC')?_c('div',{staticClass:"taskName"},[_vm._v("\n      当前节点："),_c('span',[_vm._v(_vm._s(_vm.taskName || '无'))])]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || _vm.processName || '无'))]),(_vm.taskName && _vm.clientType === 'PC')?_c('div',{staticClass:"tips"}):_vm._e(),(_vm.toReader)?_c('el-button',{attrs:{"size":"mini","type":"primary","round":"","plain":""},on:{"click":_vm.showToReadDialog}},[_vm._v("传阅")]):_vm._e(),(_vm.clientType === 'PC')?_c('el-button',{attrs:{"size":"mini","type":"primary","round":"","plain":""},on:{"click":function($event){return _vm.copyTitle(_vm.title || _vm.processName || '无')}}},[_vm._v("复制标题和链接")]):_vm._e(),(_vm.showMsg())?_c('el-button',{attrs:{"size":"mini","type":"primary","round":"","plain":""},on:{"click":_vm.showMsgDialog}},[_vm._v("查看")]):_vm._e()],2),_vm._t("timeNotice"),(_vm.html)?_c('div',{class:['form-content__container', _vm.hasTimeNotice ? 'form-content__top' : '']},[_c('online-form',{ref:"onlineForm",attrs:{"html":_vm.html,"data":_vm.data,"permission":_vm.permission,"initFillData":true,"isView":true,"nodeId":_vm.nodeId,"customerParams":_vm.customerParams,"formEventHandler":_vm.formEventHandler}})],1):_vm._e(),_c('msg-dialog',{ref:"MsgDialog"})],2)}
var FormContentvue_type_template_id_1a6a9b4a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/FormContent.vue?vue&type=template&id=1a6a9b4a&scoped=true&

// EXTERNAL MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FormContent.vue?vue&type=script&lang=js&
var FormContentvue_type_script_lang_js_ = __webpack_require__("1139");

// CONCATENATED MODULE: ./src/components/form/FormContent.vue?vue&type=script&lang=js&
 /* harmony default export */ var form_FormContentvue_type_script_lang_js_ = (FormContentvue_type_script_lang_js_["a" /* default */]); 
// EXTERNAL MODULE: ./src/components/form/FormContent.vue?vue&type=style&index=0&id=1a6a9b4a&prod&lang=scss&scoped=true&
var FormContentvue_type_style_index_0_id_1a6a9b4a_prod_lang_scss_scoped_true_ = __webpack_require__("3f1e");

// CONCATENATED MODULE: ./src/components/form/FormContent.vue






/* normalize component */

var FormContent_component = Object(componentNormalizer["a" /* default */])(
  form_FormContentvue_type_script_lang_js_,
  FormContentvue_type_template_id_1a6a9b4a_scoped_true_render,
  FormContentvue_type_template_id_1a6a9b4a_scoped_true_staticRenderFns,
  false,
  null,
  "1a6a9b4a",
  null
  
)

/* harmony default export */ var FormContent = (FormContent_component.exports);
// EXTERNAL MODULE: ./src/request/baseURL.js
var baseURL = __webpack_require__("0a3b");

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/flow-instances.vue?vue&type=template&id=ea3eb19c&
var flow_instancesvue_type_template_id_ea3eb19c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-instances"},[_c('el-form',{ref:"ruleForm",attrs:{"model":_vm.params}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label-width":"50px","label":"时间"}},[_c('el-date-picker',{staticClass:"input-with-select",staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择开始时间","type":"daterange","value-format":"timestamp","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","clearable":""},on:{"change":function (time) {
                if (Array.isArray(time)) {
                  _vm.reload({
                    startTime: time[0],
                    endTime: time[1] + 86399000,
                  })
                } else {
                  _vm.reload({ startTime: null, endTime: null })
                }
              }},model:{value:(_vm.rangeTime),callback:function ($$v) {_vm.rangeTime=$$v},expression:"rangeTime"}})],1)],1),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label-width":"50px","label":"标题","prop":"name"}},[_c('el-input',{staticClass:"input-with-select",staticStyle:{"width":"100%"},attrs:{"placeholder":"请输入标题关键字","clearable":""},on:{"change":function (name) { return _vm.reload({ name: name }); },"clear":_vm.reload},model:{value:(_vm.params.name),callback:function ($$v) {_vm.$set(_vm.params, "name", $$v)},expression:"params.name"}})],1)],1),(!_vm.simpleSearch)?_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"编号","label-width":"50px","prop":"id"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"请输入编号精确查询","clearable":""},on:{"change":function (id) { return _vm.reload({ id: id }); },"clear":_vm.reload},model:{value:(_vm.params.id),callback:function ($$v) {_vm.$set(_vm.params, "id", $$v)},expression:"params.id"}})],1)],1):_vm._e(),_c('el-col',{attrs:{"span":2}},[_c('div',{staticStyle:{"margin-left":"auto"}},[_c('el-button',{attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.reload}},[_vm._v("搜索")])],1)])],1)],1),_c('op-table',{attrs:{"data":_vm.data}},[_c('op-column',{attrs:{"type":"index","width":"50","label":"序号","fixed":"left"}}),_c('op-column',{attrs:{"prop":"name","label":"标题","min-width":400,"fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var row = ref.row;
return [_c('el-link',{attrs:{"type":"primary","title":"编辑流程"},on:{"click":function($event){return _vm.dynamicDialogShow(row, 'READ_INST')}}},[_vm._v(_vm._s(row.name))])]}}])}),_c('op-column',{attrs:{"prop":"id","width":"180","label":"编号"}}),_c('op-column',{attrs:{"prop":"tenantId","label":"所属应用","width":"100"}}),_c('op-column',{attrs:{"prop":"modelKey","label":"流程KEY","width":"180","sortable":true}}),_c('op-column',{attrs:{"prop":"starter","label":"发起人","width":"100","sortable":true}}),_c('op-column',{attrs:{"prop":"finished","label":"状态","width":"100","sortable":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var row = ref.row;
return [_c('el-tag',{attrs:{"type":row.finished ? 'primary' : 'success',"plain":""}},[_vm._v(_vm._s(row.finished ? '完成' : '进行中'))])]}}])}),_c('op-column',{attrs:{"prop":"startTime","label":"发起时间","hidden":"","width":"160","sortable":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var row = ref.row;
return [_vm._v("\n        "+_vm._s(_vm._f("formatDate")(row.startTime))+"\n      ")]}}])}),_c('op-column',{attrs:{"width":"290px","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var row = ref.row;
              var $index = ref.$index;
return _vm._l((row.authList.filter(function (_auth) { return _auth.indexOf('INST') !== -1 && _auth.indexOf('READ') === -1; })),function(auth){return _c('el-button',{key:auth,staticStyle:{"margin":"5px"},attrs:{"size":"mini","disabled":row.finished && auth === 'HANGUP_INST',"type":_vm._f("authTheme")(auth,!row.activable),"plain":""},on:{"click":function($event){return _vm.dynamicDialogShow(row, auth)}}},[_vm._v(_vm._s(_vm._f("authLabel")(auth,!row.activable)))])})}}])})],1),_c('el-pagination',{staticStyle:{"text-align":"right"},attrs:{"current-page":_vm.params.pageNo,"page-sizes":[20, 50, 100],"page-size":_vm.params.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}}),_c('dynamic-dialog',{ref:"dynamicDialog",attrs:{"title":"实例详情","componentId":"FlowInstanceDetailDialog","footer":"","canSave":_vm.canSave}})],1)}
var flow_instancesvue_type_template_id_ea3eb19c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/instance/flow-instances.vue?vue&type=template&id=ea3eb19c&

// EXTERNAL MODULE: ./src/api/uc.js
var uc = __webpack_require__("292c");

// EXTERNAL MODULE: ./src/components/dialog/DynamicDialog.vue + 4 modules
var DynamicDialog = __webpack_require__("b614");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/flow-instances.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







const AUTH_TYPE = {
  READ_TASK: 'READ_TASK',
  // 任务查看
  READ_INST: 'READ_INST',
  // 实例查看
  EDIT_INST: 'EDIT_INST',
  // 实例编辑
  HANGUP_INST: 'HANGUP_INST',
  // 实例挂起
  END_INST: 'END_INST',
  // 实例终止
  DEL_INST: 'DEL_INST' // 实例删除
};

const authTypeObjList = [{
  label: '任务查看',
  value: AUTH_TYPE.READ_TASK,
  theme: 'primary'
}, {
  label: '查看',
  value: AUTH_TYPE.READ_INST,
  theme: 'primary'
}, {
  label: '编辑',
  value: AUTH_TYPE.EDIT_INST,
  theme: 'primary'
}, {
  label: '挂起',
  value: AUTH_TYPE.HANGUP_INST,
  theme: 'warning'
}, {
  label: '终止',
  value: AUTH_TYPE.END_INST,
  theme: 'danger'
}, {
  label: '删除',
  value: AUTH_TYPE.DEL_INST,
  theme: 'danger'
}];
/* harmony default export */ var flow_instancesvue_type_script_lang_js_ = ({
  name: 'flow-instances',
  props: {
    rolePlatformType: {
      type: String,
      default: 'ASSP'
    },
    tenantId: {
      type: String,
      default: 'ASSP'
    },
    isSuspend: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canViewDiagram: {
      type: Boolean,
      default: false
    },
    canStop: {
      type: Boolean,
      default: false
    },
    simpleSearch: {
      type: Boolean,
      default: false
    },
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    },
    isRouterDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DynamicDialog: DynamicDialog["default"]
  },
  filters: {
    formatDate: utils["a" /* default */].formatDate,
    authLabel(auth, activate) {
      if (auth === 'HANGUP_INST') {
        return activate ? '挂起' : '激活';
      }
      let authTypeObj = authTypeObjList.find(item => item.value === auth);
      return authTypeObj ? authTypeObj.label : auth;
    },
    authTheme(auth, activate) {
      if (auth === 'HANGUP_INST') {
        return activate ? 'danger' : 'success';
      }
      let authTypeObj = authTypeObjList.find(item => item.value === auth);
      return authTypeObj ? authTypeObj.theme : '';
    }
  },
  data() {
    return {
      ...AUTH_TYPE,
      data: [],
      platformList: [],
      total: 0,
      rangeTime: null,
      params: {
        startTime: '',
        endTime: '',
        id: '',
        name: '',
        modelKey: '',
        rolePlatformType: '',
        pageNo: 1,
        pageSize: 20,
        orderDescs: [{
          col: 'startTime',
          desc: true
        }]
      },
      canSave: false
    };
  },
  methods: {
    reload(params = {}) {
      this.params.pageNo = 1;
      this.loadData(params);
    },
    // 加载流程列表
    async loadData(params = {}) {
      params.rolePlatformType = this.rolePlatformType || '';
      params.tenantId = this.tenantId;
      const option = Object.assign(this.params, params);
      delete option.total;
      const loading = this.$loading();
      const {
        status,
        data
      } = await processInstance["a" /* default */].pageFindManagementInstanceByCriteria(option).finally(() => loading.close());
      if (status) {
        this.data = data.records;
        this.total = data.total;
      }
    },
    dynamicDialogShow({
      id,
      processDefinitionId,
      activable,
      businessKey
    }, auth) {
      switch (auth) {
        case AUTH_TYPE.READ_INST:
          this.canSave = false;
          if (!this.isRouterDetail || !request_utils["c" /* hasHandleToEmit */].call(this, constants["m" /* HANDLE_ROUTER */], {
            id,
            businessKey,
            processDefinitionId,
            activable
          })) {
            this.$refs.dynamicDialog.show({
              id,
              businessKey,
              readOnly: true,
              hiddenAssignee: this.hiddenAssignee,
              hiddenComment: this.hiddenComment
            });
          }
          break;
        case AUTH_TYPE.EDIT_INST:
          this.canSave = true;
          if (!this.isRouterDetail || !request_utils["c" /* hasHandleToEmit */].call(this, constants["m" /* HANDLE_ROUTER */], {
            id,
            businessKey,
            processDefinitionId,
            activable
          })) {
            this.$refs.dynamicDialog.show({
              id,
              businessKey,
              readOnly: false,
              hiddenAssignee: this.hiddenAssignee,
              hiddenComment: this.hiddenComment
            });
          }
          break;
        case AUTH_TYPE.DEL_INST:
          // 删除
          this.executeRequest('softDelete', id, '删除');
          break;
        case AUTH_TYPE.END_INST:
          // 终止
          this.executeRequest('stop', id, '终止');
          break;
        case AUTH_TYPE.HANGUP_INST:
          // 挂起
          this.executeRequest(!activable ? 'suspend' : 'activate', id, !activable ? '挂起' : '激活');
          break;
        default:
          break;
      }
    },
    async executeRequest(API_TYPE, processInstanceId, message) {
      const confirm = await this.$confirm(`正在进行${message}操作！`, '温馨提示').catch(() => {});
      if (confirm === 'confirm') {
        const {
          status,
          message
        } = await processInstance["a" /* default */][API_TYPE]({
          processInstanceId
        });
        if (status) {
          this.loadData();
          request_utils["a" /* doHandleToEmitOrToast */].call(this, 'handle-success', 'success', '操作成功');
        } else {
          request_utils["a" /* doHandleToEmitOrToast */].call(this, 'handle-error', 'error', message || constants["B" /* UNKNOWN_ERROR */].message);
        }
      }
    },
    handleSizeChange(size) {
      this.params.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo;
      this.loadData();
    },
    async getPlatformList() {
      const {
        status,
        data
      } = await uc["a" /* default */].getDictPowerPlatformListToUser();
      if (status) {
        this.platformList = data;
      }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      let now = new Date();
      let nowYear = now.getFullYear();
      let nowMonth = now.getMonth();
      this.params.startTime = new Date(nowYear, nowMonth, 1).getTime();
      this.params.endTime = new Date(nowYear, nowMonth + 1, 0).getTime() + 86399000;
      this.rangeTime = [this.params.startTime, this.params.endTime];
      this.loadData();
    }
  },
  mounted() {
    this.resetForm();
    this.getPlatformList();
  }
});
// CONCATENATED MODULE: ./src/components/instance/flow-instances.vue?vue&type=script&lang=js&
 /* harmony default export */ var instance_flow_instancesvue_type_script_lang_js_ = (flow_instancesvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/instance/flow-instances.vue





/* normalize component */

var flow_instances_component = Object(componentNormalizer["a" /* default */])(
  instance_flow_instancesvue_type_script_lang_js_,
  flow_instancesvue_type_template_id_ea3eb19c_render,
  flow_instancesvue_type_template_id_ea3eb19c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var flow_instances = (flow_instances_component.exports);
// EXTERNAL MODULE: ./src/components/dialog/FlowInstanceDetailDialog.vue + 11 modules
var FlowInstanceDetailDialog = __webpack_require__("9d19");

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/flow-tasks.vue?vue&type=template&id=50489b64&
var flow_tasksvue_type_template_id_50489b64_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-tasks-list"},[_c('div',[_c('el-tabs',{on:{"tab-click":_vm.handleTabClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"待办任务","name":"todo"}}),_c('el-tab-pane',{attrs:{"label":"传阅任务","name":"toread"}}),_c('el-tab-pane',{attrs:{"label":"任务移交","name":"tasktransfer"}})],1)],1),(_vm.activeName == 'todo' || _vm.activeName == 'toread')?_c('div',[_c('el-form',{ref:"ruleForm",attrs:{"model":_vm.params}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',[_c('el-date-picker',{staticClass:"input-with-select",staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择开始时间","type":"daterange","value-format":"timestamp","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","clearable":""},on:{"change":function (time) {
                  if (Array.isArray(time)) {
                    _vm.reload({ startDt: time[0], endDt: time[1] + 86399000 })
                  } else {
                    _vm.reload({ startDt: null, endDt: null })
                  }
                }},model:{value:(_vm.rangeTime),callback:function ($$v) {_vm.rangeTime=$$v},expression:"rangeTime"}})],1)],1),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"prop":"processInstanceName"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"请输入标题关键字","clearable":""},on:{"change":function (processInstanceName) { return _vm.reload({ processInstanceName: processInstanceName }); },"clear":_vm.reload},model:{value:(_vm.params.processInstanceName),callback:function ($$v) {_vm.$set(_vm.params, "processInstanceName", $$v)},expression:"params.processInstanceName"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"processInstanceId"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"请输入编码精确查询","clearable":""},on:{"change":function (processInstanceId) { return _vm.reload({ processInstanceId: processInstanceId }); },"clear":_vm.reload},model:{value:(_vm.params.processInstanceId),callback:function ($$v) {_vm.$set(_vm.params, "processInstanceId", $$v)},expression:"params.processInstanceId"}})],1)],1)],1),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"userName"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":("请输入" + (_vm.activeName == 'todo' ? '待审批' : '待阅') + "人关键字"),"clearable":""},on:{"change":function (userName) { return _vm.reload({ userName: userName }); },"clear":_vm.reload},model:{value:(_vm.params.userName),callback:function ($$v) {_vm.$set(_vm.params, "userName", $$v)},expression:"params.userName"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"processDefinitionId"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"请输入流程定义编码精确查询","clearable":""},on:{"change":function (processDefinitionId) { return _vm.reload({ processDefinitionId: processDefinitionId }); },"clear":_vm.reload},model:{value:(_vm.params.processDefinitionId),callback:function ($$v) {_vm.$set(_vm.params, "processDefinitionId", $$v)},expression:"params.processDefinitionId"}})],1)],1),_c('el-col',{attrs:{"span":6}},[(_vm.activeName == 'todo')?_c('el-form-item',{attrs:{"prop":"activityId"}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"请输入节点编码精确查询","clearable":""},on:{"change":function (activityId) { return _vm.reload({ activityId: activityId }); },"clear":_vm.reload},model:{value:(_vm.params.activityId),callback:function ($$v) {_vm.$set(_vm.params, "activityId", $$v)},expression:"params.activityId"}})],1):_vm._e()],1),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-button',{attrs:{"plain":"","type":"primary"},on:{"click":_vm.reload}},[_vm._v("搜索")]),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"导出审批中单据的任务处理记录","placement":"top"}},[_c('el-button',{attrs:{"type":"primary","plain":"","loading":_vm.exportLoading},on:{"click":_vm.exportAllInfo}},[_vm._v("导出")])],1)],1)])],1)],1),_c('op-table',{ref:"taskTable",attrs:{"data":_vm.data}},[_c('op-column',{attrs:{"type":"index","width":"50","align":"center","label":"序号","fixed":"left"}}),_c('op-column',{attrs:{"prop":"processInstanceName","label":"标题","fixed":"left","min-width":400},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var row = ref.row;
return [_c('el-link',{attrs:{"type":"primary","title":"查看详情"},on:{"click":function($event){return _vm.handleDealTask(row)}}},[_vm._v(_vm._s(row.processInstanceName))])]}}],null,false,2551581128)}),_c('op-column',{attrs:{"prop":"processInstanceId","width":"160","label":"编号"}}),_c('op-column',{attrs:{"prop":"processDefinitionName","label":"流程定义名称","width":"200","sortable":true}}),_c('op-column',{attrs:{"prop":"processDefinitionId","label":"流程定义编码","width":"180","showTooltip":true,"sortable":true}}),(_vm.activeName == 'todo')?_c('op-column',{attrs:{"prop":"taskName","label":"当前节点名称","width":"140","sortable":true}}):_vm._e(),(_vm.activeName == 'todo')?_c('op-column',{attrs:{"prop":"activityId","label":"当前节点编码","width":"120","sortable":true}}):_vm._e(),(_vm.activeName == 'todo')?_c('op-column',{attrs:{"prop":"userName","label":"待审批人","width":"120","sortable":true}}):_vm._e(),(_vm.activeName == 'toread')?_c('op-column',{attrs:{"prop":"toReadTaskCreatorName","label":"发起传阅人","width":"160","sortable":true}}):_vm._e(),(_vm.activeName == 'toread')?_c('op-column',{attrs:{"prop":"userName","label":"待阅人","width":"160","sortable":true}}):_vm._e(),_c('op-column',{attrs:{"prop":"type","label":"任务类型","width":"100","sortable":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var row = ref.row;
return [_c('el-tag',{attrs:{"type":_vm._f("taskStatus")(row.type)}},[_vm._v("\n            "+_vm._s(_vm._f("taskType")(row.type))+"\n          ")])]}}],null,false,1305556130)}),_c('op-column',{attrs:{"prop":"startTime","label":"任务到达时间","width":"160","sortable":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var row = ref.row;
return [_vm._v("\n          "+_vm._s(_vm._f("formatDate")(row.createDt))+"\n        ")]}}],null,false,3218098277)}),_c('op-column',{attrs:{"width":"180px","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var row = ref.row;
return [_vm._l((row.authList),function(auth){return [(row.type === 'TO_DO')?_c('el-button',{key:auth,staticStyle:{"margin":"5px"},attrs:{"size":"mini","type":"primary","plain":""},on:{"click":function($event){return _vm.executeAction(row, auth)}}},[_vm._v(_vm._s(_vm._f("authName")(auth)))]):_vm._e()]})]}}],null,false,1093350438)})],1),_c('el-pagination',{staticStyle:{"text-align":"right"},attrs:{"current-page":_vm.params.pageNo,"page-sizes":[20, 50, 100],"page-size":_vm.params.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e(),(_vm.activeName == 'tasktransfer')?_c('div',[_c('task-transfer',{ref:"taskTransfer",attrs:{"rolePlatformType":_vm.rolePlatformType,"tenantId":_vm.tenantId,"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment,"canAddTransfer":_vm.canAddTransfer}})],1):_vm._e(),_c('dynamic-dialog',{ref:"dynamicDialog_TO_DO",attrs:{"title":"待办任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_TO_READ",attrs:{"title":"传阅任务详情","componentId":"FlowTaskToReadDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COUNTERSIGN",attrs:{"title":"会签任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COMMUNICATING",attrs:{"title":"沟通任务详情","componentId":"FlowTaskTodoDetail"}}),_c('update-next-user-dialog',{ref:"updateNextUserDialog",on:{"update":_vm.loadData}})],1)}
var flow_tasksvue_type_template_id_50489b64_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/flow-tasks.vue?vue&type=template&id=50489b64&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/UpdateNextUserDialog.vue?vue&type=template&id=4cb8044c&scoped=true&
var UpdateNextUserDialogvue_type_template_id_4cb8044c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.editDialogVisible,"title":"更改执行人","width":"30vw","append-to-body":""},on:{"update:visible":function($event){_vm.editDialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.close}},[_vm._v("关闭")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmUser}},[_vm._v("确定")])]},proxy:true}])},[_c('el-form',{directives:[{name:"form",rawName:"v-form"}],staticStyle:{"padding":"10px 30px"}},[_c('el-form-item',{attrs:{"label-width":"60px","label":"执行人"}},[_c('op-user-selector',{staticClass:"user-input",attrs:{"appendToBody":true,"single":false,"config":{ id: 'user.id', account: 'user.account' }},on:{"onConfirm":_vm.onConfirmSelector},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1)],1)],1)}
var UpdateNextUserDialogvue_type_template_id_4cb8044c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/UpdateNextUserDialog.vue?vue&type=template&id=4cb8044c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/UpdateNextUserDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UpdateNextUserDialogvue_type_script_lang_js_ = ({
  name: 'UpdateNextUserDialog',
  data() {
    return {
      editDialogVisible: false,
      currentTask: null,
      agentUserList: [],
      user: {
        name: '',
        id: '',
        account: ''
      }
    };
  },
  directives: {
    // 表单指令，会在表单的vue实例上添加一个map，用以存放数学运算的表达式
    form: {
      bind: function (el, binding, vnode) {
        const inst = vnode.context;
        // eslint-disable-next-line no-prototype-builtins
        if (inst && !inst.hasOwnProperty('watchMap')) {
          inst['watchMap'] = new Map();
        }
      }
    }
  },
  methods: {
    init() {
      this.user = {
        name: '',
        id: '',
        account: ''
      };
      this.agentUserList = [];
    },
    show(currentTask) {
      this.editDialogVisible = true;
      this.currentTask = currentTask;
      this.agentUserList = [];
    },
    async confirmUser() {
      if (!this.currentTask) return;
      if (!this.agentUserList.length) return this.$message.warning('请选择指定人！');
      const loading = this.$loading();
      const {
        status,
        message
      } = await task["a" /* default */].changeAssignee({
        agentUserList: this.agentUserList,
        taskId: this.currentTask.taskId
      }).finally(() => loading.close());
      if (!status) return this.$message.error(message);
      if (status) this.init();
      this.$message.success('更改成功！');
      this.$emit('update');
      this.editDialogVisible = false;
    },
    close() {
      this.init();
      this.editDialogVisible = false;
    },
    onConfirmSelector(agentUserList) {
      if (!agentUserList || !Array.isArray(agentUserList)) return;
      this.agentUserList = agentUserList.map(user => {
        return {
          userId: user.id,
          name: user.name
        };
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/UpdateNextUserDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_UpdateNextUserDialogvue_type_script_lang_js_ = (UpdateNextUserDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/UpdateNextUserDialog.vue?vue&type=style&index=0&id=4cb8044c&prod&scoped=true&lang=css&
var UpdateNextUserDialogvue_type_style_index_0_id_4cb8044c_prod_scoped_true_lang_css_ = __webpack_require__("88c7");

// CONCATENATED MODULE: ./src/components/task/UpdateNextUserDialog.vue






/* normalize component */

var UpdateNextUserDialog_component = Object(componentNormalizer["a" /* default */])(
  task_UpdateNextUserDialogvue_type_script_lang_js_,
  UpdateNextUserDialogvue_type_template_id_4cb8044c_scoped_true_render,
  UpdateNextUserDialogvue_type_template_id_4cb8044c_scoped_true_staticRenderFns,
  false,
  null,
  "4cb8044c",
  null
  
)

/* harmony default export */ var UpdateNextUserDialog = (UpdateNextUserDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/TaskTransfer.vue?vue&type=template&id=118532a0&
var TaskTransfervue_type_template_id_118532a0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"ruleForm",attrs:{"model":_vm.params},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-row',{attrs:{"gutter":20}},[(_vm.firstMounted)?_c('el-col',{attrs:{"span":6}},[_c('el-form-item',[_c('op-classify-select',{attrs:{"multiple":false},model:{value:(_vm.params.marketClassify),callback:function ($$v) {_vm.$set(_vm.params, "marketClassify", $$v)},expression:"params.marketClassify"}})],1)],1):_vm._e(),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"processInstanceName"}},[_c('el-input',{attrs:{"placeholder":"请输入移交人、被移交人关键字","clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reload.apply(null, arguments)}},model:{value:(_vm.params.searchKeyWord),callback:function ($$v) {_vm.$set(_vm.params, "searchKeyWord", $$v)},expression:"params.searchKeyWord"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.reload}},[_vm._v("查询")]),_c('el-button',{attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.exportOut}},[_vm._v("导出")]),(_vm.canAddTransfer)?_c('el-button',{attrs:{"size":"small","plain":"","type":"primary","icon":"el-icon-plus"},on:{"click":_vm.add}},[_vm._v("添加")]):_vm._e()],1)],1)],1),_c('op-table',{ref:"taskTable",attrs:{"data":_vm.data,"stripe":"","border":"","height":"490","size":"small"}},[_c('op-column',{attrs:{"type":"index","width":"60","align":"center","label":"序号","fixed":"left"}}),_c('op-column',{attrs:{"prop":"marketClassifyName","label":"所属事业线"}}),_c('op-column',{attrs:{"prop":"toBeTransitionUserName","label":"移交人"}}),_c('op-column',{attrs:{"prop":"receiverName","label":"接收人"}}),_c('op-column',{attrs:{"prop":"creator","label":"操作人"}}),_c('op-column',{attrs:{"prop":"createDt","label":"移交时间"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n        "+_vm._s(_vm._f("formatDate")(row.createDt))+"\n      ")]}}])}),_c('op-column',{attrs:{"prop":"reason","label":"移交原因"}}),_c('op-column',{attrs:{"label":"操作","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.toDetail(row)}}},[_vm._v("移交明细")])]}}])})],1),_c('el-pagination',{staticStyle:{"text-align":"right"},attrs:{"current-page":_vm.params.pageNo,"page-sizes":[20, 50, 100],"page-size":_vm.params.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}}),_c('add-task-transfer-dialog',{ref:"addTaskTransferDialog",attrs:{"rolePlatformType":_vm.rolePlatformType,"tenantId":_vm.tenantId,"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment},on:{"handleSuccess":_vm.reload}}),_c('detail-task-transfer-dialog',{ref:"detailTaskTransferDialog",attrs:{"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment}})],1)}
var TaskTransfervue_type_template_id_118532a0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/TaskTransfer.vue?vue&type=template&id=118532a0&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/AddTaskTransferDialog.vue?vue&type=template&id=3b078bf8&
var AddTaskTransferDialogvue_type_template_id_3b078bf8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"add-task-transfer-dialog",attrs:{"visible":_vm.dialogVisible,"title":"添加任务移交","width":"90%","append-to-body":"","before-close":_vm.close},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.close}},[_vm._v("关闭")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v("移交")])]},proxy:true}])},[_c('el-container',[_c('el-container',[_c('el-header',{staticClass:"middle-header"},[_c('el-form',{ref:"taskForm",attrs:{"model":_vm.params},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-row',{attrs:{"gutter":20}},[(_vm.dialogVisible)?_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"required":"","label":"移交人","label-width":"100px"}},[_c('op-user-selector',{staticClass:"user-input",attrs:{"appendToBody":true,"single":true,"leave":"","config":{ id: 'user.id', account: 'user.account' }},on:{"onConfirm":_vm.onConfirmSelector},model:{value:(_vm.params.userName),callback:function ($$v) {_vm.$set(_vm.params, "userName", $$v)},expression:"params.userName"}})],1)],1):_vm._e(),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"prop":"processInstanceId"}},[_c('el-input',{attrs:{"placeholder":"请输入编码精确查询","clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reload.apply(null, arguments)}},model:{value:(_vm.params.processInstanceId),callback:function ($$v) {_vm.$set(_vm.params, "processInstanceId", $$v)},expression:"params.processInstanceId"}})],1)],1),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"prop":"processInstanceName"}},[_c('el-input',{attrs:{"placeholder":"请输入标题关键字","clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reload.apply(null, arguments)}},model:{value:(_vm.params.processInstanceName),callback:function ($$v) {_vm.$set(_vm.params, "processInstanceName", $$v)},expression:"params.processInstanceName"}})],1)],1),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"processDefinitionName","label-width":"100px"}},[_c('el-input',{attrs:{"placeholder":"请输入流程定义关键字","clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reload.apply(null, arguments)}},model:{value:(_vm.params.processDefinitionName),callback:function ($$v) {_vm.$set(_vm.params, "processDefinitionName", $$v)},expression:"params.processDefinitionName"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.reload}},[_vm._v("查询")])],1)],1)],1)],1),_c('el-main',{staticStyle:{"padding":"0"}},[(_vm.dialogVisible)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"selectorTable",staticClass:"selector-table",attrs:{"data":_vm.data,"stripe":"","border":"","height":"490","row-key":function (row) { return row.id; },"size":"small"},on:{"select":_vm.handleTableSelect,"select-all":_vm.handleTableSelect}},[_c('el-table-column',{attrs:{"type":"selection","align":"center","width":"45"}}),_c('el-table-column',{attrs:{"type":"index","width":"60","align":"center","label":"序号","fixed":"left"}}),_c('el-table-column',{attrs:{"prop":"processInstanceName","label":"流程标题","align":"center","min-width":300},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-link',{attrs:{"type":"primary","title":"查看详情"},on:{"click":function($event){return _vm.dynamicDialogShow(row)}}},[_vm._v(_vm._s(row.processInstanceName))])]}}],null,false,3075725085)}),_c('el-table-column',{attrs:{"prop":"processInstanceId","align":"center","label":"编号"}}),_c('el-table-column',{attrs:{"prop":"taskName","align":"center","label":"当前节点名称"}}),_c('el-table-column',{attrs:{"prop":"processDefinitionName","align":"center","label":"流程定义名称","width":"220"}}),_c('el-table-column',{attrs:{"prop":"type","align":"center","label":"任务类型"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-tag',{attrs:{"type":_vm._f("taskStatus")(row.type)}},[_vm._v("\n                "+_vm._s(_vm._f("taskType")(row.type))+"\n              ")])]}}],null,false,2670654626)})],1):_vm._e()],1),_c('el-footer',{attrs:{"height":"50px"}},[_c('el-pagination',{staticStyle:{"text-align":"right"},attrs:{"current-page":_vm.params.pageNo,"page-sizes":[20, 50, 100],"page-size":_vm.params.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_c('el-aside',{staticClass:"select-aside",attrs:{"width":"280px"}},[_c('el-header',{staticClass:"select-header"},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("已选择")])]),_c('div',{staticClass:"select-tree-div"},_vm._l((_vm.selects),function(item){return _c('el-tag',{key:item.id,staticClass:"item",attrs:{"closable":""},on:{"close":function($event){return _vm.removeItem(item)}}},[_vm._v(_vm._s(item.id + '-' + item.taskName))])}),1)],1)],1),_c('task-transfer-user-dialog',{ref:"taskTransferUserDialog",on:{"handleSuccess":_vm.handleSuccess}}),_c('dynamic-dialog',{ref:"dynamicDialog_TO_DO",attrs:{"title":"待办任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_TO_READ",attrs:{"title":"传阅任务详情","componentId":"FlowTaskToReadDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COUNTERSIGN",attrs:{"title":"会签任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COMMUNICATING",attrs:{"title":"沟通任务详情","componentId":"FlowTaskTodoDetail"}})],1)}
var AddTaskTransferDialogvue_type_template_id_3b078bf8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/AddTaskTransferDialog.vue?vue&type=template&id=3b078bf8&

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/TaskTransferUserDialog.vue?vue&type=template&id=4ca6328d&scoped=true&
var TaskTransferUserDialogvue_type_template_id_4ca6328d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"title":"批量移交单据","width":"500px","append-to-body":"","before-close":_vm.close},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.close}},[_vm._v("关闭")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmUser}},[_vm._v("确定")])]},proxy:true}])},[_c('el-form',{ref:"taskForm",staticStyle:{"padding":"10px 30px"},attrs:{"model":_vm.params,"rules":_vm.rules}},[(_vm.dialogVisible)?_c('el-form-item',{attrs:{"label-width":"100px","label":"接收人","prop":"userName"}},[_c('op-user-selector',{staticClass:"user-input",attrs:{"appendToBody":true,"single":true,"config":{ id: 'user.id', account: 'user.account' }},on:{"onConfirm":_vm.onConfirmSelector},model:{value:(_vm.params.userName),callback:function ($$v) {_vm.$set(_vm.params, "userName", $$v)},expression:"params.userName"}})],1):_vm._e(),_c('el-form-item',{attrs:{"label-width":"100px","label":"移交原因","prop":"reason"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 3, maxRows: 5 },"placeholder":"请输入标题关键字","maxlength":"100","show-word-limit":"","clearable":""},model:{value:(_vm.params.reason),callback:function ($$v) {_vm.$set(_vm.params, "reason", $$v)},expression:"params.reason"}})],1)],1)],1)}
var TaskTransferUserDialogvue_type_template_id_4ca6328d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/TaskTransferUserDialog.vue?vue&type=template&id=4ca6328d&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/TaskTransferUserDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TaskTransferUserDialogvue_type_script_lang_js_ = ({
  name: 'task-transfer-user-dialog',
  data() {
    return {
      dialogVisible: false,
      params: {
        userName: '',
        reason: ''
      },
      user: {},
      transferInfo: {},
      rules: {
        userName: [{
          required: true,
          message: '请选择接收人'
        }],
        reason: [{
          required: true,
          message: '请填写移交原因',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    reset() {
      this.user = {};
      this.params = {
        userName: '',
        reason: ''
      };
    },
    show(data) {
      this.dialogVisible = true;
      this.transferInfo = data;
    },
    confirmUser() {
      this.$refs['taskForm'].validate(async valid => {
        if (valid) {
          if (this.transferInfo.user.id == this.user.id) {
            this.$message.error('操作失败，移交人和接收人不能是同一人！');
            return;
          }
          const params = {
            toBeTransitionUserName: this.transferInfo.user.name,
            toBeTransitionUserId: this.transferInfo.user.id,
            receiverId: this.user.id,
            receiverName: this.user.name,
            reason: this.params.reason,
            taskIdList: this.transferInfo.selects.map(item => item.id)
          };
          const loading = this.$loading();
          const {
            status,
            message,
            data
          } = await task["a" /* default */].taskTransfer(params).finally(() => loading.close());
          if (!status) return this.$message.error(message);
          if (status) this.reset();
          const total = params.taskIdList.length;
          if (data && data.failureCount > 0 && data.successfulCount > 0) {
            let msg = '部分任务移交成功<br>';
            for (let i = 0; i < data.failureReasons.length; i++) {
              msg += data.failureReasons[i] + '<br>';
            }
            this.$message({
              message: msg,
              dangerouslyUseHTMLString: true,
              type: 'warning',
              duration: 5000
            });
          } else if (total == data.successfulCount) {
            this.$message.success('批量移交成功！');
          } else {
            let msg = '任务移交失败<br>';
            for (let i = 0; i < data.failureReasons.length; i++) {
              msg += data.failureReasons[i] + '<br>';
            }
            this.$message({
              message: msg,
              dangerouslyUseHTMLString: true,
              type: 'error',
              duration: 5000
            });
          }
          this.$emit('handleSuccess');
          this.dialogVisible = false;
        }
      });
    },
    close() {
      this.reset();
      this.dialogVisible = false;
    },
    onConfirmSelector(user) {
      if (!user || !Array.isArray(user)) return;
      this.user = user[0];
      this.params.userName = this.user.name;
      this.$refs['taskForm'].validateField('userName');
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/TaskTransferUserDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_TaskTransferUserDialogvue_type_script_lang_js_ = (TaskTransferUserDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/TaskTransferUserDialog.vue?vue&type=style&index=0&id=4ca6328d&prod&scoped=true&lang=css&
var TaskTransferUserDialogvue_type_style_index_0_id_4ca6328d_prod_scoped_true_lang_css_ = __webpack_require__("45ba");

// CONCATENATED MODULE: ./src/components/task/TaskTransferUserDialog.vue






/* normalize component */

var TaskTransferUserDialog_component = Object(componentNormalizer["a" /* default */])(
  task_TaskTransferUserDialogvue_type_script_lang_js_,
  TaskTransferUserDialogvue_type_template_id_4ca6328d_scoped_true_render,
  TaskTransferUserDialogvue_type_template_id_4ca6328d_scoped_true_staticRenderFns,
  false,
  null,
  "4ca6328d",
  null
  
)

/* harmony default export */ var TaskTransferUserDialog = (TaskTransferUserDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/AddTaskTransferDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var AddTaskTransferDialogvue_type_script_lang_js_ = ({
  name: 'add-task-transfer-dialog',
  props: {
    rolePlatformType: {
      type: String,
      default: 'ASSP'
    },
    tenantId: {
      type: String,
      default: 'ASSP'
    },
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: [],
      formatDate: utils["a" /* default */].formatDate,
      total: 0,
      selects: [],
      loading: false,
      dialogVisible: false,
      user: {},
      params: {
        userName: '',
        processInstanceId: '',
        processInstanceName: '',
        processDefinitionName: '',
        pageNo: 1,
        pageSize: 20,
        orderDescs: [{
          col: 'createDt',
          desc: true
        }]
      }
    };
  },
  components: {
    TaskTransferUserDialog: TaskTransferUserDialog,
    DynamicDialog: DynamicDialog["default"]
  },
  computed: {
    curSelectedRowIds() {
      if (this.selects && this.selects.length > 0) {
        return this.selects.map(item => item.id);
      } else {
        return [];
      }
    }
  },
  filters: {
    taskType(val) {
      const types = {
        TO_READ: '传阅',
        TO_DO: '待办',
        COMMUNICATION: '沟通',
        COMMUNICATING: '沟通中',
        COUNTERSIGN: '会签'
      };
      return types[val] || val;
    },
    taskStatus(val) {
      const types = {
        TO_READ: 'primary',
        COMMUNICATION: 'primary',
        TO_DO: 'success'
      };
      return types[val] || val;
    }
  },
  methods: {
    handleSuccess() {
      this.close();
      this.$emit('handleSuccess');
    },
    show() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.reset();
    },
    confirm() {
      if (!this.params.userName) {
        this.$message.warning('请选择移交人！');
        return;
      }
      if (!this.selects || this.selects.length == 0) {
        this.$message.warning('请勾选需要移交任务！');
        return;
      }
      this.$refs.taskTransferUserDialog.show({
        user: this.user,
        selects: this.selects
      });
    },
    reset() {
      this.selects = [];
      this.user = {};
      this.syncCheckedStatus();
      this.data = [];
      this.total = 0;
      this.params.pageNo = 1;
      this.params.userName = '';
      this.params.processInstanceId = '';
      this.params.processInstanceName = '';
      this.params.processDefinitionName = '';
    },
    onConfirmSelector(user) {
      if (!user || !Array.isArray(user)) return;
      this.user = user[0];
      this.params.userName = this.user.name;
      this.reload();
    },
    reload() {
      this.params.pageNo = 1;
      this.loadData();
    },
    async loadData() {
      if (!this.params.userName) {
        this.$message.warning('请选择移交人！');
        return;
      }
      this.loading = true;
      const option = {
        ...this.params
      };
      option.rolePlatformType = this.rolePlatformType;
      option.tenantId = this.tenantId;
      let res = await task["a" /* default */].taskPageManage(option).finally(() => this.loading = false);
      let {
        status,
        data
      } = res;
      if (status) {
        this.data = data.records;
        this.total = data.total;
        this.syncCheckedStatus();
      }
    },
    handleSizeChange(size) {
      this.params.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo;
      this.loadData();
    },
    removeItem(item) {
      this.selects.remove(item);
      this.syncCheckedStatus();
    },
    handleTableSelect() {
      this.syncSelection2selects();
    },
    syncSelection2selects() {
      let selectorTable = this.$refs.selectorTable;
      // 复制一份当前已选数据
      let tmpSelects = [...this.selects];
      // 先将当前页中的数据从已选数据中移除
      // fixed Array.prototype.remove 补丁时效bug，原因是 item object 不相等，返回索引均为-1
      const __remove = function (list, item) {
        let index = list.findIndex(v => v.id === item.id);
        if (index > -1) {
          list.splice(index, 1);
        }
        return list;
      };
      this.data.forEach(m => {
        tmpSelects = __remove(tmpSelects, m);
      });
      // 将剩余的已选数据与当前页选中的数据合并
      tmpSelects = [...tmpSelects, ...selectorTable.selection];
      // 数组去重
      this.selects = tmpSelects.unique('id');
    },
    // 同步已选数据在Table中的选中状态
    syncCheckedStatus() {
      let selectorTable = this.$refs.selectorTable;
      if (!selectorTable || !selectorTable.selection) {
        throw '未获取到数据列表，无法选择数据。';
      }
      selectorTable.clearSelection();
      this.selects.length > 0 && this.$nextTick(() => {
        this.data.some(n => {
          if (this.curSelectedRowIds.indexOf(n.id) > -1) {
            selectorTable.toggleRowSelection(n, true);
          }
        });
      });
    },
    dynamicDialogShow(row) {
      this.$refs[`dynamicDialog_${row.type}`].show({
        detail: row,
        hiddenAssignee: this.hiddenAssignee,
        hiddenComment: this.hiddenComment
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/AddTaskTransferDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_AddTaskTransferDialogvue_type_script_lang_js_ = (AddTaskTransferDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/AddTaskTransferDialog.vue?vue&type=style&index=0&id=3b078bf8&prod&lang=postcss&
var AddTaskTransferDialogvue_type_style_index_0_id_3b078bf8_prod_lang_postcss_ = __webpack_require__("1721");

// CONCATENATED MODULE: ./src/components/task/AddTaskTransferDialog.vue






/* normalize component */

var AddTaskTransferDialog_component = Object(componentNormalizer["a" /* default */])(
  task_AddTaskTransferDialogvue_type_script_lang_js_,
  AddTaskTransferDialogvue_type_template_id_3b078bf8_render,
  AddTaskTransferDialogvue_type_template_id_3b078bf8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddTaskTransferDialog = (AddTaskTransferDialog_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/DetailTaskTransferDialog.vue?vue&type=template&id=27debcfc&
var DetailTaskTransferDialogvue_type_template_id_27debcfc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"detail-task-transfer-dialog",attrs:{"visible":_vm.dialogVisible,"title":"任务移交明细","width":"85%","append-to-body":"","before-close":_vm.close},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.close}},[_vm._v("关闭")])]},proxy:true}])},[_c('el-container',[_c('el-header',{staticClass:"middle-header"},[_c('el-form',{ref:"taskForm",attrs:{"model":_vm.params,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"移交人:","required":""}},[_c('div',[_vm._v(_vm._s(_vm.row.toBeTransitionUserName))])])],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"接收人:","required":""}},[_c('div',[_vm._v(_vm._s(_vm.row.receiverName))])])],1)],1),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"移交原因:","required":""}},[_c('div',[_vm._v(_vm._s(_vm.row.reason))])])],1)],1)],1)],1),_c('el-main',{staticStyle:{"padding":"0"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"table",attrs:{"data":_vm.data,"stripe":"","border":"","height":"490","size":"small"}},[_c('el-table-column',{attrs:{"type":"index","width":"60","align":"center","label":"序号","fixed":"left"}}),_c('el-table-column',{attrs:{"prop":"processInstanceName","label":"流程标题","align":"center","min-width":300},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-link',{attrs:{"type":"primary","title":"查看详情"},on:{"click":function($event){return _vm.dynamicDialogShow(row)}}},[_vm._v(_vm._s(row.processInstanceName))])]}}])}),_c('el-table-column',{attrs:{"prop":"processInstanceId","align":"center","label":"编号"}}),_c('el-table-column',{attrs:{"prop":"activityName","align":"center","label":"当前节点名称"}}),_c('el-table-column',{attrs:{"prop":"processDefinitionName","align":"center","label":"流程定义名称","width":"220"}}),_c('el-table-column',{attrs:{"prop":"type","align":"center","label":"任务类型"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-tag',{attrs:{"type":_vm._f("taskStatus")(row.type)}},[_vm._v("\n              "+_vm._s(_vm._f("taskType")(row.type))+"\n            ")])]}}])})],1)],1),_c('el-footer',{attrs:{"height":"50px"}},[_c('el-pagination',{staticStyle:{"text-align":"right"},attrs:{"current-page":_vm.params.pageNo,"page-sizes":[20, 50, 100],"page-size":_vm.params.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_c('dynamic-dialog',{ref:"dynamicDialog_TO_DO",attrs:{"title":"待办任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_TO_READ",attrs:{"title":"传阅任务详情","componentId":"FlowTaskToReadDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COUNTERSIGN",attrs:{"title":"会签任务详情","componentId":"FlowTaskTodoDetail"}}),_c('dynamic-dialog',{ref:"dynamicDialog_COMMUNICATING",attrs:{"title":"沟通任务详情","componentId":"FlowTaskTodoDetail"}})],1)}
var DetailTaskTransferDialogvue_type_template_id_27debcfc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/task/DetailTaskTransferDialog.vue?vue&type=template&id=27debcfc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/DetailTaskTransferDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DetailTaskTransferDialogvue_type_script_lang_js_ = ({
  name: 'detail-task-transfer-dialog',
  props: {
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: [],
      formatDate: utils["a" /* default */].formatDate,
      total: 0,
      loading: false,
      dialogVisible: false,
      row: {},
      params: {
        id: '',
        pageNo: 1,
        pageSize: 20
      }
    };
  },
  components: {
    DynamicDialog: DynamicDialog["default"]
  },
  filters: {
    taskType(val) {
      const types = {
        TO_READ: '传阅',
        TO_DO: '待办',
        COMMUNICATION: '沟通',
        COMMUNICATING: '沟通中',
        COUNTERSIGN: '会签'
      };
      return types[val.toUpperCase()] || val;
    },
    taskStatus(val) {
      const types = {
        TO_READ: 'primary',
        COMMUNICATION: 'primary',
        TO_DO: 'success'
      };
      return types[val] || val;
    }
  },
  methods: {
    show(data) {
      this.dialogVisible = true;
      this.row = data;
      this.params.relaTransitionTaskId = data.id;
      this.reload();
    },
    close() {
      this.dialogVisible = false;
      this.reset();
    },
    confirm() {},
    reset() {
      this.params.pageNo = 1;
      this.total = 0;
    },
    reload() {
      this.params.pageNo = 1;
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const option = {
        ...this.params
      };
      let res = await task["a" /* default */].taskTransferDetail(option).finally(() => this.loading = false);
      let {
        status,
        data
      } = res;
      if (status) {
        this.data = data.records;
        this.total = data.total;
      }
    },
    handleSizeChange(size) {
      this.params.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo;
      this.loadData();
    },
    dynamicDialogShow(row) {
      this.$refs[`dynamicDialog_${row.type}`].show({
        detail: row,
        hiddenAssignee: this.hiddenAssignee,
        hiddenComment: this.hiddenComment
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/DetailTaskTransferDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_DetailTaskTransferDialogvue_type_script_lang_js_ = (DetailTaskTransferDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/DetailTaskTransferDialog.vue?vue&type=style&index=0&id=27debcfc&prod&lang=css&
var DetailTaskTransferDialogvue_type_style_index_0_id_27debcfc_prod_lang_css_ = __webpack_require__("0dbf");

// CONCATENATED MODULE: ./src/components/task/DetailTaskTransferDialog.vue






/* normalize component */

var DetailTaskTransferDialog_component = Object(componentNormalizer["a" /* default */])(
  task_DetailTaskTransferDialogvue_type_script_lang_js_,
  DetailTaskTransferDialogvue_type_template_id_27debcfc_render,
  DetailTaskTransferDialogvue_type_template_id_27debcfc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DetailTaskTransferDialog = (DetailTaskTransferDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/TaskTransfer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var TaskTransfervue_type_script_lang_js_ = ({
  name: 'task-transfer',
  props: {
    rolePlatformType: {
      type: String,
      default: 'ASSP'
    },
    tenantId: {
      type: String,
      default: 'ASSP'
    },
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    },
    canAddTransfer: {
      // 添加移交权限
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      firstMounted: false,
      data: [],
      total: 0,
      params: {
        marketClassify: [],
        searchKeyWord: '',
        pageNo: 1,
        pageSize: 20
      }
    };
  },
  components: {
    AddTaskTransferDialog: AddTaskTransferDialog,
    DetailTaskTransferDialog: DetailTaskTransferDialog
  },
  filters: {
    formatDate: utils["a" /* default */].formatDate
  },
  async mounted() {
    await this.getDitByDitTypes();
    this.reload();
  },
  methods: {
    reload() {
      this.params.pageNo = 1;
      this.loadData();
    },
    async getDitByDitTypes() {
      let userInfo = JSON.parse(sessionStorage.getItem('currentUser'));
      if (userInfo.authorities.some(i => i.authority == 'marketClassifyManager')) {
        this.params.marketClassify = userInfo.attributes.businessLineId ? [userInfo.attributes.businessLineId] : [];
      } else {
        let res = await uc["a" /* default */].getDitByDitTypes({
          typeList: ['ROOT_market_classify']
        });
        this.params.marketClassify = res.ROOT_market_classify[0] ? [res.ROOT_market_classify[0].value] : [];
      }
      this.firstMounted = true;
    },
    async loadData() {
      const loading = this.$loading();
      const option = {
        ...this.params
      };
      if (option.marketClassify) {
        option.marketClassify = option.marketClassify[0];
      }
      let res = await task["a" /* default */].taskTransferPage(option).finally(() => loading.close());
      let {
        status,
        data
      } = res;
      if (status) {
        this.data = data.records;
        this.total = data.total;
      }
    },
    handleSizeChange(size) {
      this.params.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo;
      this.loadData();
    },
    // 导出
    async exportOut() {
      const loading = this.$loading();
      const option = {
        ...this.params
      };
      if (option.marketClassify) {
        option.marketClassify = option.marketClassify[0];
      }
      let flie = await task["a" /* default */].exportTaskTransferPage(option).finally(() => loading.close());
      Object(utils["b" /* downloadBlob */])(flie, '任务移交.xlsx');
    },
    add() {
      this.$refs.addTaskTransferDialog.show();
    },
    toDetail(row) {
      this.$refs.detailTaskTransferDialog.show(row);
    }
  }
});
// CONCATENATED MODULE: ./src/components/task/TaskTransfer.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_TaskTransfervue_type_script_lang_js_ = (TaskTransfervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/task/TaskTransfer.vue





/* normalize component */

var TaskTransfer_component = Object(componentNormalizer["a" /* default */])(
  task_TaskTransfervue_type_script_lang_js_,
  TaskTransfervue_type_template_id_118532a0_render,
  TaskTransfervue_type_template_id_118532a0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TaskTransfer = (TaskTransfer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/task/flow-tasks.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var flow_tasksvue_type_script_lang_js_ = ({
  name: 'flow-tasks',
  props: {
    rolePlatformType: {
      type: String,
      default: 'ASSP'
    },
    tenantId: {
      type: String,
      default: 'ASSP'
    },
    isSuspend: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canViewDiagram: {
      type: Boolean,
      default: false
    },
    canStop: {
      type: Boolean,
      default: false
    },
    simpleSearch: {
      type: Boolean,
      default: false
    },
    hiddenAssignee: {
      // 隐藏处理人
      type: Boolean,
      default: false
    },
    hiddenComment: {
      // 隐藏处理意见
      type: Boolean,
      default: false
    },
    canAddTransfer: {
      // 添加移交权限
      type: Boolean,
      default: false
    },
    // 外置处理任务方法，提供给业务系统引入时，重载READ_TASK逻辑
    handleTask: {
      type: Function | null,
      default: null
    }
  },
  components: {
    DynamicDialog: DynamicDialog["default"],
    UpdateNextUserDialog: UpdateNextUserDialog,
    TaskTransfer: TaskTransfer
  },
  filters: {
    formatDate: utils["a" /* default */].formatDate,
    taskType(val) {
      const types = {
        TO_READ: '传阅',
        TO_DO: '待办',
        COMMUNICATION: '沟通',
        COMMUNICATING: '沟通中',
        COUNTERSIGN: '会签'
      };
      return types[val] || val;
    },
    taskStatus(val) {
      const types = {
        TO_READ: 'primary',
        COMMUNICATION: 'primary',
        TO_DO: 'success'
      };
      return types[val] || val;
    },
    authName(auth) {
      switch (auth) {
        case 'READ_TASK':
          return '详情';
        case 'CHANGE_HANDLER_TASK':
          return '更改执行人';
        default:
          return auth;
      }
    }
  },
  data() {
    return {
      data: [],
      platformList: [],
      total: 0,
      rangeTime: null,
      exportLoading: false,
      params: {
        startDt: '',
        endDt: '',
        processInstanceName: '',
        taskId: '',
        processDefinitionId: '',
        userName: '',
        processInstanceId: '',
        activityId: '',
        pageNo: 1,
        pageSize: 20,
        orderDescs: [{
          col: 'createDt',
          desc: true
        }]
      },
      activeName: 'todo'
    };
  },
  methods: {
    handleTabClick() {
      this.$nextTick(() => {
        if (this.activeName != 'tasktransfer') {
          this.$refs.taskTable.handleResize();
          this.resetForm();
        }
      });
    },
    reload(params = {}) {
      this.params.pageNo = 1;
      this.loadData(params);
    },
    async exportAllInfo() {
      if (!this.params.startDt || !this.params.endDt) {
        this.$message.warning('请选择申报时间');
        return;
      }
      this.exportLoading = true;
      const _params = {
        ...this.params
      };
      _params.rolePlatformType = this.rolePlatformType;
      _params.tenantId = this.tenantId;
      delete _params.pageNo;
      delete _params.pageSize;
      const res = await task["a" /* default */].exportTaskCommitInfo(_params);
      this.exportLoading = false;
      // 当前时间生成yyyyMMdd格式的时间
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const nowDate = `${year}${month < 10 ? '0' + month : month}${day < 10 ? '0' + day : day}`;
      Object(tool["b" /* downloadFile */])(res, `代办任务${nowDate}.xlsx`);
    },
    // 加载流程列表
    async loadData(params = {}) {
      params.rolePlatformType = this.rolePlatformType;
      params.tenantId = this.tenantId;
      const option = Object.assign(this.params, params);
      delete option.total;
      const loading = this.$loading();
      let res;
      if (this.activeName == 'todo') {
        res = await task["a" /* default */].taskPageManage(option).finally(() => loading.close());
      } else {
        res = await task["a" /* default */].taskPageToReadManage(option).finally(() => loading.close());
      }
      let {
        status,
        data
      } = res;
      if (status) {
        this.data = data.records;
        this.total = data.total;
      }
    },
    handleDealTask(row) {
      if (this.handleTask) {
        this.handleTask(row);
      } else {
        this.dynamicDialogShow(row);
      }
    },
    dynamicDialogShow(row) {
      this.$refs[`dynamicDialog_${row.type}`].show({
        detail: row,
        hiddenAssignee: this.hiddenAssignee,
        hiddenComment: this.hiddenComment
      });
    },
    executeAction(row, type) {
      switch (type) {
        case 'READ_TASK':
          this.handleDealTask(row);
          break;
        case 'CHANGE_HANDLER_TASK':
          this.showUpdateNextUserDialog(row);
          break;
      }
    },
    showUpdateNextUserDialog(row) {
      this.$refs.updateNextUserDialog.show(row);
    },
    handleSizeChange(size) {
      this.params.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.params.pageNo = pageNo;
      this.loadData();
    },
    async getPlatformList() {
      const {
        status,
        data
      } = await uc["a" /* default */].getDictPowerPlatformListToUser();
      if (status) {
        this.platformList = data;
      }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      let now = new Date();
      let nowYear = now.getFullYear();
      let nowMonth = now.getMonth();
      this.params.startDt = new Date(nowYear, nowMonth, 1).getTime();
      this.params.endDt = new Date(nowYear, nowMonth + 1, 0).getTime() + 86399000;
      this.rangeTime = [this.params.startDt, this.params.endDt];
      this.$nextTick(() => {});
      this.loadData();
    }
  },
  mounted() {
    this.resetForm();
    eventBus["a" /* default */].$on('refresh', () => {
      this.loadData();
    });
  }
});
// CONCATENATED MODULE: ./src/components/task/flow-tasks.vue?vue&type=script&lang=js&
 /* harmony default export */ var task_flow_tasksvue_type_script_lang_js_ = (flow_tasksvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/task/flow-tasks.vue?vue&type=style&index=0&id=50489b64&prod&lang=scss&scope=true&
var flow_tasksvue_type_style_index_0_id_50489b64_prod_lang_scss_scope_true_ = __webpack_require__("5f57");

// CONCATENATED MODULE: ./src/components/task/flow-tasks.vue






/* normalize component */

var flow_tasks_component = Object(componentNormalizer["a" /* default */])(
  task_flow_tasksvue_type_script_lang_js_,
  flow_tasksvue_type_template_id_50489b64_render,
  flow_tasksvue_type_template_id_50489b64_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var flow_tasks = (flow_tasks_component.exports);
// EXTERNAL MODULE: ./src/components/dialog/FlowTaskTodoDetail.vue + 4 modules
var FlowTaskTodoDetail = __webpack_require__("a691");

// EXTERNAL MODULE: ./src/components/dialog/FlowTaskToReadDetail.vue + 4 modules
var FlowTaskToReadDetail = __webpack_require__("4386");

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/flow-instance-detail.vue?vue&type=template&id=5fbc17c8&scoped=true&
var flow_instance_detailvue_type_template_id_5fbc17c8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-instance-detail"},[_c('flow-instance-detail-dialog',{ref:"flowInstanceDetailDialog",attrs:{"hiddenAssignee":_vm.hiddenAssignee,"hiddenComment":_vm.hiddenComment,"inst-id":_vm.instId,"to-reader":_vm.toReader},on:{"handle-router":_vm.onRouter,"handle-error":_vm.onError,"handle-success":_vm.onSuccess}}),(_vm.footer)?_c('div',{staticClass:"footer"},[_c('el-button',{attrs:{"size":"mini","plain":""},on:{"click":_vm.back}},[_vm._v("返回")]),(!_vm.readOnly)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":_vm.submit}},[_vm._v("保存")]):_vm._e()],1):_vm._e()],1)}
var flow_instance_detailvue_type_template_id_5fbc17c8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/instance/flow-instance-detail.vue?vue&type=template&id=5fbc17c8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/flow-instance-detail.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @warning: 如果展示详情交互本身是路由切换，例如列表跳转到详情页面，则跳转带上路由模式的参数即可，路由自己获取当前实例$route对象
 * 如是弹窗模式，无路有切换，则需要使用使用组件模式prop传递参数
 * @description 流程实例详情，可操作保存表单编辑，可通过组件，或者作为路由目标页面
 *    -| 路由模式使用，系要query参数：
 *          -| id，required 实例id, 如果没有次确认一参数，则认为是组件模式
 *          -| formReadOnly，是否仅为查看模式，如果如果未查看模式，会隐藏保存按钮
 *          -| hiddenAssignee，是否隐藏处理记录处理人，false->0,true->1
 *          -| hiddenComment，是否隐藏处理记录意见，false->0,true->1
 *          -| toReader，是否显示右上角传阅按钮，false->0,true->1
 *          示例：https://xxx.com/instance/detail?id=712352798423326720&formReadOnly=0&hiddenAssignee=0&hiddenComment=0
 *   -| 组件模式， props参数
 *          -| instId，required 实例id,
 *          -| formReadOnly，是否仅为查看模式，如果如果未查看模式，会隐藏保存按钮
 *          -| hiddenAssignee，是否隐藏处理记录处理人，默认：false
 *          -| hiddenComment，是否隐藏处理记录意见，默认：false
 *          -| toReader，是否显示右上角传阅按钮，默认：false
 *          示例： <flow-instance-detail inst-id="709018478187061248" form-read-only hidden-assignee hidden-comment/>
 * @event handle-error, args: message, error-obj
 * @event handle-success, args: message
 * @event handle-back, args: 无，返回按钮，不监听默认$router.back()
 * @event handle-router, args: 无，返回按钮，不监听默认$router.back()
 *
 * */




/* harmony default export */ var flow_instance_detailvue_type_script_lang_js_ = ({
  name: 'flow-instance-detail',
  components: {
    FlowInstanceDetailDialog: FlowInstanceDetailDialog["default"]
  },
  props: {
    instId: String,
    footer: {
      type: Boolean,
      default: true
    },
    formReadOnly: {
      type: Boolean,
      default: false
    },
    toReader: {
      type: Boolean,
      default: false
    }
  },
  mixins: [props],
  data() {
    return {
      readOnly: false
    };
  },
  mounted() {
    const {
      hiddenComment,
      hiddenAssignee,
      instId,
      formReadOnly,
      toReader
    } = this;
    // 默认拿取props
    const data = {
      hiddenComment,
      hiddenAssignee,
      id: instId,
      readOnly: formReadOnly
    };
    this.readOnly = formReadOnly || false;
    // 如路由有对应参数，则路由query参数优先
    if (this.$route) {
      // 路由query参数
      let query = this.$route.query;
      if (query.hasOwnProperty('id')) data.id = query.id;
      if (query.hasOwnProperty('businessKey')) {
        data.businessKey = query.businessKey;
      }
      if (query.hasOwnProperty('formReadOnly')) {
        this.readOnly = query.formReadOnly == 1 ? true : false;
        data.readOnly = this.readOnly;
      }
      if (query.hasOwnProperty('hiddenComment')) data.hiddenComment = query.hiddenComment == 1 ? true : false;
      if (query.hasOwnProperty('hiddenAssignee')) data.hiddenAssignee = query.hiddenAssignee == 1 ? true : false;
      if (query.hasOwnProperty('toReader')) data.toReader = query.toReader == 1 ? true : false;
    }
    if (!data.id) return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], '缺少实例id，请联系管理员！');
    this.$refs.flowInstanceDetailDialog.setValue(data);
  },
  methods: {
    back() {
      if (!request_utils["c" /* hasHandleToEmit */].call(this, constants["j" /* HANDLE_BACK */])) {
        this.$router.back();
      }
    },
    submit() {
      this.$refs.flowInstanceDetailDialog.submit();
    },
    onRouter(query) {
      if (!request_utils["c" /* hasHandleToEmit */].call(this, constants["j" /* HANDLE_BACK */])) {
        this.$emit(constants["m" /* HANDLE_ROUTER */], query);
      }
    },
    onError() {
      return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["l" /* HANDLE_ERROR */], constants["h" /* ERROR */], ...arguments);
    },
    onSuccess() {
      return request_utils["a" /* doHandleToEmitOrToast */].call(this, constants["n" /* HANDLE_SUCCESS */], constants["y" /* SUCCESS */], ...arguments);
    }
  }
});
// CONCATENATED MODULE: ./src/components/instance/flow-instance-detail.vue?vue&type=script&lang=js&
 /* harmony default export */ var instance_flow_instance_detailvue_type_script_lang_js_ = (flow_instance_detailvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/instance/flow-instance-detail.vue?vue&type=style&index=0&id=5fbc17c8&prod&scoped=true&lang=css&
var flow_instance_detailvue_type_style_index_0_id_5fbc17c8_prod_scoped_true_lang_css_ = __webpack_require__("b53e");

// CONCATENATED MODULE: ./src/components/instance/flow-instance-detail.vue






/* normalize component */

var flow_instance_detail_component = Object(componentNormalizer["a" /* default */])(
  instance_flow_instance_detailvue_type_script_lang_js_,
  flow_instance_detailvue_type_template_id_5fbc17c8_scoped_true_render,
  flow_instance_detailvue_type_template_id_5fbc17c8_scoped_true_staticRenderFns,
  false,
  null,
  "5fbc17c8",
  null
  
)

/* harmony default export */ var flow_instance_detail = (flow_instance_detail_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/pc.vue?vue&type=template&id=c02fc530&scoped=true&
var pcvue_type_template_id_c02fc530_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"applyRecord"}},[(_vm.showTitle)?_c('div',{staticClass:"text"},[_c('div',[_vm._v("商场申报记录")])]):_vm._e(),(_vm.showSearch)?_c('el-row',{staticStyle:{"padding":"10px 10px 20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('el-select',{attrs:{"size":"small","placeholder":"制度所属年份","clearable":""},model:{value:(_vm.originSearch.business_year),callback:function ($$v) {_vm.$set(_vm.originSearch, "business_year", $$v)},expression:"originSearch.business_year"}},_vm._l((_vm.yearsList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_c('el-col',{attrs:{"span":4}},[_c('el-select',{attrs:{"size":"small","placeholder":"状态","clearable":""},model:{value:(_vm.originSearch.status),callback:function ($$v) {_vm.$set(_vm.originSearch, "status", $$v)},expression:"originSearch.status"}},_vm._l((_vm.flowCenterStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_c('el-col',{attrs:{"span":4}},[_c('el-select',{attrs:{"size":"small","placeholder":"补贴类型","clearable":""},model:{value:(_vm.originSearch.business_type),callback:function ($$v) {_vm.$set(_vm.originSearch, "business_type", $$v)},expression:"originSearch.business_type"}},_vm._l((_vm.businessTypeList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.handleCurrentChange(1)}}},[_vm._v("搜索")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.exportOut}},[_vm._v("导出")])],1)],1):_vm._e(),_c('op-table',{attrs:{"data":_vm.tableData,"maxHeight":_vm.maxHeight,"loading":_vm.loading}},[_c('op-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"expand-area"},[_c('ProcessSummary',{attrs:{"data":props.row},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_vm._t("summaryButtons",null,{"data":props.row})]},proxy:true}],null,true)}),_vm._t("footer",null,{"data":props.row})],2)]}}],null,true)}),_vm._l((_vm.tableHeader),function(item){return _c('op-column',{key:item.prop,attrs:{"label":item.label,"prop":item.prop,"type":item.type,"width":item.width,"nested":item.nested}})})],2),(_vm.isPagination)?_c('div',{staticClass:"pages"},[_c('el-pagination',{attrs:{"current-page":_vm.searchParams.pageNo,"page-sizes":[5, 20, 50, 100],"page-size":_vm.searchParams.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e()],1)}
var pcvue_type_template_id_c02fc530_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/instance/ProcessESList/pc.vue?vue&type=template&id=c02fc530&scoped=true&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/lodash/defaultsDeep.js
var defaultsDeep = __webpack_require__("c926");
var defaultsDeep_default = /*#__PURE__*/__webpack_require__.n(defaultsDeep);

// CONCATENATED MODULE: ./src/components/instance/ProcessESList/utils.js
const SIGN = {
  EQ: 'EQ',
  LIKE: 'LIKE',
  IN: 'IN',
  LTLT: 'LTLT',
  LTLE: 'LTLE',
  LELT: 'LELT',
  BETWEEN: 'BETWEEN',
  LT: 'LT',
  LE: 'LE',
  GT: 'GT',
  GE: 'GE'
};
const setValue = (val, sign = SIGN.LIKE) => {
  return {
    value: Array.isArray(val) ? [...val] : [val],
    queryType: sign
  };
};
const setTableParam = tableName => {};
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/components/ProcessSummary.vue?vue&type=template&id=1a7e81fb&scoped=true&
var ProcessSummaryvue_type_template_id_1a7e81fb_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-info"},[_c('div',{staticClass:"summary"},[_c('span',{staticClass:"text"},[_vm._v("流程编码："+_vm._s(_vm.data.id))]),_c('span',{staticClass:"text"},[_vm._v("审批状态："+_vm._s(_vm.data.statusName))]),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.openDetail(_vm.data.id)}}},[_vm._v("查看表单")]),_vm._t("buttons")],2),_c('div',[_c('div',{staticClass:"text"},[_vm._v("处理记录：")]),_c('flow-record',{attrs:{"instId":_vm.data.id,"hidden-title":true}})],1)])}
var ProcessSummaryvue_type_template_id_1a7e81fb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/instance/ProcessESList/components/ProcessSummary.vue?vue&type=template&id=1a7e81fb&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/components/ProcessSummary.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProcessSummaryvue_type_script_lang_js_ = ({
  name: 'ProcessSummary',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    openDetail(id) {
      // TODO: 后续要换成新的通用工作流页面
      const flowUrl = baseURL["a" /* default */].getBaseUrl().flowCenter;
      window.open(flowUrl + '/work-flow/instance-flow?instId=' + id);
    }
  }
});
// CONCATENATED MODULE: ./src/components/instance/ProcessESList/components/ProcessSummary.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProcessSummaryvue_type_script_lang_js_ = (ProcessSummaryvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/instance/ProcessESList/components/ProcessSummary.vue?vue&type=style&index=0&id=1a7e81fb&prod&lang=postcss&scoped=true&
var ProcessSummaryvue_type_style_index_0_id_1a7e81fb_prod_lang_postcss_scoped_true_ = __webpack_require__("8eda");

// CONCATENATED MODULE: ./src/components/instance/ProcessESList/components/ProcessSummary.vue






/* normalize component */

var ProcessSummary_component = Object(componentNormalizer["a" /* default */])(
  components_ProcessSummaryvue_type_script_lang_js_,
  ProcessSummaryvue_type_template_id_1a7e81fb_scoped_true_render,
  ProcessSummaryvue_type_template_id_1a7e81fb_scoped_true_staticRenderFns,
  false,
  null,
  "1a7e81fb",
  null
  
)

/* harmony default export */ var ProcessSummary = (ProcessSummary_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/pc.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ProcessESList_pcvue_type_script_lang_js_ = ({
  name: 'process-es-list',
  components: {
    ProcessSummary: ProcessSummary
  },
  props: {
    modelKey: {
      type: String,
      default: ''
    },
    businessYear: {
      type: String,
      default: ''
    },
    businessType: {
      type: String,
      default: ''
    },
    params: {
      type: [Object, null],
      default: null
    },
    // TODO: 增加自定义表头
    header: {
      type: [Array, null],
      default: null
    },
    exportData: {
      type: [Object, null],
      default: null
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 400
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    immediated: {
      type: Boolean,
      default: true
    },
    taskDetail: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
      tableData: [],
      searchParams: {
        processInstanceParam: {},
        formTableParam: [],
        pageSize: 20,
        pageNo: 1
      },
      originSearch: {
        business_year: '',
        business_type: ''
      },
      loading: false,
      total: 0,
      businessTypeList: [],
      tableHeader: [{
        label: '流程标题',
        prop: 'name'
      }, {
        label: '发起人',
        prop: 'starterUserName',
        width: '150'
      }, {
        label: '发起人',
        prop: 'startTime',
        width: '180',
        type: 'date'
      }]
    };
  },
  computed: {
    flowCenterStatus() {
      return Object.keys(FLOW_CENTER_STATUS).map(key => {
        key = {
          value: key,
          label: FLOW_CENTER_STATUS[key]
        };
        return key;
      });
    },
    yearsList() {
      const years = [];
      let date = new Date();
      let year = date.getFullYear() - 2;
      for (let i = 0; i < 4; i++) {
        if (i == 2) {
          years.push({
            label: '今年',
            value: String(year + i)
          });
        } else {
          years.push({
            label: year + i,
            value: String(year + i)
          });
        }
      }
      return years;
    }
  },
  watch: {
    params: {
      deep: true,
      handler: function () {
        if (this.params) {
          this.searchParams = defaultsDeep_default()(JSON.parse(JSON.stringify(this.params)), this.searchParams);
        }
        this.originSearch.business_year = this.businessYear;
        this.originSearch.business_type = this.businessType;
        this.loadData();
        this.maintainRelationship();
      }
    }
  },
  created() {
    if (this.header) {
      this.tableHeader = this.header;
    }
    if (this.immediated) {
      if (this.params) {
        this.searchParams = defaultsDeep_default()(JSON.parse(JSON.stringify(this.params)), this.searchParams);
      }
      this.originSearch.business_year = this.businessYear;
      this.originSearch.business_type = this.businessType;
      // 默认立即加载
      this.loadData();
      this.maintainRelationship();
    }
  },
  methods: {
    setParams() {
      if (this.modelKey) {
        this.searchParams.processInstanceParam.modelKey = setValue(this.modelKey, SIGN.IN);
      }
      if (this.originSearch.status) {
        this.searchParams.processInstanceParam.status = {
          value: [this.originSearch.status],
          queryType: SIGN.IN
        };
      } else {
        this.searchParams.processInstanceParam.status = {
          value: Object.keys(FLOW_CENTER_STATUS).map(key => {
            return key;
          }),
          queryType: SIGN.IN
        };
      }
      if (this.originSearch.business_year || this.originSearch.business_type) {
        let hasBasic = false;
        this.searchParams.formTableParam.forEach(item => {
          // 判断是否有基础表单
          if (item.formTableName === 'dyfo_ad_subsidy_assp_ba') {
            hasBasic = true;
          }
        });
        if (!hasBasic) {
          this.searchParams.formTableParam.push({
            formTableName: 'dyfo_ad_subsidy_assp_ba',
            selectFieldList: []
          });
        }
      }
      this.searchParams.formTableParam.forEach(item => {
        if (item.formTableName === 'dyfo_ad_subsidy_assp_ba') {
          let hasType = true;
          let hasYear = true;
          item.selectFieldList.forEach(it => {
            if (it.fieldName === 'business_type') {
              it.value = this.originSearch.business_type ? [this.originSearch.business_type] : [];
              hasType = false;
            }
            if (it.fieldName === 'business_year') {
              it.value = this.originSearch.business_year ? [String(this.originSearch.business_year)] : [];
              hasYear = false;
            }
          });
          if (hasType) {
            item.selectFieldList.push({
              fieldName: 'business_type',
              value: this.originSearch.business_type ? [this.originSearch.business_type] : [],
              queryType: 'LIKE'
            });
          }
          if (hasYear) {
            item.selectFieldList.push({
              fieldName: 'business_year',
              value: this.originSearch.business_year ? [this.originSearch.business_year] : [],
              queryType: 'LIKE'
            });
          }
        }
      });
    },
    loadData() {
      this.$emit('paramsChange', this.originSearch);
      this.setParams();
      this.loading = true;
      processInstance["a" /* default */].getFlowInstListByEs(this.searchParams).then(res => {
        if (res.status) {
          this.tableData = res.data.records.map(item => {
            item.statusName = constant[item.status];
            if (item && item.dyfo_subsidy_bpm && item.dyfo_subsidy_bpm.bpmStatus) {
              item.dyfo_subsidy_bpm['bpmStatusName'] = BPM_STATUS[item.dyfo_subsidy_bpm.bpmStatus];
            }
            this.sorterBpmItme(item);
            return item;
          });
          this.total = res.data.total;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    sorterBpmItme(data) {
      if (data.dyfo_ad_subsidy_assp_ba && data.dyfo_ad_subsidy_assp_ba.business_type_code == '9' && data.dyfo_subsidy_bpm_item) {
        const bpmItem = [],
          typeList = ['yf_YXBT_YP', 'hx_YXBT_YP', 'yf_YXBT_ZX', 'hx_YXBT_ZX'];
        typeList.forEach(item => {
          let bpm = data.dyfo_subsidy_bpm_item.filter(i => i.costType == item);
          bpmItem.push(...bpm);
        });
        data.dyfo_subsidy_bpm_item = bpmItem;
      }
    },
    // 获取维护关系
    maintainRelationship() {
      const postData = {
        groupRelation: 'AND',
        params: {},
        querys: [{
          property: 'TYPE',
          value: 1,
          group: 'main',
          operation: 'EQUAL',
          relation: 'AND'
        }],
        sorter: [{
          direction: 'ASC',
          property: 'id'
        }]
      };
      let belong_classify_type = '';
      this.params.formTableParam.forEach(item => {
        if (item.formTableName === 'dyfo_ad_subsidy_assp_ba') {
          item.selectFieldList.forEach(it => {
            if (it.fieldName === 'belong_classify_type') {
              belong_classify_type = it.value[0];
            }
          });
        }
      });
      if (belong_classify_type) {
        postData.querys.push(Object(utils["c" /* getAsspApiParams */])('businessOnlineId', belong_classify_type, 'main', 'EQUAL', 'AND'));
      }
      processInstance["a" /* default */].shopFlowSelectList(postData).then(res => {
        this.businessTypeList = res.rows.reduce((prev, cur) => {
          const value = cur.businessTypeName;
          // isNotExist 判断去重
          const isNotExist = !prev.some(item => {
            return item.value.includes(value);
          });
          if (isNotExist) {
            prev.push({
              value: value,
              label: value
            });
          }
          return prev;
        }, []);
        this.businessTypeList.push({
          value: '调整补贴',
          label: '调整补贴'
        });
      });
    },
    openDetail(id) {
      // TODO: 后续要换成新的通用工作流页面
      const flowUrl = baseUrlInst.getBaseUrl().flowCenter;
      window.open(flowUrl + '/work-flow/instance-flow?instId=' + id);
    },
    handleSizeChange(size) {
      this.searchParams.pageSize = size;
      this.loadData();
    },
    handleCurrentChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.loadData();
    },
    // 导出
    exportOut() {
      let params = Object.assign(this.exportData, {
        formTableParam: this.searchParams.formTableParam,
        processInstanceParam: this.searchParams.processInstanceParam
      });
      processInstance["a" /* default */].exportProcessInstance(params).then(file => {
        Object(utils["b" /* downloadBlob */])(file, `${this.exportData.exportFileName}.xlsx`);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/instance/ProcessESList/pc.vue?vue&type=script&lang=js&
 /* harmony default export */ var instance_ProcessESList_pcvue_type_script_lang_js_ = (ProcessESList_pcvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/instance/ProcessESList/pc.vue?vue&type=style&index=0&id=c02fc530&prod&lang=postcss&scoped=true&
var pcvue_type_style_index_0_id_c02fc530_prod_lang_postcss_scoped_true_ = __webpack_require__("ab6a");

// CONCATENATED MODULE: ./src/components/instance/ProcessESList/pc.vue






/* normalize component */

var ProcessESList_pc_component = Object(componentNormalizer["a" /* default */])(
  instance_ProcessESList_pcvue_type_script_lang_js_,
  pcvue_type_template_id_c02fc530_scoped_true_render,
  pcvue_type_template_id_c02fc530_scoped_true_staticRenderFns,
  false,
  null,
  "c02fc530",
  null
  
)

/* harmony default export */ var ProcessESList_pc = (ProcessESList_pc_component.exports);
// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/mobile.vue?vue&type=template&id=ef9748b6&
var mobilevue_type_template_id_ef9748b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  开发中！\n")])}
var mobilevue_type_template_id_ef9748b6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/instance/ProcessESList/mobile.vue?vue&type=template&id=ef9748b6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/instance/ProcessESList/mobile.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var ProcessESList_mobilevue_type_script_lang_js_ = ({
  name: 'process-es-list'
});
// CONCATENATED MODULE: ./src/components/instance/ProcessESList/mobile.vue?vue&type=script&lang=js&
 /* harmony default export */ var instance_ProcessESList_mobilevue_type_script_lang_js_ = (ProcessESList_mobilevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/instance/ProcessESList/mobile.vue





/* normalize component */

var ProcessESList_mobile_component = Object(componentNormalizer["a" /* default */])(
  instance_ProcessESList_mobilevue_type_script_lang_js_,
  mobilevue_type_template_id_ef9748b6_render,
  mobilevue_type_template_id_ef9748b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProcessESList_mobile = (ProcessESList_mobile_component.exports);
// CONCATENATED MODULE: ./src/components/instance/ProcessESList/index.js



const ProcessEsList = {};
ProcessEsList.install = Vue => {
  if (Object(helper_env["b" /* isPCWidth */])()) {
    Vue.component(ProcessESList_pc.name, ProcessESList_pc);
  } else {
    Vue.component(ProcessESList_mobile.name, ProcessESList_mobile);
  }
};
/* harmony default export */ var ProcessESList = (ProcessEsList);
// EXTERNAL MODULE: ./src/request/index.js + 5 modules
var src_request = __webpack_require__("8daa");

// EXTERNAL MODULE: ./src/styles/form.css
var styles_form = __webpack_require__("7d92");

// CONCATENATED MODULE: ./src/components/index.js








// form











const FlowComponent = {
  FlowAction: FlowAction,
  FlowActionNoSubmit: FlowActionNoSubmit
};

FlowComponent.install = (Vue, opts = {}) => {
  const {
    env
  } = opts;
  baseURL["a" /* default */].init(env);
  Vue.directive('form', {
    // 当被绑定的元素插入到 DOM 中时……
    bind: function (el, binding, vnode) {
      const inst = vnode.context;
      if (inst && !inst.hasOwnProperty('watchMap')) {
        inst['watchMap'] = new Map();
      }
    }
  });
  if (!Vue.prototype.$req) {
    Vue.prototype.$req = src_request["a" /* reqWebApi */];
  }
  Vue.component(FlowAction.name, FlowAction);
  Vue.component(FlowActionNoSubmit.name, FlowActionNoSubmit);
  Vue.component(FormContent.name, FormContent);
  Vue.component(FlowDiagram.name, FlowDiagram);
  // Vue.component(OpUserSelector.name, OpUserSelector)
  Vue.component(flow_instances.name, flow_instances);
  Vue.component(flow_tasks.name, flow_tasks);
  Vue.component(flow_instance_detail.name, flow_instance_detail);
  Vue.component(flow_ProcessingTaskPrevRecord.name, flow_ProcessingTaskPrevRecord);
  Vue.use(ProcessESList);
  Vue.use(flow_ProcessingTaskPrevRecord);
  Vue.use(flow_FlowRecord);
  Vue.use(flow_ProcessStart);
  Vue.use(flow_TimeNotice);
};
/* harmony default export */ var components = (FlowComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (components);



/***/ }),

/***/ "fb51":
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export version */
/* unused harmony export VERSION */
/* unused harmony export atob */
/* unused harmony export atobPolyfill */
/* unused harmony export btoa */
/* unused harmony export btoaPolyfill */
/* unused harmony export fromBase64 */
/* unused harmony export toBase64 */
/* unused harmony export utob */
/* unused harmony export encode */
/* unused harmony export encodeURI */
/* unused harmony export encodeURL */
/* unused harmony export btou */
/* unused harmony export decode */
/* unused harmony export isValid */
/* unused harmony export fromUint8Array */
/* unused harmony export toUint8Array */
/* unused harmony export extendString */
/* unused harmony export extendUint8Array */
/* unused harmony export extendBuiltins */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gBase64; });
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */
const version = '3.7.4';
/**
 * @deprecated use lowercase `version`.
 */
const VERSION = version;
const _hasatob = typeof atob === 'function';
const _hasbtoa = typeof btoa === 'function';
const _hasBuffer = typeof Buffer === 'function';
const _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const b64chs = Array.prototype.slice.call(b64ch);
const b64tab = ((a) => {
    let tab = {};
    a.forEach((c, i) => tab[c] = i);
    return tab;
})(b64chs);
const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const _fromCC = String.fromCharCode.bind(String);
const _U8Afrom = typeof Uint8Array.from === 'function'
    ? Uint8Array.from.bind(Uint8Array)
    : (it, fn = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
const _mkUriSafe = (src) => src
    .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');
const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */
const btoaPolyfill = (bin) => {
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for (let i = 0; i < bin.length;) {
        if ((c0 = bin.charCodeAt(i++)) > 255 ||
            (c1 = bin.charCodeAt(i++)) > 255 ||
            (c2 = bin.charCodeAt(i++)) > 255)
            throw new TypeError('invalid character found');
        u32 = (c0 << 16) | (c1 << 8) | c2;
        asc += b64chs[u32 >> 18 & 63]
            + b64chs[u32 >> 12 & 63]
            + b64chs[u32 >> 6 & 63]
            + b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */
const _btoa = _hasbtoa ? (bin) => btoa(bin)
    : _hasBuffer ? (bin) => Buffer.from(bin, 'binary').toString('base64')
        : btoaPolyfill;
const _fromUint8Array = _hasBuffer
    ? (u8a) => Buffer.from(u8a).toString('base64')
    : (u8a) => {
        // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
        const maxargs = 0x1000;
        let strs = [];
        for (let i = 0, l = u8a.length; i < l; i += maxargs) {
            strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
        }
        return _btoa(strs.join(''));
    };
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */
const fromUint8Array = (u8a, urlsafe = false) => urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const cb_utob = (c) => {
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c
            : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                + _fromCC(0x80 | (cc & 0x3f)))
                : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                    + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                    + _fromCC(0x80 | (cc & 0x3f)));
    }
    else {
        var cc = 0x10000
            + (c.charCodeAt(0) - 0xD800) * 0x400
            + (c.charCodeAt(1) - 0xDC00);
        return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
            + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
            + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
            + _fromCC(0x80 | (cc & 0x3f)));
    }
};
const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */
const utob = (u) => u.replace(re_utob, cb_utob);
//
const _encode = _hasBuffer
    ? (s) => Buffer.from(s, 'utf8').toString('base64')
    : _TE
        ? (s) => _fromUint8Array(_TE.encode(s))
        : (s) => _btoa(utob(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */
const encode = (src, urlsafe = false) => urlsafe
    ? _mkUriSafe(_encode(src))
    : _encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */
const encodeURI = (src) => encode(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const cb_btou = (cccc) => {
    switch (cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                | ((0x3f & cccc.charCodeAt(1)) << 12)
                | ((0x3f & cccc.charCodeAt(2)) << 6)
                | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
            return (_fromCC((offset >>> 10) + 0xD800)
                + _fromCC((offset & 0x3FF) + 0xDC00));
        case 3:
            return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                | ((0x3f & cccc.charCodeAt(1)) << 6)
                | (0x3f & cccc.charCodeAt(2)));
        default:
            return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                | (0x3f & cccc.charCodeAt(1)));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */
const btou = (b) => b.replace(re_btou, cb_btou);
/**
 * polyfill version of `atob`
 */
const atobPolyfill = (asc) => {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!b64re.test(asc))
        throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, bin = '', r1, r2;
    for (let i = 0; i < asc.length;) {
        u24 = b64tab[asc.charAt(i++)] << 18
            | b64tab[asc.charAt(i++)] << 12
            | (r1 = b64tab[asc.charAt(i++)]) << 6
            | (r2 = b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
            : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */
const _atob = _hasatob ? (asc) => atob(_tidyB64(asc))
    : _hasBuffer ? (asc) => Buffer.from(asc, 'base64').toString('binary')
        : atobPolyfill;
//
const _toUint8Array = _hasBuffer
    ? (a) => _U8Afrom(Buffer.from(a, 'base64'))
    : (a) => _U8Afrom(_atob(a), c => c.charCodeAt(0));
/**
 * converts a Base64 string to a Uint8Array.
 */
const toUint8Array = (a) => _toUint8Array(_unURI(a));
//
const _decode = _hasBuffer
    ? (a) => Buffer.from(a, 'base64').toString('utf8')
    : _TD
        ? (a) => _TD.decode(_toUint8Array(a))
        : (a) => btou(_atob(a));
const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */
const decode = (src) => _decode(_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */
const isValid = (src) => {
    if (typeof src !== 'string')
        return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const _noEnum = (v) => {
    return {
        value: v, enumerable: false, writable: true, configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */
const extendString = function () {
    const _add = (name, body) => Object.defineProperty(String.prototype, name, _noEnum(body));
    _add('fromBase64', function () { return decode(this); });
    _add('toBase64', function (urlsafe) { return encode(this, urlsafe); });
    _add('toBase64URI', function () { return encode(this, true); });
    _add('toBase64URL', function () { return encode(this, true); });
    _add('toUint8Array', function () { return toUint8Array(this); });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */
const extendUint8Array = function () {
    const _add = (name, body) => Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
    _add('toBase64', function (urlsafe) { return fromUint8Array(this, urlsafe); });
    _add('toBase64URI', function () { return fromUint8Array(this, true); });
    _add('toBase64URL', function () { return fromUint8Array(this, true); });
};
/**
 * extend Builtin prototypes with relevant methods
 */
const extendBuiltins = () => {
    extendString();
    extendUint8Array();
};
const gBase64 = {
    version: version,
    VERSION: VERSION,
    atob: _atob,
    atobPolyfill: atobPolyfill,
    btoa: _btoa,
    btoaPolyfill: btoaPolyfill,
    fromBase64: decode,
    toBase64: encode,
    encode: encode,
    encodeURI: encodeURI,
    encodeURL: encodeURI,
    utob: utob,
    btou: btou,
    decode: decode,
    isValid: isValid,
    fromUint8Array: fromUint8Array,
    toUint8Array: toUint8Array,
    extendString: extendString,
    extendUint8Array: extendUint8Array,
    extendBuiltins: extendBuiltins,
};
// makecjs:CUT //




















// and finally,



/***/ }),

/***/ "fb54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("3a83");
var callBound = __webpack_require__("4b8b");
var inspect = __webpack_require__("2a1b");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ "fb9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("70b7");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "fbba":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("78dd"),
    defineProperty = __webpack_require__("3f3f"),
    identity = __webpack_require__("cd68");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "fd13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4acdeec1-vue-loader-template"}!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/ReplaceUserDialog/add.vue?vue&type=template&id=6508e97e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{directives:[{name:"form",rawName:"v-form"}],attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"append-to-body":"","modal":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("提交")])]},proxy:true}])},[_c('div',[_vm._v("系统识别到原单有审核人离职了，需要您选择其工作交接人")]),_c('el-table',{staticStyle:{"width":"100%","margin-top":"16px"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"departmentName","label":"原审核人部门","width":"180"}}),_c('el-table-column',{attrs:{"prop":"positionName","label":"原审核人岗位","wdith":"180"}}),_c('el-table-column',{attrs:{"prop":"name","label":"原审核人"}}),_c('el-table-column',{attrs:{"prop":"newUser","label":"新审核人"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('op-user-selector',{attrs:{"appendToBody":true,"single":_vm.signle,"config":{
            account: ("tableData[" + (scope.$index) + "].newAccount"),
          }},model:{value:(scope.row.newUser),callback:function ($$v) {_vm.$set(scope.row, "newUser", $$v)},expression:"scope.row.newUser"}})]}}])})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/dialog/ReplaceUserDialog/add.vue?vue&type=template&id=6508e97e&

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/element-ui/lib/message.js
var message = __webpack_require__("e3ca");
var message_default = /*#__PURE__*/__webpack_require__.n(message);

// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("0894");

// EXTERNAL MODULE: external "vue-demi"
var external_vue_demi_ = __webpack_require__("f281");

// EXTERNAL MODULE: ./src/api/uc.js
var uc = __webpack_require__("292c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/ReplaceUserDialog/add.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var addvue_type_script_lang_js_ = (Object(external_vue_demi_["defineComponent"])({
  name: 'ReplaceUserDialog',
  props: {
    userNoList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String,
      default: '选择后面节点审核人'
    },
    // all: 全部都要替换, one: 至少一个替换, none: 可以不替换
    replaceType: {
      type: String,
      default: 'all'
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const dialogVisible = Object(external_vue_demi_["ref"])(false);
    const tableData = Object(external_vue_demi_["ref"])([]);
    const userList = Object(external_vue_demi_["ref"])([]);
    uc["a" /* default */].getUserPageListByConToPost({
      accountList: props.userNoList || [],
      orgId: '1'
    }).then(res => {
      userList.value = res;
      const leaveUsers = res.filter(x => x.status == 5);
      tableData.value = leaveUsers.map(x => {
        return {
          newUser: '',
          newAccount: '',
          ...x
        };
      });
      if (leaveUsers.length > 0) {
        dialogVisible.value = true;
      } else {
        emit('returnValue', null);
        close();
      }
    });
    const close = () => {
      dialogVisible.value = false;
      emit('close');
    };
    const onConfirm = () => {
      if (props.replaceType === 'all' && tableData.value.some(x => !x.newUser)) {
        return message_default.a.error('请选择新审核人');
      } else if (props.replaceType === 'one' && tableData.value.every(x => !x.newUser)) {
        return message_default.a.error('请至少选择一个新审核人');
      }
      const newUserNameList = [];
      const newUserNoList = [];
      userList.value.forEach(item => {
        const replaceItem = tableData.value.find(x => x.account === item.account);
        if (replaceItem) {
          if (replaceItem.newAccount) {
            newUserNameList.push(...replaceItem.newUser.split(','));
            newUserNoList.push(...replaceItem.newAccount.split(','));
          }
        } else {
          newUserNameList.push(item.name);
          newUserNoList.push(item.account);
        }
      });
      const value = {
        replceList: tableData.value,
        originUserNoList: userList.value.map(x => x.account),
        originUserNameList: userList.value.map(x => x.name),
        newUserNameList,
        newUserNoList
      };
      emit('returnValue', value);
      close();
    };
    return {
      dialogVisible,
      tableData,
      close,
      onConfirm
    };
  }
}));
// CONCATENATED MODULE: ./src/components/dialog/ReplaceUserDialog/add.vue?vue&type=script&lang=js&
 /* harmony default export */ var ReplaceUserDialog_addvue_type_script_lang_js_ = (addvue_type_script_lang_js_); 
// EXTERNAL MODULE: /Users/yuxuanhui/oppein/lerna-op-lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2be6");

// CONCATENATED MODULE: ./src/components/dialog/ReplaceUserDialog/add.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  ReplaceUserDialog_addvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var add = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fd44":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "feca":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("083f");
var isSymbol = __webpack_require__("cfd1");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "ff00":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4c0b");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "ff3b":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("d4cb");
var fails = __webpack_require__("72df");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "ff7d":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("0e19"),
    isObjectLike = __webpack_require__("b4b4");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ })

/******/ });
});